(() => {
const initializeDesigner = () => {
  if (customElements.get('tan-neon-designer')) return;
const TAN_FONT_PREVIEW_SOURCES = Object.freeze({"catalog-barcelona":["Barcelona","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/barcelona-6mm.woff2?v=1785448176"],"catalog-tan-brush-6mm-pilot":["Madrid","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/TANBrush6mmPilot-Regular_78a5724f-46a1-4fa5-8d20-d4f566664171.woff2?v=1785448176"],"catalog-alaska":["ALASKA","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/alaska-6mm.woff2?v=1785448175"],"catalog-amsterdam":["Amsterdam","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/amsterdam-6mm.woff2?v=1785448175"],"catalog-arizona":["ARIZONA","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/arizona-6mm.woff2?v=1785448176"],"catalog-athens":["ATHENS","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/athens-6mm.woff2?v=1785448176"],"catalog-atlanta":["ATLANTA","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/atlanta-6mm.woff2?v=1785448176"],"catalog-basel":["Basel","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/basel-6mm.woff2?v=1785448175"],"catalog-beachfront-cn":["Beachfront","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Beachfront_CN-6mm.woff2?v=1785448175"],"catalog-berlin":["Berlin","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/berlin-6mm.woff2?v=1785448176"],"catalog-bordeaux":["Bordeaux","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/bordeaux-6mm.woff2?v=1785448175"],"catalog-boston":["BOSTON","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/boston-6mm.woff2?v=1785448176"],"catalog-broadway":["BROADWAY","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/broadway-6mm.woff2?v=1785448176"],"catalog-brooklyn":["BROOKLYN","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/brooklyn-6mm.woff2?v=1785448175"],"catalog-brussels":["Brussels","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/brussels-6mm.woff2?v=1785448176"],"catalog-budapest":["Budapest","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/budapest-6mm.woff2?v=1785448176"],"catalog-cat-north":["Cat north","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/cat-north-6mm.woff2?v=1785448176"],"catalog-chicago":["CHICAGO","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/chicago-6mm.woff2?v=1785448176"],"catalog-copenhagen":["Copenhagen","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/copenhagen-6mm.woff2?v=1785448176"],"catalog-dallas":["DALLAS","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/dallas-6mm.woff2?v=1785448176"],"catalog-detroit":["DETROIT","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/detroit-6mm.woff2?v=1785448175"],"catalog-dublin":["DUBLIN","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/dublin-6mm.woff2?v=1785448176"],"catalog-edinburgh":["EDINBURGH","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/edinburgh-6mm.woff2?v=1785448176"],"catalog-father":["Father","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/father-6mm.woff2?v=1785448176"],"catalog-frankfurt":["Frankfurt","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/frankfurt-6mm.woff2?v=1785448176"],"catalog-gothenburg":["Gothenburg","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/gothenburg-6mm.woff2?v=1785448176"],"catalog-granada":["Granada","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/granada-6mm.woff2?v=1785448176"],"catalog-helsinki":["Helsinki","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/helsinki-6mm.woff2?v=1785448175"],"catalog-illinois":["Illinois","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/illinois-6mm.woff2?v=1785448176"],"catalog-library":["LIBRARY","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/library-6mm.woff2?v=1785448175"],"catalog-lisbon":["Lisbon","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/lisbon-6mm.woff2?v=1785448175"],"catalog-london":["London","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/london-6mm.woff2?v=1785448176"],"catalog-los-angeles":["Los Angeles","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/los-angeles-6mm.woff2?v=1785448175"],"catalog-manchester":["Manchester","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/manchester-_RochesterSignature.woff2?v=1785455672"],"catalog-mayfair":["Mayfair","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/mayfair-6mm.woff2?v=1785448175"],"catalog-melbourne-cn":["Melbourne","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Melbourne_CN-6mm.woff2?v=1785448176"],"catalog-monaco-cn":["MONACO","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Monaco_CN-6mm.woff2?v=1785448175"],"catalog-monalisa":["MonaLisa","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/monalisa-6mm.woff2?v=1785448175"],"catalog-montreal":["Montreal","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/montreal-6mm.woff2?v=1785448176"],"catalog-munich":["Munich","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/munich-6mm.woff2?v=1785448176"],"catalog-national-park":["National Park","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/national-park-6mm.woff2?v=1785448175"],"catalog-neotokyo-cn":["NeoTokyo","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/NeoTokyo_CN-6mm.woff2?v=1785448176"],"catalog-neontrace":["NEONTRACE","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/neontrace-6mm.woff2?v=1785448175"],"catalog-oxford":["OXFORD","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/oxford-6mm.woff2?v=1785448176"],"catalog-paris":["Paris","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/paris-6mm.woff2?v=1785448176"],"catalog-prague":["Prague","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/prague-6mm.woff2?v=1785448175"],"catalog-quebec":["QUEBEC","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/quebec-6mm.woff2?v=1785448175"],"catalog-riga":["RIGA","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/riga-6mm.woff2?v=1785448175"],"catalog-sacramento-regular":["Sacramento","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Sacramento-Regular-6mm.woff2?v=1785448175"],"catalog-san-francisco":["San Francisco","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/san-francisco-6mm.woff2?v=1785448176"],"catalog-scifi":["SCIFI","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/scifi-6mm.woff2?v=1785448176"],"catalog-seinajoki":["Seinäjoki","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/seinajoki-6mm.woff2?v=1785448176"],"catalog-sorrento-cn":["Sorrento","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Sorrento_CN-6mm.woff2?v=1785448176"],"catalog-sydney":["Sydney","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/sydney-6mm.woff2?v=1785448175"],"catalog-tahiti":["TAHITI","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/tahiti-6mm.woff2?v=1785448176"],"catalog-trondheim":["Trondheim","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/trondheim-6mm.woff2?v=1785448175"],"catalog-turku":["TURKU","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/turku-6mm.woff2?v=1785448175"],"catalog-typewriter-cn":["Typewriter","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Typewriter_CN-6mm.woff2?v=1785448176"],"catalog-valencia":["Valencia","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/valencia-6mm.woff2?v=1785448175"],"catalog-vegas":["VEGAS","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/vegas-6mm.woff2?v=1785448175"],"catalog-venice":["VENICE","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/venice-6mm.woff2?v=1785448175"],"catalog-vintage":["Rotterdam","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Vintage-6mm.woff2?v=1785448176"],"catalog-waikiki-cn":["WAIKIKI","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/Waikiki_CN-6mm.woff2?v=1785448175"],"catalog-wildscript":["WolfScript","https://cdn.shopify.com/s/files/1/0759/0743/2776/files/WildScript-6mm.woff2?v=1785448177"]});
// Generated from the exact versioned WOFF2 files in TAN_FONT_PREVIEW_SOURCES.
// This compact cmap index requires no font downloads or parsing in the browser.
const TAN_FONT_GLYPH_RANGES = [[32,126,160,163,165,165,169,169,173,174,176,177,180,180,191,207,209,221,223,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,710,732,732,8216,8217,8220,8221,8364,8364,8482,8482,8800,8800,8804,8805,57344,57346,61441,61441,64262,64262],[13,13,32,491,506,563,567,567,601,601,697,698,700,700,710,711,728,733,768,772,774,780,783,783,785,786,795,795,803,804,806,808,814,814,817,817,821,821,960,960,7808,7813,7838,7838,7840,7929,8208,8208,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8242,8243,8249,8250,8260,8260,8274,8274,8308,8308,8353,8353,8355,8356,8358,8359,8361,8361,8363,8365,8369,8370,8373,8373,8377,8378,8380,8381,8467,8467,8470,8470,8482,8482,8486,8486,8494,8494,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9674,9674,10216,10217,63743,63743,64257,64258,65532,65533],[0,0,29,29,32,41,43,126,160,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,713,713,728,733,894,894,1025,1025,1037,1037,1040,1103,1105,1105,1117,1117,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8249,8250,8260,8260,8355,8356,8359,8359,8364,8364,8470,8470,8482,8482,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8804,8805,61441,61442,64257,64258],[0,0,10,10,13,13,32,94,96,126,160,161,169,169,173,174,177,177,180,180,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8217,8220,8222,8240,8240,8482,8482,8800,8800,8804,8805,61440,61447,64262,64262],[0,0,13,13,32,126,160,165,171,171,173,173,177,177,187,187,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8223,8249,8250,8364,8364,8482,8482,8722,8722],[0,0,10,10,13,13,32,93,95,95,97,126,160,163,165,165,169,169,173,174,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8217,8220,8221,8364,8364,8482,8482],[0,0,10,10,13,13,32,126,160,169,171,180,182,185,187,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,732,732,7838,7838,8211,8212,8216,8226,8230,8230,8240,8240,8249,8250,8260,8260,8364,8364,8482,8482,8722,8722],[32,126,160,255,258,263,268,273,278,283,286,287,302,305,313,314,317,318,321,324,327,328,336,341,344,347,350,353,356,357,362,363,366,371,376,382,402,402,536,539,710,711,728,732,937,937,960,960,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8249,8250,8355,8355,8482,8482,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9674,9674,61440,61442],[0,0,13,13,32,126,161,165,167,169,174,174,176,176,180,182,184,184,191,207,209,221,223,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,710,730,730,732,732,8216,8217,8220,8221,8226,8226,8240,8240,8364,8364,8482,8482,64256,64256],[0,0,10,10,13,13,32,91,93,95,97,125,160,161,173,173,191,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8217,8220,8221,8364,8364,61440,61457,61459,61468,64256,64256,64262,64262],[32,36,38,126,161,161,168,168,176,176,180,180,183,183,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,732,732,8211,8212,8216,8218,8220,8222,8226,8226,8240,8240,8249,8250,8260,8260,8722,8722,64257,64258],[0,0,10,10,13,13,32,126,160,169,171,180,182,185,187,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,402,402,536,539,710,711,732,732,7838,7838,8211,8212,8216,8226,8230,8230,8240,8240,8249,8250,8260,8260,8364,8364,8482,8482,8722,8722],[6,6,8,8,12,13,25,25,30,126,160,172,174,174,176,180,182,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,710,732,732,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8249,8250,8482,8482,8729,8729],[32,126,161,172,174,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8217,8220,8221,8364,8364,12288,12288,63742,63742],[32,126,160,171,173,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,768,772,775,776,778,778,780,780,807,807,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8249,8250,8260,8260,8355,8356,8359,8359,8364,8364,8470,8470,8482,8482,8706,8706,8722,8722,8725,8725,8729,8730,8747,8747,8776,8776,8804,8805,57344,57348],[0,0,13,13,32,126,161,165,177,177,181,182,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,402,402,536,539,8216,8217,8220,8221,8364,8364,8482,8482,57344,57344],[32,125,161,329,332,383,402,402,508,511,536,539,567,567,710,711,713,713,728,733,902,902,904,906,908,908,910,915,917,929,931,936,938,974,1025,1103,1105,1119,1122,1123,1138,1141,1168,1169,1241,1241,7808,7813,7838,7838,7922,7923,7936,7957,7960,7965,7968,8005,8008,8013,8016,8023,8025,8025,8027,8027,8029,8029,8031,8061,8064,8116,8118,8132,8134,8147,8150,8155,8157,8175,8179,8179,8182,8190,8208,8208,8210,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8249,8250,8252,8252,8260,8260,8304,8304,8308,8313,8317,8329,8333,8334,8364,8364,8470,8470,8482,8482,8486,8486,8531,8532,8539,8542,8710,8710,8719,8719,8721,8722,8725,8725,8734,8734,42843,42843,57914,57914,58369,58384,58386,58387,58390,58399,58834,58834,58844,58844,60321,60323,60326,60328,61124,61124,61129,61129,61131,61131,61134,61134,61145,61145,61148,61148,61883,61883,62713,62719,63168,63168,63171,63171,63199,63208,64256,64261],[32,63,65,94,97,125,160,165,171,171,176,176,182,183,187,187,191,246,248,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8211,8212,8216,8218,8220,8222,8226,8226,8230,8230,8240,8240,8249,8250,8364,8364],[32,126,160,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,768,772,775,776,778,778,780,780,807,807,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8249,8250,8260,8260,8355,8356,8359,8359,8364,8364,8470,8470,8482,8482,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8804,8805,57345,57409,64257,64258],[32,126,160,382,399,399,402,402,416,417,431,432,461,476,486,487,536,539,567,567,593,593,601,601,609,609,699,700,702,703,710,716,728,733,768,772,774,780,795,795,803,804,806,808,814,814,817,817,916,916,937,937,956,956,960,960,7692,7695,7712,7713,7716,7717,7722,7723,7734,7739,7746,7753,7770,7779,7788,7791,7808,7813,7822,7823,7826,7827,7831,7831,7838,7838,7840,7929,8192,8195,8199,8199,8208,8208,8210,8213,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8242,8243,8249,8250,8260,8260,8304,8304,8308,8313,8317,8329,8333,8334,8353,8353,8356,8356,8358,8359,8363,8364,8369,8370,8373,8373,8377,8378,8381,8381,8467,8467,8471,8471,8480,8480,8482,8482,8486,8486,8494,8494,8531,8532,8539,8542,8592,8595,8598,8601,8618,8619,8624,8627,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9608,9608,9632,9632,9650,9651,9654,9655,9660,9661,9664,9665,9670,9670,9674,9674,9686,9687,9692,9695,9754,9759,10145,10145,11035,11035,11044,11044,57600,57685,57687,57950,63171,63171,64257,64258,65281,65282,65285,65287,65290,65290,65296,65307,65311,65311,65313,65342],[0,0,13,13,32,34,39,39,44,46,48,59,63,63,65,90,97,122,161,161,191,207,209,214,216,221,224,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539],[0,0,13,13,32,32,44,122,161,161,191,207,209,214,216,221,224,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539],[0,0,13,13,33,126,160,165,167,169,171,185,187,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539],[32,126,161,165,168,169,174,175,177,177,180,180,184,184,188,221,224,239,241,253,255,255,258,273,278,283,286,287,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,350,353,356,357,362,363,366,371,376,382,536,539,710,711,713,713,728,732,8208,8208,8216,8222,8230,8230,8240,8240,8539,8542],[0,0,13,13,32,126,161,165,177,177,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8217,8220,8221,8364,8364,8482,8482,57344,57344],[13,13,32,126,160,305,308,328,330,382,399,399,402,402,416,417,431,432,452,470,473,476,486,487,490,491,506,539,554,557,560,563,567,567,601,601,697,698,700,700,710,711,728,733,768,772,774,780,783,783,785,786,795,795,803,804,806,808,814,814,817,817,821,821,937,937,960,960,7808,7813,7838,7838,7840,7929,8208,8208,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8242,8243,8249,8250,8260,8260,8274,8274,8308,8308,8353,8353,8355,8356,8358,8359,8361,8361,8363,8365,8369,8370,8373,8373,8377,8378,8380,8381,8470,8470,8482,8482,8486,8486,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9674,9674,10216,10217,63743,63743,64257,64258],[13,13,32,126,160,305,308,328,330,382,399,399,402,402,416,417,431,432,452,470,473,476,486,487,490,491,506,539,554,557,560,563,567,567,601,601,697,698,700,700,710,711,713,713,728,733,768,772,774,780,783,783,785,786,795,795,803,804,806,808,814,814,817,817,821,821,916,916,937,937,956,956,960,960,7808,7813,7838,7838,7840,7929,8208,8208,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8242,8243,8249,8250,8260,8260,8274,8274,8308,8308,8353,8353,8355,8356,8358,8359,8361,8361,8363,8365,8369,8370,8373,8373,8377,8378,8380,8381,8470,8470,8482,8482,8486,8486,8494,8494,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9674,9674,10216,10217,63743,63743,64257,64258],[13,13,32,126,160,305,308,328,330,382,399,399,402,402,416,417,431,432,452,470,473,476,486,487,490,491,506,539,554,557,560,563,567,567,601,601,697,698,700,700,710,711,728,733,768,772,774,780,783,783,785,786,795,795,803,804,806,808,814,814,817,817,821,821,7808,7813,7838,7838,7840,7929,8208,8208,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8242,8243,8249,8250,8260,8260,8274,8274,8308,8308,8353,8353,8355,8356,8358,8359,8361,8361,8363,8365,8369,8370,8373,8373,8377,8378,8380,8381,8470,8470,8482,8482,8706,8706,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9674,9674,10216,10217,63743,63743,64257,64258],[32,126,160,161,168,169,171,171,173,174,180,180,187,187,191,214,216,246,248,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,729,729,732,733,1025,1025,1028,1028,1030,1031,1037,1038,1040,1103,1105,1105,1108,1108,1110,1111,1117,1118,1168,1169,8211,8212,8216,8218,8220,8222,8230,8230,8364,8364,8381,8381,8470,8470,8482,8482,8722,8722],[0,0,10,10,13,13,32,95,97,126,160,161,173,173,191,207,209,214,216,221,224,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8217,8220,8221],[0,0,13,13,32,126,161,161,166,166,168,168,177,177,180,180,184,184,191,221,223,239,241,253,255,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,729,730,732,733,8216,8218,8220,8222,8224,8224,8260,8260,8722,8722,64257,64258],[32,126,161,165,168,171,174,176,180,180,183,184,186,187,191,246,248,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,728,733,8211,8212,8216,8218,8220,8222,8224,8224,8226,8226,8230,8230,8249,8250,8364,8364,8482,8482,8722,8722,64257,64258],[32,126,160,163,168,169,173,174,176,176,180,180,184,184,191,197,199,207,209,221,224,229,231,239,241,253,255,255,305,305,352,353,376,376,381,382,768,771,776,776,778,778,780,780,807,807,8216,8217,8220,8221,8364,8364,57344,57345],[32,126,161,167,169,171,174,182,186,207,209,214,216,221,224,239,241,246,248,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,402,402,536,539,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8249,8250,8364,8364,8482,8482],[0,0,2,2,13,13,32,126,160,383,402,402,416,417,431,432,496,496,506,511,536,539,567,567,601,601,700,700,710,711,713,713,728,733,755,755,768,769,771,771,777,777,783,783,803,803,900,906,908,908,910,929,931,974,977,978,982,982,1024,1158,1160,1299,7680,7681,7742,7743,7808,7813,7840,7929,8013,8013,8192,8203,8211,8213,8215,8222,8224,8226,8229,8230,8240,8240,8242,8243,8249,8250,8252,8252,8260,8260,8308,8308,8319,8319,8355,8356,8359,8359,8363,8364,8453,8453,8467,8467,8470,8470,8482,8482,8486,8486,8494,8494,8539,8542,8706,8706,8710,8710,8719,8719,8721,8722,8730,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9674,9674,60929,60930,63171,63171,64257,64260,65279,65279,65532,65533],[32,126,160,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,713,713,728,733,894,894,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8249,8250,8260,8260,8355,8356,8359,8359,8364,8364,8470,8470,8482,8482,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8804,8805,61441,61442,64257,64258],[0,0,13,13,32,126,161,165,177,177,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8216,8217,8220,8221,8364,8364,8482,8482],[32,126,160,174,176,176,178,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,768,771,776,776,778,778,807,807,8211,8212,8216,8218,8220,8222,8224,8224,8226,8226,8230,8230,8249,8250,8260,8260,8355,8356,8359,8359,8364,8364,8470,8470,8482,8482,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8804,8805,57345,57345],[0,0,29,29,32,126,160,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,713,713,728,733,894,894,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8249,8250,8260,8260,8355,8356,8359,8359,8364,8364,8470,8470,8482,8482,8706,8706,8710,8710,8719,8719,8721,8722,8725,8725,8729,8730,8734,8734,8747,8747,8776,8776,8804,8805,57464,57465,57472,57481,57488,57497,57600,57609,57616,57625,57632,57641,57864,57865,57872,57878],[32,37,39,95,97,122,161,161,183,183,191,207,209,214,216,221,224,239,241,246,248,253,255,263,268,275,278,283,298,299,302,303,313,314,317,318,321,324,327,328,333,333,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8211,8212,8216,8217,8226,8226,8230,8230,8722,8722],[32,126,160,163,165,166,168,169,174,174,177,181,184,185,188,275,278,299,302,305,308,318,321,328,330,333,336,382,536,539,710,711,728,733,7682,7683,7690,7691,7710,7711,7744,7745,7766,7767,7776,7777,7786,7787,7808,7813,7922,7923,8216,8217,8220,8221,8226,8226,8249,8250,8260,8260,8364,8364,8482,8482,8722,8722],[0,0,13,13,32,41,43,126,161,163,165,165,168,169,175,177,180,180,184,184,191,214,216,239,241,246,248,263,266,275,278,283,286,291,295,295,298,299,302,305,310,311,313,318,321,328,330,333,336,347,350,359,362,363,366,382,536,539,710,711,728,733,768,772,774,776,778,780,786,786,806,808,821,824,7808,7813,7922,7923,8211,8212,8216,8217,8220,8221,8240,8240,8364,8364,8482,8482,8722,8722,8776,8776],[32,41,44,59,63,90,92,92,95,95,97,122,161,163,165,165,169,169,174,174,183,183,191,214,216,246,248,263,266,275,278,283,286,291,294,295,298,299,302,305,310,311,313,318,321,328,330,333,336,347,350,359,362,363,366,382,536,539,768,772,774,776,778,780,786,786,806,808,821,824,1025,1025,1037,1037,1040,1103,1105,1105,1117,1117,7808,7813,7922,7923,8211,8212,8216,8218,8220,8222,8226,8226,8230,8230,8364,8364,8482,8482],[32,93,95,95,97,126,160,162,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,8211,8212,8216,8217,8220,8221,8230,8230,8722,8722],[0,0,29,29,32,126,160,165,167,170,173,174,178,179,191,207,209,214,216,221,223,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,894,894,8216,8218,8220,8222],[32,126,130,130,132,133,137,138,140,140,145,149,152,154,156,156,159,162,165,165,168,169,173,174,176,177,180,180,182,182,188,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,732,732,8216,8222,8226,8226,8230,8230,8240,8240,8482,8482],[32,126,160,297,299,382,402,402,508,511,536,539,567,567,710,711,728,733,789,789,956,956,7808,7813,7922,7923,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8249,8250,8260,8260,8364,8364,8482,8482,8706,8706,8722,8722,8725,8725,8730,8730,8734,8734,8776,8776,8800,8800,8804,8805,64257,64258],[32,126,160,163,168,169,173,174,176,176,180,180,184,184,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,768,771,776,776,778,778,780,780,807,807,8216,8217,8220,8221,8364,8364,57344,57345],[32,126,161,165,169,169,171,171,174,174,176,176,180,180,187,187,191,207,209,214,216,221,224,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,710,732,732,8208,8208,8216,8217,8220,8221,8364,8364],[32,126,160,172,174,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,383,402,402,536,539,710,711,728,733,916,916,937,937,956,956,960,960,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8249,8250,8260,8260,8364,8364,8471,8471,8482,8482,8486,8486,8706,8706,8710,8710,8719,8719,8721,8722,8730,8730,8734,8734,8747,8747,8776,8776,8800,8800,8804,8805,9674,9674,57344,57376,64256,64260,64262,64262],[0,0,13,13,32,126,161,163,165,165,168,169,174,176,180,180,183,184,191,214,216,221,223,239,241,246,248,253,255,299,302,329,332,383,402,402,536,539,710,711,728,733,7808,7813,8211,8211,8216,8217,8220,8221,8230,8230,8260,8260,8355,8356,8359,8359,8364,8364,8482,8482,63743,63743,64256,64262],[0,0,29,29,32,126,160,161,169,169,173,174,176,176,180,180,191,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,894,894,8482,8482,57344,57350],[32,93,95,122,161,165,167,172,174,183,185,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,402,402,536,539,710,711,730,730,732,732,956,956,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8249,8250,8364,8364,8482,8482,8722,8722],[32,126,160,383,402,402,536,539,562,563,710,711,728,733,890,890,900,902,904,906,908,908,910,929,931,974,977,978,981,982,1025,1103,1105,1119,7682,7683,7690,7691,7710,7711,7744,7745,7766,7767,7776,7777,7786,7786,7808,7813,7922,7923,8211,8213,8216,8218,8220,8222,8224,8226,8230,8230,8240,8240,8242,8243,8249,8250,8260,8260,8304,8305,8308,8334,8336,8348,8364,8364,8367,8367,8470,8470,8482,8482,8592,8596,8629,8629,8656,8660,8704,8704,8706,8707,8709,8709,8711,8713,8719,8719,8721,8722,8727,8727,8730,8730,8733,8734,8736,8736,8743,8747,8756,8756,8764,8764,8773,8773,8776,8776,8800,8801,8804,8805,8834,8836,8838,8839,8853,8853,8855,8855,8869,8869,8900,8901,9674,9674,9824,9824,9827,9827,9829,9830,57374,57374,63719,63722,64257,64258],[32,32,46,46,65,90,97,122,161,161,191,207,209,214,216,221,224,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539],[13,13,32,126,160,163,165,165,167,177,180,184,186,187,191,214,216,275,278,289,292,293,298,299,302,305,308,309,313,314,317,318,321,324,327,328,336,341,344,357,362,371,376,382,402,402,536,539,710,711,728,733,884,885,890,890,894,894,900,906,908,908,910,929,931,974,977,977,984,989,991,993,1024,1143,1146,1158,1160,1230,1232,1273,1276,1279,8192,8202,8208,8212,8214,8214,8216,8226,8230,8230,8233,8233,8239,8241,8249,8251,8253,8253,8255,8256,8260,8262,8274,8274,8276,8276,8287,8287,8353,8353,8356,8356,8358,8358,8361,8361,8363,8364,8370,8370,8482,8482,8710,8710,8730,8730,57344,57344,64256,64260],[0,0,13,13,32,126,161,161,177,177,191,207,209,221,224,239,241,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539],[32,46,48,91,93,123,125,126,160,161,191,207,209,214,216,221,224,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539],[0,0,23,23,32,59,61,61,63,125,160,163,165,165,168,169,171,171,174,176,180,180,183,184,187,187,191,214,216,246,248,263,266,283,286,291,294,295,302,307,310,311,313,314,317,318,321,328,330,347,350,382,536,539,710,711,728,733,7808,7813,7922,7923,8216,8218,8220,8222,8230,8230,8249,8250,8364,8364,8482,8482],[32,95,97,126,161,163,165,166,169,169,171,171,174,174,176,176,182,183,187,187,191,246,248,263,266,275,278,283,286,291,294,295,298,299,302,305,310,311,313,318,321,328,330,333,336,347,350,359,362,363,366,382,536,539,768,772,774,776,778,780,786,786,806,808,821,824,1025,1025,1037,1037,1040,1103,1105,1105,1117,1117,7808,7813,7922,7923,8211,8212,8216,8218,8220,8222,8224,8226,8230,8230,8249,8250,8364,8364,8470,8470,8482,8482,8722,8722],[32,126,161,163,165,165,169,169,171,171,174,174,176,176,180,180,187,187,191,221,223,239,241,246,248,253,255,255,258,263,268,273,278,283,302,303,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,382,536,539,768,771,775,776,778,778,807,807,821,821,824,824,7808,7813,7922,7923,8211,8211,8216,8218,8220,8222,8230,8230,8249,8250,8260,8260,8364,8364,8482,8482,8722,8722],[0,0,13,13,32,126,161,163,168,169,171,171,176,177,180,180,183,184,187,187,191,207,209,221,223,239,241,253,255,255,258,263,268,273,278,283,302,303,305,305,313,314,317,318,321,324,327,328,336,341,344,347,352,353,356,357,362,363,366,371,376,382,536,539,710,711,729,732,8211,8212,8216,8218,8220,8221,8226,8226,8249,8250,8260,8260,8364,8364,8722,8722]];
const TAN_FONT_GLYPH_PROFILE = {"catalog-barcelona":0,"catalog-tan-brush-6mm-pilot":1,"catalog-alaska":2,"catalog-amsterdam":3,"catalog-arizona":4,"catalog-athens":5,"catalog-atlanta":6,"catalog-basel":7,"catalog-beachfront-cn":8,"catalog-berlin":9,"catalog-bordeaux":10,"catalog-boston":11,"catalog-broadway":12,"catalog-brooklyn":13,"catalog-brussels":14,"catalog-budapest":15,"catalog-cat-north":16,"catalog-chicago":17,"catalog-copenhagen":18,"catalog-dallas":19,"catalog-detroit":20,"catalog-dublin":21,"catalog-edinburgh":22,"catalog-father":23,"catalog-frankfurt":24,"catalog-gothenburg":25,"catalog-granada":26,"catalog-helsinki":5,"catalog-illinois":27,"catalog-library":28,"catalog-lisbon":29,"catalog-london":30,"catalog-los-angeles":31,"catalog-manchester":32,"catalog-mayfair":33,"catalog-melbourne-cn":34,"catalog-monaco-cn":35,"catalog-monalisa":36,"catalog-montreal":37,"catalog-munich":38,"catalog-national-park":39,"catalog-neotokyo-cn":40,"catalog-neontrace":41,"catalog-oxford":42,"catalog-paris":5,"catalog-prague":43,"catalog-quebec":44,"catalog-riga":45,"catalog-sacramento-regular":46,"catalog-san-francisco":47,"catalog-scifi":48,"catalog-seinajoki":49,"catalog-sorrento-cn":50,"catalog-sydney":51,"catalog-tahiti":52,"catalog-trondheim":53,"catalog-turku":54,"catalog-typewriter-cn":55,"catalog-valencia":56,"catalog-vegas":57,"catalog-venice":58,"catalog-vintage":59,"catalog-waikiki-cn":60,"catalog-wildscript":61};
const tanFontSourceKey = (value) => {
  try {
    const url = new URL(String(value || ''), window.location.href);
    // A changed file/version must be audited again; never trust its label or ID.
    return url.origin + url.pathname + '?v=' + (url.searchParams.get('v') || '');
  } catch { return ''; }
};
const TAN_FONT_GLYPHS_BY_SOURCE = new Map(Object.entries(TAN_FONT_GLYPH_PROFILE).map(
  ([id, index]) => [tanFontSourceKey(TAN_FONT_PREVIEW_SOURCES[id][1]), TAN_FONT_GLYPH_RANGES[index]]
));
const tanFontHasCodePoint = (ranges, point) => {
  let low = 0, high = ranges.length / 2 - 1;
  while (low <= high) {
    const mid = (low + high) >>> 1;
    if (point < ranges[mid * 2]) high = mid - 1;
    else if (point > ranges[mid * 2 + 1]) low = mid + 1;
    else return true;
  }
  return false;
};
const tanCheckFontText = (text, font) => {
  if (!text) return { valid: true, known: true, missing: [] };
  const ranges = TAN_FONT_GLYPHS_BY_SOURCE.get(tanFontSourceKey(font?.url));
  if (!ranges) return { valid: false, known: false, missing: [] };
  const missing = [...new Set(Array.from(text).filter(character =>
    !/[\r\n\t ]/.test(character) && !tanFontHasCodePoint(ranges, character.codePointAt(0))
  ))];
  return { valid: missing.length === 0, known: true, missing };
};

const TAN_FONT_COMPATIBILITY_NOTICE = Object.freeze({
  "en": [
    "[[font]] does not support these characters: [[characters]]. Choose another font or request a custom quote.",
    "We cannot verify character support for [[font]]. Choose another font or request a custom quote."
  ],
  "fi": [
    "Fontti [[font]] ei tue näitä merkkejä: [[characters]]. Valitse toinen fontti tai pyydä tarjous omasta mallista.",
    "Fontin [[font]] merkkitukea ei voida varmistaa. Valitse toinen fontti tai pyydä tarjous omasta mallista."
  ],
  "sv": [
    "[[font]] stöder inte dessa tecken: [[characters]]. Välj ett annat typsnitt eller be om en offert för din egen design.",
    "Vi kan inte kontrollera vilka tecken [[font]] stöder. Välj ett annat typsnitt eller be om en offert för din egen design."
  ],
  "de": [
    "[[font]] unterstützt diese Zeichen nicht: [[characters]]. Wähle eine andere Schriftart oder fordere ein individuelles Angebot an.",
    "Die Zeichenunterstützung für [[font]] kann nicht überprüft werden. Wähle eine andere Schriftart oder fordere ein individuelles Angebot an."
  ],
  "fr": [
    "[[font]] ne prend pas en charge ces caractères : [[characters]]. Choisissez une autre police ou demandez un devis personnalisé.",
    "Nous ne pouvons pas vérifier les caractères pris en charge par [[font]]. Choisissez une autre police ou demandez un devis personnalisé."
  ],
  "nl": [
    "[[font]] ondersteunt deze tekens niet: [[characters]]. Kies een ander lettertype of vraag een offerte op maat aan.",
    "We kunnen de tekenondersteuning van [[font]] niet controleren. Kies een ander lettertype of vraag een offerte op maat aan."
  ],
  "da": [
    "[[font]] understøtter ikke disse tegn: [[characters]]. Vælg en anden skrifttype, eller bed om et personligt tilbud.",
    "Vi kan ikke kontrollere tegnunderstøttelsen for [[font]]. Vælg en anden skrifttype, eller bed om et personligt tilbud."
  ],
  "es": [
    "[[font]] no admite estos caracteres: [[characters]]. Elige otra fuente o solicita un presupuesto personalizado.",
    "No podemos comprobar qué caracteres admite [[font]]. Elige otra fuente o solicita un presupuesto personalizado."
  ],
  "it": [
    "[[font]] non supporta questi caratteri: [[characters]]. Scegli un altro carattere o richiedi un preventivo personalizzato.",
    "Non possiamo verificare quali caratteri supporta [[font]]. Scegli un altro carattere o richiedi un preventivo personalizzato."
  ],
  "pt-PT": [
    "[[font]] não suporta estes caracteres: [[characters]]. Escolha outro tipo de letra ou peça um orçamento personalizado.",
    "Não é possível verificar os caracteres suportados por [[font]]. Escolha outro tipo de letra ou peça um orçamento personalizado."
  ],
  "pl": [
    "Czcionka [[font]] nie obsługuje tych znaków: [[characters]]. Wybierz inną czcionkę lub poproś o indywidualną wycenę.",
    "Nie możemy sprawdzić znaków obsługiwanych przez czcionkę [[font]]. Wybierz inną czcionkę lub poproś o indywidualną wycenę."
  ],
  "cs": [
    "Písmo [[font]] nepodporuje tyto znaky: [[characters]]. Vyberte jiné písmo nebo požádejte o individuální nabídku.",
    "Nemůžeme ověřit podporu znaků písma [[font]]. Vyberte jiné písmo nebo požádejte o individuální nabídku."
  ],
  "sk": [
    "Písmo [[font]] nepodporuje tieto znaky: [[characters]]. Vyberte iné písmo alebo požiadajte o individuálnu ponuku.",
    "Podporu znakov písma [[font]] nemôžeme overiť. Vyberte iné písmo alebo požiadajte o individuálnu ponuku."
  ],
  "hu": [
    "A(z) [[font]] betűtípus nem támogatja ezeket a karaktereket: [[characters]]. Válassz másik betűtípust, vagy kérj egyedi árajánlatot.",
    "Nem tudjuk ellenőrizni a(z) [[font]] betűtípus karaktertámogatását. Válassz másik betűtípust, vagy kérj egyedi árajánlatot."
  ],
  "ro": [
    "Fontul [[font]] nu acceptă aceste caractere: [[characters]]. Alege alt font sau solicită o ofertă personalizată.",
    "Nu putem verifica ce caractere acceptă fontul [[font]]. Alege alt font sau solicită o ofertă personalizată."
  ],
  "bg": [
    "Шрифтът [[font]] не поддържа тези знаци: [[characters]]. Изберете друг шрифт или поискайте индивидуална оферта.",
    "Не можем да проверим кои знаци поддържа шрифтът [[font]]. Изберете друг шрифт или поискайте индивидуална оферта."
  ],
  "el": [
    "Η γραμματοσειρά [[font]] δεν υποστηρίζει αυτούς τους χαρακτήρες: [[characters]]. Επιλέξτε άλλη γραμματοσειρά ή ζητήστε εξατομικευμένη προσφορά.",
    "Δεν μπορούμε να επαληθεύσουμε τους χαρακτήρες που υποστηρίζει η γραμματοσειρά [[font]]. Επιλέξτε άλλη γραμματοσειρά ή ζητήστε εξατομικευμένη προσφορά."
  ],
  "et": [
    "Font [[font]] ei toeta neid märke: [[characters]]. Vali teine font või küsi personaalset hinnapakkumist.",
    "Me ei saa kontrollida fondi [[font]] märgituge. Vali teine font või küsi personaalset hinnapakkumist."
  ],
  "hr": [
    "Font [[font]] ne podržava ove znakove: [[characters]]. Odaberite drugi font ili zatražite prilagođenu ponudu.",
    "Ne možemo provjeriti koje znakove podržava font [[font]]. Odaberite drugi font ili zatražite prilagođenu ponudu."
  ],
  "lt": [
    "Šriftas [[font]] nepalaiko šių simbolių: [[characters]]. Pasirinkite kitą šriftą arba paprašykite individualaus pasiūlymo.",
    "Negalime patikrinti, kokius simbolius palaiko šriftas [[font]]. Pasirinkite kitą šriftą arba paprašykite individualaus pasiūlymo."
  ],
  "sl": [
    "Pisava [[font]] ne podpira teh znakov: [[characters]]. Izberite drugo pisavo ali zahtevajte ponudbo po meri.",
    "Ne moremo preveriti, katere znake podpira pisava [[font]]. Izberite drugo pisavo ali zahtevajte ponudbo po meri."
  ]
});

// Emoji sequences cannot be manufactured by the sign fonts. Keep ordinary
// numbers, punctuation and international scripts intact; symbols use the icon picker.
const TAN_FONT_LOCALE_CHARACTERS = Object.freeze({"en":"abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ","fi":"abcdefghijklmnopqrsštuvwxyzžåäöABCDEFGHIJKLMNOPQRSŠTUVWXYZŽÅÄÖ","sv":"aàbcdeéfghijklmnopqrstuvwxyzåäöAÀBCDEÉFGHIJKLMNOPQRSTUVWXYZÅÄÖ","de":"aäbcdefghijklmnoöpqrsßtuüvwxyzAÄBCDEFGHIJKLMNOÖPQRSTUÜVWXYZ","fr":"aàâæbcçdeéèêëfghiîïjklmnoôœpqrstuùûüvwxyÿzAÀÂÆBCÇDEÉÈÊËFGHIÎÏJKLMNOÔŒPQRSTUÙÛÜVWXYŸZ","nl":"aáäbcdeéëfghiíïj́klmnoóöpqrstuúüvwxyzAÁÄBCDEÉËFGHIÍÏJKLMNOÓÖPQRSTUÚÜVWXYZ","da":"abcdefghijklmnopqrstuvwxyzæøåABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ","es":"aábcdeéfghiíjklmnñoópqrstuúüvwxyzAÁBCDEÉFGHIÍJKLMNÑOÓPQRSTUÚÜVWXYZ","it":"aàbcdeéèfghiìjklmnoòpqrstuùvwxyzAÀBCDEÉÈFGHIÌJKLMNOÒPQRSTUÙVWXYZ","pt":"aáàâãbcçdeéêfghiíjklmnoóòôõpqrstuúvwxyzAÁÀÂÃBCÇDEÉÊFGHIÍJKLMNOÓÒÔÕPQRSTUÚVWXYZ","pl":"aąbcćdeęfghijklłmnńoóprsśtuwyzźżAĄBCĆDEĘFGHIJKLŁMNŃOÓPRSŚTUWYZŹŻ","cs":"aábcčdďeéěfghiíjklmnňoópqrřsštťuúůvwxyýzžAÁBCČDĎEÉĚFGHIÍJKLMNŇOÓPQRŘSŠTŤUÚŮVWXYÝZŽ","sk":"aáäbcčdďzžeéfghiíjklĺľmnňoóôpqrŕsštťuúvwxyýAÁÄBCČDĎZŽEÉFGHIÍJKLĹĽMNŇOÓÔPQRŔSŠTŤUÚVWXYÝ","hu":"aábcsdzeéfgyhiíjklmnoóöőprtuúüűvAÁBCSDZEÉFGYHIÍJKLMNOÓÖŐPRTUÚÜŰV","ro":"aăâbcdefghiîjklmnopqrsștțuvwxyzAĂÂBCDEFGHIÎJKLMNOPQRSȘTȚUVWXYZ","bg":"абвгдежзийклмнопрстуфхцчшщъьюяАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЬЮЯ","el":"αάβγδεέζηήθιίϊΐκλμνξοόπρσςτυύϋΰφχψωώΑΆΒΓΔΕΈΖΗΉΘΙΊΪ́ΚΛΜΝΞΟΌΠΡΣΤΥΎΫΦΧΨΩΏ","et":"abcdefghijklmnopqrsšzžtuvwõäöüxyABCDEFGHIJKLMNOPQRSŠZŽTUVWÕÄÖÜXY","hr":"abcčćdžđefghijklmnoprsštuvzABCČĆDŽĐEFGHIJKLMNOPRSŠTUVZ","lt":"aąbcčdeęėfghiįyjklmnoprsštuųūvzžAĄBCČDEĘĖFGHIĮYJKLMNOPRSŠTUŲŪVZŽ","sl":"abcčdefghijklmnoprsštuvzžABCČDEFGHIJKLMNOPRSŠTUVZŽ"});

function tanOrderFontsForLocale(fonts, locale) {
  const language = String(locale || '').trim().replace(/_/g, '-').toLowerCase().split('-')[0];
  const sample = TAN_FONT_LOCALE_CHARACTERS[language];
  if (!sample) return fonts;
  return fonts.map((font, index) => {
    const support = tanCheckFontText(sample, font);
    return {font, index, missing: support.known ? support.missing.length : Infinity};
  }).sort((left, right) => left.missing - right.missing || left.index - right.index)
    .map(entry => entry.font);
}

function tanDefaultFontForLocale(fonts, locale) {
  const preferred = fonts.find(font => String(font.id || '') === 'catalog-barcelona' ||
    String(font.label || '').trim().toLowerCase() === 'barcelona') || fonts[0];
  if (!preferred) return preferred;
  const language = String(locale || '').trim().replace(/_/g, '-').toLowerCase().split('-')[0];
  const sample = TAN_FONT_LOCALE_CHARACTERS[language];
  if (!sample) return preferred;
  const support = tanCheckFontText(sample, preferred);
  if (support.known && support.missing.length === 0) return preferred;
  return tanOrderFontsForLocale(fonts, locale)[0] || preferred;
}

const TAN_TEXT_EMOJI_PATTERN = /[#*0-9]\uFE0F?\u20E3|[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\u2661\u2765-\u2767](?:[\uFE0E\uFE0F]|\p{Emoji_Modifier}|[\u{E0020}-\u{E007F}])*(?:\u200D[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}](?:[\uFE0E\uFE0F]|\p{Emoji_Modifier}|[\u{E0020}-\u{E007F}])*)*|[\u20E3\uFE0F]/gu;
const tanRemoveTextEmojis = (value) => String(value || '').replace(
  TAN_TEXT_EMOJI_PATTERN,
  (sequence) => /^[©®™‼⁉]\uFE0E?$/u.test(sequence) ? sequence : ''
);
const TAN_TEXT_EMOJI_NOTICE = Object.freeze({
  "en": "Emojis are not supported in sign text. Please choose a symbol from the icon menu below.",
  "fi": "Emojeja ei voi käyttää kyltin tekstissä. Valitse symboli alla olevasta kuvakevalikosta.",
  "sv": "Emojier stöds inte i skyltens text. Välj en symbol från ikonmenyn nedan.",
  "de": "Emojis werden im Schildtext nicht unterstützt. Bitte wähle ein Symbol aus dem Symbolmenü unten.",
  "fr": "Les emojis ne sont pas pris en charge dans le texte de l’enseigne. Choisissez un symbole dans le menu d’icônes ci-dessous.",
  "nl": "Emoji’s worden niet ondersteund in de tekst op je bord. Kies een symbool uit het pictogrammenmenu hieronder.",
  "da": "Emojis kan ikke bruges i skiltets tekst. Vælg et symbol i ikonmenuen nedenfor.",
  "es": "El texto del letrero no admite emojis. Elige un símbolo del menú de iconos de abajo.",
  "it": "Le emoji non sono supportate nel testo dell’insegna. Scegli un simbolo dal menu delle icone qui sotto.",
  "pt-PT": "Não é possível usar emojis no texto do letreiro. Escolha um símbolo no menu de ícones abaixo.",
  "pl": "Emoji nie są obsługiwane w tekście neonu. Wybierz symbol z menu ikon poniżej.",
  "cs": "Text neonového nápisu nepodporuje emoji. Vyberte symbol z nabídky ikon níže.",
  "sk": "Emoji nie sú v texte nápisu podporované. Vyberte si symbol z ponuky ikon nižšie.",
  "hu": "A felirat szövegében nem használhatók emojik. Válassz egy szimbólumot az alábbi ikonmenüből.",
  "ro": "Emojiurile nu sunt acceptate în textul semnului luminos. Alege un simbol din meniul de pictograme de mai jos.",
  "bg": "Емоджита не се поддържат в текста на табелата. Изберете символ от менюто с икони по-долу.",
  "el": "Δεν υποστηρίζονται emoji στο κείμενο της επιγραφής. Επιλέξτε ένα σύμβολο από το παρακάτω μενού εικονιδίων.",
  "et": "Emodžisid ei saa sildi tekstis kasutada. Vali sümbol allolevast ikoonimenüüst.",
  "hr": "U tekstu natpisa nije moguće koristiti emojije. Odaberite simbol iz izbornika ikona u nastavku.",
  "lt": "Iškabos tekste negalima naudoti jaustukų. Pasirinkite simbolį iš žemiau esančio piktogramų meniu.",
  "sl": "Emodžiji v besedilu napisa niso podprti. Izberite simbol iz spodnjega menija ikon."
});

const TAN_ICON_PICKER_PROMPT = Object.freeze({
  "en": "Choose an icon",
  "fi": "Valitse kuvake",
  "sv": "Välj en ikon",
  "de": "Symbol auswählen",
  "fr": "Choisir une icône",
  "nl": "Kies een pictogram",
  "da": "Vælg et ikon",
  "es": "Elige un icono",
  "it": "Scegli un’icona",
  "pt-PT": "Escolher um ícone",
  "pl": "Wybierz ikonę",
  "cs": "Vyberte ikonu",
  "sk": "Vyberte ikonu",
  "hu": "Válassz egy ikont",
  "ro": "Alege o pictogramă",
  "bg": "Изберете икона",
  "el": "Επιλέξτε εικονίδιο",
  "et": "Vali ikoon",
  "hr": "Odaberite ikonu",
  "lt": "Pasirinkite piktogramą",
  "sl": "Izberite ikono"
});

const TAN_PRICING_ENGINE = window.TanNeonPricing;
const TAN_ICON_CATALOG = Array.isArray(window.TanNeonIconCatalog)
  ? window.TanNeonIconCatalog
  : [];
const TAN_MOBILE_VIEWPORT = window.matchMedia(
  '(max-width: 749px), ' +
    '(hover: none) and (pointer: coarse) and (max-width: 1099px) and (orientation: landscape) and (max-height: 600px)'
);
const TAN_MOBILE_BACKGROUND_VIEWPORT = window.matchMedia(
  '(max-width: 749px) and (orientation: portrait)'
);
const TAN_SINGLE_COLUMN_VIEWPORT = window.matchMedia(
  '(max-width: 749px), (hover: none) and (pointer: coarse) and (max-width: 1099px)'
);
const TAN_NARROW_DESKTOP_VIEWPORT = window.matchMedia(
  '(hover: hover) and (pointer: fine) and (max-width: 1099px)'
);
const TAN_FINE_POINTER_VIEWPORT = window.matchMedia(
  '(hover: hover) and (pointer: fine)'
);
const TAN_PAGE_WRAPPER_SCROLL = window.matchMedia(
  '(min-width: 990px), (hover: hover) and (pointer: fine)'
);
const TAN_FONT_DISPLAY_ORDER = [
  'barcelona',
  'madrid',
  'lisbon',
  'amsterdam',
  'sorrento',
  'berlin',
  'copenhagen',
  'brussels',
  'helsinki',
  'rotterdam',
  'paris',
  'manchester',
  'sanfrancisco',
  'montreal',
  'munich',
  'wolfscript',
  'sacramento',
  'london',
  'sydney',
  'budapest',
  'frankfurt',
  'gothenburg',
  'losangeles',
  'granada',
  'prague',
  'beachfront',
  'monalisa',
  'athens',
  'waikiki',
  'quebec',
  'neotokyo',
  'monaco',
  'basel',
  'valencia',
  'edinburgh',
  'vegas',
  'typewriter',
  'seinajoki',
  'detroit',
  'neontrace',
  'melbourne',
  'brooklyn',
  'alaska',
  'bordeaux',
  'venice',
  'trondheim',
  'dublin',
  'oxford',
  'broadway',
  'tahiti',
  'boston',
  'dallas',
  'arizona',
  'atlanta',
  'father',
  'scifi',
  'chicago',
  'mayfair',
  'turku',
  'library',
  'nationalpark',
  'catnorth',
  'riga',
  'illinois',
];
const TAN_ICON_DISPLAY_ORDER = [
  'king',
  'diamond',
  'ringsmark',
  'classicheart',
  'forkknife',
  'funkystar',
  'linkedhearts',
  'scissorsmark',
  'wavemark',
  'coffeebean',
  'heart3',
  'winemark',
  'star',
  'cocktailmark',
  'softheart2',
  'bulbmark',
  'champagnemark',
  'heart',
  'bagmark',
  'micmark',
  'pawheart',
  'cartmark',
  'flowermark',
  'heart2',
  'music',
  'infinitymark',
  'loveheart',
  'peacemark',
  'leafmark',
  'heartmark',
  'clovermark',
  'sunmark',
  'heartline',
  'searchmark',
  'moonmark',
  'softheart',
  'notemark',
  'flamemark',
  'heartglow',
  'music2',
  'smilemark3',
  'shineheart',
  'trophymark',
  'smilemark',
  'lovemark',
  'tennisball',
  'funkystar3',
  'lovepure',
  'signalmark',
  'dnamark',
  'lovemark3',
  'femalemark',
  'malemark',
  'heartmark3',
  'chatmark',
  'mailmark',
  'heartmark4',
  'lettermark',
  'paperplane',
  'heart5',
  'paperplane3',
  'eyemark',
  'heartwave',
  'bookmark',
  'dollarmark',
  'lovepulse',
  'euromark',
  'bowmark',
  'heartribbon',
  'swirlmark',
  'keytolove',
  'cloudmark',
  'lovetag',
  'softcloud',
  'whiskerheart',
  'leafmark3',
  'swirlline',
  'ribbonmark',
  'swirlline2',
  'lightningmark',
  'thunderbolt',
  'thundericon',
  'zapmark',
  'arrow',
  'arrowswitch',
  'arrowup',
  'checkmark',
  'plusmark',
  'exclaimmark',
  'questionmark',
  'wowmarks',
  'circlemark',
  'squaremark',
  'trianglemark',
  'spademark',
  'butterflymark',
  'bombmark',
  'skullmark',
  'butterfly',
  'alienmark',
  'popsiclemark',
  'poopmark',
];
const TAN_ICON_DISPLAY_ORDER_INDEX = new Map(
  TAN_ICON_DISPLAY_ORDER.map((id, index) => [id, index])
);

const normalizedEquipmentValue = (value) =>
  String(value || '').trim().toLocaleLowerCase('en');

/*
 * Preview-only optical tube calibration. Each value is the median visible
 * stroke width, expressed in em, measured from the shipped WOFF2 face at high
 * resolution. The manufactured icon tube remains 6 mm; this table only keeps
 * the centreline SVG from looking like a hairline beside a heavier font.
 */
const TAN_FONT_ICON_STROKE_EM = Object.freeze({
  'catalog-barcelona': 0.02912,
  'catalog-tan-brush-6mm-pilot': 0.02822,
  'catalog-alaska': 0.03194,
  'catalog-amsterdam': 0.03252,
  'catalog-arizona': 0.03121,
  'catalog-athens': 0.03189,
  'catalog-atlanta': 0.03054,
  'catalog-basel': 0.02996,
  'catalog-beachfront-cn': 0.02851,
  'catalog-berlin': 0.02979,
  'catalog-bordeaux': 0.03367,
  'catalog-boston': 0.03092,
  'catalog-broadway': 0.034,
  'catalog-brooklyn': 0.0306,
  'catalog-brussels': 0.02983,
  'catalog-budapest': 0.02988,
  'catalog-cat-north': 0.03164,
  'catalog-chicago': 0.03149,
  'catalog-copenhagen': 0.03081,
  'catalog-dallas': 0.03139,
  'catalog-detroit': 0.03088,
  'catalog-dublin': 0.03046,
  'catalog-edinburgh': 0.03074,
  'catalog-father': 0.03329,
  'catalog-frankfurt': 0.02946,
  'catalog-gothenburg': 0.02962,
  'catalog-granada': 0.02846,
  'catalog-helsinki': 0.03093,
  'catalog-illinois': 0.02705,
  'catalog-library': 0.03021,
  'catalog-lisbon': 0.0285,
  'catalog-london': 0.02906,
  'catalog-los-angeles': 0.02808,
  'catalog-manchester': 0.04096,
  'catalog-mayfair': 0.03146,
  'catalog-melbourne-cn': 0.02967,
  'catalog-monaco-cn': 0.03135,
  'catalog-monalisa': 0.03031,
  'catalog-montreal': 0.0294,
  'catalog-munich': 0.03046,
  'catalog-national-park': 0.02944,
  'catalog-neotokyo-cn': 0.02919,
  'catalog-neontrace': 0.03093,
  'catalog-oxford': 0.03269,
  'catalog-paris': 0.02999,
  'catalog-prague': 0.03045,
  'catalog-quebec': 0.03108,
  'catalog-riga': 0.03143,
  'catalog-sacramento-regular': 0.02919,
  'catalog-san-francisco': 0.02999,
  'catalog-scifi': 0.0308,
  'catalog-seinajoki': 0.03057,
  'catalog-sorrento-cn': 0.02899,
  'catalog-sydney': 0.02992,
  'catalog-tahiti': 0.03161,
  'catalog-trondheim': 0.03305,
  'catalog-turku': 0.03115,
  'catalog-typewriter-cn': 0.03125,
  'catalog-valencia': 0.03244,
  'catalog-vegas': 0.0312,
  'catalog-venice': 0.03448,
  'catalog-vintage': 0.02957,
  'catalog-waikiki-cn': 0.031,
  'catalog-wildscript': 0.03027,
});

/**
 * Match the icon's solid SVG stroke to the selected font without touching the
 * approved CorelDRAW text glow. The cap is intentionally tighter for complex
 * icons so intersections remain open instead of turning into blobs.
 *
 * @param {{fontSize: number, strokeEm?: number, iconWidth: number, iconHeight: number, tier?: string, opticalScale?: number}} input
 */
const tanResolveFontMatchedIconTubePixels = (input) => {
  const positive = (value, fallback) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : fallback;
  };
  const clamp = (value, minimum, maximum) =>
    Math.max(minimum, Math.min(maximum, Number(value) || 0));
  const fontSize = positive(input?.fontSize, 16);
  const strokeEm = clamp(positive(input?.strokeEm, 0.0306), 0.008, 0.12);
  const opticalScale = clamp(positive(input?.opticalScale, 1.1), 0.8, 1.25);
  const iconMinorSize = Math.min(
    positive(input?.iconWidth, fontSize),
    positive(input?.iconHeight, fontSize)
  );
  const tier = String(input?.tier || 'standard');
  const capFraction =
    {
      simple: 0.12,
      standard: 0.1,
      detailed: 0.075,
      complex: 0.055,
    }[tier] || 0.1;
  const previewOpticalWeight =
    {
      simple: 1.42,
      standard: 1.35,
      detailed: 1.2,
      complex: 1.1,
    }[tier] || 1.35;
  const minimumReadable = Math.max(0.75, fontSize * 0.008);
  const maximumSafe = Math.max(
    minimumReadable,
    Math.min(16, iconMinorSize * capFraction)
  );

  return clamp(
    fontSize * strokeEm * opticalScale * previewOpticalWeight,
    minimumReadable,
    maximumSafe
  );
};
const tanIconVectorCatalogPromises = new Map();

/**
 * Convert wheel deltas to CSS pixels. Windows mice commonly report lines,
 * while trackpads generally report pixels and some accessibility devices use
 * pages. Keeping the conversion here makes picker scrolling deterministic.
 * @param {{deltaY?: number, deltaMode?: number}} event
 * @param {number} pageSize
 */
const tanWheelDeltaPixels = (event, pageSize) => {
  const delta = Number(event?.deltaY) || 0;
  if (event?.deltaMode === 1) return delta * 18;
  if (event?.deltaMode === 2) return delta * Math.max(1, Number(pageSize) || 1);
  return delta;
};

/**
 * Consume as much of a vertical wheel delta as one scroller can use and pass
 * the remainder to its parent. This avoids the dead wheel zone that Windows
 * creates over font/icon cards and preserves momentum at list boundaries.
 * @param {number} start
 * @param {number} maximum
 * @param {number} delta
 */
const tanConsumeWheelDelta = (start, maximum, delta) => {
  const safeStart = Math.min(Math.max(0, Number(start) || 0), Math.max(0, Number(maximum) || 0));
  const safeMaximum = Math.max(0, Number(maximum) || 0);
  const safeDelta = Number(delta) || 0;
  const next = Math.min(safeMaximum, Math.max(0, safeStart + safeDelta));
  const consumed = next - safeStart;
  return {
    next,
    consumed,
    remaining: safeDelta - consumed,
  };
};

/**
 * Keep the native range minimum stable while an icon is being dragged.
 * Production sizing independently raises the finished sign whenever the
 * physical icon would fall below its minimum height, so this UI floor must
 * never ratchet upward from the scale value it is currently measuring.
 *
 * @param {{hasIcon?: boolean, iconId?: string, previousIconId?: string, previousFloor?: number, candidateFloor?: number, defaultFloor?: number}} input
 */
const tanResolveStableIconScaleFloor = (input) => {
  const normalize = (value, fallback) => {
    const numeric = Number(value);
    const safe = Number.isFinite(numeric) ? numeric : fallback;
    return Math.round(Math.max(70, Math.min(160, safe)) / 5) * 5;
  };
  if (!input?.hasIcon) return 70;

  const iconId = String(input.iconId || '');
  const candidateFloor = normalize(input.candidateFloor, 70);
  const defaultFloor = normalize(input.defaultFloor, 100);
  const startingFloor = Math.min(defaultFloor, candidateFloor);
  if (!iconId || String(input.previousIconId || '') !== iconId) {
    return startingFloor;
  }

  return Math.min(
    normalize(input.previousFloor, startingFloor),
    candidateFloor
  );
};

/**
 * Keep a stable optical font size while the customer's wording grows. The
 * reference box defines the normal display size; the current design is only
 * reduced when its real ink would exceed the available artboard.
 *
 * @param {{referenceWidth: number, referenceHeight: number, currentWidth: number, currentHeight: number, referenceSafeWidth: number, referenceSafeHeight: number, overflowWidth: number, overflowHeight: number, baseFontSize?: number, maximumFontSize?: number, headroom?: number}} input
 */
const tanResolveStablePreviewSize = (input) => {
  const positive = (value, fallback = 1) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : fallback;
  };
  const baseFontSize = positive(input?.baseFontSize, 100);
  const maximumFontSize = positive(input?.maximumFontSize, 320);
  const headroom = Math.min(1, Math.max(0.5, positive(input?.headroom, 0.92)));
  const referenceSize =
    Math.min(
      maximumFontSize,
      (positive(input?.referenceSafeWidth) / positive(input?.referenceWidth)) * baseFontSize,
      (positive(input?.referenceSafeHeight) / positive(input?.referenceHeight)) * baseFontSize
    ) * headroom;
  const overflowWidthSize =
    (positive(input?.overflowWidth) / positive(input?.currentWidth)) * baseFontSize;
  const overflowHeightSize =
    (positive(input?.overflowHeight) / positive(input?.currentHeight)) * baseFontSize;

  return Math.max(
    0.1,
    Math.min(referenceSize, overflowWidthSize, overflowHeightSize)
  );
};

const tanResolveProductionWidth = (input) => {
  const positive = (value, fallback = 1) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : fallback;
  };
  const naturalWidth = positive(input?.naturalWidth);
  const naturalHeight = positive(input?.naturalHeight);
  const maximumWidth = positive(input?.maximumWidth, 240);
  const maximumHeight = positive(input?.maximumHeight, 120);
  const minimumWidth = Math.min(
    maximumWidth,
    positive(input?.minimumWidth, 1)
  );
  const maximumWidthForHeight = Math.floor(
    (maximumHeight * naturalWidth) / naturalHeight
  );
  const effectiveMaximumWidth = Math.max(
    minimumWidth,
    Math.min(maximumWidth, maximumWidthForHeight)
  );
  const targetWidth = positive(input?.requestedWidth, minimumWidth);

  return Math.max(
    minimumWidth,
    Math.min(effectiveMaximumWidth, Math.round(targetWidth))
  );
};

class TanNeonDesigner extends HTMLElement {
  /** @type {Record<string, string>} */
  #copy = {};

  /** @type {AbortController} */
  #abortController = new AbortController();

  /** @type {CanvasRenderingContext2D | null} */
  #measureContext = null;
  #previewTextMetrics = null;

  /** @type {Array<Record<string, any>>} */
  #fonts = [];

  /** @type {Array<Record<string, any>>} */
  #icons = [];

  /** @type {string} */
  #selectedIconId = '';

  /** @type {'left' | 'between' | 'right'} */
  #iconPosition = 'right';

  /**
   * Icon insertion slot in the text flow. -1 keeps the icon anchored after
   * the final character while the customer edits the text.
   * @type {number}
   */
  #iconPlacement = -1;

  /** @type {number} */
  #iconScale = 100;

  /** @type {number} */
  #iconScaleFloor = 70;

  /** @type {string} */
  #iconScaleFloorIconId = '';

  /** @type {string} */
  #iconColorId = '';

  /** @type {boolean} */
  #iconColorActive = false;

  /** @type {Array<{id: string, price: number}>} */
  #feeVariants = [];

  /** @type {Set<string>} */
  #loadedFeeUrls = new Set();

  /** @type {Set<string>} */
  #failedFeeUrls = new Set();

  /** @type {Map<string, Promise<void>>} */
  #feeLoadPromises = new Map();

  /** @type {Map<string, Promise<boolean>>} */
  #fontLoadPromises = new Map();

  /** @type {Map<string, Promise<SVGElement | null>>} */
  #iconSvgPromises = new Map();

  /** @type {Promise<Record<string, string>> | null} */
  #iconVectorCatalogPromise = null;

  /** @type {Set<string>} */
  #fontReadyFamilies = new Set();

  /** @type {Set<string>} */
  #fontFailedFamilies = new Set();

  /** @type {Map<string, FontFace>} */
  #fontFaces = new Map();

  /** @type {IntersectionObserver | null} */
  #fontOptionObserver = null;

  /** @type {Promise<void> | null} */
  #fontPickerPromise = null;
  #fontGridReady = false;
  #fontPreviewPaths = null;
  #fontPreviewPromise = null;
  #iconOptionObserver = null;
  #fontTriggerFitKey = '';

  #fontPickerWarmupStarted = false;

  /** @type {Array<{option: HTMLButtonElement, generation: number}>} */
  #fontOptionQueue = [];

  /** @type {Set<HTMLButtonElement>} */
  #queuedFontOptions = new Set();

  /** @type {number} */
  #activeFontOptionLoads = 0;

  /** @type {number} */
  #fontOptionQueueGeneration = 0;

  /** @type {string} */
  #fontGridFitSignature = '';

  /** @type {string} */
  #renderedFontId = '';

  /** @type {string} */
  #syncedFontPickerId = '';

  /** @type {string} */
  #syncedIconPickerSignature = '';

  /** @type {string} */
  #syncedIconSelectionId = '';

  /** @type {boolean} */
  #iconGridReady = false;

  /** @type {'width' | 'height'} */
  #sizeDriver = 'width';

  /** @type {number | null} */
  #requestedHeight = null;

  /** @type {number | null} */
  #requestedWidth = null;

  #customerSelectedSize = false;

  #automaticSizeInitialized = false;

  /**
   * The app is the authority for the final production geometry. Retaining the
   * resolved size here keeps later visual-only rerenders from falling back to
   * a lower browser font metric.
   * @type {{widthCm: number, heightCm: number, minimumWidthCm: number, geometryKey: string} | null}
   */
  #authoritativeSize = null;

  /** @type {boolean} */
  #suppressNextDesignerChange = false;

  /** @type {'idle' | 'pending' | 'ready' | 'error'} */
  #exactQuoteStatus = 'idle';

  /** @type {string} */
  #exactQuoteDesignSignature = '';

  /** @type {'cm' | 'in'} */
  #measurementUnit = 'cm';

  /** @type {Map<string, {key: string, title: string, images: Array<Record<string, any>>}>} */
  #exampleLibrary = new Map();

  /** @type {string} */
  #exampleKey = '';

  /** @type {number} */
  #exampleIndex = 0;

  /** @type {HTMLElement | null} */
  #exampleOpener = null;

  /** @type {number} */
  #exampleRenderToken = 0;

  /** @type {number | null} */
  #examplePointerStart = null;

  /** @type {Array<string>} */
  #characterColors = [];

  /** @type {string} */
  #characterUiSignature = '';

  /** @type {number} */
  #activeCharacterIndex = 0;

  /** @type {Array<Record<string, string>> | null} */
  #colorDescriptorsCache = null;

  /** @type {Map<string, Record<string, string>> | null} */
  #colorDescriptorMap = null;

  /** @type {Intl.NumberFormat | null} */
  #currencyFormatter = null;

  /** @type {number | null} */
  #currencyMinorUnitValue = null;

  /** @type {Intl.Segmenter | null} */
  #graphemeSegmenter = null;

  /** @type {string} */
  #graphemeCacheSource = '';

  /** @type {Array<string>} */
  #graphemeCache = [];

  /** @type {{x: number, y: number}} */
  #previewOffset = { x: 0, y: 0 };

  /** @type {{pointerId: number, pointerType: string, clientX: number, clientY: number, latestClientX: number, latestClientY: number, committedClientX: number, committedClientY: number, x: number, y: number, initialOffset: {x: number, y: number}, target: HTMLElement, bounds: {zoom: number, left: number, right: number, up: number, down: number}, moved: boolean, scrollGesture: boolean, tapEligible: boolean, characterIndex: number | null} | null} */
  #previewDrag = null;

  /** @type {number} */
  #previewDragFrame = 0;

  /** @type {number} */
  #previewLayoutFrame = 0;

  /** @type {number} */
  #previewLayoutTimer = 0;

  /** @type {number} */
  #zoom = 0.7;

  /** @type {number} */
  #backgroundIndex = 0;

  /** @type {Array<{id: string, label: string, src: string, mobileSrc?: string, thumbnail?: string}>} */
  #backgrounds = [];

  /** @type {string} */
  #selectedBackgroundId = '';

  /** @type {number} */
  #backgroundRequest = 0;

  /** @type {number} */
  #renderFrame = 0;

  /** @type {boolean} */
  #isComposingText = false;

  #emojiTextNotice = false;
  #fontCompatibility = { valid: true, known: true, missing: [] };
  #fontCompatibilityMessage = '';

  /** @type {Record<string, any>} */
  #designState = {};

  /** @type {'standard' | 'rgb'} */
  #controllerLockMode = 'standard';

  /** @type {string} */
  #previousRemoteValue = 'Yes, included';

  /** @type {boolean} */
  #mountingOutdoorLocked = false;

  /** @type {string} */
  #previousMountingValue = 'Wall mount kit';

  /** @type {boolean} */
  #reviewTracked = false;

  /** @type {boolean} */
  #focusEditorAfterPopstate = false;

  /** @type {number} */
  #mobileViewportFrame = 0;

  /** @type {number} */
  #mobileAlignmentFrame = 0;

  /** @type {number} */
  #mobileAlignmentTimer = 0;

  /** @type {number} */
  #mobileKeyboardRestoreTimer = 0;

  /** @type {boolean} */
  #mobileKeyboardRestorePending = false;

  /** @type {number} */
  #mobileTextFocusUntil = 0;

  /** @type {{pointerId: number, clientX: number, clientY: number, moved: boolean} | null} */
  #textPointerGesture = null;

  /** @type {string} */
  #addButtonIdleLabel = '';

  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  #renderedStageSize = '';

  /** @type {number} */
  #responsiveFontFrame = 0;

  /** @type {number} */
  #viewportResizeTimer = 0;

  /** @type {number} */
  #pageScrollSettleTimer = 0;

  /** @type {boolean} */
  #fontPickerSuspendedForResize = false;

  /**
   * Commit production dimensions returned by the app without treating them as
   * a customer slider choice. The following synchronous update is deliberately
   * silent so the bridge cannot quote its own authoritative response again.
   *
   * @param {{widthCm?: unknown, heightCm?: unknown, minimumWidthCm?: unknown, width?: unknown, height?: unknown, minimumWidth?: unknown}} resolvedSize
   * @param {string | number=} expectedRevision
   * @returns {boolean}
   */
  commitAuthoritativeSize(resolvedSize, expectedRevision) {
    const widthCm = Math.round(
      Number(resolvedSize?.widthCm ?? resolvedSize?.width)
    );
    const heightCm = Math.round(
      Number(resolvedSize?.heightCm ?? resolvedSize?.height)
    );
    const minimumWidthCm = Math.round(
      Number(resolvedSize?.minimumWidthCm ?? resolvedSize?.minimumWidth)
    );
    const maxWidth = this.#numberData('maxWidth', 240);
    const maxHeight = this.#numberData('maxHeight', 120);
    if (
      !Number.isFinite(widthCm) ||
      !Number.isFinite(heightCm) ||
      !Number.isFinite(minimumWidthCm) ||
      widthCm < 1 ||
      widthCm > maxWidth ||
      heightCm < 1 ||
      heightCm > maxHeight ||
      minimumWidthCm < 1 ||
      minimumWidthCm > widthCm
    ) {
      return false;
    }

    const hadPendingUpdate = Boolean(this.#renderFrame);
    const revisionBeforeFlush = String(this.dataset.designRevision || '');
    if (hadPendingUpdate) {
      // A queued customer edit must complete as a normal update and publish its
      // own change event before an older quote is considered. Never let the
      // authoritative-response suppression consume that edit.
      this.#suppressNextDesignerChange = false;
      this.#flushPendingUpdate();
      if (String(this.dataset.designRevision || '') === revisionBeforeFlush) {
        return false;
      }
    }
    const hasExpectedRevision =
      expectedRevision !== undefined && expectedRevision !== null;
    if (
      (!hasExpectedRevision && hadPendingUpdate) ||
      (hasExpectedRevision &&
        String(this.dataset.designRevision || '') !== String(expectedRevision))
    ) return false;

    const textInput = this.querySelector('[data-text-input]');
    const text =
      textInput instanceof HTMLTextAreaElement
        ? textInput.value.trim()
        : String(this.#designState.text || '');
    const geometryKey = this.#measurementGeometryKey(
      text || this.#t('text_entry.placeholder', {}, 'Your Text'),
      this.#getSelectedFont()
    );
    const unchanged =
      Number(this.#designState.width) === widthCm &&
      Number(this.#designState.height) === heightCm &&
      Number(this.#designState.minimumWidth) >= minimumWidthCm;

    this.#authoritativeSize = {
      widthCm,
      heightCm,
      minimumWidthCm,
      geometryKey,
    };
    this.#requestedWidth = widthCm;
    this.#requestedHeight = heightCm;
    this.#automaticSizeInitialized = true;
    if (unchanged) return true;

    this.#suppressNextDesignerChange = true;
    this.#update();
    return true;
  }

  /**
   * Let the app publish the lifecycle of the exact server quote. The status is
   * tied to the current design signature, so a later customer change cannot
   * accidentally reuse an older ready result.
   *
   * @param {'pending' | 'ready' | 'error' | 'idle'} status
   * @returns {boolean}
   */
  setExactQuoteStatus(status) {
    const normalized = String(status || '').toLowerCase();
    if (!['pending', 'ready', 'error', 'idle'].includes(normalized)) {
      return false;
    }
    this.#exactQuoteStatus = normalized;
    this.dataset.exactQuoteStatus = normalized;
    this.#exactQuoteDesignSignature =
      normalized === 'pending' || normalized === 'ready'
        ? this.#quoteDesignSignature(this.#designState)
        : '';
    this.#syncAddButton(Boolean(this.#designState.valid));
    return true;
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    if (this.dataset.appBridgeInitialized !== 'true') {
      if (this.dataset.appBridgeWaiting === 'true') return;
      this.dataset.appBridgeWaiting = 'true';
      let timeout = 0;
      const resume = () => {
        window.clearTimeout(timeout);
        delete this.dataset.appBridgeWaiting;
        this.connectedCallback();
      };
      this.addEventListener('tan:app-bridge:ready', resume, { once: true });
      timeout = window.setTimeout(resume, 5000);
      return;
    }
    if (!TAN_PRICING_ENGINE || typeof TAN_PRICING_ENGINE.calculate !== 'function') {
      console.error('[tan-neon-designer] Pricing engine is unavailable.');
      return;
    }
    this.dataset.initialized = 'true';
    this.dataset.exactQuoteStatus = this.#exactQuoteStatus;

    const canvas = document.createElement('canvas');
    this.#measureContext = canvas.getContext('2d');
    this.#copy = this.#readJson('[data-tan-nd-copy]', {});
    this.#fonts = this.#normaliseFonts(this.#readJson('[data-tan-nd-fonts]', []));
    this.#rebuildFontControls();
    const defaultFont = tanDefaultFontForLocale(
      this.#fonts, this.dataset.locale || document.documentElement.lang
    );
    if (defaultFont) {
      const fontSelect = this.querySelector('[data-font-select]');
      if (
        fontSelect instanceof HTMLSelectElement &&
        Array.from(fontSelect.options).some(
          (option) => option.value === String(defaultFont.id || '')
        )
      ) {
        /*
         * Fresh visits use a font that supports the storefront language.
         * Restored drafts and shared-design URLs below still take priority;
         * later text edits never replace the customer's font selection.
         */
        fontSelect.value = String(defaultFont.id || '');
      }
    }
    this.#icons = this.#normaliseIcons(TAN_ICON_CATALOG);
    this.#rebuildIconControls();
    this.#backgrounds = this.#readJson('[data-tan-nd-backgrounds]', []).filter(
      (entry) => entry && typeof entry.id === 'string' && typeof entry.src === 'string' && entry.src
    );
    const initialBackgroundId = String(
      this.dataset.initialBackgroundId || this.#backgrounds[0]?.id || ''
    );
    const initialBackgroundIndex = this.#backgrounds.findIndex(
      (entry) => entry.id === initialBackgroundId
    );
    this.#selectedBackgroundId =
      initialBackgroundIndex >= 0 ? initialBackgroundId : String(this.#backgrounds[0]?.id || '');
    this.#backgroundIndex = Math.max(0, initialBackgroundIndex);
    this.#exampleLibrary = this.#readExampleLibrary();
    this.#requestedWidth = this.#numberData('minWidth', 20);
    this.#restoreMeasurementUnit();
    this.#rememberAddButtonIdleLabel();
    this.#prepareMobileSheetHandle();

    /*
     * A review entry can be restored as a new document after the customer
     * visits the cart. Browser form restoration brings the text back, but it
     * cannot restore private sizing state. Restore our history snapshot first;
     * explicit share-link parameters still win below.
     */
    this.#applyHistoryDraft();
    this.#applyUrlState();
    /*
     * URL restoration may select a different face. Start exactly that one
     * instead of downloading Barcelona and the shared-design font together.
     */
    const initialFont = this.#getSelectedFont();
    const initialText = this.querySelector('[data-text-input]');
    if (initialText instanceof HTMLTextAreaElement) this.#sanitizeTextEmojis(initialText);
    void this.#loadFont(
      initialFont,
      initialText instanceof HTMLTextAreaElement
        ? initialText.value.trim() || initialFont.label || 'Sample'
        : initialFont.label || 'Sample'
    );
    this.#applyInitialResponsiveUi();
    this.#applySelectedBackgroundForViewport();
    this.#bindEvents();
    this.#syncDesignerStepFromLocation({ focus: false });
    this.#syncConditionalFields();
    this.#syncColorModeUi();
    this.#syncMobileAlignmentButtons();
    this.#scheduleUpdate();

    const stage = this.querySelector('[data-stage]');
    if ('ResizeObserver' in window) {
      this.#resizeObserver = new ResizeObserver(() => {
        if (this.dataset.viewportResizing === 'true') return;
        if (stage instanceof HTMLElement &&
            this.#renderedStageSize === `${stage.clientWidth}:${stage.clientHeight}`) return;
        this.#scheduleUpdate();
        this.#scheduleResponsiveFontRefresh();
      });
      if (stage instanceof HTMLElement) this.#resizeObserver.observe(stage);
    }

    if (
      this.#isHomeEmbed() &&
      this.dataset.bridgeSource === 'app_extension' &&
      this.dataset.homeLazy !== 'true' &&
      this.dataset.homeEmbedReady !== 'true'
    ) {
      this.dataset.homeEmbedReady = 'true';
      this.setAttribute('aria-busy', 'false');
      this.dispatchEvent(new CustomEvent('tan:home-designer:ready', { bubbles: true }));
    }
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#iconOptionObserver?.disconnect();
    this.#iconOptionObserver = null;
    this.#fontPreviewPaths = null;
    this.#fontPreviewPromise = null;
    this.#fontTriggerFitKey = '';
    this.#resetFontOptionQueue();
    this.#abortController = new AbortController();
    this.#resizeObserver?.disconnect();
    this.#renderedStageSize = '';
    this.#resizeObserver = null;
    if (this.#renderFrame) cancelAnimationFrame(this.#renderFrame);
    this.#renderFrame = 0;
    if (this.#previewDragFrame) cancelAnimationFrame(this.#previewDragFrame);
    this.#previewDragFrame = 0;
    if (this.#previewLayoutFrame) cancelAnimationFrame(this.#previewLayoutFrame);
    this.#previewLayoutFrame = 0;
    if (this.#previewLayoutTimer) window.clearTimeout(this.#previewLayoutTimer);
    this.#previewLayoutTimer = 0;
    if (this.#mobileViewportFrame) cancelAnimationFrame(this.#mobileViewportFrame);
    this.#mobileViewportFrame = 0;
    if (this.#responsiveFontFrame) cancelAnimationFrame(this.#responsiveFontFrame);
    this.#responsiveFontFrame = 0;
    if (this.#viewportResizeTimer) window.clearTimeout(this.#viewportResizeTimer);
    this.#viewportResizeTimer = 0;
    if (this.#pageScrollSettleTimer) window.clearTimeout(this.#pageScrollSettleTimer);
    this.#pageScrollSettleTimer = 0;
    this.#fontPickerSuspendedForResize = false;
    this.#cancelMobileAlignment();
    this.#cancelMobileKeyboardRestore();
    this.#feeVariants = [];
    this.#loadedFeeUrls.clear();
    this.#failedFeeUrls.clear();
    this.#feeLoadPromises.clear();
    this.#fontLoadPromises.clear();
    this.#iconSvgPromises.clear();
    this.#iconVectorCatalogPromise = null;
    this.#fontReadyFamilies.clear();
    this.#fontFailedFamilies.clear();
    this.#fontOptionObserver?.disconnect();
    this.#fontOptionObserver = null;
    if (document.fonts) {
      this.#fontFaces.forEach((face) => document.fonts.delete(face));
    }
    this.#fontFaces.clear();
    this.#fontPickerPromise = null;
    this.#fontGridFitSignature = '';
    this.#renderedFontId = '';
    this.#syncedFontPickerId = '';
    this.#syncedIconPickerSignature = '';
    this.#syncedIconSelectionId = '';
    this.#iconGridReady = false;
    this.#icons = [];
    this.#selectedIconId = '';
    this.#iconPosition = 'right';
    this.#iconPlacement = -1;
    this.#iconScale = 100;
    this.#iconScaleFloor = 70;
    this.#iconScaleFloorIconId = '';
    this.#iconColorId = '';
    this.#iconColorActive = false;
    this.#sizeDriver = 'width';
    this.#requestedHeight = null;
    this.#requestedWidth = null;
    this.#customerSelectedSize = false;
    this.#automaticSizeInitialized = false;
    this.#measurementUnit = 'cm';
    this.#exampleLibrary.clear();
    this.#exampleRenderToken += 1;
    this.#exampleKey = '';
    this.#exampleIndex = 0;
    this.#exampleOpener = null;
    this.#examplePointerStart = null;
    this.#characterColors = [];
    this.#characterUiSignature = '';
    this.#activeCharacterIndex = 0;
    this.#colorDescriptorsCache = null;
    this.#colorDescriptorMap = null;
    this.#currencyFormatter = null;
    this.#currencyMinorUnitValue = null;
    this.#graphemeSegmenter = null;
    this.#graphemeCacheSource = '';
    this.#graphemeCache = [];
    this.#previewOffset = { x: 0, y: 0 };
    this.#previewDrag = null;
    this.#isComposingText = false;
    this.#backgrounds = [];
    this.#selectedBackgroundId = '';
    this.#backgroundRequest += 1;
    this.#focusEditorAfterPopstate = false;
    this.#textPointerGesture = null;
    this.#reviewTracked = false;
    this.#zoom = 0.7;
    this.#backgroundIndex = 0;
    this.#designState = {};
    this.#controllerLockMode = 'standard';
    this.#previousRemoteValue = 'Yes, included';
    this.#mountingOutdoorLocked = false;
    this.#previousMountingValue = 'Wall mount kit';
    this.#copy = {};
    this.style.removeProperty('--tan-nd-zoom');
    this.style.removeProperty('--tan-nd-mobile-app-height');
    this.removeAttribute('data-mobile-keyboard');
    this.removeAttribute('data-mobile-sheet-dragging');
    this.removeAttribute('data-mobile-sheet-collapsed');
    this.removeAttribute('data-viewport-resizing');
    this.removeAttribute('data-page-scrolling');
    this.querySelector('.tan-nd__layout')?.style.removeProperty('--tan-nd-mobile-sheet-offset');
    this
      .querySelector('.tan-nd__layout')
      ?.style.removeProperty('--tan-nd-mobile-sheet-offset-inverse');
    delete this.dataset.fontReady;
    delete this.dataset.fontLoading;
    delete this.dataset.mobileReady;
    delete this.dataset.measurementUnit;
    delete this.dataset.initialized;
  }

  #isMobileViewport() {
    return TAN_MOBILE_VIEWPORT.matches;
  }

  #isHomeEmbed() {
    return this.dataset.homeEmbed === 'true';
  }

  #isSingleColumnLayout() {
    return TAN_SINGLE_COLUMN_VIEWPORT.matches;
  }

  #defaultZoomForViewport() {
    if (this.#isMobileViewport()) return 1;
    return TAN_NARROW_DESKTOP_VIEWPORT.matches ? 1 : 0.7;
  }

  #syncMobileSheetAccessibility() {
    const sidebar = this.querySelector('.tan-nd__sidebar');
    if (!(sidebar instanceof HTMLElement)) return;
    sidebar.tabIndex = this.#isMobileViewport() && this.#isHomeEmbed() ? 0 : -1;
  }

  #prepareMobileSheetHandle() {
    const handle = this.querySelector('.tan-nd__mobile-sheet-handle');
    if (!(handle instanceof HTMLElement)) return;
    delete handle.dataset.mobileSheetHandle;
    handle.setAttribute('aria-hidden', 'true');
    handle.removeAttribute('role');
    handle.removeAttribute('aria-label');
    handle.removeAttribute('aria-orientation');
    handle.removeAttribute('aria-valuemin');
    handle.removeAttribute('aria-valuemax');
    handle.removeAttribute('aria-valuenow');
    handle.removeAttribute('aria-valuetext');
    handle.tabIndex = -1;
  }

  #scheduleMobileViewportSync() {
    if (this.#mobileViewportFrame) cancelAnimationFrame(this.#mobileViewportFrame);
    this.#mobileViewportFrame = requestAnimationFrame(() => {
      this.#mobileViewportFrame = 0;
      this.#syncMobileViewportState();
    });
  }

  #syncMobileViewportState() {
    // Do not resize, translate or restore the workspace in response to
    // VisualViewport changes. Safari and Chrome can then keep one native page
    // scroller active while the keyboard is open.
    this.style.removeProperty('--tan-nd-mobile-app-height');
    this.removeAttribute('data-mobile-keyboard');
    this.removeAttribute('data-mobile-sheet-dragging');
    this.removeAttribute('data-mobile-sheet-collapsed');
    const layout = this.querySelector('.tan-nd__layout');
    if (layout instanceof HTMLElement) {
      layout.style.removeProperty('--tan-nd-mobile-sheet-offset');
      layout.style.removeProperty('--tan-nd-mobile-sheet-offset-inverse');
    }
  }

  #cancelMobileAlignment() {
    if (this.#mobileAlignmentFrame) cancelAnimationFrame(this.#mobileAlignmentFrame);
    this.#mobileAlignmentFrame = 0;
    if (this.#mobileAlignmentTimer) window.clearTimeout(this.#mobileAlignmentTimer);
    this.#mobileAlignmentTimer = 0;
  }

  #cancelMobileKeyboardRestore() {
    if (this.#mobileKeyboardRestoreTimer) {
      window.clearTimeout(this.#mobileKeyboardRestoreTimer);
    }
    this.#mobileKeyboardRestoreTimer = 0;
    this.#mobileKeyboardRestorePending = false;
    this.#mobileTextFocusUntil = 0;
  }

  /** @param {Element | null} element */
  #isMobileKeyboardEditor(element) {
    return (
      element instanceof HTMLElement &&
      element.matches(
        [
          '[data-text-input]',
          '[data-width-input]',
          '[data-height-input]',
          '[data-rush-input]',
          '[data-greeting-input]',
          '[data-special-request-input]',
        ].join(', ')
      )
    );
  }

  #beginMobileKeyboardSession() {
    if (!this.#isMobileViewport()) return;
    if (this.#mobileKeyboardRestoreTimer) {
      window.clearTimeout(this.#mobileKeyboardRestoreTimer);
      this.#mobileKeyboardRestoreTimer = 0;
    }
    this.#mobileKeyboardRestorePending = true;
  }

  /** @param {number} delay */
  #scheduleMobileKeyboardCloseRestore(delay = 280) {
    this.#mobileTextFocusUntil = 0;
    if (!this.#isMobileViewport()) return;
    this.#mobileKeyboardRestorePending = true;
    this.#scheduleMobileAlignment('workspace', delay);

    if (this.#mobileKeyboardRestoreTimer) {
      window.clearTimeout(this.#mobileKeyboardRestoreTimer);
    }
    this.#mobileKeyboardRestoreTimer = window.setTimeout(() => {
      this.#mobileKeyboardRestoreTimer = 0;
      this.#mobileKeyboardRestorePending = false;
    }, 1400);
  }

  #restoreAfterMobileViewportChange() {
    // Keyboard opening may finish after the focus event. Coalesce its resize
    // events only during this short session; a real gesture cancels it.
    if (this.#usesNativeMobileScroll() && performance.now() < this.#mobileTextFocusUntil) {
      const input = document.activeElement;
      if (input instanceof HTMLTextAreaElement && input === this.querySelector('[data-text-input]')) {
        this.#scheduleMobileAlignment('text', 100, input);
        return;
      }
    }
    if (
      !this.#mobileKeyboardRestorePending ||
      !this.#isMobileViewport() ||
      this.#isMobileKeyboardEditor(document.activeElement)
    ) {
      return;
    }
    // iOS can finish expanding the visual viewport after the blur event.
    // Re-align from the final viewport size instead of leaving the page at
    // Safari's temporary keyboard scroll position.
    this.#scheduleMobileKeyboardCloseRestore(90);
  }

  #mobileAlignmentBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
  }

  /**
   * Keep every phone interaction on one native document scroller. Calls are
   * coalesced so page entry and keyboard changes cannot launch competing
   * scroll animations. Font choices update the preview in place.
   *
   * @param {'workspace' | 'text'} mode
   * @param {number} delay
   * @param {HTMLTextAreaElement | null} textInput
   */
  #scheduleMobileAlignment(mode = 'workspace', delay = 60, textInput = null) {
    if (!this.#isMobileViewport() || (this.#isHomeEmbed() && mode !== 'text')) return;
    this.#cancelMobileAlignment();

    this.#mobileAlignmentFrame = requestAnimationFrame(() => {
      this.#mobileAlignmentFrame = 0;
      this.#mobileAlignmentTimer = window.setTimeout(() => {
        this.#mobileAlignmentTimer = 0;
        if (!this.isConnected || !this.#isMobileViewport()) return;
        if (mode === 'text' && textInput && document.activeElement !== textInput) return;

        if (mode === 'text' && textInput instanceof HTMLElement) {
          this.#alignMobileTextFocus(textInput);
          return;
        }
        const anchor = this.querySelector('.tan-nd__layout');
        if (!(anchor instanceof HTMLElement)) return;
        const behavior = this.#mobileAlignmentBehavior();

        const scroller = this.#getPageScroller();
        const targetTop = Math.max(
          0,
          this.#elementTopInScroller(anchor, scroller) - (mode === 'text' ? 8 : 0)
        );
        if (Math.abs(this.#getPageScrollTop(scroller) - targetTop) > 4) {
          this.#setPageScrollTop(scroller, targetTop, behavior);
        }
      }, Math.max(0, Number(delay) || 0));
    });
  }

  /** @param {HTMLTextAreaElement} textInput @param {number} delay */
  #scheduleMobileTextFocusScroll(textInput, delay = 260) {
    if (!this.#usesNativeMobileScroll() || document.activeElement !== textInput) return;
    this.#mobileTextFocusUntil = performance.now() + 1400;
    this.#scheduleMobileAlignment('text', delay, textInput);
  }

  /** @param {HTMLTextAreaElement} textInput @param {DOMRect} inputRect */
  #mobileTextPreviewAllowance(textInput, inputRect) {
    const viewport = window.visualViewport;
    const ua = window.navigator?.userAgent || '';
    // The supplied iPhone framing uses the empty bottom of the textarea
    // behind Safari's floating controls. Keep actual text above that area.
    // Other browsers, landscape and hardware keyboards retain full-box fit.
    if (
      !viewport || window.innerHeight - viewport.height < 150 ||
      !window.matchMedia('(orientation: portrait)').matches ||
      !/iPhone|iPod/.test(ua) || !/Version\/[\d.]+.*Safari\//.test(ua) ||
      /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua) || window.navigator?.standalone
    ) return 0;

    const style = getComputedStyle(textInput);
    const px = value => Number.parseFloat(value) || 0;
    const contentWidth = textInput.clientWidth - px(style.paddingLeft) - px(style.paddingRight);
    if (!Number.isFinite(contentWidth) || contentWidth <= 0 || !document.body) return 0;

    // Measure wrapped text once during focus alignment, never on page scroll.
    // A full or multiline field gives back any space needed by its contents.
    const measure = document.createElement('div');
    measure.setAttribute('aria-hidden', 'true');
    Object.assign(measure.style, {
      position: 'absolute', left: '0', top: '0', visibility: 'hidden',
      pointerEvents: 'none', display: 'block', boxSizing: 'content-box',
      width: `${contentWidth}px`, minWidth: '0', maxWidth: 'none',
      height: 'auto', minHeight: '0', maxHeight: 'none',
      padding: '0', border: '0', margin: '0', whiteSpace: 'pre-wrap',
    });
    for (const property of [
      'fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'fontStretch',
      'fontVariant', 'lineHeight', 'letterSpacing', 'wordSpacing', 'tabSize',
      'textIndent', 'textTransform', 'wordBreak', 'overflowWrap', 'direction',
    ]) measure.style[property] = style[property];
    measure.textContent = `${textInput.value || ''}\u200b`;
    document.body.append(measure);
    try {
      const textHeight = measure.getBoundingClientRect().height;
      if (!Number.isFinite(textHeight) || textHeight <= 0) return 0;
      const occupiedHeight = Math.ceil(textHeight + px(style.paddingTop) +
        px(style.paddingBottom) + px(style.borderTopWidth) + px(style.borderBottomWidth));
      return Math.min(42, Math.max(0, inputRect.height - occupiedHeight));
    } finally {
      measure.remove();
    }
  }

  /** @param {HTMLTextAreaElement} textInput */
  #alignMobileTextFocus(textInput) {
    if (
      !this.#usesNativeMobileScroll() ||
      this.dataset.designerStep === 'review' ||
      !(textInput instanceof HTMLTextAreaElement) ||
      document.activeElement !== textInput
    ) return;

    const layout = this.querySelector('.tan-nd__layout');
    if (!(layout instanceof HTMLElement)) return;
    const viewport = window.visualViewport;
    // Pinch zoom and its caret positioning remain under browser control.
    if (viewport && Math.abs(viewport.scale - 1) > 0.05) return;
    const visibleHeight = viewport?.height || window.innerHeight;
    this.#alignMobileEmbedControl(textInput, 12, false);
    const inputRect = textInput.getBoundingClientRect();
    const gap = 12;
    if (!Number.isFinite(visibleHeight) || visibleHeight <= inputRect.height + gap * 2) return;

    const scroller = this.#getPageScroller();
    const layoutTop = this.#elementTopInScroller(layout, scroller);
    const inputTop = this.#elementTopInScroller(textInput, scroller);
    let currentTop;
    let targetTop;
    if (this.#isDocumentScroller(scroller)) {
      // Window.scrollTo addresses the coordinated viewport. Compare against
      // pageTop, which includes iOS keyboard panning, rather than scrollY alone.
      currentTop = viewport && Number.isFinite(viewport.pageTop)
        ? viewport.pageTop
        : this.#getPageScrollTop(scroller);
      const emptyAllowance = this.#mobileTextPreviewAllowance(textInput, inputRect);
      targetTop = Math.max(
        0, layoutTop, inputTop + inputRect.height - emptyAllowance + gap - visibleHeight
      );
    } else {
      const scrollerRect = scroller.getBoundingClientRect();
      const visibleTop = Math.max(viewport?.offsetTop || 0, scrollerRect.top);
      const visibleBottom = Math.min(
        (viewport?.offsetTop || 0) + visibleHeight,
        scrollerRect.top + scroller.clientHeight
      );
      if (visibleBottom - visibleTop <= inputRect.height + gap * 2) return;
      currentTop = this.#getPageScrollTop(scroller);
      targetTop = Math.max(
        0,
        layoutTop - (visibleTop - scrollerRect.top),
        inputTop + inputRect.height + gap - (visibleBottom - scrollerRect.top)
      );
    }
    // Keep the writing area visible while leaving more preview above it.
    // A settled correction avoids a second smooth animation with the keyboard.
    if (Math.abs(currentTop - targetTop) > 4) {
      this.#setPageScrollTop(scroller, targetTop, 'auto');
    }
  }
  /** @param {boolean} open @param {boolean} focus */
  #setBackgroundPickerOpen(open, focus = false) {
    const picker = this.querySelector('[data-background-picker]');
    const toggle = this.querySelector('[data-background-toggle]');
    if (!(picker instanceof HTMLElement) || !(toggle instanceof HTMLButtonElement)) return;

    picker.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (!focus) return;

    if (open) {
      const selected =
        picker.querySelector('[data-background-option][aria-pressed="true"]') ||
        picker.querySelector('button');
      selected?.focus({ preventScroll: true });
      return;
    }
    toggle.focus({ preventScroll: true });
  }

  #applyInitialResponsiveUi() {
    this.#syncMobileSheetAccessibility();
    this.#zoom = this.#defaultZoomForViewport();
    this.style.setProperty('--tan-nd-zoom', String(this.#zoom));
    if (this.#isMobileViewport()) {
      this.#setBackgroundPickerOpen(false);
    }
    this.dataset.mobileReady = 'true';
    this.#syncMobileViewportState();
  }

  #bindEvents() {
    const { signal } = this.#abortController;

    this.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const characterColor = target.closest('[data-character-color]');
        if (characterColor instanceof HTMLElement) {
          const colorId = String(
            characterColor.dataset.characterColor ||
              (characterColor instanceof HTMLInputElement ? characterColor.value : '')
          ).trim();
          if (colorId) {
            if (characterColor instanceof HTMLButtonElement) event.preventDefault();
            this.#setCharacterColor(this.#activeCharacterIndex, colorId);
            return;
          }
        }

        const iconColorTarget = target.closest('[data-icon-color-target]');
        if (iconColorTarget instanceof HTMLElement) {
          this.#iconColorActive = true;
          this.#syncCharacterColorUi();
          return;
        }

        const characterTarget = target.closest('[data-character-index]');
        if (characterTarget instanceof HTMLElement) {
          const index = Number(characterTarget.dataset.characterIndex);
          const isPreviewCharacter = Boolean(characterTarget.closest('[data-preview-drag-target]'));
          if (!isPreviewCharacter && Number.isInteger(index) && index >= 0) {
            this.#iconColorActive = false;
            this.#activeCharacterIndex = index;
            this.#syncCharacterColorUi();
            return;
          }
        }

        const unitToggle = target.closest('[data-unit-toggle]');
        if (unitToggle instanceof HTMLButtonElement) {
          event.preventDefault();
          this.#setMeasurementUnit(this.#measurementUnit === 'cm' ? 'in' : 'cm');
          return;
        }

        const exampleTrigger = target.closest('[data-example-trigger]');
        if (exampleTrigger instanceof HTMLButtonElement) {
          event.preventDefault();
          event.stopPropagation();
          this.#openExample(exampleTrigger);
          return;
        }

        if (target.closest('[data-example-close]')) {
          this.#closeExample();
          return;
        }
        if (target.closest('[data-example-previous]')) {
          this.#stepExample(-1);
          return;
        }
        if (target.closest('[data-example-next]')) {
          this.#stepExample(1);
          return;
        }

        if (target.closest('[data-text-limit-close]')) {
          this.#closeTextLimitDialog(true);
          return;
        }

        const dialog = this.querySelector('[data-example-dialog]');
        if (dialog instanceof HTMLDialogElement && event.target === dialog) this.#closeExample();
        const limitDialog = this.querySelector('[data-text-limit-dialog]');
        if (limitDialog instanceof HTMLDialogElement && event.target === limitDialog) {
          this.#closeTextLimitDialog(true);
        }
      },
      { signal }
    );

    this.addEventListener(
      'input',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement)) {
          return;
        }

        if (target.matches('[data-icon-search]')) {
          this.#filterIconOptions(target.value);
          return;
        } else if (target.matches('[data-icon-placement]')) {
          this.#setIconPlacement(target.value);
          return;
        } else if (target.matches('[data-icon-scale]')) {
          this.#setIconScale(target.value, false);
        } else if (
          target instanceof HTMLTextAreaElement &&
          target.matches('[data-text-input]') &&
          !this.#isComposingText &&
          event.isComposing !== true
        ) {
          this.#enforceTextLimit(target, true);
        } else if (target.matches('[data-width-range]')) {
          this.#setWidth(target.value);
        } else if (target.matches('[data-width-input]')) {
          const value = target.valueAsNumber;
          const minimum = Number(target.min);
          const maximum = Number(target.max);
          if (
            !Number.isFinite(value) ||
            (Number.isFinite(minimum) && value < minimum) ||
            (Number.isFinite(maximum) && value > maximum)
          ) {
            return;
          }
          this.#setWidth(this.#displayValueToCm(value), false);
        } else if (target.matches('[data-height-input]')) {
          const value = target.valueAsNumber;
          const minimum = Number(target.min);
          const maximum = Number(target.max);
          if (
            !Number.isFinite(value) ||
            (Number.isFinite(minimum) && value < minimum) ||
            (Number.isFinite(maximum) && value > maximum)
          ) {
            return;
          }
          this.#setHeight(this.#displayValueToCm(value), false);
        }

        this.#scheduleUpdate();
      },
      { signal }
    );

    this.addEventListener(
      'focusout',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.matches('[data-width-input]')) {
          this.#setWidth(this.#displayValueToCm(target.value));
        } else if (target.matches('[data-height-input]')) {
          this.#setHeight(this.#displayValueToCm(target.value));
        } else {
          return;
        }
        this.#scheduleUpdate();
      },
      { signal }
    );

    const textInput = this.querySelector('[data-text-input]');
    if (textInput instanceof HTMLTextAreaElement) {
      textInput.addEventListener(
        'beforeinput',
        (event) => {
          if (event.isComposing || this.#isComposingText || !event.cancelable) return;
          const inserted = typeof event.data === 'string' ? event.data : '';
          if (inserted && !tanRemoveTextEmojis(inserted)) {
            event.preventDefault();
            this.#emojiTextNotice = true;
            this.#scheduleUpdate();
          }
        },
        { signal }
      );
      textInput.addEventListener(
        'pointerdown',
        (event) => {
          if (
            !this.#isMobileViewport() ||
            document.activeElement === textInput ||
            event.pointerType !== 'touch'
          ) {
            return;
          }

          // Do not focus on touch-down. A customer may be starting a vertical
          // pan over the large textarea; opening the keyboard here makes the
          // landscape control column jump before that intent is known.
          this.#textPointerGesture = {
            pointerId: event.pointerId,
            clientX: event.clientX,
            clientY: event.clientY,
            moved: false,
          };
          event.preventDefault();
        },
        { signal }
      );
      textInput.addEventListener(
        'pointermove',
        (event) => {
          const gesture = this.#textPointerGesture;
          if (!gesture || gesture.pointerId !== event.pointerId) return;
          if (
            Math.hypot(
              event.clientX - gesture.clientX,
              event.clientY - gesture.clientY
            ) >= 9
          ) {
            gesture.moved = true;
          }
        },
        { signal }
      );
      textInput.addEventListener(
        'pointerup',
        (event) => {
          const gesture = this.#textPointerGesture;
          if (!gesture || gesture.pointerId !== event.pointerId) return;
          this.#textPointerGesture = null;
          if (gesture.moved) return;

          // A clean tap still opens the editor inside the trusted touch
          // gesture, while a pan leaves the keyboard closed.
          event.preventDefault();
          textInput.focus({ preventScroll: true });
          const caret = textInput.value.length;
          textInput.setSelectionRange(caret, caret);
        },
        { signal }
      );
      textInput.addEventListener(
        'pointercancel',
        (event) => {
          if (this.#textPointerGesture?.pointerId === event.pointerId) {
            this.#textPointerGesture = null;
          }
        },
        { signal }
      );
      textInput.addEventListener(
        'focus',
        () => {
          this.#beginMobileKeyboardSession();
          this.#scheduleMobileTextFocusScroll(textInput);
        },
        { signal }
      );
      textInput.addEventListener(
        'blur',
        () => {
          // Let iOS Safari and Android Chrome finish restoring the visual
          // viewport after the software keyboard closes, then bring the live
          // preview back into view with one coalesced document scroll.
          this.#scheduleMobileKeyboardCloseRestore();
        },
        { signal }
      );
      textInput.addEventListener(
        'compositionstart',
        () => {
          this.#isComposingText = true;
          this.#designState.valid = false;
          this.#syncAddButton(false);
        },
        { signal }
      );
      textInput.addEventListener(
        'compositionend',
        () => {
          this.#isComposingText = false;
          this.#enforceTextLimit(textInput, true);
          this.#scheduleUpdate();
        },
        { signal }
      );
    }

    this.querySelectorAll(
      [
        '[data-width-input]',
        '[data-height-input]',
        '[data-rush-input]',
        '[data-greeting-input]',
        '[data-special-request-input]',
      ].join(', ')
    ).forEach((editor) => {
      editor.addEventListener(
        'focus',
        () => this.#beginMobileKeyboardSession(),
        { signal }
      );
      editor.addEventListener(
        'blur',
        () => this.#scheduleMobileKeyboardCloseRestore(),
        { signal }
      );
    });

    // A real touch or wheel gesture always wins over a pending automatic
    // alignment. Text confirmation may schedule a fresh preview reveal
    // after its interaction has completed.
    this.addEventListener(
      'pointerdown',
      () => {
        this.#cancelMobileAlignment();
        this.#cancelMobileKeyboardRestore();
      },
      {
        capture: true,
        signal,
      }
    );
    this.addEventListener(
      'wheel',
      () => {
        this.#cancelMobileAlignment();
        this.#cancelMobileKeyboardRestore();
      },
      {
        passive: true,
        signal,
      }
    );

    /*
     * The RGB preview is deliberately animated, but advancing that colour
     * clock while a sticky, filter-heavy canvas is moving wastes compositor
     * time. Freeze only the animation during an active page scroll and resume
     * from the same frame once the gesture settles. Solid-colour previews do
     * not take this path, and no geometry or design state is changed.
     */
    const markPageScrolling = () => {
      if (this.dataset.rgb !== 'true') return;
      if (this.dataset.pageScrolling !== 'true') {
        this.dataset.pageScrolling = 'true';
      }
      if (this.#pageScrollSettleTimer) {
        window.clearTimeout(this.#pageScrollSettleTimer);
      }
      this.#pageScrollSettleTimer = window.setTimeout(() => {
        this.#pageScrollSettleTimer = 0;
        this.removeAttribute('data-page-scrolling');
      }, 140);
    };
    const pageWrapper = document.querySelector('.page-wrapper');
    const designerSidebar = this.querySelector('.tan-nd__sidebar');
    window.addEventListener('scroll', markPageScrolling, { passive: true, signal });
    if (pageWrapper instanceof HTMLElement) {
      pageWrapper.addEventListener('scroll', markPageScrolling, { passive: true, signal });
    }
    if (designerSidebar instanceof HTMLElement) {
      designerSidebar.addEventListener('scroll', markPageScrolling, { passive: true, signal });
    }

    this.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (
          target instanceof HTMLInputElement &&
          target.matches('[data-character-color]') &&
          target.checked
        ) {
          const colorId = String(target.dataset.characterColor || target.value || '').trim();
          if (colorId) this.#setCharacterColor(this.#activeCharacterIndex, colorId);
          return;
        }
        if (target instanceof HTMLInputElement && target.matches('[data-alignment]')) {
          this.#syncMobileAlignmentButtons();
        }
        if (target instanceof HTMLSelectElement && target.matches('[data-icon-select]')) {
          this.#selectedIconId = target.value;
        }
        this.#syncConditionalFields();
        const affectsColorUi =
          target instanceof HTMLInputElement &&
          target.matches('[data-color-mode], [data-color]');
        if (affectsColorUi) this.#syncColorModeUi();
        else this.#syncExampleTriggers();
        this.#scheduleUpdate();
      },
      { signal }
    );

    this.querySelector('[data-glow-toggle]')?.addEventListener(
      'click',
      (event) => {
        const button = event.currentTarget;
        const visualizer = this.querySelector('[data-visualizer]');
        if (!(button instanceof HTMLButtonElement) || !(visualizer instanceof HTMLElement)) return;

        const glowEnabled = visualizer.classList.toggle('is-glow-off') === false;
        button.classList.toggle('is-active', glowEnabled);
        button.setAttribute('aria-pressed', String(glowEnabled));
        this.#scheduleUpdate();
      },
      { signal }
    );

    this.querySelector('[data-background-toggle]')?.addEventListener(
      'click',
      (event) => {
        const button = event.currentTarget;
        const stage = this.querySelector('[data-stage]');
        const picker = this.querySelector('[data-background-picker]');
        if (!(button instanceof HTMLButtonElement) || !(stage instanceof HTMLElement)) return;

        if (picker instanceof HTMLElement && this.#backgrounds.length) {
          this.#setBackgroundPickerOpen(picker.hidden, true);
          this.#scheduleUpdate();
          return;
        }

        const backgrounds = ['room', 'dark', 'light'];
        this.#backgroundIndex = (this.#backgroundIndex + 1) % backgrounds.length;
        stage.dataset.background = backgrounds[this.#backgroundIndex];
      },
      { signal }
    );

    this.querySelectorAll('[data-background-option]').forEach((option) => {
      option.addEventListener(
        'click',
        () => {
          if (!(option instanceof HTMLButtonElement)) return;
          this.#selectBackground(option.dataset.backgroundOption || '');
          if (this.#isMobileViewport()) this.#setBackgroundPickerOpen(false, true);
        },
        { signal }
      );
    });

    this.querySelector('[data-zoom-out]')?.addEventListener('click', () => this.#setZoom(this.#zoom - 0.1), {
      signal,
    });
    this.querySelector('[data-zoom-in]')?.addEventListener('click', () => this.#setZoom(this.#zoom + 0.1), {
      signal,
    });
    this.querySelector('[data-artboard]')?.addEventListener(
      'transitionend',
      (event) => {
        if (event.propertyName === 'transform') this.#positionMetrics();
      },
      { signal }
    );
    this.querySelectorAll('[data-share]').forEach((button) => {
      button.addEventListener('click', this.#shareDesign, { signal });
    });
    this.querySelector('[data-next-to-review]')?.addEventListener(
      'click',
      async (event) => {
        event.preventDefault();
        if (this.dataset.reviewPreparing === 'true' || !this.#canUseCurrentDesign()) return;
        const bridge = window.TANDesignerAppBridge;
        if (!bridge || typeof bridge.prepareReview !== 'function') {
          this.#showCartError(
            this.#t(
              'errors.secure_service_unavailable',
              {},
              'The secure designer service is unavailable. Refresh the page and try again.'
            )
          );
          return;
        }
        this.dataset.reviewPreparing = 'true';
        this.dataset.reviewTransition = 'preparing';
        let reviewOpened = false;
        const minimumReviewTransitionMs = this.#isMobileViewport() ? 360 : 0;
        const nextButton = event.currentTarget;
        if (nextButton instanceof HTMLButtonElement) {
          nextButton.disabled = true;
          nextButton.setAttribute('aria-busy', 'true');
        }
        try {
          // Yield one paint so the customer sees an immediate, stable loading
          // surface while the secure app confirms the exact design price.
          await new Promise((resolve) => requestAnimationFrame(resolve));
          await Promise.all([
            bridge.prepareReview(this, this.#designState),
            new Promise((resolve) => window.setTimeout(resolve, minimumReviewTransitionMs)),
          ]);
          this.dataset.reviewTransition = 'entering';
          this.#openReview();
          reviewOpened = this.dataset.designerStep === 'review';
          if (reviewOpened) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                if (this.dataset.designerStep === 'review') {
                  this.dataset.reviewTransition = 'ready';
                }
              });
            });
          }
        } catch (error) {
          this.#showCartError(
            error instanceof Error
              ? error.message
              : this.#t(
                  'errors.exact_price_failed',
                  {},
                  'The exact design price could not be confirmed.'
                )
          );
        } finally {
          delete this.dataset.reviewPreparing;
          if (!reviewOpened) delete this.dataset.reviewTransition;
          if (nextButton instanceof HTMLButtonElement) {
            nextButton.removeAttribute('aria-busy');
          }
          this.#syncAddButton(Boolean(this.#designState.valid));
        }
      },
      { signal }
    );
    this.querySelector('[data-review-back]')?.addEventListener('click', this.#leaveReview, { signal });
    this.querySelector('[data-add-to-cart]')?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        const bridge = window.TANDesignerAppBridge;
        if (!bridge || typeof bridge.addToCart !== 'function') {
          this.#showCartError(
            this.#t(
              'errors.secure_service_unavailable',
              {},
              'The secure designer service is unavailable. Refresh the page and try again.'
            )
          );
          return;
        }
        if (!this.#canUseCurrentDesign()) return;
        void bridge.addToCart(this, this.#designState);
      },
      { signal }
    );
    window.addEventListener('popstate', this.#handleDesignerPopState, { signal });
    window.addEventListener('pageshow', this.#handlePageShow, { signal });

    const warmFontPicker = () => this.#warmFontPicker();
    const fontTrigger = this.querySelector('[data-font-trigger]');
    fontTrigger?.addEventListener('pointerenter', warmFontPicker, { signal, passive: true });
    fontTrigger?.addEventListener('pointerdown', warmFontPicker, { signal, passive: true });
    fontTrigger?.addEventListener('focus', warmFontPicker, { signal });
    this.querySelector('[data-text-input]')?.addEventListener('focus', warmFontPicker, { signal });

    this.querySelector('[data-font-trigger]')?.addEventListener(
      'click',
      () => this.#toggleFontPicker(),
      { signal }
    );
    this.querySelector('[data-icon-trigger]')?.addEventListener(
      'click',
      () => this.#toggleIconPicker(),
      { signal }
    );

    this.querySelectorAll('[data-mobile-alignment]').forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          if (!(button instanceof HTMLButtonElement)) return;
          event.preventDefault();
          const value = String(button.dataset.mobileAlignment || '');
          const input = Array.from(this.querySelectorAll('input[data-alignment]')).find(
            (candidate) =>
              candidate instanceof HTMLInputElement && candidate.value === value
          );
          if (!(input instanceof HTMLInputElement)) return;
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            this.#syncMobileAlignmentButtons();
          }
        },
        { signal }
      );
    });

    this.querySelector('[data-font-menu]')?.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const option = target.closest('[data-font-option]');
        if (!(option instanceof HTMLButtonElement) || option.disabled) return;
        this.#selectFont(option.dataset.fontOption || '');
      },
      { signal }
    );
    this.querySelector('[data-icon-menu]')?.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const option = target.closest('[data-icon-option]');
        if (!(option instanceof HTMLButtonElement) || option.disabled) return;
        this.#selectIcon(option.dataset.iconOption || '');
      },
      { signal }
    );

    this.querySelectorAll('[data-font-menu], [data-icon-menu]').forEach((menu) => {
      menu.addEventListener('wheel', (event) => this.#handlePickerWheel(event), {
        passive: false,
        signal,
      });
    });

    document.addEventListener(
      'click',
      (event) => {
        const picker = this.querySelector('[data-font-picker]');
        if (!(event.target instanceof Node)) return;
        if (
          !this.#isMobileViewport() &&
          picker instanceof HTMLElement &&
          !picker.contains(event.target)
        ) {
          this.#closeFontPicker();
        }
        const iconPicker = this.querySelector('[data-icon-picker]');
        if (
          !this.#isMobileViewport() &&
          iconPicker instanceof HTMLElement &&
          !iconPicker.contains(event.target)
        ) {
          this.#closeIconPicker();
        }

        const backgroundPicker = this.querySelector('[data-background-picker]');
        const backgroundToggle = this.querySelector('[data-background-toggle]');
        if (
          this.#isMobileViewport() &&
          backgroundPicker instanceof HTMLElement &&
          !backgroundPicker.hidden &&
          !backgroundPicker.contains(event.target) &&
          !(backgroundToggle instanceof HTMLElement && backgroundToggle.contains(event.target))
        ) {
          this.#setBackgroundPickerOpen(false);
        }
      },
      { signal }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        const target = event.target;
        if (
          event.key === 'Enter' &&
          target instanceof HTMLInputElement &&
          this.contains(target) &&
          target.matches('[data-width-input], [data-height-input]')
        ) {
          event.preventDefault();
          target.blur();
          return;
        }

        const limitDialog = this.querySelector('[data-text-limit-dialog]');
        if (limitDialog instanceof HTMLDialogElement && limitDialog.open) {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.#closeTextLimitDialog(true);
          }
          return;
        }

        const dialog = this.querySelector('[data-example-dialog]');
        if (dialog instanceof HTMLDialogElement && dialog.open) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.#stepExample(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.#stepExample(1);
          } else if (event.key === 'Escape') {
            event.preventDefault();
            this.#closeExample();
          }
          return;
        }

        if (event.key === 'Escape') {
          const backgroundPicker = this.querySelector('[data-background-picker]');
          if (backgroundPicker instanceof HTMLElement && !backgroundPicker.hidden) {
            this.#setBackgroundPickerOpen(false, true);
          }
          this.#closeFontPicker(true);
          this.#closeIconPicker(true);
        }
      },
      { signal }
    );

    this.#bindMobileNativeScroll(signal);
    const mobileMedia = TAN_MOBILE_VIEWPORT;
    const mobileBackgroundMedia = TAN_MOBILE_BACKGROUND_VIEWPORT;
    const narrowDesktopMedia = TAN_NARROW_DESKTOP_VIEWPORT;

    const handleResponsiveModeChange = () => {
      this.#closeFontPicker();
      this.#closeIconPicker();
      this.#fontOptionObserver?.disconnect();
      this.#fontOptionObserver = null;
      this.#fontPickerPromise = null;
      this.#resetFontOptionQueue();
      this.#zoom = this.#defaultZoomForViewport();
      this.style.setProperty('--tan-nd-zoom', String(this.#zoom));
      if (mobileMedia.matches) this.#setBackgroundPickerOpen(false);
      this.#syncMobileSheetAccessibility();
      this.dataset.mobileReady = 'true';
      this.#syncMobileViewportState();
      this.#applySelectedBackgroundForViewport();
      this.#scheduleUpdate();
      requestAnimationFrame(() => this.#fitLoadedFontOptions());
    };
    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', handleResponsiveModeChange, { signal });
    }
    if (typeof mobileBackgroundMedia.addEventListener === 'function') {
      mobileBackgroundMedia.addEventListener('change', handleResponsiveModeChange, { signal });
    }

    const handleNarrowDesktopModeChange = () => {
      if (this.#isMobileViewport()) return;
      this.#zoom = this.#defaultZoomForViewport();
      this.style.setProperty('--tan-nd-zoom', String(this.#zoom));
      if (this.dataset.viewportResizing !== 'true') this.#scheduleUpdate();
    };
    if (typeof narrowDesktopMedia.addEventListener === 'function') {
      narrowDesktopMedia.addEventListener('change', handleNarrowDesktopModeChange, { signal });
    }

    let lastViewportWidth = window.innerWidth;
    window.addEventListener(
      'resize',
      () => {
        const currentViewportWidth = window.innerWidth;
        const widthChanged = currentViewportWidth !== lastViewportWidth;
        lastViewportWidth = currentViewportWidth;
        // Phone browser chrome changes viewport height during a native swipe.
        // The fixed-size editor canvas has not resized. Rebuilding price,
        // preview and font controls here competes with scrolling. Observe the
        // stage itself for real size changes; keep keyboard restoration alive.
        if (
          this.#usesNativeMobileScroll() &&
          this.dataset.designerStep !== 'review' &&
          !TAN_FINE_POINTER_VIEWPORT.matches &&
          !widthChanged &&
          this.#resizeObserver
        ) {
          this.#restoreAfterMobileViewportChange();
          return;
        }
        if (TAN_FINE_POINTER_VIEWPORT.matches) this.#beginViewportResize();
        this.#refreshPreviewDragBounds();
        this.#scheduleMobileViewportSync();
        this.#restoreAfterMobileViewportChange();
        if (!TAN_FINE_POINTER_VIEWPORT.matches) {
          this.#scheduleUpdate();
          this.#scheduleResponsiveFontRefresh();
        }
      },
      { signal }
    );
    window.visualViewport?.addEventListener(
      'resize',
      () => {
        this.#scheduleMobileViewportSync();
        this.#restoreAfterMobileViewportChange();
      },
      { signal }
    );
    window.addEventListener(
      'orientationchange',
      () => {
        this.#refreshPreviewDragBounds();
        this.#scheduleMobileViewportSync();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.#scheduleUpdate();
            this.#fitLoadedFontOptions();
          });
        });
      },
      { signal }
    );
    document.addEventListener(
      'shopify:section:load',
      () => {
        window.requestAnimationFrame(() => this.#refreshExampleLibrary());
      },
      { signal }
    );

    document.addEventListener(
      'shopify:section:unload',
      () => {
        window.requestAnimationFrame(() => this.#refreshExampleLibrary());
      },
      { signal }
    );

    const exampleStage = this.querySelector('[data-example-stage]');
    exampleStage?.addEventListener(
      'pointerdown',
      (event) => {
        if (!event.isPrimary) return;
        this.#examplePointerStart = event.clientX;
        event.currentTarget?.setPointerCapture?.(event.pointerId);
      },
      { signal }
    );
    exampleStage?.addEventListener(
      'pointerup',
      (event) => {
        if (this.#examplePointerStart === null) return;
        const delta = event.clientX - this.#examplePointerStart;
        this.#examplePointerStart = null;
        if (Math.abs(delta) < 46) return;
        this.#stepExample(delta > 0 ? -1 : 1);
      },
      { signal }
    );
    exampleStage?.addEventListener(
      'pointercancel',
      () => {
        this.#examplePointerStart = null;
      },
      { signal }
    );

    const dragTarget =
      this.querySelector('[data-preview-drag-target]') || this.querySelector('[data-backboard]');
    const stage = this.querySelector('[data-stage]');
    if (dragTarget instanceof HTMLElement && stage instanceof HTMLElement) {
      dragTarget.dataset.previewDragTarget = dragTarget.dataset.previewDragTarget || 'sign';
      if (!dragTarget.hasAttribute('tabindex')) dragTarget.tabIndex = 0;
      if (!dragTarget.hasAttribute('role')) dragTarget.setAttribute('role', 'group');
      if (!dragTarget.hasAttribute('aria-label')) {
        dragTarget.setAttribute(
          'aria-label',
          this.#t(
            'accessibility.interactive_preview',
            {},
            'Neon sign preview. Drag to reposition, or use the arrow keys. Press Home to reset.'
          )
        );
      }
      dragTarget.style.cursor = 'grab';
      dragTarget.style.touchAction = window.matchMedia('(pointer: coarse)').matches
        ? 'pan-y pinch-zoom'
        : 'none';
      dragTarget.style.userSelect = 'none';

      dragTarget.addEventListener('pointerdown', this.#beginPreviewDrag, { signal });
      dragTarget.addEventListener('pointermove', this.#movePreviewDrag, { signal });
      dragTarget.addEventListener('pointerup', this.#endPreviewDrag, { signal });
      dragTarget.addEventListener('pointercancel', this.#endPreviewDrag, { signal });
      dragTarget.addEventListener('lostpointercapture', this.#endPreviewDrag, { signal });
      dragTarget.addEventListener('keydown', this.#handlePreviewKeydown, { signal });
    }
  }

  /**
   * Keep vertical wheel scrolling alive over every font/icon card. The open
   * picker consumes the movement first; any unused delta continues through
   * the containing sidebar (compact layouts) or the page scroller (desktop).
   * Native touch/pan behaviour is intentionally left untouched.
   * @param {WheelEvent} event
   */
  #handlePickerWheel(event) {
    if (event.ctrlKey || !event.deltaY) return;
    const menu = event.currentTarget;
    if (!(menu instanceof HTMLElement) || menu.hidden) return;

    const delta = tanWheelDeltaPixels(event, menu.clientHeight);
    if (!Number.isFinite(delta) || Math.abs(delta) < 0.01) return;

    const menuMaximum = Math.max(0, menu.scrollHeight - menu.clientHeight);
    const menuResult = tanConsumeWheelDelta(menu.scrollTop, menuMaximum, delta);
    let handled = Math.abs(menuResult.consumed) >= 0.01;
    if (handled) menu.scrollTop = menuResult.next;

    let remaining = menuResult.remaining;
    if (Math.abs(remaining) >= 0.01) {
      const sidebar = menu.closest('.tan-nd__sidebar');
      const sidebarStyle = sidebar instanceof HTMLElement
        ? window.getComputedStyle(sidebar)
        : null;
      const sidebarCanScroll =
        sidebar instanceof HTMLElement &&
        /auto|scroll|overlay/.test(sidebarStyle?.overflowY || '') &&
        sidebar.scrollHeight > sidebar.clientHeight + 1;
      const outerScroller = sidebarCanScroll ? sidebar : this.#getPageScroller();

      if (outerScroller instanceof Element && outerScroller !== menu) {
        const outerStart = this.#getPageScrollTop(outerScroller);
        const outerViewport = this.#isDocumentScroller(outerScroller)
          ? window.innerHeight
          : outerScroller.clientHeight;
        const outerMaximum = Math.max(0, outerScroller.scrollHeight - outerViewport);
        const outerResult = tanConsumeWheelDelta(outerStart, outerMaximum, remaining);
        if (Math.abs(outerResult.consumed) >= 0.01) {
          this.#setPageScrollTop(outerScroller, outerResult.next, 'auto');
          handled = true;
          remaining = outerResult.remaining;
        }
      }
    }

    if (handled) event.preventDefault();
  }

  #toggleFontPicker() {
    const menu = this.querySelector('[data-font-menu]');
    const trigger = this.querySelector('[data-font-trigger]');
    if (!(menu instanceof HTMLElement) || !(trigger instanceof HTMLButtonElement)) return;

    if (!menu.hidden) {
      this.#closeFontPicker();
      return;
    }

    const firstOpen = !this.#fontGridReady;
    this.#closeIconPicker();
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => {
      if (menu.hidden || trigger.getAttribute('aria-expanded') !== 'true') return;
      requestAnimationFrame(() => {
        if (menu.hidden || trigger.getAttribute('aria-expanded') !== 'true') return;
        this.#prepareFontPicker().then(() => {
          this.#prioritiseVisibleFontOptions();
          this.#pumpFontOptionQueue();
          requestAnimationFrame(() => {
            if (menu.hidden || trigger.getAttribute('aria-expanded') !== 'true') return;
            if (this.#isMobileViewport()) {
              this.#fitLoadedFontOptions();
              this.#alignMobileControl(trigger, 8);
              return;
            }
            if (firstOpen) {
              menu.scrollTop = 0;
              return;
            }
            const selected = menu.querySelector(
              '[data-font-option][aria-pressed="true"]'
            );
            if (!(selected instanceof HTMLElement)) return;
            const selectedTop = this.#elementTopInScroller(selected, menu);
            const selectedBottom = selectedTop + selected.offsetHeight;
            const visibleTop = menu.scrollTop + 30;
            const visibleBottom = menu.scrollTop + menu.clientHeight - 20;

            // Keep the active face visible inside the bounded font menu.
            if (selectedTop < visibleTop) {
              this.#setPageScrollTop(
                menu,
                selectedTop - 30,
                this.#mobileAlignmentBehavior()
              );
            } else if (selectedBottom > visibleBottom) {
              this.#setPageScrollTop(
                menu,
                selectedBottom - menu.clientHeight + 20,
                this.#mobileAlignmentBehavior()
              );
            }
          });
        });
      });
    });
  }

  /** @param {boolean} returnFocus @param {boolean} alignMobile */
  #closeFontPicker(returnFocus = false, alignMobile = false) {
    const menu = this.querySelector('[data-font-menu]');
    const trigger = this.querySelector('[data-font-trigger]');
    if (!(menu instanceof HTMLElement) || menu.hidden) return;
    menu.hidden = true;
    if (trigger instanceof HTMLButtonElement) {
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus({ preventScroll: true });
    }
    if (!alignMobile || !this.#isMobileViewport()) return;

    if (!(trigger instanceof HTMLElement)) return;
    requestAnimationFrame(() => this.#alignMobileControl(trigger, 30));
  }

  #toggleIconPicker() {
    const menu = this.querySelector('[data-icon-menu]');
    const trigger = this.querySelector('[data-icon-trigger]');
    if (!(menu instanceof HTMLElement) || !(trigger instanceof HTMLButtonElement)) return;

    if (!menu.hidden) {
      this.#closeIconPicker();
      return;
    }

    this.#closeFontPicker();
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    /*
     * Start the compact centreline request while the customer is browsing the
     * menu, so selection never flashes the whitespace-heavy CDN mask first.
     */
    void this.#loadIconVectorCatalog();
    requestAnimationFrame(() => {
      if (menu.hidden || trigger.getAttribute('aria-expanded') !== 'true') return;
      requestAnimationFrame(() => {
        if (menu.hidden || trigger.getAttribute('aria-expanded') !== 'true') return;
        this.#buildIconGrid();
        if (!this.#isMobileViewport()) return;
        requestAnimationFrame(() => {
          if (menu.hidden || trigger.getAttribute('aria-expanded') !== 'true') return;
          this.#alignMobileControl(trigger, 8);
        });
      });
    });
    const search = this.querySelector('[data-icon-search]');
    if (!this.#isMobileViewport() && search instanceof HTMLInputElement) {
      search.focus({ preventScroll: true });
    }
  }

  /** @param {boolean} returnFocus */
  #closeIconPicker(returnFocus = false) {
    const menu = this.querySelector('[data-icon-menu]');
    const trigger = this.querySelector('[data-icon-trigger]');
    if (!(menu instanceof HTMLElement) || menu.hidden) return;
    menu.hidden = true;
    if (trigger instanceof HTMLButtonElement) {
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus({ preventScroll: true });
    }
  }

  /** @param {string} id */
  #selectIcon(id) {
    const select = this.querySelector('[data-icon-select]');
    if (!(select instanceof HTMLSelectElement)) return;
    if (id && !this.#icons.some((icon) => String(icon.id) === id)) return;

    const menu = this.querySelector('[data-icon-menu]');
    const trigger = this.querySelector('[data-icon-trigger]');
    const menuWasOpen = menu instanceof HTMLElement && !menu.hidden;
    const menuScrollTop = menu instanceof HTMLElement ? menu.scrollTop : 0;
    const pageScroller = this.#getPageScroller();
    const pageScrollTop = this.#getPageScrollTop(pageScroller);
    const previousId = String(select.value || '');
    const previousIcon = this.#icons.find(
      (icon) => String(icon.id || '') === previousId
    );
    const selectedIcon = this.#icons.find(
      (icon) => String(icon.id || '') === id
    );
    select.value = id;
    this.#selectedIconId = id;
    if (id && id !== previousId) {
      /*
       * Infinity Mark is optically much wider than the other icons. Start it
       * at its audited 70% manufacturing-safe default without lowering the
       * global 6 mm tube/minimum-height floor. When the customer leaves it at
       * that default, restore the next icon's normal default; a deliberate
       * customer adjustment is preserved.
       */
      if (id === 'infinitymark') {
        this.#setIconScale(selectedIcon?.defaultScale || 70);
      } else if (
        previousId === 'infinitymark' &&
        this.#iconScale === (previousIcon?.defaultScale || 70)
      ) {
        this.#setIconScale(selectedIcon?.defaultScale || 100);
      }
      /*
       * The combination palette belongs to the design, not to one icon asset.
       * Initialise it from the current solid colour only once; afterwards keep
       * the remembered combination colour while customers try other icons.
       * Solid and RGB modes still mask this value with their shared colour and
       * returning to Color Combination restores it.
       */
      this.#iconColorId = this.#colorDescriptorFor(
        this.#iconColorId || this.#selectedSolidColor().id
      ).id;
      this.#iconColorActive = false;
      if (!previousId) this.#iconPlacement = -1;
    } else if (!id) {
      if (
        previousId === 'infinitymark' &&
        this.#iconScale === (previousIcon?.defaultScale || 70)
      ) {
        this.#setIconScale(100);
      }
      this.#iconColorActive = false;
    }
    select.dispatchEvent(new Event('change', { bubbles: true }));
    if (menuWasOpen) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const currentMenu = this.querySelector('[data-icon-menu]');
          const currentTrigger = this.querySelector('[data-icon-trigger]');
          if (!(currentMenu instanceof HTMLElement)) return;
          currentMenu.hidden = false;
          currentMenu.scrollTop = menuScrollTop;
          if (currentTrigger instanceof HTMLButtonElement) {
            currentTrigger.setAttribute('aria-expanded', 'true');
          }
          if (!this.#isMobileViewport() || this.#isHomeEmbed()) return;
          this.#setPageScrollTop(pageScroller, pageScrollTop, 'auto');
        });
      });
    }
  }

  /** @param {Record<string, any> | null} icon @param {string=} text */
  #syncIconPicker(icon, text = '') {
    const selectedId = String(icon?.id || '');
    const signature = JSON.stringify([
      selectedId,
      icon ? this.#iconScale : 0,
      icon ? text : '',
      icon ? this.#iconPlacement : -1,
      icon ? this.#iconColorId : '',
      icon ? this.#iconColorActive : false,
    ]);
    if (this.#syncedIconPickerSignature === signature) return;
    this.#syncedIconPickerSignature = signature;
    this.#selectedIconId = selectedId;
    const sample = this.querySelector('[data-icon-sample]');
    const sampleImage = this.querySelector('[data-icon-sample-image]');
    const samplePrice = this.querySelector('[data-icon-sample-price]');
    const controls = this.querySelector('[data-icon-custom-controls]');
    const scaleInput = this.querySelector('[data-icon-scale]');
    const scaleOutput = this.querySelector('[data-icon-scale-output]');

    const locale = String(this.dataset.locale || document.documentElement.lang || 'en');
    const chooseIcon = TAN_ICON_PICKER_PROMPT[locale] ||
      TAN_ICON_PICKER_PROMPT[locale.split('-')[0]] ||
      (locale.split('-')[0] === 'pt' ? TAN_ICON_PICKER_PROMPT['pt-PT'] : TAN_ICON_PICKER_PROMPT.en);
    const sampleLabel =
      icon?.label || this.#t('font_icon.choose_icon', {}, chooseIcon);
    if (sample && sample.textContent !== sampleLabel) sample.textContent = sampleLabel;
    if (sampleImage instanceof HTMLImageElement) {
      if (sampleImage.hidden === Boolean(icon)) sampleImage.hidden = !icon;
      if (icon && sampleImage.src !== icon.url) sampleImage.src = icon.url;
    }
    if (samplePrice instanceof HTMLElement) {
      if (samplePrice.hidden === Boolean(icon)) samplePrice.hidden = !icon;
      const nextPrice = icon
        ? `+${this.#formatCurrency(this.#iconShopPrice(icon) * this.#marketRate())}`
        : '';
      if (samplePrice.textContent !== nextPrice) samplePrice.textContent = nextPrice;
    }
    if (controls instanceof HTMLElement && controls.hidden === Boolean(icon)) {
      controls.hidden = !icon;
    }
    if (
      scaleInput instanceof HTMLInputElement &&
      document.activeElement !== scaleInput &&
      scaleInput.value !== String(this.#iconScale)
    ) {
      scaleInput.value = String(this.#iconScale);
    }
    const scaleLabel = `${Math.round(this.#iconScale)}%`;
    if (scaleOutput && scaleOutput.textContent !== scaleLabel) {
      scaleOutput.textContent = scaleLabel;
    }

    if (this.#syncedIconSelectionId !== selectedId) {
      this.#syncedIconSelectionId = selectedId;
      this.querySelectorAll('[data-icon-option]').forEach((candidate) => {
        if (!(candidate instanceof HTMLButtonElement)) return;
        const selected = String(candidate.dataset.iconOption || '') === selectedId;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', String(selected));
      });
    }
    this.#syncIconPlacementControls(text);
  }

  /** @param {string} text */
  #iconPlacementSlotCount(text) {
    return this.#splitGraphemes(String(text || '')).filter(
      (grapheme) => !/^[\r\n]+$/u.test(grapheme)
    ).length;
  }

  /** @param {string} text */
  #resolvedIconPlacement(text) {
    const maximum = this.#iconPlacementSlotCount(text);
    if (this.#iconPlacement < 0) return maximum;
    return this.#clamp(Math.round(this.#iconPlacement), 0, maximum);
  }

  /** @param {string} text */
  #iconTextSplit(text) {
    const source = String(text || '');
    const graphemes = this.#splitGraphemes(source);
    const placement = this.#resolvedIconPlacement(source);
    let slot = 0;
    let insertionIndex = graphemes.length;
    for (let index = 0; index < graphemes.length; index += 1) {
      if (slot === placement) {
        insertionIndex = index;
        break;
      }
      if (!/^[\r\n]+$/u.test(graphemes[index])) slot += 1;
    }
    const before = graphemes.slice(0, insertionIndex).join('');
    const after = graphemes.slice(insertionIndex).join('');
    return {
      before,
      after,
      placement,
      maximum: this.#iconPlacementSlotCount(source),
      visibleBefore: this.#visibleGraphemes(before).length,
    };
  }

  /** @param {string} text */
  #iconPlacementState(text) {
    const source = String(text || '');
    const split = this.#iconTextSplit(source);
    const position =
      split.maximum === 0 || split.placement >= split.maximum
          ? 'right'
          : split.placement <= 0
            ? 'left'
            : 'between';
    this.#iconPosition = position;
    return {
      ...split,
      position,
      label: this.#iconPlacementCanonicalLabel(source, split.placement),
      displayLabel: this.#iconPlacementLabel(source, split.placement),
    };
  }

  /** @param {string} text @param {number=} placement */
  #iconPlacementCanonicalLabel(
    text,
    placement = this.#resolvedIconPlacement(text)
  ) {
    const graphemes = this.#splitGraphemes(String(text || '')).filter(
      (grapheme) => !/^[\r\n]+$/u.test(grapheme)
    );
    const maximum = graphemes.length;
    if (maximum === 0 || placement >= maximum) return 'After text';
    if (placement <= 0) return 'Before text';
    const describe = (grapheme) =>
      /^\s+$/u.test(grapheme) ? 'space' : `“${grapheme}”`;
    return `Between ${describe(graphemes[placement - 1])} and ${describe(
      graphemes[placement]
    )}`;
  }

  /** @param {string} text @param {number=} placement */
  #iconPlacementLabel(text, placement = this.#resolvedIconPlacement(text)) {
    const graphemes = this.#splitGraphemes(String(text || '')).filter(
      (grapheme) => !/^[\r\n]+$/u.test(grapheme)
    );
    const maximum = graphemes.length;
    if (maximum === 0 || placement >= maximum) {
      return this.#t('font_icon.after_text', {}, 'After text');
    }
    if (placement <= 0) {
      return this.#t('font_icon.before_text', {}, 'Before text');
    }
    const describe = (grapheme) =>
      /^\s+$/u.test(grapheme)
        ? this.#t('common.space', {}, 'space')
        : `“${grapheme}”`;
    return this.#t(
      'font_icon.between_characters',
      {
        before: describe(graphemes[placement - 1]),
        after: describe(graphemes[placement]),
      },
      `Between ${describe(graphemes[placement - 1])} and ${describe(
        graphemes[placement]
      )}`
    );
  }

  /** @param {unknown} value @param {string=} sourceText */
  #setIconPlacement(value, sourceText) {
    const input = this.querySelector('[data-text-input]');
    const text =
      typeof sourceText === 'string'
        ? sourceText
        : input instanceof HTMLTextAreaElement
          ? input.value.trim()
          : '';
    const maximum = this.#iconPlacementSlotCount(text);
    const next = this.#clamp(
      Math.round(this.#finiteNumber(value, maximum)),
      0,
      maximum
    );
    this.#iconPlacement = next >= maximum ? -1 : next;
    this.#syncIconPlacementControls(text);
    this.#scheduleUpdate();
  }

  /** @param {string} text */
  #syncIconPlacementControls(text) {
    const placement = this.#resolvedIconPlacement(text);
    const maximum = this.#iconPlacementSlotCount(text);
    const range = this.querySelector('input[data-icon-placement]');
    const output = this.querySelector('[data-icon-placement-label]');
    const helper = this.querySelector('[data-icon-placement-help]');
    if (range instanceof HTMLInputElement) {
      range.min = '0';
      range.max = String(Math.max(0, maximum));
      range.step = '1';
      if (document.activeElement !== range) range.value = String(placement);
      range.disabled = maximum === 0;
    }
    if (output instanceof HTMLOutputElement) {
      output.hidden = maximum === 0;
      output.textContent = maximum > 0 ? this.#iconPlacementLabel(text, placement) : '';
    }
    if (helper instanceof HTMLElement) helper.hidden = maximum > 0;
  }

  /** @param {string} query */
  #filterIconOptions(query) {
    const normalized = String(query || '').trim().toLocaleLowerCase();
    this.querySelectorAll('[data-icon-option]').forEach((candidate) => {
      if (!(candidate instanceof HTMLButtonElement)) return;
      const isClearOption = !candidate.dataset.iconOption;
      const label = String(candidate.dataset.iconLabel || '').toLocaleLowerCase();
      candidate.hidden = !isClearOption && Boolean(normalized) && !label.includes(normalized);
    });
  }

  /** @param {unknown} value @param {boolean} syncInput */
  #setIconScale(value, syncInput = true) {
    const input = this.querySelector('[data-icon-scale]');
    const output = this.querySelector('[data-icon-scale-output]');
    const nextScale = this.#clamp(this.#positiveNumber(value, 100), 70, 160);
    this.#iconScale = Math.round(nextScale / 5) * 5;
    if (syncInput && input instanceof HTMLInputElement) input.value = String(this.#iconScale);
    if (output) output.textContent = `${this.#iconScale}%`;
  }

  /**
   * Translate the physical icon floor into a stable slider percentage. The
   * candidate may fall when a larger sign creates more room, but it cannot rise
   * while the same icon is being dragged. #measureDesign still enforces the
   * physical minimum by raising the finished sign size whenever required.
   *
   * @param {number} iconHeightCm
   * @param {Record<string, any> | null} icon
   */
  #syncIconScaleFloor(iconHeightCm, icon) {
    const input = this.querySelector('[data-icon-scale]');
    const output = this.querySelector('[data-icon-scale-output]');
    if (!(input instanceof HTMLInputElement)) return;
    const minimumHeight = this.#iconMinimumHeightCm(icon);
    const proportionalMinimum =
      icon && iconHeightCm > 0
        ? Math.ceil(
            ((this.#iconScale * minimumHeight) / iconHeightCm) / 5
          ) * 5
        : 70;
    const iconId = String(icon?.id || '');
    const minimumScale = tanResolveStableIconScaleFloor({
      hasIcon: Boolean(icon),
      iconId,
      previousIconId: this.#iconScaleFloorIconId,
      previousFloor: this.#iconScaleFloor,
      candidateFloor: proportionalMinimum,
      defaultFloor: icon?.defaultScale || 100,
    });
    this.#iconScaleFloor = minimumScale;
    this.#iconScaleFloorIconId = iconId;
    const minimumScaleValue = String(minimumScale);
    const description = this.#t(
      'font_icon.fixed_tube_notice',
      { height: minimumHeight },
      `Fixed 6 mm neon tube; icon cannot be smaller than ${minimumHeight} cm.`
    );
    if (input.min !== minimumScaleValue) input.min = minimumScaleValue;
    if (input.getAttribute('aria-valuemin') !== minimumScaleValue) {
      input.setAttribute('aria-valuemin', minimumScaleValue);
    }
    if (input.getAttribute('aria-description') !== description) {
      input.setAttribute('aria-description', description);
    }
    if (output instanceof HTMLElement) {
      const title = this.#t(
        'font_icon.fixed_tube_short',
        { height: minimumHeight },
        `Fixed 6 mm tube · minimum ${minimumHeight} cm icon`
      );
      if (output.title !== title) output.title = title;
    }
  }

  #resetFontOptionQueue() {
    this.#fontOptionQueueGeneration += 1;
    this.#fontOptionQueue = [];
    this.#queuedFontOptions.clear();
    this.querySelectorAll('[data-font-queue="queued"]').forEach((option) => {
      if (!(option instanceof HTMLElement)) return;
      delete option.dataset.fontQueue;
      delete option.dataset.fontQueueGeneration;
    });
  }

  /**
   * @param {HTMLButtonElement} option
   * @param {number} generation
   */
  async #loadFontOption(option, generation) {
    if (
      generation !== this.#fontOptionQueueGeneration ||
      this.#abortController.signal.aborted ||
      !this.isConnected
    ) {
      return;
    }
    const font = this.#fonts.find(
      (candidate) => String(candidate.id || '') === String(option.dataset.fontOption || '')
    );
    if (!font) return;
    if (this.#renderFontOptionPreview(option, font)) return;
    if (option.dataset.fontLoaded === 'true') {
      this.#fitFontOption(option, font);
      return;
    }
    option.setAttribute('aria-busy', 'true');
    const ready = await this.#loadFont(font, font.label || 'Sample');
    if (
      this.#abortController.signal.aborted ||
      !this.isConnected ||
      !option.isConnected
    ) {
      return;
    }
    option.removeAttribute('aria-busy');
    const permanentlyFailed = this.#fontFailedFamilies.has(String(font.family || ''));
    option.hidden = permanentlyFailed;
    option.disabled = permanentlyFailed;
    if (ready && this.dataset.viewportResizing !== 'true') {
      /*
       * Apply the final optical label size before revealing the WOFF2.
       * This prevents a fallback-sized font name from flashing in the grid.
       */
      this.#fitFontOption(option, font);
    } else if (ready) {
      delete option.dataset.fontFitKey;
    }
    option.dataset.fontLoaded = ready ? 'true' : permanentlyFailed ? 'false' : 'pending';
  }

  #loadFontPreviewSheet() {
    if (this.#fontPreviewPaths) return Promise.resolve(this.#fontPreviewPaths);
    if (this.#fontPreviewPromise) return this.#fontPreviewPromise;
    const source = this.dataset.fontPreviewsUrl;
    if (!source) return Promise.resolve(null);
    const controller = new AbortController();
    const signal = this.#abortController.signal;
    const abort = () => controller.abort();
    if (signal.aborted) return Promise.resolve(null);
    signal.addEventListener('abort', abort, { once: true });
    const timeout = window.setTimeout(abort, 4000);
    this.#fontPreviewPromise = fetch(source, { signal: controller.signal })
      .then(response => response.ok ? response.text() : Promise.reject(new Error('Preview sheet unavailable')))
      .then(text => {
        const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
        if (doc.querySelector('parsererror')) return null;
        const paths = new Map();
        doc.querySelectorAll('symbol').forEach(symbol => {
          const id = symbol.getAttribute('id');
          const path = symbol.querySelector('path')?.getAttribute('d');
          if (TAN_FONT_PREVIEW_SOURCES[id] && path && path.length < 50000) paths.set(id, path);
        });
        if (!paths.size || signal.aborted) return null;
        this.#fontPreviewPaths = paths;
        return paths;
      })
      .catch(() => null)
      .finally(() => {
        window.clearTimeout(timeout);
        signal.removeEventListener('abort', abort);
        if (!this.#fontPreviewPaths) this.#fontPreviewPromise = null;
      });
    return this.#fontPreviewPromise;
  }

  #renderFontOptionPreview(option, font) {
    if (option.dataset.fontPreview === 'true') return true;
    const source = TAN_FONT_PREVIEW_SOURCES[String(font.id || '')];
    const pathData = this.#fontPreviewPaths?.get(String(font.id || ''));
    if (!source || !pathData || source[0] !== font.label || source[1] !== font.url) return false;
    const label = option.querySelector('span');
    if (!(label instanceof HTMLElement)) return false;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 120 50');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', pathData);
    path.setAttribute('fill', 'currentColor');
    svg.append(path);
    label.replaceChildren(svg);
    option.setAttribute('aria-label', font.label);
    option.dataset.fontPreview = 'true';
    option.dataset.fontLoaded = 'true';
    option.removeAttribute('aria-busy');
    return true;
  }

  #observeIconImages(grid) {
    this.#iconOptionObserver?.disconnect();
    const images = Array.from(grid.querySelectorAll('img[data-icon-src]'));
    const load = image => {
      const source = image.dataset.iconSrc;
      if (source) image.src = source;
      delete image.dataset.iconSrc;
    };
    if (!('IntersectionObserver' in window)) {
      images.forEach(load);
      return;
    }
    this.#iconOptionObserver = new IntersectionObserver(entries => {
      if (this.#abortController.signal.aborted || !this.isConnected) return;
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        load(entry.target);
        this.#iconOptionObserver?.unobserve(entry.target);
      });
    }, { root: null, rootMargin: '64px 0px' });
    images.forEach(image => this.#iconOptionObserver.observe(image));
  }


  #warmFontPicker() {
    const connection = navigator.connection;
    if (this.#fontPickerWarmupStarted || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
    this.#fontPickerWarmupStarted = true;
    const signal = this.#abortController.signal;
    const prepare = () => {
      const load = () => {
        if (!signal.aborted && this.isConnected) void this.#loadFontPreviewSheet();
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 600 });
      else window.setTimeout(load, 100);
    };
    if (document.readyState === 'complete') prepare();
    else window.addEventListener('load', prepare, { once: true, signal });
  }

  #pumpFontOptionQueue() {
    const menu = this.querySelector('[data-font-menu]');
    const connection = navigator.connection;
    const limited = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    const maximumConcurrentLoads = menu?.hidden === false
      ? limited ? 2 : connection?.effectiveType === '3g' ? 4 : 8
      : 2;
    if (this.#abortController.signal.aborted || !this.isConnected) return;
    while (
      this.#activeFontOptionLoads < maximumConcurrentLoads &&
      this.#fontOptionQueue.length > 0
    ) {
      const queued = this.#fontOptionQueue.shift();
      const option = queued?.option;
      const generation = queued?.generation;
      if (option instanceof HTMLButtonElement) {
        this.#queuedFontOptions.delete(option);
        if (option.dataset.fontQueue === 'queued') {
          delete option.dataset.fontQueue;
          delete option.dataset.fontQueueGeneration;
        }
      }
      if (
        !(option instanceof HTMLButtonElement) ||
        generation !== this.#fontOptionQueueGeneration ||
        option.dataset.fontLoaded === 'true' ||
        option.dataset.fontQueue === 'active'
      ) {
        continue;
      }
      this.#activeFontOptionLoads += 1;
      option.dataset.fontQueue = 'active';
      option.dataset.fontQueueGeneration = String(generation);
      void this.#loadFontOption(option, generation).finally(() => {
        if (option.dataset.fontQueueGeneration === String(generation)) {
          delete option.dataset.fontQueue;
          delete option.dataset.fontQueueGeneration;
        }
        this.#activeFontOptionLoads = Math.max(0, this.#activeFontOptionLoads - 1);
        this.#pumpFontOptionQueue();
      });
    }
  }

  /** @param {HTMLButtonElement} option @param {boolean} priority */
  #enqueueFontOption(option, priority = false) {
    if (
      !(option instanceof HTMLButtonElement) ||
      option.dataset.fontLoaded === 'true' ||
      option.dataset.fontQueue === 'active'
    ) {
      return;
    }
    if (this.#queuedFontOptions.has(option)) {
      if (priority) {
        const index = this.#fontOptionQueue.findIndex(
          (queued) => queued.option === option
        );
        if (index >= 0) {
          const [queued] = this.#fontOptionQueue.splice(index, 1);
          this.#fontOptionQueue.unshift(queued);
        }
      }
      return;
    }
    const generation = this.#fontOptionQueueGeneration;
    const queued = { option, generation };
    this.#queuedFontOptions.add(option);
    option.dataset.fontQueue = 'queued';
    option.dataset.fontQueueGeneration = String(generation);
    if (priority) this.#fontOptionQueue.unshift(queued);
    else this.#fontOptionQueue.push(queued);
    this.#pumpFontOptionQueue();
  }

  #prepareFontPicker() {
    this.#buildFontGrid();
    if (this.#fontPickerPromise) return this.#fontPickerPromise;
    const grid = this.querySelector('[data-font-options]');
    const loading = this.querySelector('[data-font-loading]');
    if (!(grid instanceof HTMLElement)) return Promise.resolve();
    grid.hidden = false;
    if (loading instanceof HTMLElement) loading.hidden = true;
    const signal = this.#abortController.signal;
    this.#fontPickerPromise = this.#loadFontPreviewSheet().then(() => {
      if (signal.aborted || !this.isConnected) return;
      return this.#initialiseFontPicker();
    });
    return this.#fontPickerPromise;
  }

  #initialiseFontPicker() {

    const loading = this.querySelector('[data-font-loading]');
    const grid = this.querySelector('[data-font-options]');
    if (!(grid instanceof HTMLElement)) return Promise.resolve();

    if (loading instanceof HTMLElement) loading.hidden = true;
    grid.hidden = false;

    const options = Array.from(grid.querySelectorAll('[data-font-option]')).filter(
      (candidate) => candidate instanceof HTMLButtonElement
    );
    options.forEach(option => {
      const font = this.#fonts.find(candidate => String(candidate.id || '') === option.dataset.fontOption);
      if (font) this.#renderFontOptionPreview(option, font);
    });
    const pendingOptions = options.filter(option => option.dataset.fontPreview !== 'true');
    this.#resetFontOptionQueue();

    const selectedOption = options.find(
      (option) => option.getAttribute('aria-pressed') === 'true'
    );
    if (selectedOption) this.#enqueueFontOption(selectedOption, true);

    this.#fontOptionObserver?.disconnect();
    if (pendingOptions.length && 'IntersectionObserver' in window) {
      this.#fontOptionObserver = new IntersectionObserver(
        (entries) => {
          if (this.dataset.viewportResizing === 'true') return;
          entries
            .filter(
              (entry) =>
                entry.isIntersecting && entry.target instanceof HTMLButtonElement
            )
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)
            .forEach((entry) => {
              if (entry.target.dataset.fontLoaded === 'true') {
                const loadedFont = this.#fonts.find(
                  (font) =>
                    String(font.id || '') ===
                    String(entry.target.dataset.fontOption || '')
                );
                if (loadedFont) this.#fitFontOption(entry.target, loadedFont);
                return;
              }
              this.#fontOptionObserver?.unobserve(entry.target);
              this.#enqueueFontOption(
                entry.target,
                entry.target.getAttribute('aria-pressed') === 'true'
              );
            });
        },
        {
          root: null,
          rootMargin: '64px 0px',
        }
      );
      pendingOptions.forEach((option) => this.#fontOptionObserver?.observe(option));
    } else {
      pendingOptions.slice(0, 8).forEach((option) => this.#enqueueFontOption(option));
    }

    this.#scheduleResponsiveFontRefresh();

    return Promise.resolve();
  }

  /** @param {HTMLButtonElement} option @param {Record<string, any>} font */
  #fitFontOption(option, font) {
    if (option.dataset.fontPreview === 'true') return;
    const context = this.#measureContext;
    const label = String(font.label || option.dataset.fontLabel || option.textContent || 'Font');
    const family = String(font.family || 'sans-serif');
    const optionWidth = option.clientWidth;
    const optionHeight = option.clientHeight;
    if (!context || optionWidth < 40 || optionHeight < 40) return;
    const mobile = this.#isMobileViewport();
    const pickerOpticalScale = this.#clamp(
      this.#positiveNumber(
        font.pickerOpticalScale,
        label.toLocaleLowerCase().replace(/[^a-z0-9]/g, '') === 'athens' ? 0.7 : 1
      ),
      0.25,
      3
    );
    const pickerLetterSpacing = this.#clamp(
      this.#finiteNumber(font.pickerLetterSpacingEm, 0),
      -1,
      2
    );
    const pickerBaselineOffset = this.#clamp(
      this.#finiteNumber(font.pickerBaselineOffsetEm, 0),
      -2,
      2
    );
    const fitKey = `optical-v5:${optionWidth}x${optionHeight}:${mobile ? 'm' : 'd'}:${family}:${label}:${pickerOpticalScale}:${pickerLetterSpacing}:${pickerBaselineOffset}`;
    if (option.dataset.fontFitKey === fitKey) return;

    const probeSize = 100;
    context.save();
    context.font = `400 ${probeSize}px ${family}`;
    const metric = context.measureText(label);
    context.restore();

    /*
     * Canvas metrics can under-report a few decorative WOFF2 faces in WebKit
     * and Chromium. Measure the same loaded face in real layout as a second
     * source so a long font name never reaches the ellipsis state.
     */
    let layoutWidth = 0;
    const layoutProbe = document.createElement('span');
    layoutProbe.textContent = label;
    Object.assign(layoutProbe.style, {
      position: 'fixed',
      left: '-10000px',
      top: '-10000px',
      visibility: 'hidden',
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      fontFamily: family,
      fontSize: `${probeSize}px`,
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '1',
      letterSpacing: `${pickerLetterSpacing}em`,
    });
    document.body.append(layoutProbe);
    layoutWidth = Math.max(0, layoutProbe.getBoundingClientRect().width);
    layoutProbe.remove();

    const inkWidth = Math.max(
      1,
      metric.width || 1,
      layoutWidth,
      Math.abs(this.#finiteNumber(metric.actualBoundingBoxLeft, 0)) +
        Math.abs(this.#finiteNumber(metric.actualBoundingBoxRight, metric.width || 1))
    );
    const inkHeight = Math.max(
      1,
      this.#finiteNumber(metric.actualBoundingBoxAscent, probeSize * 0.75) +
        this.#finiteNumber(metric.actualBoundingBoxDescent, probeSize * 0.2)
    );
    const optionStyle = window.getComputedStyle(option);
    const horizontalPadding =
      this.#finiteNumber(Number.parseFloat(optionStyle.paddingLeft), 0) +
      this.#finiteNumber(Number.parseFloat(optionStyle.paddingRight), 0);
    const verticalPadding =
      this.#finiteNumber(Number.parseFloat(optionStyle.paddingTop), 0) +
      this.#finiteNumber(Number.parseFloat(optionStyle.paddingBottom), 0);
    const availableWidth = Math.max(
      28,
      optionWidth - horizontalPadding - 4
    );
    const availableHeight = Math.max(
      26,
      optionHeight - verticalPadding - 4
    );
    /*
     * Some display faces use only a small part of their em square. The old
     * fixed 26/30px ceiling made those names look faint and much smaller even
     * when the measured ink had ample room. Keep width and ink-height fitting
     * authoritative, with only a card-relative safety ceiling for bad font
     * metrics. This normalises apparent size without clipping long labels.
     */
    const maximumFontSize = mobile
      ? Math.min(48, optionHeight * 0.78)
      : Math.min(52, optionHeight);
    const minimumFontSize = mobile ? 10 : 8;
    const fittedSize = this.#clamp(
      Math.min(
        (availableWidth / inkWidth) * probeSize,
        (availableHeight / inkHeight) * probeSize
      ) * pickerOpticalScale,
      minimumFontSize,
      Math.max(mobile ? 26 : 30, maximumFontSize)
    );
    option.dataset.fontFitKey = fitKey;
    option.style.setProperty(
      '--tan-nd-option-font-size',
      `${Math.round(fittedSize * 10) / 10}px`
    );
    const optionLabel = option.querySelector('span');
    if (optionLabel instanceof HTMLElement) {
      optionLabel.style.display = 'inline-block';
      optionLabel.style.letterSpacing = `${pickerLetterSpacing}em`;
      optionLabel.style.transform = `translateY(${pickerBaselineOffset}em)`;
    }
  }

  #fitLoadedFontOptions() {
    const grid = this.querySelector('[data-font-options]');
    const loadedOptions = Array.from(
      this.querySelectorAll('[data-font-option][data-font-loaded="true"]:not([data-font-preview="true"])')
    );
    const fitSignature = `${grid instanceof HTMLElement ? grid.clientWidth : 0}:${
      this.#isMobileViewport() ? 'm' : 'd'
    }:${loadedOptions.length}`;
    if (this.#fontGridFitSignature === fitSignature) {
      this.#fitFontTrigger(this.#getSelectedFont());
      return;
    }
    this.#fontGridFitSignature = fitSignature;
    loadedOptions.forEach((candidate) => {
      if (!(candidate instanceof HTMLButtonElement)) return;
      const font = this.#fonts.find(
        (entry) => String(entry.id || '') === String(candidate.dataset.fontOption || '')
      );
      if (font) this.#fitFontOption(candidate, font);
    });
    this.#fitFontTrigger(this.#getSelectedFont());
  }

  /*
   * Resize can move a previously off-screen font row into view before an
   * IntersectionObserver callback is delivered. Promote only the visible
   * rows so the real WOFF2 previews appear in the first available load slots
   * without downloading the entire catalogue during a window drag.
   */
  #prioritiseVisibleFontOptions() {
    const menu = this.querySelector('[data-font-menu]');
    const grid = this.querySelector('[data-font-options]');
    if (
      !(menu instanceof HTMLElement) ||
      menu.hidden ||
      !(grid instanceof HTMLElement) ||
      grid.hidden
    ) {
      return;
    }

    if (!grid.querySelector('[data-font-option]:not([data-font-preview="true"])')) return;
    const sidebar = this.querySelector('.tan-nd__sidebar');
    const root =
      this.#isMobileViewport() && sidebar instanceof HTMLElement ? sidebar : menu;
    const rootRect = root.getBoundingClientRect();
    const visibleTop = Math.max(0, rootRect.top) - 36;
    const visibleBottom = Math.min(window.innerHeight, rootRect.bottom) + 36;
    if (visibleBottom <= visibleTop) return;

    Array.from(grid.querySelectorAll('[data-font-option]:not([data-font-preview="true"])'))
      .map((candidate) => ({
        option: candidate,
        rect:
          candidate instanceof HTMLButtonElement
            ? candidate.getBoundingClientRect()
            : null,
      }))
      .filter(
        ({ option, rect }) =>
          option instanceof HTMLButtonElement &&
          !option.hidden &&
          rect &&
          rect.bottom >= visibleTop &&
          rect.top <= visibleBottom
      )
      .sort((left, right) => left.rect.top - right.rect.top)
      .slice(0, 8)
      .forEach(({ option }) => {
        if (option.dataset.fontLoaded === 'true') {
          const font = this.#fonts.find(
            (entry) =>
              String(entry.id || '') === String(option.dataset.fontOption || '')
          );
          if (font) this.#fitFontOption(option, font);
          return;
        }
        this.#fontOptionObserver?.unobserve(option);
        this.#enqueueFontOption(option, true);
      });
  }

  #scheduleResponsiveFontRefresh() {
    if (this.#responsiveFontFrame) return;
    this.#responsiveFontFrame = requestAnimationFrame(() => {
      this.#responsiveFontFrame = 0;
      this.#fitFontTrigger(this.#getSelectedFont());
      this.#prioritiseVisibleFontOptions();
    });
  }

  /*
   * Live window dragging can fire dozens of ResizeObserver callbacks while
   * Chromium is also resizing the page's compositor layer. CSS handles the
   * panel width immediately; postpone the expensive neon/font measurement
   * pass until the pointer has been still for one short frame window.
   */
  #beginViewportResize() {
    if (this.dataset.viewportResizing !== 'true') {
      if (this.#renderFrame) cancelAnimationFrame(this.#renderFrame);
      this.#renderFrame = 0;
      if (this.#previewLayoutFrame) cancelAnimationFrame(this.#previewLayoutFrame);
      this.#previewLayoutFrame = 0;
      if (this.#previewLayoutTimer) window.clearTimeout(this.#previewLayoutTimer);
      this.#previewLayoutTimer = 0;
      if (this.#responsiveFontFrame) cancelAnimationFrame(this.#responsiveFontFrame);
      this.#responsiveFontFrame = 0;

      const fontMenu = this.querySelector('[data-font-menu]');
      this.#fontPickerSuspendedForResize =
        fontMenu instanceof HTMLElement && !fontMenu.hidden;
      this.#fontOptionObserver?.disconnect();
      this.#fontOptionObserver = null;
      this.#fontPickerPromise = null;
      this.#resetFontOptionQueue();
    }
    this.dataset.viewportResizing = 'true';
    if (this.#viewportResizeTimer) window.clearTimeout(this.#viewportResizeTimer);
    this.#viewportResizeTimer = window.setTimeout(() => {
      this.#viewportResizeTimer = 0;
      delete this.dataset.viewportResizing;
      this.#fontGridFitSignature = '';
      this.#scheduleUpdate();
      const fontMenu = this.querySelector('[data-font-menu]');
      const restoreOpenPicker =
        this.#fontPickerSuspendedForResize &&
        fontMenu instanceof HTMLElement &&
        !fontMenu.hidden;
      this.#fontPickerSuspendedForResize = false;
      if (restoreOpenPicker) {
        void this.#prepareFontPicker();
      } else {
        this.#scheduleResponsiveFontRefresh();
      }
    }, 48);
  }

  /** @param {string} id */
  #selectFont(id) {
    const select = this.querySelector('[data-font-select]');
    if (!(select instanceof HTMLSelectElement)) return;
    if (!Array.from(select.options).some((option) => option.value === id)) return;

    select.value = id;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /** @param {Record<string, any>} font */
  #syncFontPicker(font) {
    const selectedId = String(font.id || '');
    if (this.#syncedFontPickerId === selectedId) return;
    this.#syncedFontPickerId = selectedId;
    const sample = this.querySelector('[data-font-sample]');
    if (sample) {
      sample.textContent = font.label || 'Font';
      sample.setAttribute('title', font.label || 'Font');
    }
    this.#scheduleResponsiveFontRefresh();

    this.querySelectorAll('[data-font-option]').forEach((candidate) => {
      if (!(candidate instanceof HTMLButtonElement)) return;
      const selected = candidate.dataset.fontOption === selectedId;
      candidate.classList.toggle('is-selected', selected);
      candidate.setAttribute('aria-pressed', String(selected));
    });
  }

  /** @param {Record<string, any>} font */
  #fitFontTrigger(font) {
    const sample = this.querySelector('[data-font-sample]');
    if (!(sample instanceof HTMLElement)) return;
    const availableWidth = sample.clientWidth;
    const availableHeight = sample.clientHeight;
    const context = this.#measureContext;
    if (!context || availableWidth < 24 || availableHeight < 24) return;

    const label = String(font?.label || sample.textContent || 'Font');
    const family = String(font?.family || 'sans-serif');
    const pickerOpticalScale = this.#clamp(
      this.#positiveNumber(
        font?.pickerOpticalScale,
        label.toLocaleLowerCase().replace(/[^a-z0-9]/g, '') === 'athens' ? 0.7 : 1
      ),
      0.25,
      3
    );
    const pickerLetterSpacing = this.#clamp(
      this.#finiteNumber(font?.pickerLetterSpacingEm, 0),
      -1,
      2
    );
    const pickerBaselineOffset = this.#clamp(
      this.#finiteNumber(font?.pickerBaselineOffsetEm, 0),
      -2,
      2
    );
    if (!this.#isFontReady(font, label)) return;
    const fitKey = [availableWidth, availableHeight, family, label, font?.url,
      pickerOpticalScale, pickerLetterSpacing, pickerBaselineOffset, this.#isMobileViewport()].join(':');
    if (this.#fontTriggerFitKey === fitKey) return;
    const probeSize = 100;
    context.save();
    context.font = `400 ${probeSize}px ${family}`;
    const metric = context.measureText(label);
    context.restore();
    let layoutWidth;
    if ('letterSpacing' in context) {
      // Measure the spaced label without inserting an element and flushing
      // document layout. Save/restore protects live preview measurements.
      context.save();
      context.font = `400 ${probeSize}px ${family}`;
      context.letterSpacing = `${pickerLetterSpacing * probeSize}px`;
      layoutWidth = Math.max(0, context.measureText(label).width);
      context.restore();
    } else {
      // Older browsers keep the existing CSS text measurement.
      const layoutProbe = document.createElement('span');
      layoutProbe.textContent = label;
      Object.assign(layoutProbe.style, {
        position: 'fixed',
        left: '-10000px',
        top: '-10000px',
        visibility: 'hidden',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        fontFamily: family,
        fontSize: `${probeSize}px`,
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '1',
        letterSpacing: `${pickerLetterSpacing}em`,
      });
      document.body.append(layoutProbe);
      layoutWidth = Math.max(0, layoutProbe.getBoundingClientRect().width);
      layoutProbe.remove();
    }
    const inkWidth = Math.max(
      1,
      metric.width || 1,
      layoutWidth,
      Math.abs(this.#finiteNumber(metric.actualBoundingBoxLeft, 0)) +
        Math.abs(this.#finiteNumber(metric.actualBoundingBoxRight, metric.width || 1))
    );
    const inkHeight = Math.max(
      1,
      this.#finiteNumber(metric.actualBoundingBoxAscent, probeSize * 0.75) +
        this.#finiteNumber(metric.actualBoundingBoxDescent, probeSize * 0.2)
    );
    const mobile = this.#isMobileViewport();
    const fittedSize = this.#clamp(
      Math.min(
        (Math.max(20, availableWidth - 6) / inkWidth) * probeSize,
        (Math.max(20, availableHeight - 8) / inkHeight) * probeSize
      ) * pickerOpticalScale,
      mobile ? 11 : 12,
      mobile ? 24 : 26
    );
    sample.style.setProperty(
      '--tan-nd-trigger-font-size',
      `${Math.round(fittedSize * 10) / 10}px`
    );
    this.#fontTriggerFitKey = fitKey;
    sample.style.letterSpacing = `${pickerLetterSpacing}em`;
    sample.style.transform = `translateY(${pickerBaselineOffset}em)`;
  }

  #syncMobileAlignmentButtons() {
    const selected = this.querySelector('input[data-alignment]:checked');
    const value = selected instanceof HTMLInputElement ? selected.value : 'center';
    this.querySelectorAll('[data-mobile-alignment]').forEach((candidate) => {
      if (!(candidate instanceof HTMLButtonElement)) return;
      const active = candidate.dataset.mobileAlignment === value;
      candidate.setAttribute('aria-pressed', String(active));
      candidate.classList.toggle('is-selected', active);
    });
  }

  #readExampleLibrary() {
    const library = new Map();
    document.querySelectorAll('script[data-tan-nd-example-library]').forEach((source) => {
      if (!(source instanceof HTMLScriptElement)) return;
      try {
        const payload = JSON.parse(source.textContent || '');
        const groups = Array.isArray(payload?.groups) ? payload.groups : [];
        groups.forEach((group) => {
          const key = String(group?.key || '').trim();
          if (!key) return;
          const images = Array.isArray(group?.images)
            ? group.images.filter((image) => image && typeof image.src === 'string' && image.src.trim())
            : [];
          const current = library.get(key);
          library.set(key, {
            key,
            title: String(
              group?.title ||
                current?.title ||
                this.#t('examples.heading', {}, 'Example')
            ),
            images: [...(current?.images || []), ...images],
          });
        });
      } catch {
        // Invalid or incomplete theme-editor JSON should never block the designer.
      }
    });
    return library;
  }

  /** @param {HTMLButtonElement} trigger */
  #resolveExampleKey(trigger) {
    const directKey = String(trigger.dataset.exampleKey || '').trim();
    if (directKey) return directKey;

    switch (trigger.dataset.exampleSource) {
      case 'font': {
        const select = this.querySelector('[data-font-select]');
        return select instanceof HTMLSelectElement ? `font:${select.value}` : '';
      }
      case 'color': {
        const mode = this.querySelector('input[data-color-mode]:checked');
        const modeId =
          mode instanceof HTMLInputElement ? this.#normalizeColorMode(mode.dataset.colorMode) : 'solid';
        if (modeId !== 'solid') {
          return mode instanceof HTMLInputElement ? String(mode.dataset.exampleKey || '') : '';
        }
        const input = this.querySelector('input[data-color]:checked');
        const colorKey = input instanceof HTMLInputElement ? String(input.dataset.exampleKey || '') : '';
        return colorKey || (mode instanceof HTMLInputElement ? String(mode.dataset.exampleKey || '') : '');
      }
      case 'alignment': {
        const input = this.querySelector('input[data-alignment]:checked');
        return input instanceof HTMLInputElement ? String(input.dataset.exampleKey || '') : '';
      }
      case 'backboard-color': {
        const select = this.querySelector('[data-backboard-color]');
        return select instanceof HTMLSelectElement
          ? String(select.selectedOptions[0]?.dataset.exampleKey || '')
          : '';
      }
      case 'usage':
      case 'backboard':
      case 'mounting':
      case 'remote':
      case 'mockup':
      case 'greeting': {
        const input = this.querySelector(`input[name$="-${trigger.dataset.exampleSource}"]:checked`);
        return input instanceof HTMLInputElement ? String(input.dataset.exampleKey || '') : '';
      }
      case 'production': {
        const input = this.querySelector('input[name$="-rush"]:checked');
        return input instanceof HTMLInputElement ? String(input.dataset.exampleKey || '') : '';
      }
      default:
        return '';
    }
  }

  #syncExampleTriggers() {
    if (this.#exampleLibrary.size === 0) this.#exampleLibrary = this.#readExampleLibrary();
    this.querySelectorAll('[data-example-trigger]').forEach((candidate) => {
      if (!(candidate instanceof HTMLButtonElement)) return;
      const key = this.#resolveExampleKey(candidate);
      const group = this.#exampleLibrary.get(key);
      candidate.dataset.exampleResolvedKey = key;
      candidate.hidden = !group || group.images.length === 0;
      candidate.setAttribute(
        'aria-label',
        this.#t(
          'accessibility.open_example',
          {
            selection:
              group?.title ||
              candidate.dataset.exampleTitle ||
              this.#t('examples.heading', {}, 'Example'),
          },
          `Open ${group?.title || candidate.dataset.exampleTitle || 'selection'} example`
        )
      );
    });
  }

  #refreshExampleLibrary() {
    this.#exampleLibrary = this.#readExampleLibrary();
    this.#syncExampleTriggers();

    const dialog = this.querySelector('[data-example-dialog]');
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
    const group = this.#exampleLibrary.get(this.#exampleKey);
    this.#exampleIndex = group?.images.length
      ? Math.min(this.#exampleIndex, group.images.length - 1)
      : 0;
    this.#renderExample();
  }

  /** @param {HTMLButtonElement} trigger */
  #openExample(trigger) {
    this.#exampleLibrary = this.#readExampleLibrary();
    this.#syncExampleTriggers();
    const key =
      this.#resolveExampleKey(trigger) ||
      String(trigger.dataset.exampleResolvedKey || trigger.dataset.exampleSource || 'selection');

    if (!this.#exampleLibrary.get(key)?.images.length) return;

    const dialog = this.querySelector('[data-example-dialog]');
    if (!(dialog instanceof HTMLDialogElement)) return;
    this.#exampleKey = key;
    this.#exampleIndex = 0;
    this.#exampleOpener = trigger;
    this.#renderExample();
    if (!dialog.open) dialog.showModal();
  }

  #renderExample() {
    const renderToken = ++this.#exampleRenderToken;
    const group = this.#exampleLibrary.get(this.#exampleKey);
    const dialog = this.querySelector('[data-example-dialog]');
    const stage = this.querySelector('[data-example-stage]');
    const title = this.querySelector('[data-example-title]');
    const counter = this.querySelector('[data-example-counter]');
    const previous = this.querySelector('[data-example-previous]');
    const next = this.querySelector('[data-example-next]');
    const footer = counter?.closest('footer');
    if (!(stage instanceof HTMLElement)) return;

    if (!group || group.images.length === 0) {
      dialog?.classList.add('is-empty');
      stage.replaceChildren();
      stage.classList.remove('is-loading');
      stage.classList.add('is-empty');
      const message = document.createElement('p');
      message.className = 'tan-nd__example-empty';
      message.textContent = this.#t(
        'examples.coming_soon',
        {},
        'Example image coming soon.'
      );
      stage.append(message);
      if (title) {
        title.textContent =
          group?.title ||
          this.#exampleOpener?.dataset.exampleTitle ||
          this.#t('examples.heading', {}, 'Example');
      }
      if (counter) counter.textContent = '';
      if (footer instanceof HTMLElement) footer.hidden = true;
      if (previous instanceof HTMLButtonElement) previous.disabled = true;
      if (next instanceof HTMLButtonElement) next.disabled = true;
      return;
    }

    dialog?.classList.remove('is-empty');
    this.#exampleIndex = (this.#exampleIndex + group.images.length) % group.images.length;
    const imageData = group.images[this.#exampleIndex];
    stage.replaceChildren();
    stage.classList.remove('is-empty');
    stage.classList.add('is-loading');
    if (footer instanceof HTMLElement) footer.hidden = false;
    if (title) {
      title.textContent =
        group.title || this.#t('examples.heading', {}, 'Example');
    }
    if (counter) counter.textContent = `${this.#exampleIndex + 1} / ${group.images.length}`;
    if (previous instanceof HTMLButtonElement) previous.disabled = group.images.length < 2;
    if (next instanceof HTMLButtonElement) next.disabled = group.images.length < 2;

    const image = document.createElement('img');
    image.alt = String(
      imageData.alt ||
        this.#t(
          'accessibility.selected_example',
          {
            selection:
              group.title || this.#t('examples.heading', {}, 'Example'),
          },
          `${group.title || 'Selection'} example`
        )
    );
    image.decoding = 'async';
    image.loading = 'eager';
    if (Number(imageData.width) > 0) image.width = Number(imageData.width);
    if (Number(imageData.height) > 0) image.height = Number(imageData.height);

    const srcset =
      typeof imageData.srcset === 'string'
        ? imageData.srcset
        : Array.isArray(imageData.sources)
          ? imageData.sources
              .map((source) =>
                Array.isArray(source) && source.length >= 2 ? `${source[1]} ${source[0]}w` : ''
              )
              .filter(Boolean)
              .join(', ')
          : '';
    if (srcset) image.srcset = srcset;
    image.sizes =
      '(orientation: landscape) and (max-height: 600px) min(620px, calc(100vw - 48px)), ' +
      '(max-width: 599px) calc(100vw - 16px), min(920px, calc(100vw - 32px))';
    image.addEventListener(
      'load',
      () => {
        if (
          renderToken === this.#exampleRenderToken &&
          stage.contains(image)
        ) {
          stage.classList.remove('is-loading');
        }
      },
      { once: true, signal: this.#abortController.signal }
    );
    image.addEventListener(
      'error',
      () => {
        if (
          renderToken !== this.#exampleRenderToken ||
          !stage.contains(image)
        ) {
          return;
        }
        stage.classList.remove('is-loading');
        const message = document.createElement('p');
        message.textContent = this.#t(
          'examples.load_error',
          {},
          'This example could not be loaded. Please try again.'
        );
        stage.replaceChildren(message);
      },
      { once: true, signal: this.#abortController.signal }
    );
    image.src = imageData.src;
    stage.append(image);
  }

  /** @param {number} direction */
  #stepExample(direction) {
    const group = this.#exampleLibrary.get(this.#exampleKey);
    if (!group || group.images.length < 2) return;
    this.#exampleIndex = (this.#exampleIndex + direction + group.images.length) % group.images.length;
    this.#renderExample();
  }

  #closeExample() {
    this.#exampleRenderToken += 1;
    const dialog = this.querySelector('[data-example-dialog]');
    const stage = this.querySelector('[data-example-stage]');
    if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
    dialog?.classList.remove('is-empty');
    if (stage instanceof HTMLElement) {
      stage.classList.remove('is-loading');
      stage.replaceChildren();
    }
    this.#exampleOpener?.focus({ preventScroll: true });
    this.#exampleOpener = null;
    this.#exampleKey = '';
    this.#exampleIndex = 0;
  }

  /** @param {Record<string, any>} font */
  #fontDescriptor(font) {
    return `400 100px ${JSON.stringify(String(font.family || 'sans-serif'))}`;
  }

  /** @param {Record<string, any>} font */
  #isManagedFont(font) {
    const family = String(font.family || '');
    return Boolean(font.url) && (
      family.startsWith('TanDesigner-') ||
      family.startsWith('TanCatalog-')
    );
  }

  /** @param {Record<string, any>} font */
  #ensureCatalogFontFace(font) {
    const family = String(font.family || '');
    const url = String(font.url || '').trim();
    if (
      !family.startsWith('TanCatalog-') ||
      !url ||
      !document.fonts ||
      typeof FontFace !== 'function'
    ) {
      return null;
    }

    const current = this.#fontFaces.get(family);
    if (current) return current;

    // Reuse the full inline startup face only for its exact catalog source.
    // This avoids downloading the same local-language default a second time.
    if (family === this.dataset.initialFontFamily && url === this.dataset.initialFontUrl) {
      const embedded = Array.from(document.fonts).find(face =>
        face.family.replace(/^['"]|['"]$/g, '') === family && face.weight === '400'
      );
      if (embedded) {
        this.#fontFaces.set(family, embedded);
        return embedded;
      }
    }

    try {
      const face = new FontFace(
        family,
        `url(${JSON.stringify(url)})`,
        { style: 'normal', weight: '400' }
      );
      document.fonts.add(face);
      this.#fontFaces.set(family, face);
      return face;
    } catch {
      return null;
    }
  }

  /**
   * @param {Record<string, any>} font
   * @param {string} sample
   */
  #isFontReady(font, sample) {
    const family = String(font.family || '');
    if (!this.#isManagedFont(font) || !document.fonts) return true;
    if (this.#fontReadyFamilies.has(family)) return true;
    if (this.#fontFailedFamilies.has(family)) return false;

    if (family.startsWith('TanCatalog-')) {
      const face = this.#fontFaces.get(family);
      if (!face) return false;
      if (face.status === 'loaded') {
        this.#fontReadyFamilies.add(family);
        return true;
      }
      if (face.status === 'error') return false;
    }

    try {
      if (document.fonts.check(this.#fontDescriptor(font), sample || 'Sample')) {
        this.#fontReadyFamilies.add(family);
        return true;
      }
    } catch {
      return false;
    }

    return false;
  }

  /**
   * @param {Record<string, any>} font
   * @param {string} sample
   * @returns {Promise<boolean>}
   */
  #loadFont(font, sample) {
    const family = String(font.family || '');
    if (!this.#isManagedFont(font) || !document.fonts) return Promise.resolve(true);
    if (this.#fontReadyFamilies.has(family)) return Promise.resolve(true);
    if (this.#fontFailedFamilies.has(family)) return Promise.resolve(false);

    const existing = this.#fontLoadPromises.get(family);
    if (existing) return existing;
    const catalogFace = this.#ensureCatalogFontFace(font);

    const promise = new Promise((resolve) => {
      let settled = false;
      const finish = (ready, permanentFailure = false) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        if (ready) {
          this.#fontReadyFamilies.add(family);
          this.#fontFailedFamilies.delete(family);
        } else if (permanentFailure) {
          this.#fontFailedFamilies.add(family);
        } else {
          /*
           * A slow connection is not a broken font. Allow a later retry
           * instead of hiding the face permanently after the time budget.
           */
          this.#fontLoadPromises.delete(family);
        }
        resolve(ready);
      };
      const timeout = window.setTimeout(() => finish(false), 8000);

      try {
        if (catalogFace) {
          catalogFace
            .load()
            .then(() =>
              finish(
                catalogFace.status === 'loaded',
                catalogFace.status === 'error'
              )
            )
            .catch(() => finish(false, true));
        } else {
          document.fonts
            .load(this.#fontDescriptor(font), sample || 'Sample')
            .then((matches) => finish(matches.length > 0, false))
            .catch(() => finish(false, true));
        }
      } catch {
        finish(false, true);
      }
    });

    this.#fontLoadPromises.set(family, promise);
    return promise;
  }

  /** @param {Array<Record<string, any>>} fonts */
  #normaliseFonts(fonts) {
    if (!Array.isArray(fonts)) return [];
    const normalised = [];
    const indexByKey = new Map();

    fonts.forEach((font) => {
      if (!font || typeof font !== 'object') return;
      const id = String(font.id || '').trim();
      const label = String(font.label || '').trim();
      const url = String(font.url || '').trim();
      if (!id || !label || !url) return;

      let key = label.toLocaleLowerCase();
      try {
        const pathname = new URL(url, window.location.href).pathname;
        key = decodeURIComponent(pathname.split('/').pop() || key).toLocaleLowerCase();
      } catch {
        // Keep the normalised label as a stable fallback identity.
      }

      const next = { ...font, id, label, url };
      const calibratedIconStrokeEm = TAN_FONT_ICON_STROKE_EM[id];
      if (Number.isFinite(Number(font.iconStrokeEm))) {
        next.iconStrokeEm = this.#clamp(Number(font.iconStrokeEm), 0.008, 0.12);
      } else if (Number.isFinite(calibratedIconStrokeEm)) {
        next.iconStrokeEm = calibratedIconStrokeEm;
      }
      const existingIndex = indexByKey.get(key);
      if (existingIndex === undefined) {
        indexByKey.set(key, normalised.length);
        normalised.push(next);
      } else {
        /*
         * Theme-editor blocks come after the built-in catalog. Let an existing
         * block override catalog metrics and examples without changing the
         * catalog's stable ordering.
         */
        const existing = normalised[existingIndex];
        const catalogPricingManaged =
          existing.catalogPricingManaged === true ||
          String(existing.id || '').startsWith('catalog-');
        const merged = { ...existing, ...next };
        if (catalogPricingManaged) {
          /*
           * Built-in production pricing has one controlled source of truth.
           * A theme-editor block may override the preview metrics or CDN URL,
           * but it must not silently reset a catalog font's audited factor.
           */
          merged.priceFactor = existing.priceFactor;
          merged.priceMultiplier = existing.priceMultiplier;
          merged.measurementHeightScale = existing.measurementHeightScale;
          merged.doubleLine = existing.doubleLine;
          merged.doubleLinePremium = existing.doubleLinePremium;
          merged.priceBand = existing.priceBand;
          /* Keep the audited storefront name stable across theme blocks. */
          merged.label = existing.label;
          merged.catalogPricingManaged = true;
        }
        normalised[existingIndex] = merged;
      }
    });

    const displayKey = (value) => {
      const key = String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase()
        .replace(/[^a-z0-9]/g, '');
      if (key === 'tanbrush6mmpilot' || key === 'tanbrush') return 'madrid';
      if (key === 'wildscript') return 'wolfscript';
      return key;
    };
    const orderByKey = new Map(
      TAN_FONT_DISPLAY_ORDER.map((key, index) => [key, index])
    );

    return normalised
      .map((font, sourceIndex) => ({ font, sourceIndex }))
      .sort((left, right) => {
        const leftOrder =
          orderByKey.get(displayKey(left.font.label)) ?? Number.MAX_SAFE_INTEGER;
        const rightOrder =
          orderByKey.get(displayKey(right.font.label)) ?? Number.MAX_SAFE_INTEGER;
        return leftOrder - rightOrder || left.sourceIndex - right.sourceIndex;
      })
      .map(({ font }) => font);
  }

  #rebuildFontControls() {
    const select = this.querySelector('[data-font-select]');
    const grid = this.querySelector('[data-font-options]');
    if (!(select instanceof HTMLSelectElement) || !(grid instanceof HTMLElement)) return;
    this.#resetFontOptionQueue();

    const selectedId = String(select.value || this.#fonts[0]?.id || '');
    const selectFragment = document.createDocumentFragment();

    this.#fonts.forEach((font) => {
      const id = String(font.id || '');
      const label = String(font.label || 'Font');

      const option = document.createElement('option');
      option.value = id;
      option.textContent = label;
      selectFragment.append(option);
    });

    select.replaceChildren(selectFragment);
    grid.replaceChildren();
    this.#fontGridReady = false;
    if (Array.from(select.options).some((option) => option.value === selectedId)) {
      select.value = selectedId;
    } else if (select.options.length) {
      select.selectedIndex = 0;
    }
  }

  #buildFontGrid() {
    if (this.#fontGridReady) return;
    const grid = this.querySelector('[data-font-options]');
    const select = this.querySelector('[data-font-select]');
    if (!(grid instanceof HTMLElement) || !(select instanceof HTMLSelectElement)) return;
    const selectedId = String(select.value || this.#fonts[0]?.id || '');
    const gridFragment = document.createDocumentFragment();
    const orderedFonts = tanOrderFontsForLocale(this.#fonts, this.dataset.locale || document.documentElement.lang);
    orderedFonts.forEach((font, index) => {
      const id = String(font.id || '');
      const label = String(font.label || 'Font');
      const family = String(font.family || 'sans-serif');
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.fontOption = id;
      button.dataset.fontLabel = label.toLocaleLowerCase();
      button.dataset.fontLoaded = 'false';
      button.style.setProperty('--tan-nd-option-font', JSON.stringify(family));
      const buttonLabel = document.createElement('span');
      buttonLabel.textContent = label;
      button.append(buttonLabel);
      const selected = id === selectedId || (!selectedId && index === 0);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
      const unavailable = this.#fontFailedFamilies.has(family);
      button.hidden = unavailable;
      button.disabled = unavailable;
      gridFragment.append(button);
    });
    grid.replaceChildren(gridFragment);
    this.#fontGridReady = true;
  }

  /** @param {Array<Record<string, any>>} icons */
  #normaliseIcons(icons) {
    if (!Array.isArray(icons)) return [];
    const ids = new Set();
    return icons
      .map((icon) => {
        if (!icon || typeof icon !== 'object') return null;
        const id = String(icon.id || '').trim();
        const label = String(icon.label || '').trim();
        const url = String(icon.url || '').trim();
        if (!id || !label || !url || ids.has(id)) return null;
        if (!url.startsWith('https://cdn.shopify.com/')) return null;
        const viewBoxValues = (
          Array.isArray(icon.viewBox)
            ? icon.viewBox
            : String(icon.viewBox || '')
                .trim()
                .split(/[\s,]+/)
        )
          .map(Number)
          .slice(0, 4);
        const hasTightViewBox =
          viewBoxValues.length === 4 &&
          viewBoxValues.every(Number.isFinite) &&
          viewBoxValues[2] > 0 &&
          viewBoxValues[3] > 0;
        const viewBox = hasTightViewBox
          ? viewBoxValues.map((value) => Math.round(value * 100) / 100).join(' ')
          : '0 0 1000 1000';
        const geometryAspect = hasTightViewBox
          ? viewBoxValues[2] / viewBoxValues[3]
          : this.#positiveNumber(icon.aspect, 1);
        ids.add(id);
        return {
          id,
          label,
          url,
          tier: ['simple', 'standard', 'detailed', 'complex'].includes(icon.tier)
            ? icon.tier
            : 'standard',
          viewBox,
          aspect: this.#clamp(geometryAspect, 0.15, 8),
          defaultScale: this.#clamp(
            this.#positiveNumber(icon.defaultScale, 100),
            70,
            160
          ),
          strokeScale: this.#clamp(
            this.#positiveNumber(icon.strokeScale, 1),
            0.8,
            1.2
          ),
        };
      })
      .filter(Boolean)
      .sort((left, right) => {
        const leftIndex = TAN_ICON_DISPLAY_ORDER_INDEX.has(left.id)
          ? TAN_ICON_DISPLAY_ORDER_INDEX.get(left.id)
          : Number.MAX_SAFE_INTEGER;
        const rightIndex = TAN_ICON_DISPLAY_ORDER_INDEX.has(right.id)
          ? TAN_ICON_DISPLAY_ORDER_INDEX.get(right.id)
          : Number.MAX_SAFE_INTEGER;
        return leftIndex - rightIndex;
      });
  }

  #iconTubeWidthCm() {
    return this.#clamp(this.#numberData('iconTubeWidthCm', 0.6), 0.4, 1);
  }

  /**
   * Resolve the on-screen icon tube from the selected font's measured core
   * stroke. This is deliberately separate from #iconTubeWidthCm(): checkout
   * and production still receive the real 6 mm tube specification.
   *
   * @param {number} fontSize
   * @param {number} iconWidth
   * @param {number} iconHeight
   * @param {Record<string, any> | null=} font
   * @param {Record<string, any> | null=} icon
   */
  #fontMatchedIconTubePixels(
    fontSize,
    iconWidth,
    iconHeight,
    font = null,
    icon = null
  ) {
    const resolvedFont = font || this.#getSelectedFont();
    const resolvedIcon = icon || this.#getSelectedIcon();
    const fontScale = this.#positiveNumber(
      resolvedFont?.iconOpticalScale,
      1.1
    );
    const iconScale = this.#positiveNumber(resolvedIcon?.strokeScale, 1);

    return tanResolveFontMatchedIconTubePixels({
      fontSize,
      strokeEm: this.#positiveNumber(resolvedFont?.iconStrokeEm, 0.0306),
      iconWidth,
      iconHeight,
      tier: String(resolvedIcon?.tier || 'standard'),
      opticalScale: fontScale * iconScale,
    });
  }

  /** @param {Record<string, any> | null=} icon */
  #iconMinimumHeightCm(icon = null) {
    return this.#clamp(
      this.#positiveNumber(icon?.minHeightCm, this.#numberData('iconMinHeightCm', 12)),
      8,
      30
    );
  }

  /**
   * Load the centreline bundle only when the customer actually selects an
   * icon. The mask preview works immediately, while the 68 KB vector catalog
   * stays off the initial designer critical path.
   *
   * @returns {Promise<Record<string, string>>}
   */
  #loadIconVectorCatalog() {
    const current =
      window.TanNeonIconVectors &&
      typeof window.TanNeonIconVectors === 'object'
        ? window.TanNeonIconVectors
        : null;
    if (current) return Promise.resolve(current);
    if (this.#iconVectorCatalogPromise) {
      return this.#iconVectorCatalogPromise;
    }

    const source = String(this.dataset.iconVectorsUrl || '').trim();
    if (!source) return Promise.resolve({});

    const sharedPromise = tanIconVectorCatalogPromises.get(source);
    if (sharedPromise) {
      this.#iconVectorCatalogPromise = sharedPromise;
      return sharedPromise;
    }

    const promise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.dataset.tanIconVectorsLoader = '';
      script.addEventListener(
        'load',
        () => {
          const catalog =
            window.TanNeonIconVectors &&
            typeof window.TanNeonIconVectors === 'object'
              ? window.TanNeonIconVectors
              : {};
          resolve(catalog);
        },
        { once: true }
      );
      script.addEventListener(
        'error',
        () => {
          tanIconVectorCatalogPromises.delete(source);
          if (this.#iconVectorCatalogPromise === promise) {
            this.#iconVectorCatalogPromise = null;
          }
          resolve({});
        },
        { once: true }
      );
      document.head.append(script);
    });

    tanIconVectorCatalogPromises.set(source, promise);
    this.#iconVectorCatalogPromise = promise;
    return promise;
  }

  /**
   * Build one SVG from the audited local centreline bundle. Keeping the 103
   * small geometry fragments in a theme asset avoids CORS, loading flicker and
   * the off-canvas drawing-board debris present in the original CDN masters.
   * The original mask remains visible if this optional asset is unavailable.
   *
   * @param {Record<string, any>} icon
   * @returns {Promise<SVGElement | null>}
   */
  #loadIconVector(icon) {
    const id = String(icon?.id || '').trim();
    if (!id) return Promise.resolve(null);
    if (this.#iconSvgPromises.has(id)) return this.#iconSvgPromises.get(id);

    const request = this.#loadIconVectorCatalog().then((catalog) => {
      const geometry = String(catalog[id] || '');
      if (geometry.length < 8 || geometry.length > 10000) return null;

      const root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('viewBox', String(icon.viewBox || '0 0 1000 1000'));
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('focusable', 'false');
      root.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      root.classList.add('tan-nd__inline-icon-svg');
      root.innerHTML = geometry;

      const allowedElements = new Set([
        'path',
        'circle',
        'ellipse',
        'rect',
        'line',
        'polyline',
        'polygon',
      ]);
      const elements = Array.from(root.querySelectorAll('*'));
      const invalid = elements.some((element) => {
        if (!allowedElements.has(element.localName.toLocaleLowerCase())) return true;
        return Array.from(element.attributes).some((attribute) => {
          const name = attribute.name.toLocaleLowerCase();
          return (
            name.startsWith('on') ||
            name === 'href' ||
            name === 'xlink:href' ||
            name === 'src' ||
            name === 'style'
          );
        });
      });
      return !invalid && elements.length > 0 ? root : null;
    });

    this.#iconSvgPromises.set(id, request);
    return request;
  }

  /**
   * Replace the proportional mask fallback with a centreline SVG. Its stroke
   * uses vector-effect so resizing the icon never scales the physical tube.
   *
   * @param {HTMLElement} container
   * @param {Record<string, any>} icon
   */
  #hydrateIconVector(container, icon) {
    const id = String(icon?.id || '');
    if (!id) return;
    container.dataset.iconVectorId = id;
    this.#loadIconVector(icon).then((vector) => {
      if (
        !vector ||
        !container.isConnected ||
        container.dataset.iconVectorId !== id
      ) {
        return;
      }
      const clone = document.importNode(vector, true);
      container.replaceChildren(clone);
      container.classList.add('is-vector-ready');
    });
  }

  #rebuildIconControls() {
    const select = this.querySelector('[data-icon-select]');
    if (!(select instanceof HTMLSelectElement)) return;

    const selectFragment = document.createDocumentFragment();
    const emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.textContent = this.#t('font_icon.no_icon', {}, 'No icon');
    selectFragment.append(emptyOption);

    this.#icons.forEach((icon) => {
      const option = document.createElement('option');
      option.value = icon.id;
      option.textContent = icon.label;
      selectFragment.append(option);
    });

    select.replaceChildren(selectFragment);
    select.value = '';
    this.#selectedIconId = '';
    this.#iconGridReady = false;
  }

  #buildIconGrid() {
    if (this.#iconGridReady) return;
    const grid = this.querySelector('[data-icon-options]');
    if (!(grid instanceof HTMLElement)) return;
    this.#iconGridReady = true;

    const gridFragment = document.createDocumentFragment();
    const clearButton = document.createElement('button');
    clearButton.type = 'button';
    clearButton.className = 'tan-nd__icon-option tan-nd__icon-option--none is-selected';
    clearButton.dataset.iconOption = '';
    clearButton.dataset.iconLabel = this.#t(
      'font_icon.no_icon',
      {},
      'No icon'
    ).toLocaleLowerCase();
    clearButton.setAttribute('aria-pressed', 'true');
    clearButton.setAttribute(
      'aria-label',
      this.#t('font_icon.remove', {}, 'Remove icon')
    );
    const clearVisual = document.createElement('span');
    clearVisual.className = 'tan-nd__icon-option-visual';
    clearVisual.setAttribute('aria-hidden', 'true');
    clearVisual.textContent = '×';
    const clearLabel = document.createElement('strong');
    clearLabel.textContent = this.#t('font_icon.no_icon', {}, 'No icon');
    clearButton.append(clearVisual, clearLabel);
    gridFragment.append(clearButton);

    this.#icons.forEach((icon) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tan-nd__icon-option';
      button.dataset.iconOption = icon.id;
      button.dataset.iconLabel = icon.label.toLocaleLowerCase();
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute(
        'aria-label',
        this.#t(
          'font_icon.add_accessibility',
          {
            icon: icon.label,
            price: this.#formatCurrency(
              this.#iconBasePrice(icon) * this.#marketRate()
            ),
          },
          `${icon.label}, add ${this.#formatCurrency(
            this.#iconBasePrice(icon) * this.#marketRate()
          )}`
        )
      );

      const visual = document.createElement('span');
      visual.className = 'tan-nd__icon-option-visual';
      const image = document.createElement('img');
      image.dataset.iconSrc = icon.url;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.fetchPriority = 'low';
      image.setAttribute('aria-hidden', 'true');
      visual.append(image);

      const label = document.createElement('strong');
      label.textContent = icon.label;
      const price = document.createElement('small');
      price.textContent = `+${this.#formatCurrency(
        this.#iconBasePrice(icon) * this.#marketRate()
      )}`;
      button.append(visual, label, price);
      gridFragment.append(button);
    });

    grid.replaceChildren(gridFragment);
    this.#observeIconImages(grid);
    this.#syncedIconPickerSignature = '';
    this.#syncedIconSelectionId = '';
    const input = this.querySelector('[data-text-input]');
    const text =
      input instanceof HTMLTextAreaElement ? input.value.trim() : '';
    this.#syncIconPicker(this.#getSelectedIcon(), text);
    const search = this.querySelector('[data-icon-search]');
    if (search instanceof HTMLInputElement && search.value) {
      this.#filterIconOptions(search.value);
    }
  }

  /** @param {string} unavailableId */
  #recoverUnavailableFont(unavailableId) {
    const grid = this.querySelector('[data-font-options]');
    const unavailableOption = Array.from(grid?.querySelectorAll('[data-font-option]') || []).find(
      (candidate) => candidate instanceof HTMLButtonElement && candidate.dataset.fontOption === unavailableId
    );
    if (unavailableOption instanceof HTMLButtonElement) {
      unavailableOption.hidden = true;
      unavailableOption.disabled = true;
    }

    const select = this.querySelector('[data-font-select]');
    if (!(select instanceof HTMLSelectElement)) return;

    const previousIsAvailable =
      this.#renderedFontId &&
      Array.from(select.options).some((option) => option.value === this.#renderedFontId);
    const nextFont =
      this.#fonts.find((font) => !this.#fontFailedFamilies.has(String(font.family || ''))) || null;
    const nextId = previousIsAvailable ? this.#renderedFontId : String(nextFont?.id || '');

    delete this.dataset.fontLoading;
    this.querySelector('[data-font-trigger]')?.removeAttribute('aria-busy');
    if (!nextId) return;
    select.value = nextId;
    if (this.dataset.viewportResizing !== 'true') this.#scheduleUpdate();
  }

  #scheduleUpdate() {
    if (this.#renderFrame) return;
    this.#renderFrame = requestAnimationFrame(() => {
      this.#renderFrame = 0;
      this.#update();
    });
  }

  #flushPendingUpdate() {
    if (!this.#renderFrame) return;
    cancelAnimationFrame(this.#renderFrame);
    this.#renderFrame = 0;
    this.#update();
  }

  #canUseCurrentDesign() {
    if (this.#isComposingText) return false;
    this.#flushPendingUpdate();
    const input = this.querySelector('[data-text-input]');
    const text = input instanceof HTMLTextAreaElement ? input.value.trim() : '';
    const font = this.#getSelectedFont();
    if (text !== this.#designState.text || font.id !== this.#designState.font?.id) this.#update();
    const valid = this.#designState.valid && this.#fontCompatibility.valid &&
      this.dataset.fontLoading !== 'true';
    if (!valid) {
      this.#syncAddButton(false);
      input?.focus();
    }
    return valid;
  }

  #update() {
    if (this.#isComposingText) return;
    const textInput = this.querySelector('[data-text-input]');
    if (textInput instanceof HTMLTextAreaElement) this.#sanitizeTextEmojis(textInput);
    const rawText = textInput instanceof HTMLTextAreaElement ? textInput.value : '';
    const text = rawText.trim();
    const placeholder =
      textInput instanceof HTMLTextAreaElement
        ? textInput.placeholder ||
          this.#t('text_entry.placeholder', {}, 'Your Text')
        : this.#t('text_entry.placeholder', {}, 'Your Text');
    const displayText = text || placeholder;
    const characterCount = this.#countCharacters(text);
    const validText = characterCount >= this.#numberData('minCharacters', 2);
    const font = this.#getSelectedFont();
    this.#refreshFontCompatibility(text, font);
    if (!text) {
      this.#automaticSizeInitialized = false;
      if (!this.#customerSelectedSize) {
        this.#sizeDriver = 'width';
        this.#requestedWidth = this.#numberData('minWidth', 20);
        this.#requestedHeight = null;
      }
    }
    const textLineCount = text ? Math.max(1, text.split(/\r?\n/).length) : 1;
    this.dataset.textLines = String(textLineCount);
    const previewAnchor =
      textLineCount <= 1 ? 29 : textLineCount === 2 ? 32 : textLineCount === 3 ? 35 : 38;
    this.style.setProperty('--tan-nd-preview-anchor', `${previewAnchor}%`);

    if (!this.#isFontReady(font, displayText)) {
      const requestedFontId = String(font.id || '');
      this.dataset.fontLoading = 'true';
      // Reject the previous design while the newly selected font is loading.
      // The invalid change also cancels an older quote waiting in the bridge.
      this.#designState = { ...this.#designState, text, font, valid: false };
      this.dataset.designRevision = String((Number(this.dataset.designRevision) || 0) + 1);
      this.dispatchEvent(new CustomEvent('tan:designer:change', {
        bubbles: true,
        detail: { state: this.#designState, revision: Number(this.dataset.designRevision) },
      }));
      this.querySelector('[data-font-trigger]')?.setAttribute('aria-busy', 'true');
      this.#syncAddButton(false);
      this.#loadFont(font, displayText).then((ready) => {
        if (String(this.#getSelectedFont().id || '') !== requestedFontId) return;
        if (ready) {
          if (this.dataset.viewportResizing !== 'true') this.#scheduleUpdate();
        } else if (this.#fontFailedFamilies.has(String(font.family || ''))) {
          this.#recoverUnavailableFont(requestedFontId);
        } else {
          window.setTimeout(() => {
            if (
              this.isConnected &&
              this.dataset.viewportResizing !== 'true' &&
              String(this.#getSelectedFont().id || '') === requestedFontId
            ) {
              this.#scheduleUpdate();
            }
          }, 400);
        }
      });
      return;
    }

    const suppressDesignerChange = this.#suppressNextDesignerChange;
    this.#suppressNextDesignerChange = false;
    this.#syncCharacterColorUi(text);
    const measurements = this.#measureDesign(displayText, font);
    if (
      validText &&
      !this.#customerSelectedSize &&
      !this.#automaticSizeInitialized
    ) {
      this.#sizeDriver = 'width';
      this.#requestedWidth = measurements.width;
      this.#requestedHeight = null;
      this.#automaticSizeInitialized = true;
    }
    const validSize =
      measurements.width >= measurements.minimumWidth &&
      measurements.width <= this.#numberData('maxWidth', 240) &&
      measurements.height <= this.#numberData('maxHeight', 120) &&
      measurements.minimumWidth <= this.#numberData('maxWidth', 240);

    const price = this.#calculatePrice({
      text,
      characterCount,
      font,
      measurements,
      valid: validText && this.#fontCompatibility.valid,
    });
    const checkoutValid = validText && this.#fontCompatibility.valid && validSize && price.purchasable;

    this.#designState = {
      ...this.#collectSelections(),
      text,
      characterCount,
      sizeDriver: this.#sizeDriver,
      width: measurements.width,
      height: measurements.height,
      minimumWidth: measurements.minimumWidth,
      naturalWidth: measurements.naturalWidth,
      naturalHeight: measurements.naturalHeight,
      lineHeightEm: measurements.lineHeightEm,
      font,
      iconMeasurement: measurements.icon || null,
      valid: checkoutValid,
      price,
    };
    this.dataset.designRevision = String(
      Math.max(0, Number.parseInt(this.dataset.designRevision || '0', 10) || 0) + 1
    );
    const revision = Math.max(
      0,
      Number.parseInt(this.dataset.designRevision || '0', 10) || 0
    );
    const currentQuoteSignature = this.#quoteDesignSignature(this.#designState);
    if (
      !suppressDesignerChange &&
      (this.#exactQuoteStatus === 'pending' || this.#exactQuoteStatus === 'ready') &&
      this.#exactQuoteDesignSignature !== currentQuoteSignature
    ) {
      this.#exactQuoteStatus = 'idle';
      this.dataset.exactQuoteStatus = 'idle';
      this.#exactQuoteDesignSignature = '';
    }

    // Write labels and field visibility before preview geometry reads, so
    // rulers measure the current labels without forcing another layout later.
    this.#renderMeasurements(measurements, text.length > 0);
    this.#renderValidation(validText, validSize, measurements);
    this.#renderPrice(price);
    this.#renderPreview(displayText, text.length === 0, font, measurements);
    delete this.dataset.fontLoading;
    this.dataset.fontReady = 'true';
    this.querySelector('[data-font-trigger]')?.removeAttribute('aria-busy');
    if (this.dataset.designerStep === 'review') {
      const productReady = this.dataset.appBackendReady === 'true';
      if (checkoutValid && productReady) {
        this.#renderReview();
      } else {
        const url = new URL(window.location.href);
        const currentState =
          window.history.state && typeof window.history.state === 'object'
            ? { ...window.history.state }
            : {};
        url.searchParams.delete('designer_step');
        delete currentState.tanDesignerStep;
        delete currentState.tanDesignerId;
        window.history.replaceState(currentState, '', url);
        this.#setDesignerStep('edit', { focus: false });
      }
    }
    this.#syncAddButton(checkoutValid);

    const characterOutput = this.querySelector('[data-character-count]');
    if (
      characterOutput &&
      characterOutput.textContent !== String(characterCount)
    ) {
      characterOutput.textContent = String(characterCount);
    }
    if (!suppressDesignerChange) {
      this.dispatchEvent(
        new CustomEvent('tan:designer:change', {
          bubbles: true,
          detail: {
            state: this.#designState,
            revision,
          },
        })
      );
    }
  }

  /**
   * Measure the visible WOFF2 ink independently from the production
   * calibration metrics. Production height coefficients continue to drive the
   * ruler, minimum size and price; they must not make one font look optically
   * larger or smaller than another inside the fixed preview canvas.
   *
   * @param {string} text
   * @param {Record<string, any>} font
   * @param {Record<string, any>} measurements
   * @returns {{width: number, height: number} | null}
   */
  #measurePreviewOpticalBox(text, font, measurements) {
    const context = this.#measureContext;
    if (!context) return null;

    const baseFontSize = 100;
    const family = String(font?.family || 'sans-serif');
    const lineHeight =
      baseFontSize *
      this.#positiveNumber(
        measurements?.lineHeightEm,
        this.#positiveNumber(font?.lineHeight, 1.6)
      );
    const lines = String(text || ' ').split(/\r?\n/);
    const lineBoxes = [];
    let inkTop = Number.POSITIVE_INFINITY;
    let inkBottom = Number.NEGATIVE_INFINITY;

    context.save();
    context.font = `400 ${baseFontSize}px ${JSON.stringify(family)}`;
    context.textBaseline = 'alphabetic';

    lines.forEach((line, index) => {
      const safeLine = line || ' ';
      const metric = context.measureText(safeLine);
      const advance = Math.max(1, metric.width || safeLine.length * 58);
      const actualLeft = this.#finiteNumber(metric.actualBoundingBoxLeft, 0);
      const actualRight = this.#finiteNumber(
        metric.actualBoundingBoxRight,
        advance
      );
      const actualWidth = Math.max(1, actualLeft + actualRight);
      const leadingWhitespace = safeLine.match(/^\s+/u)?.[0] || '';
      const trailingWhitespace = safeLine.match(/\s+$/u)?.[0] || '';
      const edgeWhitespaceWidth =
        (leadingWhitespace ? context.measureText(leadingWhitespace).width : 0) +
        (trailingWhitespace ? context.measureText(trailingWhitespace).width : 0);
      const width = Math.max(
        1,
        actualWidth + Math.max(0, edgeWhitespaceWidth)
      );
      const ascent = Math.max(
        0,
        this.#finiteNumber(
          metric.actualBoundingBoxAscent,
          baseFontSize * 0.78
        )
      );
      const descent = Math.max(
        0,
        this.#finiteNumber(
          metric.actualBoundingBoxDescent,
          baseFontSize * 0.2
        )
      );
      const baseline = index * lineHeight;
      const top = baseline - ascent;
      const bottom = baseline + descent;
      lineBoxes.push({ width, top, bottom, baseline, ascent, descent });
      inkTop = Math.min(inkTop, top);
      inkBottom = Math.max(inkBottom, bottom);
    });

    const iconMeasurement = measurements?.icon;
    if (iconMeasurement && lineBoxes.length > 0) {
      const placementState = this.#iconPlacementState(text);
      const beforeLines = String(placementState.before || '').split(/\r?\n/);
      const insertionLine = this.#clamp(
        beforeLines.length - 1,
        0,
        lineBoxes.length - 1
      );
      const lineBox = lineBoxes[insertionLine];
      const iconWidth =
        baseFontSize *
        this.#positiveNumber(iconMeasurement.widthEm, 1);
      const iconHeight =
        baseFontSize *
        this.#positiveNumber(iconMeasurement.heightEm, 1);
      const fallbackHalfGap =
        Math.max(0, this.#finiteNumber(iconMeasurement.gapEm, 0.22)) / 2;
      const gapBefore =
        baseFontSize *
        Math.max(
          0,
          this.#finiteNumber(
            iconMeasurement.gapBeforeEm,
            fallbackHalfGap
          )
        );
      const gapAfter =
        baseFontSize *
        Math.max(
          0,
          this.#finiteNumber(
            iconMeasurement.gapAfterEm,
            fallbackHalfGap
          )
        );
      const beforeLine =
        String(placementState.before || '').split(/\r?\n/).at(-1) || '';
      const afterLine =
        String(placementState.after || '').split(/\r?\n/)[0] || '';
      const fragmentBounds = (value) => {
        if (!value || !context) return null;
        const metric = context.measureText(value);
        const advance = Math.max(0, this.#finiteNumber(metric.width, 0));
        return {
          advance,
          left: -this.#finiteNumber(metric.actualBoundingBoxLeft, 0),
          right: this.#finiteNumber(
            metric.actualBoundingBoxRight,
            advance
          ),
        };
      };
      const beforeBounds = fragmentBounds(beforeLine);
      const afterBounds = fragmentBounds(afterLine);
      const beforeAdvance = beforeBounds?.advance || 0;
      const iconLeft = beforeAdvance + gapBefore;
      const iconRight = iconLeft + iconWidth;
      const afterOrigin = iconRight + gapAfter;
      const horizontalBounds = [iconLeft, iconRight];
      if (beforeBounds) {
        horizontalBounds.push(beforeBounds.left, beforeBounds.right);
      }
      if (afterBounds) {
        horizontalBounds.push(
          afterOrigin + afterBounds.left,
          afterOrigin + afterBounds.right
        );
      }
      lineBox.width = Math.max(
        1,
        Math.max(...horizontalBounds) - Math.min(...horizontalBounds)
      );

      const iconAlignEm = this.#clamp(
        this.#finiteNumber(
          iconMeasurement.alignEm,
          this.#iconVerticalAlignment(lineBox, iconHeight, baseFontSize)
        ),
        -0.68,
        0.3
      );
      const iconBottom = lineBox.baseline - baseFontSize * iconAlignEm;
      const iconTop = iconBottom - iconHeight;
      lineBox.top = Math.min(lineBox.top, iconTop);
      lineBox.bottom = Math.max(lineBox.bottom, iconBottom);
      inkTop = Math.min(inkTop, lineBox.top);
      inkBottom = Math.max(inkBottom, lineBox.bottom);
    }
    context.restore();

    if (
      !Number.isFinite(inkTop) ||
      !Number.isFinite(inkBottom) ||
      inkBottom <= inkTop
    ) {
      return null;
    }

    return {
      width: Math.max(1, ...lineBoxes.map((line) => line.width)),
      height: Math.max(1, inkBottom - inkTop),
    };
  }

  /**
   * @param {string} displayText
   * @param {boolean} isPlaceholder
   * @param {Record<string, any>} font
   * @param {Record<string, any>} measurements
   */
  #renderPreview(displayText, isPlaceholder, font, measurements) {
    const preview = this.querySelector('[data-neon-preview]');
    const glow = this.querySelector('[data-neon-glow]');
    const iconGlows = Array.from(
      this.querySelectorAll('[data-icon-glow]')
    ).filter((candidate) => candidate instanceof HTMLElement);
    const core = this.querySelector('[data-neon-core]');
    const sample = this.querySelector('[data-font-sample]');
    const stage = this.querySelector('[data-stage]');
    const selectedIcon = this.#getSelectedIcon();
    const selectedAlignment = this.querySelector('input[data-alignment]:checked');
    const colorMode = this.#selectedColorMode();
    const selectedColor = this.#selectedSolidColor();
    const colorValue = colorMode === 'rgb' ? '#9d00ff' : selectedColor.color;
    const coreValue = colorMode === 'rgb' ? '#ffffff' : selectedColor.core;
    const alignment = selectedAlignment instanceof HTMLInputElement ? selectedAlignment.value : 'center';
    const visualizer = this.querySelector('[data-visualizer]');
    const glowEnabled =
      !(visualizer instanceof HTMLElement) ||
      !visualizer.classList.contains('is-glow-off');
    const compactGlow = this.#isMobileViewport();
    const rgbState = String(colorMode === 'rgb');
    const fontFamily = font.family || 'sans-serif';
    const resolvedLineHeight = this.#positiveNumber(
      measurements?.lineHeightEm,
      this.#positiveNumber(font.lineHeight, 1.6)
    );
    const lineHeight = String(
      Math.round(resolvedLineHeight * 10000) / 10000
    );
    if (this.dataset.rgb !== rgbState) this.dataset.rgb = rgbState;
    if (this.dataset.colorMode !== colorMode) this.dataset.colorMode = colorMode;
    if (this.style.getPropertyValue('--tan-nd-neon') !== colorValue) {
      this.style.setProperty('--tan-nd-neon', colorValue);
    }
    if (this.style.getPropertyValue('--tan-nd-core') !== coreValue) {
      this.style.setProperty('--tan-nd-core', coreValue);
    }
    const reviewNeon = this.querySelector('[data-review-neon]');
    for (const target of [preview, reviewNeon, sample]) {
      if (!(target instanceof HTMLElement)) continue;
      if (target.style.getPropertyValue('--tan-nd-font') !== fontFamily) {
        target.style.setProperty('--tan-nd-font', fontFamily);
      }
      if (target === sample) continue;
      if (target.style.getPropertyValue('--tan-nd-line-height') !== lineHeight) {
        target.style.setProperty('--tan-nd-line-height', lineHeight);
      }
      if (target.style.getPropertyValue('--tan-nd-align') !== alignment) {
        target.style.setProperty('--tan-nd-align', alignment);
      }
    }
    this.#renderedFontId = String(font.id || '');
    this.#syncFontPicker(font);
    this.#syncIconPicker(selectedIcon, isPlaceholder ? '' : displayText);
    if (
      sample instanceof HTMLElement &&
      sample.textContent !== (font.label || 'Font')
    ) {
      sample.textContent = font.label || 'Font';
    }

    const backboard = this.querySelector('[data-backboard]');
    const selectedBackboard = this.querySelector('input[data-backboard-style]:checked');
    const colorSelect = this.querySelector('[data-backboard-color]');
    if (backboard instanceof HTMLElement) {
      const selectedStyle =
        selectedBackboard instanceof HTMLInputElement ? selectedBackboard.dataset.backboardStyle || 'cut' : 'cut';
      const showBackboardPreview = this.dataset.showBackboardPreview !== 'false';
      const style =
        !showBackboardPreview || selectedStyle === 'cut-letter' ? 'cut' : selectedStyle;
      if (backboard.dataset.style !== style) backboard.dataset.style = style;
      // Cut shapes use a fixed gap; only the other styles need canvas width.
      const compactCanvas = style !== 'cut' && style !== 'cut-letter' &&
        (stage instanceof HTMLElement ? stage.clientWidth : 0) < 600;
      const gap =
        style === 'cut-letter'
          ? 2
          : style === 'cut'
            ? 5
            : style === 'rectangle'
              ? compactCanvas
                ? 14
                : 20
              : compactCanvas
                ? 10
                : 14;
      const boardGap = `${gap}px`;
      if (backboard.style.getPropertyValue('--tan-nd-board-gap') !== boardGap) {
        backboard.style.setProperty('--tan-nd-board-gap', boardGap);
      }
      const selectedColorOption =
        colorSelect instanceof HTMLSelectElement ? colorSelect.selectedOptions[0]?.dataset.previewColor || 'clear' : 'clear';
      const colorOption = showBackboardPreview ? selectedColorOption : 'clear';
      if (backboard.dataset.color !== colorOption) backboard.dataset.color = colorOption;
    }

    if (preview instanceof HTMLElement) {
      const fontLabel = String(font.label || '').trim().toLocaleLowerCase();
      if (preview.dataset.fontLabel !== fontLabel) preview.dataset.fontLabel = fontLabel;
      const renderedIcon = selectedIcon && measurements.icon ? selectedIcon : null;
      const hasIcon = Boolean(renderedIcon);
      if (preview.classList.contains('has-icon') !== hasIcon) {
        preview.classList.toggle('has-icon', hasIcon);
      }
      const iconPosition = renderedIcon
        ? String(measurements.icon.position || '')
        : '';
      const iconPlacement = renderedIcon
        ? String(measurements.icon.placement)
        : '';
      if (preview.dataset.iconPosition !== iconPosition) {
        preview.dataset.iconPosition = iconPosition;
      }
      if (preview.dataset.iconPlacement !== iconPlacement) {
        preview.dataset.iconPlacement = iconPlacement;
      }
      if (renderedIcon) {
        const iconWidth = `${Math.round(measurements.icon.widthEm * 1000) / 1000}em`;
        const iconHeight = `${Math.round(measurements.icon.heightEm * 1000) / 1000}em`;
        const iconGap = `${Math.round(measurements.icon.gapEm * 1000) / 1000}em`;
        const iconAlign =
          `${Math.round(this.#finiteNumber(
            measurements.icon.alignEm,
            -0.18
          ) * 1000) / 1000}em`;
        const fallbackHalfGap =
          Math.max(0, this.#finiteNumber(measurements.icon.gapEm, 0.22)) / 2;
        const iconGapBefore =
          `${Math.round(
            Math.max(
              0,
              this.#finiteNumber(
                measurements.icon.gapBeforeEm,
                fallbackHalfGap
              )
            ) * 1000
          ) / 1000}em`;
        const iconGapAfter =
          `${Math.round(
            Math.max(
              0,
              this.#finiteNumber(
                measurements.icon.gapAfterEm,
                fallbackHalfGap
              )
            ) * 1000
          ) / 1000}em`;
        if (preview.style.getPropertyValue('--tan-nd-icon-width') !== iconWidth) {
          preview.style.setProperty('--tan-nd-icon-width', iconWidth);
        }
        if (preview.style.getPropertyValue('--tan-nd-icon-height') !== iconHeight) {
          preview.style.setProperty('--tan-nd-icon-height', iconHeight);
        }
        if (preview.style.getPropertyValue('--tan-nd-icon-gap') !== iconGap) {
          preview.style.setProperty('--tan-nd-icon-gap', iconGap);
        }
        if (preview.style.getPropertyValue('--tan-nd-icon-align') !== iconAlign) {
          preview.style.setProperty('--tan-nd-icon-align', iconAlign);
        }
        if (
          preview.style.getPropertyValue('--tan-nd-icon-gap-before') !==
          iconGapBefore
        ) {
          preview.style.setProperty('--tan-nd-icon-gap-before', iconGapBefore);
        }
        if (
          preview.style.getPropertyValue('--tan-nd-icon-gap-after') !==
          iconGapAfter
        ) {
          preview.style.setProperty('--tan-nd-icon-gap-after', iconGapAfter);
        }
      } else {
        preview.style.removeProperty('--tan-nd-icon-width');
        preview.style.removeProperty('--tan-nd-icon-height');
        preview.style.removeProperty('--tan-nd-icon-gap');
        preview.style.removeProperty('--tan-nd-icon-gap-before');
        preview.style.removeProperty('--tan-nd-icon-gap-after');
        preview.style.removeProperty('--tan-nd-icon-align');
        preview.style.removeProperty('--tan-nd-icon-tube-px');
      }

      if (colorMode === 'combination' && !isPlaceholder) {
        if (glow instanceof HTMLElement) {
          glow.style.removeProperty('color');
          glow.style.textShadow = 'none';
          this.#renderPreviewLayer(
            glow,
            displayText,
            'glow',
            colorMode,
            renderedIcon,
            measurements.icon
          );
        }
        if (core instanceof HTMLElement) {
          core.style.removeProperty('color');
          core.style.textShadow = 'none';
          this.#renderPreviewLayer(
            core,
            displayText,
            'core',
            colorMode,
            renderedIcon,
            measurements.icon
          );
        }
      } else {
        if (glow instanceof HTMLElement) {
          if (renderedIcon) {
            this.#renderPreviewLayer(
              glow,
              displayText,
              'glow',
              colorMode,
              renderedIcon,
              measurements.icon
            );
          } else {
            delete glow.dataset.layerSignature;
            if (glow.childElementCount > 0 || glow.textContent !== displayText) {
              glow.textContent = displayText;
            }
          }
          glow.style.removeProperty('color');
          glow.style.textShadow = glowEnabled
            ? compactGlow
              ? [
                  '0 0 0.04em currentColor',
                  '0 0 0.12em currentColor',
                  '0 0 0.25em currentColor',
                  '0 0 0.42em currentColor',
                  '0 0 0.64em currentColor',
                ].join(',')
              : [
                  '0 0 0.08em currentColor',
                  '0 0 0.24em currentColor',
                  '0 0 0.52em currentColor',
                  '0 0 0.95em currentColor',
                  '0 0 1.45em currentColor',
                ].join(',')
            : 'none';
        }
        if (core instanceof HTMLElement) {
          if (renderedIcon) {
            this.#renderPreviewLayer(
              core,
              displayText,
              'core',
              colorMode,
              renderedIcon,
              measurements.icon
            );
          } else {
            delete core.dataset.layerSignature;
            const hasRenderedChildren = Array.from(core.children).some(
              (child) =>
                child instanceof HTMLElement &&
                !child.hasAttribute('data-preview-baseline')
            );
            if (hasRenderedChildren || core.textContent !== displayText) {
              core.textContent = displayText;
            }
          }
          core.style.removeProperty('color');
          const coreGlowColor =
            colorMode === 'rgb' ? 'currentColor' : 'var(--tan-nd-neon)';
          const coreTubeColor = 'var(--tan-nd-core)';
          core.style.textShadow = glowEnabled
            ? compactGlow
              ? `0 0 0.015em ${coreTubeColor}, 0 0 0.05em ${coreGlowColor}, 0 0 0.16em ${coreGlowColor}`
              : `0 0 0.025em ${coreTubeColor}, 0 0 0.1em ${coreGlowColor}, 0 0 0.34em ${coreGlowColor}`
            : 'none';
        }
      }
      iconGlows.forEach((iconGlow) => {
        iconGlow.style.removeProperty('color');
        iconGlow.style.textShadow = 'none';
        if (renderedIcon) {
          this.#renderPreviewLayer(
            iconGlow,
            displayText,
            'glow',
            colorMode,
            renderedIcon,
            measurements.icon
          );
          return;
        }
        delete iconGlow.dataset.layerSignature;
        if (iconGlow.childNodes.length > 0) iconGlow.replaceChildren();
      });
      if (core instanceof HTMLElement) {
        this.#ensurePreviewBaselineMarker(core);
      }
      preview.classList.toggle('is-placeholder', isPlaceholder);
      const previewMeasurements = this.#formatMeasurements(
        measurements.width,
        measurements.height
      );
      const previewLabel = renderedIcon
        ? this.#t(
            'accessibility.preview_label',
            {
              text: displayText,
              icon: renderedIcon.label,
              measurements: previewMeasurements,
            },
            `${displayText} with ${renderedIcon.label} icon, ${previewMeasurements}`
          )
        : this.#t(
            'accessibility.preview_label_without_icon',
            {
              text: displayText,
              measurements: previewMeasurements,
            },
            `Design text ${displayText}, ${previewMeasurements}`
          );
      if (preview.getAttribute('aria-label') !== previewLabel) {
        preview.setAttribute('aria-label', previewLabel);
      }

      const artboard = preview.closest('[data-artboard]');
      const stageWidth = stage?.clientWidth || 0;
      const measuredStageHeight = stage?.clientHeight || 0;
      const stageHeight = measuredStageHeight || artboard?.clientHeight || 600;
      this.#renderedStageSize = `${stageWidth}:${measuredStageHeight}`;
      const artboardWidth = artboard?.clientWidth || 0;
      const artboardHeight = artboard?.clientHeight || 0;
      const compactCanvas = this.#isMobileViewport();
      const backboardStyle =
        backboard instanceof HTMLElement ? backboard.dataset.style || 'cut' : 'cut';
      const geometryInputSignature = JSON.stringify([
        String(font.id || ''),
        resolvedLineHeight,
        displayText,
        alignment,
        stageWidth,
        stageHeight,
        artboardWidth,
        artboardHeight,
        compactCanvas,
        this.#isMobileViewport(),
        backboardStyle,
        colorMode === 'combination',
        String(renderedIcon?.id || ''),
        renderedIcon ? measurements.icon.placement : '',
        renderedIcon ? this.#iconScale : 0,
        renderedIcon ? measurements.icon.widthEm : 0,
        renderedIcon ? measurements.icon.heightEm : 0,
        renderedIcon ? measurements.icon.gapEm : 0,
        renderedIcon ? measurements.icon.gapBeforeEm : 0,
        renderedIcon ? measurements.icon.gapAfterEm : 0,
        renderedIcon ? measurements.icon.alignEm : 0,
      ]);
      if (preview.dataset.geometryInputSignature === geometryInputSignature) {
        this.#syncPreviewIconTubeWidth(preview, measurements);
        if (
          backboard instanceof HTMLElement &&
          artboard instanceof HTMLElement &&
          core instanceof HTMLElement
        ) {
          this.#syncBackboardPreviewGeometry(
            backboard,
            core,
            artboard,
            measurements
          );
        }
        return;
      }
      preview.dataset.geometryInputSignature = geometryInputSignature;

      const previewContainer = preview.parentElement;
      const containerStyle = previewContainer ? window.getComputedStyle(previewContainer) : null;
      const horizontalPadding =
        this.#positiveNumber(containerStyle?.paddingLeft, 0) +
        this.#positiveNumber(containerStyle?.paddingRight, 0);
      const availableWidth = Math.max(
        120,
        (artboardWidth || stageWidth || 720) - horizontalPadding - 20
      );
      const referenceText = 'Your Text';
      const referenceCharacterCount = 8;
      const referenceWidthRatio = compactCanvas
        ? Math.max(
            0.62,
            Math.min(
              0.94,
              0.55 + referenceCharacterCount * 0.016
            )
          )
        : Math.max(
            0.54,
            Math.min(
              0.84,
              0.48 + referenceCharacterCount * 0.014
            )
          );
      const heightRatio = compactCanvas ? 0.72 : 0.3;
      const reservedHeight = stageHeight < 480 ? 110 : 180;
      const usableHeight = compactCanvas
        ? Math.max(100, artboardHeight || stageHeight - 150)
        : Math.max(160, stageHeight - reservedHeight);
      const referenceSafeWidth = availableWidth * referenceWidthRatio;
      const referenceSafeHeight = usableHeight * heightRatio;
      const opticalBox =
        this.#measurePreviewOpticalBox(displayText, font, measurements);
      const referenceOpticalBox =
        this.#measurePreviewOpticalBox(referenceText, font, {
          ...measurements,
          icon: null,
        });
      const visualNaturalWidth = this.#positiveNumber(
        opticalBox?.width,
        measurements.naturalWidth
      );
      const visualNaturalHeight = this.#positiveNumber(
        opticalBox?.height,
        measurements.naturalHeight
      );
      const referenceNaturalWidth = this.#positiveNumber(
        referenceOpticalBox?.width,
        visualNaturalWidth
      );
      const referenceNaturalHeight = this.#positiveNumber(
        referenceOpticalBox?.height,
        visualNaturalHeight
      );
      const previewSize = tanResolveStablePreviewSize({
        referenceWidth: referenceNaturalWidth,
        referenceHeight: referenceNaturalHeight,
        currentWidth: visualNaturalWidth,
        currentHeight: visualNaturalHeight,
        referenceSafeWidth,
        referenceSafeHeight,
        overflowWidth: availableWidth,
        overflowHeight: usableHeight,
        baseFontSize: 100,
        maximumFontSize: 320,
        headroom: 0.92,
      });
      const nextFontSize = `${Math.round(previewSize * 100) / 100}px`;
      const layoutSignature = JSON.stringify([
        String(font.id || ''),
        displayText,
        alignment,
        nextFontSize,
        Math.round(availableWidth * 10) / 10,
        Math.round(usableHeight * 10) / 10,
        compactCanvas,
        backboardStyle,
        String(renderedIcon?.id || ''),
        renderedIcon ? measurements.icon.placement : '',
        renderedIcon ? this.#iconScale : 0,
        colorMode === 'combination',
        colorMode === 'combination' && renderedIcon ? this.#iconColorId : '',
      ]);
      const layoutChanged = preview.dataset.layoutSignature !== layoutSignature;

      /*
       * Width-slider updates change the manufactured size and price, not the
       * visual text layout inside this fixed preview canvas. Keep the fitted
       * font size and ink offset until text/font/canvas geometry actually
       * changes; resetting them on every range input creates a visible
       * grow-shrink/recentre pulse on mobile.
       */
      if (layoutChanged) {
        preview.dataset.layoutSignature = layoutSignature;
        preview.style.fontSize = nextFontSize;
      } else if (!preview.style.fontSize) {
        preview.style.fontSize = nextFontSize;
      }

      /*
       * WebKit can report a FontFace as ready one or more paints before its
       * final glyph metrics are used by layout. Fit once immediately, then
       * repeat across a few guarded animation frames. Updates that do not
       * change geometry (price, picker scrolling, etc.) must not cancel this
       * settling pass.
       */
      let initialLayoutFitted = false;
      if (
        layoutChanged &&
        artboard instanceof HTMLElement &&
        core instanceof HTMLElement
      ) {
        if (this.#previewLayoutFrame) {
          cancelAnimationFrame(this.#previewLayoutFrame);
          this.#previewLayoutFrame = 0;
        }
        if (this.#previewLayoutTimer) {
          window.clearTimeout(this.#previewLayoutTimer);
          this.#previewLayoutTimer = 0;
        }

        const stableLayoutSignature = layoutSignature;
        const stableFontId = String(font.id || '');
        const hasStableLayout = () =>
          this.isConnected &&
          preview.isConnected &&
          artboard.isConnected &&
          core.isConnected &&
          preview.dataset.layoutSignature === stableLayoutSignature &&
          String(this.#getSelectedFont().id || '') === stableFontId;
        let settledGeometry = '';
        const readSettledGeometry = () => {
          const boardRect = artboard.getBoundingClientRect();
          const coreRect = core.getBoundingClientRect();
          const ink = this.#visibleDesignBounds(core, boardRect, coreRect);
          const signature = JSON.stringify([
            preview.style.fontSize,
            boardRect.width,
            boardRect.height,
            coreRect.width,
            coreRect.height,
            ink.left,
            ink.top,
            ink.width,
            ink.height,
          ].map((value) => typeof value === 'number' ? Math.round(value * 1000) / 1000 : value));
          return { signature, stage, core, coreRect, referenceRect: boardRect, ink };
        };
        const fitStableLayout = () => {
          const previousMetrics = this.#previewTextMetrics;
          this.#previewTextMetrics = new Map();
          try {
            if (!hasStableLayout()) return false;
            if (settledGeometry && readSettledGeometry().signature === settledGeometry) return true;

            /*
             * Start every settling pass from the same calculated size. If the
             * fallback face briefly measured larger, an early shrink must not
             * become permanent after the real WOFF2 face reaches WebKit layout.
             */
            preview.style.fontSize = nextFontSize;
            this.#applyPreviewOffset();
            this.#fitPreviewInk(preview, artboard, core, measurements);
            this.#syncPreviewIconTubeWidth(
              preview,
              { icon: this.#designState?.iconMeasurement || null },
              true
            );
            const geometry = readSettledGeometry();
            this.#positionMetrics(geometry);
            settledGeometry = geometry.signature;
            return true;
          } finally {
            this.#previewTextMetrics = previousMetrics;
          }
        };
        const settlePreview = (remainingFrames) => {
          this.#previewLayoutFrame = requestAnimationFrame(() => {
            this.#previewLayoutFrame = 0;
            if (!fitStableLayout()) return;
            if (remainingFrames > 1) settlePreview(remainingFrames - 1);
          });
        };
        const lateDelays = [120, 180];
        const settleLate = (index) => {
          this.#previewLayoutTimer = window.setTimeout(() => {
            this.#previewLayoutTimer = 0;
            if (!fitStableLayout()) return;
            if (index + 1 < lateDelays.length) settleLate(index + 1);
          }, lateDelays[index]);
        };

        initialLayoutFitted = fitStableLayout();
        settlePreview(4);
        settleLate(0);
      } else {
        this.#applyPreviewOffset();
      }
      if (!initialLayoutFitted) {
        this.#syncPreviewIconTubeWidth(preview, measurements, true);
        this.#positionMetrics();
      }
    }
  }

  /**
   * Fit visible glyph ink, rather than the font's often inaccurate CSS line
   * box, inside the artboard. Script fonts with unusual ascender/descender
   * metadata (notably Amsterdam) can otherwise lose half of a letter on a
   * narrow mobile canvas even though their logical text box still fits.
   *
   * @param {HTMLElement} preview
   * @param {HTMLElement} artboard
   * @param {HTMLElement} core
   * @param {Record<string, any>} measurements
   */
  #fitPreviewInk(preview, artboard, core, measurements) {
    /*
     * Always measure a new font from a neutral transform. Reusing the previous
     * face's correction can make a font with very different vertical metrics
     * inherit that offset for one or more layouts.
     */
    preview.style.setProperty('--tan-nd-preview-ink-shift-x', '0px');
    preview.style.setProperty('--tan-nd-preview-ink-shift-y', '0px');

    const artboardRect = artboard.getBoundingClientRect();
    const previewRect = preview.getBoundingClientRect();
    if (
      artboardRect.width <= 0 ||
      artboardRect.height <= 0 ||
      previewRect.width <= 0 ||
      previewRect.height <= 0
    ) {
      return;
    }

    const mobile = this.#isMobileViewport();
    const inset = mobile ? 8 : 14;
    /*
     * getBoundingClientRect() is expressed in transformed screen pixels while
     * CSS translate values are unscaled layout pixels. Keep the containment
     * arithmetic in screen space, then convert only when writing the shift.
     */
    const layoutScaleX = Math.max(
      0.01,
      artboardRect.width / Math.max(1, artboard.offsetWidth)
    );
    const layoutScaleY = Math.max(
      0.01,
      artboardRect.height / Math.max(1, artboard.offsetHeight)
    );
    /*
     * The horizontal ruler is rendered below the visible ink. Reserve its
     * line, ticks and label inside the artboard on phones so neither the ruler
     * nor a late-settling font can enter the size/price bar.
     */
    const bottomInset = mobile ? 46 : inset;
    const safeLeft = inset;
    const safeRight = Math.max(safeLeft + 1, artboardRect.width - inset);
    const safeTop = inset;
    const safeBottom = Math.max(safeTop + 1, artboardRect.height - bottomInset);
    const availableWidth = Math.max(1, safeRight - safeLeft);
    const availableHeight = Math.max(1, safeBottom - safeTop);
    let ink = this.#visibleDesignBounds(core, artboardRect);

    /*
     * Some decorative fonts need more than one layout pass because their CSS
     * line box and their visible glyph box scale at different rates. The old
     * two-call path could return from both calls while still shrinking, which
     * skipped optical centring completely. Iterate synchronously until the ink
     * fits, then always continue into the centring step below.
     */
    for (let pass = 0; pass < 6; pass += 1) {
      const fitRatio = Math.min(
        1,
        availableWidth / Math.max(1, ink.width),
        availableHeight / Math.max(1, ink.height)
      );
      if (fitRatio >= 0.995) break;

      const currentSize = this.#positiveNumber(
        window.getComputedStyle(preview).fontSize,
        16
      );
      const nextSize = Math.max(
        0.1,
        Math.round(currentSize * fitRatio * 0.97 * 100) / 100
      );
      if (Math.abs(nextSize - currentSize) < 0.01) break;
      preview.style.fontSize = `${nextSize}px`;
      ink = this.#visibleDesignBounds(core, artboardRect);
    }

    /*
     * Centre actual ink inside the backboard itself. Unlike the font's logical
     * line box, this anchor is stable across every WOFF2 face. It also follows
     * the customer's independent drag offset because the backboard is the
     * draggable element.
     */
    const designTarget = preview.closest('[data-preview-drag-target]');
    const designRect =
      designTarget instanceof HTMLElement
        ? designTarget.getBoundingClientRect()
        : previewRect;
    const inkCenterX = artboardRect.left + ink.left + ink.width / 2;
    const inkCenterY = artboardRect.top + ink.top + ink.height / 2;
    const previewCenterX = designRect.left + designRect.width / 2;
    const previewCenterY = designRect.top + designRect.height / 2;
    const minimumShiftX = safeLeft - ink.left;
    const maximumShiftX = safeRight - (ink.left + ink.width);
    const minimumShiftY = safeTop - ink.top;
    const maximumShiftY = safeBottom - (ink.top + ink.height);
    const centredShiftX = previewCenterX - inkCenterX;
    const centredShiftY = previewCenterY - inkCenterY;
    /*
     * Centre the real ink, but make containment the final authority. A
     * percentage clamp can still leave a font below the artboard when WebKit
     * returns extreme ascender/descender metrics; these bounds mathematically
     * guarantee that the fitted ink remains inside the same safe rectangle.
     */
    let shiftX =
      minimumShiftX <= maximumShiftX
        ? this.#clamp(centredShiftX, minimumShiftX, maximumShiftX)
        : (safeLeft + safeRight) / 2 - (ink.left + ink.width / 2);
    let shiftY =
      minimumShiftY <= maximumShiftY
        ? this.#clamp(centredShiftY, minimumShiftY, maximumShiftY)
        : (safeTop + safeBottom) / 2 - (ink.top + ink.height / 2);
    preview.style.setProperty(
      '--tan-nd-preview-ink-shift-x',
      `${Math.round((shiftX / layoutScaleX) * 100) / 100}px`
    );
    preview.style.setProperty(
      '--tan-nd-preview-ink-shift-y',
      `${Math.round((shiftY / layoutScaleY) * 100) / 100}px`
    );

    /*
     * Force one layout read after applying the transform and correct any
     * residual sub-layout movement. This catches the iOS case where the custom
     * face swaps between the canvas measurement and the transformed DOM read.
     */
    const shiftedInk = this.#visibleDesignBounds(core, artboardRect);
    if (shiftedInk.left < safeLeft) {
      shiftX += safeLeft - shiftedInk.left;
    } else if (shiftedInk.left + shiftedInk.width > safeRight) {
      shiftX -= shiftedInk.left + shiftedInk.width - safeRight;
    }
    if (shiftedInk.top < safeTop) {
      shiftY += safeTop - shiftedInk.top;
    } else if (shiftedInk.top + shiftedInk.height > safeBottom) {
      shiftY -= shiftedInk.top + shiftedInk.height - safeBottom;
    }
    preview.style.setProperty(
      '--tan-nd-preview-ink-shift-x',
      `${Math.round((shiftX / layoutScaleX) * 100) / 100}px`
    );
    preview.style.setProperty(
      '--tan-nd-preview-ink-shift-y',
      `${Math.round((shiftY / layoutScaleY) * 100) / 100}px`
    );
    const backboard = preview.closest('[data-backboard]');
    if (backboard instanceof HTMLElement) {
      this.#syncBackboardPreviewGeometry(
        backboard,
        core,
        artboard,
        measurements
      );
    }
  }

  /**
   * Draw rectangle, stand and box previews from the same visible-ink bounds
   * used by the rulers. The real acrylic extends 2 cm beyond the design on
   * every side, so font line-height metadata must never determine its size.
   *
   * @param {HTMLElement} backboard
   * @param {HTMLElement} core
   * @param {HTMLElement} artboard
   * @param {Record<string, any>} measurements
   */
  #syncBackboardPreviewGeometry(backboard, core, artboard, measurements) {
    const style = String(backboard.dataset.style || 'cut');
    if (!['rectangle', 'stand', 'box'].includes(style)) return;

    const artboardRect = artboard.getBoundingClientRect();
    const backboardRect = backboard.getBoundingClientRect();
    if (
      artboardRect.width <= 0 ||
      artboardRect.height <= 0 ||
      backboardRect.width <= 0 ||
      backboardRect.height <= 0
    ) {
      return;
    }

    const ink = this.#visibleDesignBounds(core, artboardRect);
    const widthCm = this.#positiveNumber(measurements?.width, 0);
    const heightCm = this.#positiveNumber(measurements?.height, 0);
    if (
      widthCm <= 0 ||
      heightCm <= 0 ||
      ink.width <= 0 ||
      ink.height <= 0
    ) {
      return;
    }

    const scaleX = Math.max(
      0.01,
      backboardRect.width / Math.max(1, backboard.offsetWidth)
    );
    const scaleY = Math.max(
      0.01,
      backboardRect.height / Math.max(1, backboard.offsetHeight)
    );
    const marginCm = 2;
    const marginX = (ink.width / widthCm) * marginCm;
    const marginY = (ink.height / heightCm) * marginCm;
    const inkScreenLeft = artboardRect.left + ink.left;
    const inkScreenTop = artboardRect.top + ink.top;

    const visualLeft =
      (inkScreenLeft - backboardRect.left - marginX) / scaleX;
    const visualTop =
      (inkScreenTop - backboardRect.top - marginY) / scaleY;
    const visualWidth = (ink.width + marginX * 2) / scaleX;
    const visualHeight = (ink.height + marginY * 2) / scaleY;
    const values = {
      '--tan-nd-board-visual-left': visualLeft,
      '--tan-nd-board-visual-top': visualTop,
      '--tan-nd-board-visual-width': visualWidth,
      '--tan-nd-board-visual-height': visualHeight,
    };

    Object.entries(values).forEach(([property, value]) => {
      const nextValue = `${Math.round(value * 100) / 100}px`;
      if (backboard.style.getPropertyValue(property) !== nextValue) {
        backboard.style.setProperty(property, nextValue);
      }
    });
  }

  /**
   * Return the visible glyph bounds instead of the CSS line box. Font files can
   * contain very different ascender, descender and side-bearing values; using
   * getBoundingClientRect() alone therefore lets a ruler cross fonts with large
   * overhangs or unusually small em boxes.
   *
   * @param {HTMLElement} core
   * @param {DOMRect} stageRect
   * @param {DOMRect=} coreRect
   */
  #renderedInkBounds(core, stageRect, coreRect = core.getBoundingClientRect()) {
    const fallback = {
      left: coreRect.left - stageRect.left,
      top: coreRect.top - stageRect.top,
      width: coreRect.width,
      height: coreRect.height,
    };
    const context = this.#measureContext;
    if (!context || coreRect.width <= 0 || coreRect.height <= 0) return fallback;

    const style = window.getComputedStyle(core);
    const fontSize = this.#positiveNumber(style.fontSize, 16);
    const parsedLineHeight = Number.parseFloat(style.lineHeight);
    const lineHeight = Number.isFinite(parsedLineHeight)
      ? parsedLineHeight
      : fontSize * this.#positiveNumber(this.#getSelectedFont().lineHeight, 1.2);
    const family = style.fontFamily || this.#getSelectedFont().family || 'sans-serif';
    const fontStyle = style.fontStyle || 'normal';
    const fontWeight = style.fontWeight || '400';
    const lines = String(core.textContent || ' ').split(/\r?\n/);
    const logicalHeight = Math.max(1, lines.length * lineHeight);

    context.save();
    context.font = `${fontStyle} ${fontWeight} ${fontSize}px ${family}`;
    context.textBaseline = 'alphabetic';

    const metricCache = this.#previewTextMetrics || new Map();
    const metricKey = JSON.stringify([
      context.font, context.textAlign, context.textBaseline, context.direction,
      context.fontKerning, context.fontStretch, context.fontVariantCaps,
      context.letterSpacing, context.wordSpacing, context.textRendering,
    ]);
    let textMetrics = metricCache.get(metricKey);
    if (!textMetrics) {
      textMetrics = new Map();
      metricCache.set(metricKey, textMetrics);
    }
    const measureText = (value) => {
      if (!textMetrics.has(value)) textMetrics.set(value, context.measureText(value));
      return textMetrics.get(value);
    };

    const renderedGraphemes = Array.from(
      core.querySelectorAll('[data-preview-grapheme]')
    ).filter((candidate) => candidate instanceof HTMLElement);

    const measuredLines = renderedGraphemes.length ? [] : lines.map((line) => {
      const metric = measureText(line || ' ');
      return {
        metric,
        advance: Math.max(1, metric.width || fontSize * 0.5),
      };
    });
    const maxAdvance = Math.max(1, ...measuredLines.map((line) => line.advance));
    const renderedScaleX = coreRect.width / maxAdvance;
    const renderedScaleY = coreRect.height / logicalHeight;
    const baselineMarker = Array.from(core.children).find(
      (child) =>
        child instanceof HTMLElement &&
        child.hasAttribute('data-preview-baseline')
    );
    const baselineMarkerRect =
      baselineMarker instanceof HTMLElement
        ? baselineMarker.getBoundingClientRect()
        : null;
    const exactLastBaseline =
      baselineMarkerRect && Number.isFinite(baselineMarkerRect.top)
        ? baselineMarkerRect.top - stageRect.top
        : Number.NaN;
    const exactLastBaselineLocal =
      Number.isFinite(exactLastBaseline) && renderedScaleY > 0
        ? (exactLastBaseline - fallback.top) / renderedScaleY
        : Number.NaN;
    const probe = measureText('MgÅyj');
    const fontAscent = Math.max(
      1,
      this.#finiteNumber(
        probe.fontBoundingBoxAscent,
        this.#finiteNumber(probe.emHeightAscent, probe.actualBoundingBoxAscent || fontSize * 0.8)
      )
    );
    const fontDescent = Math.max(
      0,
      this.#finiteNumber(
        probe.fontBoundingBoxDescent,
        this.#finiteNumber(probe.emHeightDescent, probe.actualBoundingBoxDescent || fontSize * 0.2)
      )
    );
    const fontBoxHeight = Math.max(1, fontAscent + fontDescent);
    /*
     * CSS distributes line-height leading equally above and below the font box.
     * The leading may be negative for fonts whose internal ascender/descender
     * box is taller than the selected line-height, so it must not be clamped.
     */
    const baselineOffset = (lineHeight - fontBoxHeight) / 2 + fontAscent;
    const textAlign = String(style.textAlign || 'center').toLowerCase();

    let inkLeft = Number.POSITIVE_INFINITY;
    let inkTop = Number.POSITIVE_INFINITY;
    let inkRight = Number.NEGATIVE_INFINITY;
    let inkBottom = Number.NEGATIVE_INFINITY;

    /*
     * Icon-enabled layers wrap each visible grapheme so an icon can occupy an
     * actual character gap. Measure those real DOM positions individually;
     * scaling the whole core box by the text-only canvas advance would include
     * the icon width twice and detach the ruler.
     */
    if (renderedGraphemes.length > 0) {
      renderedGraphemes.forEach((character) => {
        const characterRect = character.getBoundingClientRect();
        if (characterRect.width <= 0 || characterRect.height <= 0) return;
        const metric = measureText(character.textContent || ' ');
        const advance = Math.max(1, metric.width || characterRect.width);
        const scaleX = characterRect.width / advance;
        const actualLeft = this.#finiteNumber(metric.actualBoundingBoxLeft, 0);
        const actualRight = this.#finiteNumber(
          metric.actualBoundingBoxRight,
          advance
        );
        const actualAscent = Math.max(
          0,
          this.#finiteNumber(metric.actualBoundingBoxAscent, fontAscent)
        );
        const actualDescent = Math.max(
          0,
          this.#finiteNumber(metric.actualBoundingBoxDescent, fontDescent)
        );
        const previewLine = this.#clamp(
          Number.parseInt(character.dataset.previewLine || '0', 10),
          0,
          Math.max(0, lines.length - 1)
        );
        const baseline = Number.isFinite(exactLastBaseline)
          ? exactLastBaseline -
            (lines.length - 1 - previewLine) * lineHeight * renderedScaleY
          : characterRect.top -
            stageRect.top +
            (characterRect.height - fontBoxHeight * renderedScaleY) / 2 +
            fontAscent * renderedScaleY;

        inkLeft = Math.min(
          inkLeft,
          characterRect.left - stageRect.left - actualLeft * scaleX
        );
        inkRight = Math.max(
          inkRight,
          characterRect.left - stageRect.left + actualRight * scaleX
        );
        inkTop = Math.min(
          inkTop,
          baseline - actualAscent * renderedScaleY
        );
        inkBottom = Math.max(
          inkBottom,
          baseline + actualDescent * renderedScaleY
        );
      });
      context.restore();

      if (
        [inkLeft, inkTop, inkRight, inkBottom].every(Number.isFinite) &&
        inkRight > inkLeft &&
        inkBottom > inkTop
      ) {
        const measuredWidth = inkRight - inkLeft;
        const measuredHeight = inkBottom - inkTop;
        const guardX = Math.max(1.5, Math.min(4, measuredWidth * 0.006));
        const guardY = Math.max(1.5, Math.min(4, measuredHeight * 0.012));
        return {
          left: inkLeft - guardX,
          top: inkTop - guardY,
          width: measuredWidth + guardX * 2,
          height: measuredHeight + guardY * 2,
        };
      }

      return fallback;
    }

    measuredLines.forEach(({ metric, advance }, index) => {
      let lineOrigin = 0;
      if (textAlign === 'center') lineOrigin = (maxAdvance - advance) / 2;
      if (textAlign === 'right' || textAlign === 'end') lineOrigin = maxAdvance - advance;

      /*
       * actualBoundingBoxLeft is signed. A negative value is a real positive
       * side-bearing, not invalid data; clamping it to zero adds invisible
       * whitespace and visibly detaches the ruler on several script fonts.
       */
      const actualLeft = this.#finiteNumber(metric.actualBoundingBoxLeft, 0);
      const actualRight = this.#finiteNumber(metric.actualBoundingBoxRight, advance);
      const actualAscent = Math.max(
        0,
        this.#finiteNumber(metric.actualBoundingBoxAscent, fontAscent)
      );
      const actualDescent = Math.max(
        0,
        this.#finiteNumber(metric.actualBoundingBoxDescent, fontDescent)
      );
      const baseline = Number.isFinite(exactLastBaselineLocal)
        ? exactLastBaselineLocal - (lines.length - 1 - index) * lineHeight
        : index * lineHeight + baselineOffset;

      inkLeft = Math.min(inkLeft, lineOrigin - actualLeft);
      inkRight = Math.max(inkRight, lineOrigin + actualRight);
      inkTop = Math.min(inkTop, baseline - actualAscent);
      inkBottom = Math.max(inkBottom, baseline + actualDescent);
    });
    context.restore();

    if (
      ![inkLeft, inkTop, inkRight, inkBottom].every(Number.isFinite) ||
      inkRight <= inkLeft ||
      inkBottom <= inkTop
    ) {
      return fallback;
    }

    const measuredLeft = fallback.left + inkLeft * renderedScaleX;
    const measuredTop = fallback.top + inkTop * renderedScaleY;
    const measuredRight = fallback.left + inkRight * renderedScaleX;
    const measuredBottom = fallback.top + inkBottom * renderedScaleY;
    const measuredWidth = measuredRight - measuredLeft;
    const measuredHeight = measuredBottom - measuredTop;
    if (
      ![measuredLeft, measuredTop, measuredWidth, measuredHeight].every(Number.isFinite) ||
      measuredWidth <= 0 ||
      measuredHeight <= 0
    ) {
      return fallback;
    }

    /*
     * Do not union these bounds with the CSS line box. A font's line box can be
     * two or three times taller than its visible letters (Frankfurt is a good
     * example), which made the ruler look detached from the sign. The small
     * guard only protects antialiased edge pixels; the regular ruler padding is
     * added in #positionMetrics().
     */
    const guardX = Math.max(1.5, Math.min(4, measuredWidth * 0.006));
    const guardY = Math.max(1.5, Math.min(4, measuredHeight * 0.012));
    return {
      left: measuredLeft - guardX,
      top: measuredTop - guardY,
      width: measuredWidth + guardX * 2,
      height: measuredHeight + guardY * 2,
    };
  }

  /**
   * Union the text's visible glyph bounds with the selected icon's rendered
   * box. The SVG files are normalized to a tight square viewBox, so the icon
   * mask box is also its manufactured visual boundary.
   *
   * @param {HTMLElement} core
   * @param {DOMRect} stageRect
   * @param {DOMRect=} coreRect
   */
  #visibleDesignBounds(core, stageRect, coreRect) {
    const textBounds = this.#renderedInkBounds(core, stageRect, coreRect);
    const icon = core.querySelector('[data-neon-icon]');
    if (!(icon instanceof HTMLElement)) return textBounds;

    const iconRect = icon.getBoundingClientRect();
    if (iconRect.width <= 0 || iconRect.height <= 0) return textBounds;
    const iconBounds = {
      left: iconRect.left - stageRect.left,
      top: iconRect.top - stageRect.top,
      width: iconRect.width,
      height: iconRect.height,
    };
    const left = Math.min(textBounds.left, iconBounds.left);
    const top = Math.min(textBounds.top, iconBounds.top);
    const right = Math.max(
      textBounds.left + textBounds.width,
      iconBounds.left + iconBounds.width
    );
    const bottom = Math.max(
      textBounds.top + textBounds.height,
      iconBounds.top + iconBounds.height
    );
    return {
      left,
      top,
      width: Math.max(1, right - left),
      height: Math.max(1, bottom - top),
    };
  }

  #positionMetrics(geometry = null) {
    const stage = this.querySelector('[data-stage]');
    const core = this.querySelector('[data-neon-core]');
    const metrics = this.querySelector('[data-sign-metrics]');
    if (
      !(stage instanceof HTMLElement) ||
      !(core instanceof HTMLElement) ||
      !(metrics instanceof HTMLElement)
    ) {
      return;
    }

    if (metrics.hidden) metrics.hidden = false;
    const sharedGeometry = geometry?.core === core && geometry.stage === stage;
    const coreRect = sharedGeometry ? geometry.coreRect : core.getBoundingClientRect();
    if (coreRect.width <= 0 || coreRect.height <= 0) {
      if (!metrics.hidden) metrics.hidden = true;
      return;
    }

    const stageRect = stage.getBoundingClientRect();
    const ink = sharedGeometry
      ? {
          left: geometry.ink.left + (geometry.referenceRect.left - stageRect.left),
          top: geometry.ink.top + (geometry.referenceRect.top - stageRect.top),
          width: geometry.ink.width,
          height: geometry.ink.height,
        }
      : this.#visibleDesignBounds(core, stageRect, coreRect);
    const selectedFont = this.#getSelectedFont();
    const rulerPadding =
      this.#clamp(this.#positiveNumber(selectedFont.rulerPadding, 6), 2, 18) / 100;
    const renderedFontSize = this.#positiveNumber(
      window.getComputedStyle(core).fontSize,
      72
    );
    /*
     * The metric box must stay equal to the visible ink box. Font-specific
     * ruler padding controls only the perpendicular gap between the letters and
     * the ruler; it must never lengthen either measurement line.
     */
    const rulerGap = this.#clamp(12 + renderedFontSize * rulerPadding, 14, 28);
    const rawWidth = Math.max(1, ink.width);
    const rawHeight = Math.max(1, ink.height);
    const rawLeft = ink.left;
    const rawTop = ink.top;
    /*
     * Keep the metric box attached to the sign even when the customer drags it
     * close to an edge. Clamping the box independently from the sign shortens a
     * ruler or makes it drift away; stage overflow may clip it, but its
     * geometry remains truthful.
     */
    const left = rawLeft;
    const top = rawTop;
    const heightLabel = metrics.querySelector('.tan-nd__measure--height span');
    const heightLabelWidth =
      heightLabel instanceof HTMLElement ? heightLabel.getBoundingClientRect().width : 0;
    const metricLeft = `${left}px`;
    const metricTop = `${top}px`;
    const metricWidth = `${rawWidth}px`;
    const metricHeight = `${rawHeight}px`;
    const metricRulerGap = `${rulerGap}px`;
    if (metrics.style.getPropertyValue('--tan-nd-metric-left') !== metricLeft) {
      metrics.style.setProperty('--tan-nd-metric-left', metricLeft);
    }
    if (metrics.style.getPropertyValue('--tan-nd-metric-top') !== metricTop) {
      metrics.style.setProperty('--tan-nd-metric-top', metricTop);
    }
    if (metrics.style.getPropertyValue('--tan-nd-metric-width') !== metricWidth) {
      metrics.style.setProperty('--tan-nd-metric-width', metricWidth);
    }
    if (metrics.style.getPropertyValue('--tan-nd-metric-height') !== metricHeight) {
      metrics.style.setProperty('--tan-nd-metric-height', metricHeight);
    }
    if (metrics.style.getPropertyValue('--tan-nd-ruler-gap') !== metricRulerGap) {
      metrics.style.setProperty('--tan-nd-ruler-gap', metricRulerGap);
    }
    if (metrics.dataset.widthPlacement !== 'below') {
      metrics.dataset.widthPlacement = 'below';
    }
    const heightRulerClearance = rulerGap + heightLabelWidth + 12;
    const availableLeft = Math.max(0, rawLeft);
    const availableRight = Math.max(0, stageRect.width - (rawLeft + rawWidth));
    const heightPlacement =
      availableLeft >= heightRulerClearance || availableLeft >= availableRight
        ? 'left'
        : 'right';
    if (metrics.dataset.heightPlacement !== heightPlacement) {
      metrics.dataset.heightPlacement = heightPlacement;
    }
  }

  /**
   * Keep the default icon optically consistent across fonts whose internal
   * ascender/descender boxes vary wildly. The customer's icon-scale control
   * still applies after this bounded reference height.
   *
   * @param {Record<string, any>} font
   * @param {CanvasRenderingContext2D | null} context
   * @param {number} baseFontSize
   * @param {number} lineVisualHeight
   */
  #iconOpticalReferenceHeight(
    font,
    context,
    baseFontSize,
    lineVisualHeight
  ) {
    const configuredHeightEm = Number(font?.iconHeightEm);
    if (Number.isFinite(configuredHeightEm) && configuredHeightEm > 0) {
      return (
        baseFontSize *
        this.#clamp(configuredHeightEm, 0.68, 1.12)
      );
    }

    const reference = context?.measureText('Hgx');
    const referenceHeight =
      this.#finiteNumber(reference?.actualBoundingBoxAscent, 0) +
      this.#finiteNumber(reference?.actualBoundingBoxDescent, 0);
    const measuredLineHeight = this.#positiveNumber(lineVisualHeight, 0);
    const opticalHeight = Math.max(
      measuredLineHeight,
      referenceHeight > baseFontSize * 0.25
        ? referenceHeight * 0.88
        : baseFontSize * 0.82
    );

    return this.#clamp(
      opticalHeight,
      baseFontSize * 0.72,
      baseFontSize * 1.04
    );
  }

  /**
   * Add breathing room on the side that touches text and compensate for real
   * glyph overhangs. Script-font swashes can extend well past the advance
   * width, which a fixed symmetric 0.22em margin cannot protect.
   *
   * @param {CanvasRenderingContext2D | null} context
   * @param {Record<string, any> | null} placementState
   * @param {number} baseFontSize
   * @param {number} iconNaturalHeight
   */
  #iconNaturalGaps(
    context,
    placementState,
    baseFontSize,
    iconNaturalHeight
  ) {
    if (!placementState) {
      return { before: 0, after: 0, total: 0 };
    }

    const beforeLine = String(placementState.before || '').split(/\r?\n/).at(-1) || '';
    const afterLine = String(placementState.after || '').split(/\r?\n/)[0] || '';
    const beforeMetric = beforeLine && context ? context.measureText(beforeLine) : null;
    const afterMetric = afterLine && context ? context.measureText(afterLine) : null;
    const maximumOverhang = baseFontSize * 0.82;
    const rightOverhang = beforeMetric
      ? this.#clamp(
          this.#finiteNumber(
            beforeMetric.actualBoundingBoxRight,
            beforeMetric.width
          ) - beforeMetric.width,
          0,
          maximumOverhang
        )
      : 0;
    const leftOverhang = afterMetric
      ? this.#clamp(
          this.#finiteNumber(afterMetric.actualBoundingBoxLeft, 0),
          0,
          maximumOverhang
        )
      : 0;

    const clearance = this.#clamp(
      iconNaturalHeight * 0.16,
      baseFontSize * 0.14,
      baseFontSize * 0.22
    );
    let before = 0;
    let after = 0;
    if (placementState.position === 'right') {
      before = clearance + rightOverhang;
    } else if (placementState.position === 'left') {
      after = clearance + leftOverhang;
    } else {
      before = clearance + rightOverhang;
      after = clearance + leftOverhang;
    }

    return {
      before,
      after,
      total: before + after,
    };
  }

  /**
   * Centre the tight icon geometry on the insertion line's real ink box.
   * CSS vertical-align is positive when the inline box is raised.
   *
   * @param {Record<string, any> | null} lineMetric
   * @param {number} iconNaturalHeight
   * @param {number} baseFontSize
   */
  #iconVerticalAlignment(lineMetric, iconNaturalHeight, baseFontSize) {
    const ascent = Math.max(
      0,
      this.#finiteNumber(lineMetric?.ascent, baseFontSize * 0.76)
    );
    const descent = Math.max(
      0,
      this.#finiteNumber(lineMetric?.descent, baseFontSize * 0.16)
    );
    return this.#clamp(
      (ascent - descent - iconNaturalHeight) / (2 * baseFontSize),
      -0.68,
      0.3
    );
  }

  /**
   * Resolve one optical baseline step for the complete multiline design.
   *
   * Custom font files carry wildly different internal line boxes, so their
   * configured line-height values cannot be compared visually. Use the real
   * ink above and below each baseline instead, then add one bounded visible
   * gap. The same result drives the live preview, rulers and manufactured
   * dimensions so the mock-up never disagrees with the quoted size.
   *
   * @param {Array<Record<string, any>>} lineMetrics
   * @param {number} baseFontSize
   * @param {number} fallbackLineHeightEm
   * @param {{lineIndex: number, height: number, alignEm: number} | null} icon
   */
  #calibratedMultilineLayout(
    lineMetrics,
    baseFontSize,
    fallbackLineHeightEm,
    icon = null
  ) {
    const safeBase = this.#positiveNumber(baseFontSize, 100);
    const fallbackAscent = safeBase * 0.78;
    const fallbackDescent = safeBase * 0.2;
    const lines = (Array.isArray(lineMetrics) && lineMetrics.length > 0
      ? lineMetrics
      : [{ text: '', width: 1 }]
    ).map((line) => {
      const ascent = Math.max(
        0,
        this.#finiteNumber(line?.ascent, fallbackAscent)
      );
      const descent = Math.max(
        0,
        this.#finiteNumber(line?.descent, fallbackDescent)
      );
      return {
        ...line,
        ascent,
        descent,
        visualHeight: Math.max(1, ascent + descent),
      };
    });
    const textVisibleHeights = lines
      .map((line) => Math.max(1, line.visualHeight))
      .sort((a, b) => a - b);

    if (icon && lines.length > 0) {
      const iconLineIndex = this.#clamp(
        Math.round(this.#finiteNumber(icon.lineIndex, 0)),
        0,
        lines.length - 1
      );
      const iconHeight = Math.max(0, this.#finiteNumber(icon.height, 0));
      const iconAlignEm = this.#clamp(
        this.#finiteNumber(icon.alignEm, 0),
        -0.68,
        0.3
      );
      if (iconHeight > 0) {
        const iconBottom = -safeBase * iconAlignEm;
        const iconTop = iconBottom - iconHeight;
        lines[iconLineIndex].ascent = Math.max(
          lines[iconLineIndex].ascent,
          -iconTop
        );
        lines[iconLineIndex].descent = Math.max(
          lines[iconLineIndex].descent,
          iconBottom
        );
        lines[iconLineIndex].visualHeight = Math.max(
          1,
          lines[iconLineIndex].ascent + lines[iconLineIndex].descent
        );
      }
    }

    if (lines.length === 1) {
      const top = -lines[0].ascent;
      const bottom = lines[0].descent;
      return {
        lines,
        lineHeightEm: this.#positiveNumber(fallbackLineHeightEm, 1.2),
        baselineStep: safeBase * this.#positiveNumber(fallbackLineHeightEm, 1.2),
        visualGap: 0,
        top,
        bottom,
        rawHeight: Math.max(1, bottom - top),
      };
    }

    const middleIndex = Math.floor(textVisibleHeights.length / 2);
    const referenceHeight =
      textVisibleHeights.length % 2 === 0
        ? (textVisibleHeights[middleIndex - 1] +
            textVisibleHeights[middleIndex]) /
          2
        : textVisibleHeights[middleIndex];
    const visualGap = this.#clamp(
      referenceHeight * 0.22,
      safeBase * 0.14,
      safeBase * 0.24
    );
    const pairSteps = lines.slice(0, -1).map(
      (line, index) =>
        line.descent + lines[index + 1].ascent + visualGap
    );
    const baselineStep = Math.max(safeBase * 0.4, ...pairSteps);
    const top = Math.min(
      ...lines.map((line, index) => index * baselineStep - line.ascent)
    );
    const bottom = Math.max(
      ...lines.map((line, index) => index * baselineStep + line.descent)
    );

    return {
      lines,
      lineHeightEm: baselineStep / safeBase,
      baselineStep,
      visualGap,
      top,
      bottom,
      rawHeight: Math.max(1, bottom - top),
    };
  }

  /**
   * @param {string} text
   * @param {Record<string, any>} font
   */
  #measurementGeometryKey(text, font) {
    const selectedIcon = this.#getSelectedIcon();
    return JSON.stringify({
      text: String(text || ''),
      fontId: String(font?.id || ''),
      iconId: String(selectedIcon?.id || ''),
      iconScale: selectedIcon ? Number(this.#iconScale) || 0 : 0,
      iconPlacement: selectedIcon
        ? this.#resolvedIconPlacement(String(text || ''))
        : null,
    });
  }

  /**
   * @param {string} text
   * @param {Record<string, any>} font
   */
  #measureDesign(text, font) {
    const lines = String(text || ' ').split(/\r?\n/);
    const family = font.family || 'sans-serif';
    const fallbackLineHeight = this.#positiveNumber(font.lineHeight, 1.6);
    const measurementHeightScale = this.#clamp(
      this.#positiveNumber(font.measurementHeightScale, 1),
      0.5,
      1.5
    );
    const context = this.#measureContext;
    const baseFontSize = 100;
    if (context) {
      context.font = `400 ${baseFontSize}px ${JSON.stringify(family)}`;
      context.textBaseline = 'alphabetic';
      context.textAlign = 'start';
    }

    const referenceMetric = context?.measureText('Hg');
    const referenceAscent = Math.max(
      1,
      this.#finiteNumber(
        referenceMetric?.actualBoundingBoxAscent,
        baseFontSize * 0.78
      )
    );
    const referenceDescent = Math.max(
      0,
      this.#finiteNumber(
        referenceMetric?.actualBoundingBoxDescent,
        baseFontSize * 0.2
      )
    );

    const lineMetrics = lines.map((line) => {
      const safeLine = line || ' ';
      const metric = context?.measureText(safeLine);
      const width = Math.max(1, metric?.width || safeLine.length * 58);
      const measuredAscent = Number(metric?.actualBoundingBoxAscent);
      const measuredDescent = Number(metric?.actualBoundingBoxDescent);
      const hasMeasuredInk =
        line.trim().length > 0 &&
        ((Number.isFinite(measuredAscent) && measuredAscent > 0) ||
          (Number.isFinite(measuredDescent) && measuredDescent > 0));
      const ascent = hasMeasuredInk
        ? Math.max(0, this.#finiteNumber(measuredAscent, referenceAscent))
        : referenceAscent;
      const descent = hasMeasuredInk
        ? Math.max(0, this.#finiteNumber(measuredDescent, referenceDescent))
        : referenceDescent;
      const visualHeight = Math.max(1, ascent + descent);
      return { text: line, width, visualHeight, ascent, descent };
    });

    const textNaturalWidth = Math.max(1, ...lineMetrics.map((line) => line.width));
    const selectedIcon = this.#getSelectedIcon();
    const iconScaleFactor = selectedIcon ? this.#iconScale / 100 : 0;
    const placementState = selectedIcon ? this.#iconPlacementState(text) : null;
    const geometryKey = this.#measurementGeometryKey(text, font);
    const authoritativeSize =
      this.#authoritativeSize?.geometryKey === geometryKey
        ? this.#authoritativeSize
        : null;
    if (this.#authoritativeSize && !authoritativeSize) {
      this.#authoritativeSize = null;
    }
    const iconInsertionLine =
      selectedIcon && placementState
        ? this.#clamp(
            String(placementState.before || '').split(/\r?\n/).length - 1,
            0,
            lineMetrics.length - 1
          )
        : 0;
    const iconLineMetric = lineMetrics[iconInsertionLine] || lineMetrics[0] || null;
    const iconReferenceHeight = selectedIcon
      ? this.#iconOpticalReferenceHeight(
          font,
          context,
          baseFontSize,
          iconLineMetric?.visualHeight
        )
      : 0;
    const iconPreviewNaturalHeight = selectedIcon
      ? Math.max(1, iconReferenceHeight * iconScaleFactor)
      : 0;
    const iconPreviewNaturalWidth = selectedIcon
      ? Math.max(
          1,
          iconPreviewNaturalHeight *
            this.#positiveNumber(selectedIcon.aspect, 1)
        )
      : 0;
    const iconNaturalHeight = selectedIcon
      ? Math.max(1, iconPreviewNaturalHeight * measurementHeightScale)
      : 0;
    const iconNaturalWidth = selectedIcon
      ? Math.max(
          1,
          iconNaturalHeight * this.#positiveNumber(selectedIcon.aspect, 1)
        )
      : 0;
    const iconGaps = selectedIcon
      ? this.#iconNaturalGaps(
          context,
          placementState,
          baseFontSize,
          iconPreviewNaturalHeight
        )
      : { before: 0, after: 0, total: 0 };
    const iconGapNatural = iconGaps.total;
    const iconAlignEm = selectedIcon
      ? this.#iconVerticalAlignment(
          iconLineMetric,
          iconPreviewNaturalHeight,
          baseFontSize
        )
      : 0;
    const measuredLineMetrics = lineMetrics.map((line) => ({ ...line }));

    if (selectedIcon && placementState) {
      const beforeLines = placementState.before.split(/\r?\n/);
      const afterLines = placementState.after.split(/\r?\n/);
      const beforeLine = beforeLines.at(-1) || '';
      const afterLine = afterLines[0] || '';
      const measurePart = (value) => {
        if (!value) return 0;
        return Math.max(
          0,
          context?.measureText(value).width || this.#countCharacters(value) * 58
        );
      };
      measuredLineMetrics[iconInsertionLine].width = Math.max(
        1,
        measurePart(beforeLine) +
          iconNaturalWidth +
          iconGapNatural +
          measurePart(afterLine)
      );
      measuredLineMetrics[iconInsertionLine].visualHeight = Math.max(
        measuredLineMetrics[iconInsertionLine].visualHeight,
        iconPreviewNaturalHeight
      );
    }

    const calibratedLayout = this.#calibratedMultilineLayout(
      measuredLineMetrics,
      baseFontSize,
      fallbackLineHeight,
      selectedIcon
        ? {
            lineIndex: iconInsertionLine,
            height: iconPreviewNaturalHeight,
            alignEm: iconAlignEm,
          }
        : null
    );
    calibratedLayout.lines.forEach((line, index) => {
      if (!measuredLineMetrics[index]) return;
      measuredLineMetrics[index].ascent = line.ascent;
      measuredLineMetrics[index].descent = line.descent;
      measuredLineMetrics[index].visualHeight = line.visualHeight;
    });

    const naturalWidth = Math.max(
      1,
      selectedIcon
        ? Math.max(...measuredLineMetrics.map((line) => line.width))
        : textNaturalWidth
    );
    const naturalHeight = Math.max(
      1,
      calibratedLayout.rawHeight * measurementHeightScale
    );
    const minWidthSetting = this.#numberData('minWidth', 20);
    const maxWidth = this.#numberData('maxWidth', 240);
    const maxHeight = this.#numberData('maxHeight', 120);
    const requestedWidth = this.#getRequestedWidth();

    let minimumScale = 0;
    const hasLowercase = /\p{Ll}/u.test(text);
    const hasUppercase = /\p{Lu}/u.test(text);

    if (context && hasLowercase) {
      const xMetric = context.measureText('x');
      const xHeight = Math.max(1, xMetric.actualBoundingBoxAscent + xMetric.actualBoundingBoxDescent);
      minimumScale = Math.max(
        minimumScale,
        this.#positiveNumber(font.minSmallestHeight, 5.45) / xHeight
      );
    }

    if (context && hasUppercase) {
      const upperMetric = context.measureText('H');
      const upperHeight = Math.max(
        1,
        upperMetric.actualBoundingBoxAscent + upperMetric.actualBoundingBoxDescent
      );
      minimumScale = Math.max(
        minimumScale,
        this.#positiveNumber(font.minUppercaseHeight, 9.45) / upperHeight
      );
    }

    if (selectedIcon && iconNaturalHeight > 0) {
      minimumScale = Math.max(
        minimumScale,
        this.#iconMinimumHeightCm(selectedIcon) / iconNaturalHeight
      );
    }

    const minimumWidth = Math.max(
      minWidthSetting,
      Math.ceil(naturalWidth * minimumScale),
      authoritativeSize?.minimumWidthCm || 0
    );
    const effectiveMinimum = Math.min(maxWidth, minimumWidth);
    const minimumHeight = Math.max(1, Math.ceil((naturalHeight * effectiveMinimum) / naturalWidth));
    const effectiveMaximumHeight = Math.max(
      minimumHeight,
      Math.min(maxHeight, Math.floor((naturalHeight * maxWidth) / naturalWidth))
    );
    const requestedHeight = this.#getRequestedHeight();
    const preserveRequestedSize =
      this.#customerSelectedSize || this.#automaticSizeInitialized;
    let width =
      this.#sizeDriver === 'height' && requestedHeight !== null
        ? Math.max(
            effectiveMinimum,
            Math.min(
              maxWidth,
              Math.round(
                (Math.max(minimumHeight, Math.min(effectiveMaximumHeight, requestedHeight)) * naturalWidth) /
                  naturalHeight
              )
            )
          )
        : tanResolveProductionWidth({
            naturalWidth,
            naturalHeight,
            minimumWidth: effectiveMinimum,
            maximumWidth: maxWidth,
            maximumHeight: maxHeight,
            requestedWidth,
            preserveRequestedSize,
          });
    let height = Math.max(1, Math.round(naturalHeight * (width / naturalWidth)));
    if (authoritativeSize) {
      width = this.#clamp(
        Math.round(authoritativeSize.widthCm),
        effectiveMinimum,
        maxWidth
      );
      height = this.#clamp(
        Math.round(authoritativeSize.heightCm),
        1,
        maxHeight
      );
    }
    const scale = width / naturalWidth;
    const iconExactWidth = selectedIcon ? iconNaturalWidth * scale : 0;
    const iconExactHeight = selectedIcon ? iconNaturalHeight * scale : 0;
    this.#syncIconScaleFloor(iconExactHeight, selectedIcon);

    const ranges = this.querySelectorAll('[data-width-range]');
    const inputs = this.querySelectorAll('[data-width-input]');
    const heightInput = this.querySelector('[data-height-input]');
    const rangeMinimum = String(effectiveMinimum);
    const rangeValue = String(width);
    const widthMinimum = this.#formatDimensionFieldValue(effectiveMinimum);
    const widthMaximum = this.#formatDimensionFieldValue(maxWidth);
    const widthValue = this.#formatDimensionFieldValue(width);
    const heightMinimum = this.#formatDimensionFieldValue(minimumHeight);
    const heightMaximum = this.#formatDimensionFieldValue(effectiveMaximumHeight);
    const heightValue = this.#formatDimensionFieldValue(height);
    const dimensionStep = this.#measurementUnit === 'in' ? '0.1' : '1';
    ranges.forEach((range) => {
      if (!(range instanceof HTMLInputElement)) return;
      if (range.min !== rangeMinimum) range.min = rangeMinimum;
      if (range.value !== rangeValue) range.value = rangeValue;
    });
    inputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      if (input.min !== widthMinimum) input.min = widthMinimum;
      if (input.max !== widthMaximum) input.max = widthMaximum;
      if (input.step !== dimensionStep) input.step = dimensionStep;
      if (document.activeElement !== input && input.value !== widthValue) {
        input.value = widthValue;
      }
    });
    if (heightInput instanceof HTMLInputElement) {
      if (heightInput.min !== heightMinimum) heightInput.min = heightMinimum;
      if (heightInput.max !== heightMaximum) heightInput.max = heightMaximum;
      if (heightInput.step !== dimensionStep) heightInput.step = dimensionStep;
      if (document.activeElement !== heightInput && heightInput.value !== heightValue) {
        heightInput.value = heightValue;
      }
    }
    return {
      width,
      height,
      minimumWidth,
      minimumHeight,
      minimumProductionScale: effectiveMinimum / naturalWidth,
      naturalWidth,
      naturalHeight,
      lineHeightEm: calibratedLayout.lineHeightEm,
      visualLineGapEm: calibratedLayout.visualGap / baseFontSize,
      lines: measuredLineMetrics.map((line) => ({
        text: line.text,
        width: Math.max(1, Math.round(line.width * scale)),
        height: Math.max(
          1,
          Math.round(line.visualHeight * scale * measurementHeightScale)
        ),
      })),
      icon: selectedIcon
        ? {
            id: selectedIcon.id,
            label: selectedIcon.label,
            position: placementState.position,
            placement: placementState.placement,
            placementLabel: placementState.label,
            placementDisplayLabel: placementState.displayLabel,
            scale: this.#iconScale,
            width: Math.max(1, Math.round(iconExactWidth)),
            height: Math.max(1, Math.round(iconExactHeight)),
            exactWidth: iconExactWidth,
            exactHeight: iconExactHeight,
            tubeWidthCm: this.#iconTubeWidthCm(),
            minimumHeightCm: this.#iconMinimumHeightCm(selectedIcon),
            gap: Math.max(1, Math.round(iconGapNatural * scale)),
            gapBefore: Math.max(0, Math.round(iconGaps.before * scale)),
            gapAfter: Math.max(0, Math.round(iconGaps.after * scale)),
            widthEm: iconPreviewNaturalWidth / baseFontSize,
            heightEm: iconPreviewNaturalHeight / baseFontSize,
            gapEm: iconGapNatural / baseFontSize,
            gapBeforeEm: iconGaps.before / baseFontSize,
            gapAfterEm: iconGaps.after / baseFontSize,
            alignEm: iconAlignEm,
          }
        : null,
    };
  }

  /**
   * @param {Record<string, any>} measurements
   * @param {boolean} hasText
   */
  #renderMeasurements(measurements, hasText) {
    const canvasWidthOutput = this.querySelector('[data-canvas-width-output]');
    const canvasHeightOutput = this.querySelector('[data-canvas-height-output]');
    const widthMeasure = this.querySelector('[data-width-measure]');
    const heightMeasure = this.querySelector('[data-height-measure]');
    const list = this.querySelector('[data-part-measurements]');

    const formattedWidth = this.#formatSingleMeasurement(measurements.width);
    const formattedHeight = this.#formatSingleMeasurement(measurements.height);
    if (canvasWidthOutput && canvasWidthOutput.textContent !== formattedWidth) {
      canvasWidthOutput.textContent = formattedWidth;
    }
    if (canvasHeightOutput && canvasHeightOutput.textContent !== formattedHeight) {
      canvasHeightOutput.textContent = formattedHeight;
    }
    if (widthMeasure && widthMeasure.textContent !== formattedWidth) {
      widthMeasure.textContent = formattedWidth;
    }
    if (heightMeasure) {
      const centimeters = this.#t('size.centimeters', {}, 'cm');
      const inches = this.#t('size.inches', {}, 'in');
      const value =
        `${Math.round(measurements.height)} ${centimeters}\n${Math.round(
          measurements.height / 2.54
        )} ${inches}`;
      if (heightMeasure.textContent !== value) heightMeasure.textContent = value;
    }

    if (!list) return;
    const listSignature = JSON.stringify([
      hasText,
      measurements.lines.map((line) => [line.width, line.height]),
      measurements.icon
        ? [
            measurements.icon.id,
            measurements.icon.width,
            measurements.icon.height,
            measurements.icon.placementDisplayLabel,
          ]
        : null,
    ]);
    if (list.dataset.renderSignature === listSignature) return;
    list.dataset.renderSignature = listSignature;
    list.replaceChildren();

    if (!hasText) {
      const item = document.createElement('li');
      item.textContent = this.#t(
        'measurements.empty',
        {},
        'Enter your text to calculate measurements.'
      );
      list.append(item);
      return;
    }

    measurements.lines.forEach((line, index) => {
      const item = document.createElement('li');
      item.textContent = this.#t(
        'measurements.part',
        {
          index: index + 1,
          measurements: this.#formatMeasurements(line.width, line.height),
        },
        `Part ${index + 1}: ${this.#formatMeasurements(line.width, line.height)}`
      );
      list.append(item);
    });
    if (measurements.icon) {
      const item = document.createElement('li');
      item.textContent = this.#t(
        'measurements.icon',
        {
          icon: measurements.icon.label,
          measurements: this.#formatMeasurements(
            measurements.icon.width,
            measurements.icon.height
          ),
          position:
            measurements.icon.placementDisplayLabel ||
            measurements.icon.placementLabel,
        },
        `${measurements.icon.label} icon: ${this.#formatMeasurements(
          measurements.icon.width,
          measurements.icon.height
        )} · ${
          measurements.icon.placementDisplayLabel ||
          measurements.icon.placementLabel
        }`
      );
      list.append(item);
    }
  }

  /**
   * @param {boolean} validText
   * @param {boolean} validSize
   * @param {Record<string, any>} measurements
   */
  #refreshFontCompatibility(text, font) {
    this.#fontCompatibility = tanCheckFontText(text, font);
    const locale = String(this.dataset.locale || document.documentElement.lang || 'en');
    const notices = TAN_FONT_COMPATIBILITY_NOTICE[locale] ||
      TAN_FONT_COMPATIBILITY_NOTICE[locale.split('-')[0]] ||
      (locale.split('-')[0] === 'pt' ? TAN_FONT_COMPATIBILITY_NOTICE['pt-PT'] : TAN_FONT_COMPATIBILITY_NOTICE.en);
    const characters = this.#fontCompatibility.missing.slice(0, 12).map(character =>
      /[\p{C}\p{Z}\p{M}]/u.test(character)
        ? 'U+' + character.codePointAt(0).toString(16).toUpperCase().padStart(4, '0')
        : character
    ).join(' ') + (this.#fontCompatibility.missing.length > 12 ? ' …' : '');
    this.#fontCompatibilityMessage = this.#fontCompatibility.valid ? '' :
      notices[this.#fontCompatibility.known ? 0 : 1]
        .replace('[[font]]', () => String(font.label || ''))
        .replace('[[characters]]', () => characters);
    this.dataset.fontCompatible = String(this.#fontCompatibility.valid);
    const previewWarning = this.querySelector('[data-font-preview-warning]');
    const previewMessage = previewWarning?.querySelector('[data-font-preview-message]');
    if (previewWarning && previewMessage) {
      if (previewMessage.textContent !== this.#fontCompatibilityMessage) {
        previewMessage.textContent = this.#fontCompatibilityMessage;
      }
      previewWarning.hidden = this.#fontCompatibility.valid;
    }
    this.#renderTextValidation(this.#countCharacters(text) >= this.#numberData('minCharacters', 2));
    if (!this.#fontCompatibility.valid) {
      this.#designState.valid = false;
      this.#syncAddButton(false);
    }
  }

  #renderTextValidation(validText) {
    const textError = this.querySelector('[data-text-error]');
    const textInput = this.querySelector('[data-text-input]');
    if (textInput instanceof HTMLTextAreaElement) {
      textInput.setAttribute('aria-invalid', String(!validText || !this.#fontCompatibility.valid));
    }
    if (textError instanceof HTMLElement) {
      const locale = String(this.dataset.locale || document.documentElement.lang || 'en');
      const message = TAN_TEXT_EMOJI_NOTICE[locale] ||
        TAN_TEXT_EMOJI_NOTICE[locale.split('-')[0]] ||
        (locale.split('-')[0] === 'pt' ? TAN_TEXT_EMOJI_NOTICE['pt-PT'] : TAN_TEXT_EMOJI_NOTICE.en);
      textError.setAttribute('aria-live', 'polite');
      const textMessage = this.#fontCompatibilityMessage || (this.#emojiTextNotice ? message : this.#t(
        'text_entry.minimum_characters',
        { count: this.#numberData('minCharacters', 2) },
        'Enter at least [[count]] characters.'
      ));
      if (textError.textContent !== textMessage) textError.textContent = textMessage;
      textError.hidden = validText && this.#fontCompatibility.valid && !this.#emojiTextNotice;
    }

  }

  #renderValidation(validText, validSize, measurements) {
    this.#renderTextValidation(validText);
    const sizeError = this.querySelector('[data-size-error]');
    if (sizeError instanceof HTMLElement) {
      if (measurements.minimumWidth > this.#numberData('maxWidth', 240)) {
        sizeError.textContent = this.#t(
          'measurements.oversize_width',
          {},
          'This text needs a wider sign than the online maximum. Request an oversize quote.'
        );
        sizeError.hidden = false;
      } else if (!validSize) {
        sizeError.textContent = this.#t(
          'measurements.oversize_height',
          {
            height: measurements.height,
            maximum: this.#numberData('maxHeight', 120),
          },
          `The calculated height is ${measurements.height} cm. The online maximum is ${this.#numberData('maxHeight', 120)} cm.`
        );
        sizeError.hidden = false;
      } else {
        sizeError.textContent = '';
        sizeError.hidden = true;
      }
    }
  }

  /**
   * @param {{text: string, characterCount: number, font: Record<string, any>, measurements: Record<string, any>, valid: boolean}} input
   */
  #calculatePrice(input) {
    if (!input.valid || !input.text) {
      return {
        valid: false,
        purchasable: false,
        listShop: 0,
        totalShop: 0,
        listCurrent: 0,
        totalCurrent: 0,
        totalMinor: 0,
        feeTargetMinor: 0,
        optionPercent: 0,
      };
    }

    const selectedColorMode = this.#selectedColorMode();
    const optionInputs = Array.from(this.querySelectorAll('[data-price-percent]:checked')).filter(
      (control) => {
        if (!(control instanceof HTMLInputElement)) return false;
        if (!control.matches('[data-color-mode]')) return true;
        return (
          selectedColorMode === 'rgb' &&
          this.#normalizeColorMode(control.dataset.colorMode || control.value) === 'rgb'
        );
      }
    );
    const optionPercent = optionInputs.reduce(
      (total, control) => total + this.#positiveNumber(control.dataset.pricePercent, 0),
      0
    );
    const fixedPriceInputs = Array.from(
      this.querySelectorAll('[data-price-fixed-shop-minor]:checked')
    ).filter(
      (control) => control instanceof HTMLInputElement && !control.disabled
    );
    const fixedAdapterShopMinor = fixedPriceInputs.reduce(
      (total, control) =>
        total +
        Math.max(
          0,
          Math.round(
            this.#positiveNumber(control.dataset.priceFixedShopMinor, 0)
          )
        ),
      0
    );
    const fixedAdapterShop = fixedAdapterShopMinor / 100;
    const backboardColorSelect = this.querySelector('[data-backboard-color]');
    const backboardColorOption =
      backboardColorSelect instanceof HTMLSelectElement
        ? backboardColorSelect.selectedOptions[0]
        : null;
    const backboardColorPercent =
      backboardColorOption instanceof HTMLOptionElement
        ? this.#positiveNumber(backboardColorOption.dataset.pricePercent, 0)
        : 0;
    const customizationPercent = optionPercent + backboardColorPercent;
    const optionLabels = optionInputs.map((inputElement) => inputElement.value);
    fixedPriceInputs.forEach((inputElement) => {
      const label = String(
        inputElement.dataset.priceLabel || inputElement.value || ''
      ).trim();
      if (label) optionLabels.push(label);
    });
    if (
      backboardColorPercent > 0 &&
      backboardColorOption instanceof HTMLOptionElement
    ) {
      optionLabels.push(backboardColorOption.value);
    }
    const discountPercent = Math.min(100, Math.max(0, this.#numberData('discountPercent', 10)));
    const doubleLine =
      input.font.doubleLine === true || String(input.font.doubleLine).toLowerCase() === 'true';
    const quote = TAN_PRICING_ENGINE.calculate({
      width: input.measurements.width,
      height: input.measurements.height,
      minimumWidth: input.measurements.minimumWidth,
      aspectRatio:
        input.measurements.naturalWidth > 0
          ? input.measurements.naturalHeight / input.measurements.naturalWidth
          : input.measurements.height / Math.max(1, input.measurements.width),
      priceFactor: this.#positiveNumber(input.font.priceFactor, 1),
      priceMultiplier: this.#positiveNumber(input.font.priceMultiplier, 1),
      doubleLine,
      doubleLinePremium: this.#positiveNumber(input.font.doubleLinePremium, 0.1),
      characterCount: input.characterCount,
      optionPercent: customizationPercent,
      displayedDiscountPercent: discountPercent,
    });
    const icon = this.#getSelectedIcon();
    const iconBaseShop = icon ? this.#iconBasePrice(icon) : 0;
    const iconScaleMultiplier = icon ? this.#iconScaleMultiplier() : 1;
    const iconSizedShop = icon ? Math.round(iconBaseShop * iconScaleMultiplier) : 0;
    const iconTotalShop = icon
      ? Math.round(iconSizedShop * (1 + customizationPercent / 100))
      : 0;
    const iconListShop =
      icon && discountPercent > 0
        ? Math.round(iconTotalShop / Math.max(0.01, 1 - discountPercent / 100))
        : iconTotalShop;
    if (icon) optionLabels.push(`Icon: ${icon.label}`);
    const listShop = quote.list + iconListShop + fixedAdapterShop;
    const totalShop = quote.total + iconTotalShop + fixedAdapterShop;
    const rate = this.#marketRate();
    const listCurrent = Math.round(listShop * rate);
    const totalCurrent = Math.round(totalShop * rate);
    const minorUnit = this.#currencyMinorUnit();
    const totalMinor = totalCurrent * minorUnit;
    const usesSecureDesignProduct = this.dataset.appBackendReady === 'true';
    const productPrice = usesSecureDesignProduct
      ? 0
      : Math.max(0, Math.round(this.#numberData('productPrice', 0)));
    const feeTargetMinor = totalMinor - productPrice;

    return {
      valid: totalMinor > 0,
      purchasable: totalMinor > 0 && (usesSecureDesignProduct || feeTargetMinor > 0),
      pricingVersion: quote.version,
      minimumPrice: quote.minimumPrice,
      sizeBasePrice: quote.size.raw,
      sizeMinimumPrice: quote.size.minimum,
      setupComponent: quote.size.setup,
      area: quote.size.area,
      areaRate: quote.size.areaRate,
      priceFactor: quote.font.complexityFactor,
      fontPriceMultiplier: quote.fontPriceMultiplier,
      doubleLine,
      doubleLinePremium: quote.font.linePremium,
      effectiveFontFactor: quote.font.effectiveFactor,
      fontAdjustedPrice: quote.fontAdjusted,
      protectedSizePrice: quote.protectedSize.raw,
      characterFloorPrice: quote.characterFloor.raw,
      characterEfficiencyCredit: quote.characterFloor.efficiencyCredit,
      characterChargePrice: quote.characterCharge.raw,
      characterFirstSixRate: quote.characterCharge.firstSixEffectiveRate,
      characterSeventhRate: quote.characterCharge.seventhEffectiveRate,
      characterEighthRate: quote.characterCharge.eighthEffectiveRate,
      characterNinthRate: quote.characterCharge.ninthEffectiveRate,
      characterFromTenthRate: quote.characterCharge.fromTenthEffectiveRate,
      characterFromTenthCount: quote.characterCharge.fromTenthCharacters,
      characterLineMultiplier: quote.characterCharge.lineMultiplier,
      characterProgressionUplift: quote.characterProgression.uplift,
      naturalProductionBasePrice: quote.naturalProductionBase,
      naturalPricingDriver: quote.naturalPriceDriver,
      sizeProgressionMinimumWidth: quote.sizeProgression.minimumWidth,
      sizeProgressionMinimumHeight: quote.sizeProgression.minimumHeight,
      sizeProgressionSteps: quote.sizeProgression.steps,
      sizeProgressionStepPrice: quote.sizeProgression.step,
      sizeProgressionUplift: quote.sizeProgression.uplift,
      productionBasePrice: quote.productionBase,
      pricingDriver: quote.priceDriver,
      optionPercent: customizationPercent,
      optionLabels,
      discountPercent,
      iconId: String(icon?.id || ''),
      iconLabel: String(icon?.label || ''),
      iconTier: String(icon?.tier || ''),
      iconPosition: icon ? String(input.measurements.icon?.position || '') : '',
      iconPlacement: icon ? Number(input.measurements.icon?.placement || 0) : null,
      iconPlacementLabel: icon
        ? String(input.measurements.icon?.placementLabel || '')
        : '',
      iconScale: icon ? this.#iconScale : 0,
      iconBasePrice: iconBaseShop,
      iconScaleMultiplier,
      iconSizedPrice: iconSizedShop,
      iconTotalPrice: iconTotalShop,
      fixedAdapterShop,
      fixedAdapterShopMinor,
      listShop,
      totalShop,
      listCurrent,
      totalCurrent,
      totalMinor,
      feeTargetMinor,
    };
  }

  /** @param {Record<string, any>} price */
  #renderPrice(price) {
    const output = this.querySelector('[data-price-output]');
    const listOutput = this.querySelector('[data-list-price]');
    const canvasOutput = this.querySelector('[data-canvas-price-output]');
    const canvasListOutput = this.querySelector('[data-canvas-list-price]');
    const canvasSizePrice = this.querySelector('[data-canvas-size-price]');
    const note = this.querySelector('[data-price-note]');
    const formattedTotal = this.#formatCurrency(price.totalCurrent || 0);
    const formattedList = this.#formatCurrency(price.listCurrent || 0);

    if (output && output.textContent !== formattedTotal) output.textContent = formattedTotal;
    if (canvasOutput && canvasOutput.textContent !== formattedTotal) {
      canvasOutput.textContent = formattedTotal;
    }
    if (canvasSizePrice) {
      const sizePriceLabel = price.valid
        ? `${this.#t('common.total', {}, 'Total')} ${formattedTotal}`
        : this.#t(
            'visualizer.digital_mockup',
            {},
            'Digital mock-up only'
          );
      if (canvasSizePrice.textContent !== sizePriceLabel) {
        canvasSizePrice.textContent = sizePriceLabel;
      }
    }
    const showListPrice = price.valid && price.discountPercent > 0;
    if (listOutput instanceof HTMLElement) {
      if (listOutput.hidden === showListPrice) listOutput.hidden = !showListPrice;
      if (listOutput.textContent !== formattedList) listOutput.textContent = formattedList;
    }
    if (canvasListOutput instanceof HTMLElement) {
      if (canvasListOutput.hidden === showListPrice) {
        canvasListOutput.hidden = !showListPrice;
      }
      if (canvasListOutput.textContent !== formattedList) {
        canvasListOutput.textContent = formattedList;
      }
    }
    if (note) {
      const oversize =
        this.#designState.characterCount >= this.#numberData('minCharacters', 2) &&
        (this.#designState.minimumWidth > this.#numberData('maxWidth', 240) ||
          this.#designState.height > this.#numberData('maxHeight', 120));
      const noteText = this.#fontCompatibilityMessage || (price.valid
        ? oversize
          ? this.#t(
              'summary.estimated_oversize',
              {},
              'Estimated price · oversize quote required'
            )
          : this.#t(
              'summary.custom_width',
              {
                width: Math.round(
                  this.#designState.width || this.#getRequestedWidth()
                ),
              },
              `${Math.round(
                this.#designState.width || this.#getRequestedWidth()
              )} cm custom width`
            )
        : this.#t(
            'summary.empty_price',
            {},
            'Enter your text to calculate the price.'
          ));
      if (note.textContent !== noteText) note.textContent = noteText;
    }

  }

  #syncConditionalFields() {
    const rush = this.#selectedValue('rush');
    const greeting = this.#selectedValue('greeting');
    const mockup = this.#selectedValue('mockup');
    const usage = this.#selectedValue('usage');
    const outdoorSelected = normalizedEquipmentValue(usage).startsWith('outdoor');
    const rushNotes = this.querySelector('[data-rush-notes]');
    const rushInput = this.querySelector('[data-rush-input]');
    const greetingMessage = this.querySelector('[data-greeting-message]');
    const greetingInput = this.querySelector('[data-greeting-input]');
    const mockupHelp = this.querySelector('[data-mockup-help]');

    this.#syncOutdoorAdapterOptions(outdoorSelected);
    this.#syncControllerOptions(this.#selectedColorMode() === 'rgb', outdoorSelected);
    this.#syncOutdoorMountingOptions(outdoorSelected);

    if (rushNotes instanceof HTMLElement) rushNotes.hidden = rush !== 'Rush my order';
    if (rushInput instanceof HTMLTextAreaElement) rushInput.disabled = rush !== 'Rush my order';
    if (greetingMessage instanceof HTMLElement) greetingMessage.hidden = greeting !== 'Yes';
    if (greetingInput instanceof HTMLTextAreaElement) {
      greetingInput.disabled = greeting !== 'Yes';
      greetingInput.required = greeting === 'Yes';
    }
    if (mockupHelp) {
      mockupHelp.textContent =
        mockup === 'Send a mock-up before production'
          ? this.#t(
              'additional.mockup.send_help',
              {},
              'We will email a design preview and start production after your approval.'
            )
          : this.#t(
              'additional.mockup.proceed_help',
              {},
              'Production will proceed without a separate mock-up approval.'
            );
    }
  }

  /** @param {boolean} outdoorSelected */
  #syncOutdoorAdapterOptions(outdoorSelected) {
    const panel = this.querySelector('[data-outdoor-adapter-panel]');
    const standardAdapter = this.querySelector('[data-outdoor-adapter-standard]');
    const outdoorAdapter = this.querySelector('[data-outdoor-adapter-rated]');

    if (panel instanceof HTMLElement) panel.hidden = !outdoorSelected;
    if (standardAdapter instanceof HTMLInputElement) {
      standardAdapter.disabled = !outdoorSelected;
    }
    if (outdoorAdapter instanceof HTMLInputElement) {
      outdoorAdapter.disabled = !outdoorSelected;
    }

    if (!outdoorSelected) {
      if (standardAdapter instanceof HTMLInputElement) standardAdapter.checked = true;
      if (outdoorAdapter instanceof HTMLInputElement) outdoorAdapter.checked = false;
      return;
    }

    if (
      standardAdapter instanceof HTMLInputElement &&
      outdoorAdapter instanceof HTMLInputElement &&
      !standardAdapter.checked &&
      !outdoorAdapter.checked
    ) {
      standardAdapter.checked = true;
    }
  }

  /**
   * @param {boolean} rgbSelected
   * @param {boolean} outdoorSelected
   */
  #syncControllerOptions(rgbSelected, outdoorSelected) {
    const yesInput = this.querySelector('[data-remote-yes]');
    const noInput = this.querySelector('[data-remote-no]');
    const yesChoice = this.querySelector('[data-remote-yes-choice]');
    const noChoice = this.querySelector('[data-remote-no-choice]');
    const options = this.querySelector('[data-remote-options]');
    const heading = this.querySelector('[data-remote-heading]');
    const description = this.querySelector('[data-remote-description]');
    const yesLabel = this.querySelector('[data-remote-yes-label]');
    const noLabel = this.querySelector('[data-remote-no-label]');
    const rgbHelp = this.querySelector('[data-rgb-controller-help]');
    const outdoorAdapterHelp = this.querySelector('[data-outdoor-adapter-dimmer-help]');

    if (!(yesInput instanceof HTMLInputElement) || !(noInput instanceof HTMLInputElement)) return;

    const nextLockMode = rgbSelected ? 'rgb' : 'standard';

    if (this.#controllerLockMode === 'standard' && nextLockMode !== 'standard') {
      const checked = this.querySelector('input[name$="-remote"]:checked');
      if (checked instanceof HTMLInputElement) this.#previousRemoteValue = checked.value;
    }

    if (nextLockMode === 'rgb') {
      yesInput.checked = true;
      yesInput.disabled = true;
      noInput.disabled = true;
      if (yesChoice instanceof HTMLElement) yesChoice.hidden = false;
      if (noChoice instanceof HTMLElement) noChoice.hidden = true;
      if (options instanceof HTMLElement) {
        options.classList.add('is-rgb-controller');
        options.classList.remove('is-outdoor-adapter');
      }
      if (heading instanceof HTMLElement) {
        heading.textContent = this.#t('additional.remote.rgb_heading', {}, 'RGB controller');
      }
      if (description instanceof HTMLElement) description.hidden = true;
      const rgbIncludedLabel = this.#t(
        'additional.remote.rgb_included',
        {},
        'Included'
      );
      if (yesLabel instanceof HTMLElement) yesLabel.textContent = rgbIncludedLabel;
      yesInput.dataset.displayLabel = rgbIncludedLabel;
      if (noLabel instanceof HTMLElement) noLabel.textContent = this.#t('common.no', {}, 'No');
      if (rgbHelp instanceof HTMLElement) rgbHelp.hidden = false;
      if (outdoorAdapterHelp instanceof HTMLElement) outdoorAdapterHelp.hidden = true;
    } else {
      yesInput.disabled = false;
      noInput.disabled = false;
      if (this.#controllerLockMode !== 'standard') {
        const restoredInput =
          Array.from(this.querySelectorAll('input[name$="-remote"]')).find(
            (candidate) =>
              candidate instanceof HTMLInputElement &&
              candidate.value === this.#previousRemoteValue
          ) || yesInput;
        if (restoredInput instanceof HTMLInputElement) restoredInput.checked = true;
      } else {
        const checked = this.querySelector('input[name$="-remote"]:checked');
        if (checked instanceof HTMLInputElement) this.#previousRemoteValue = checked.value;
      }
      if (yesChoice instanceof HTMLElement) yesChoice.hidden = false;
      if (noChoice instanceof HTMLElement) noChoice.hidden = false;
      if (options instanceof HTMLElement) {
        options.classList.remove('is-rgb-controller');
        options.classList.remove('is-outdoor-adapter');
      }
      if (heading instanceof HTMLElement) {
        heading.textContent = this.#t('additional.remote.heading', {}, 'Remote control (dimmer)');
      }
      if (description instanceof HTMLElement) description.hidden = false;
      const includedLabel = this.#t(
        'additional.remote.included',
        {},
        'Yes, included'
      );
      const notIncludedLabel = this.#t(
        'additional.remote.not_included',
        {},
        'No'
      );
      if (yesLabel instanceof HTMLElement) yesLabel.textContent = includedLabel;
      if (noLabel instanceof HTMLElement) noLabel.textContent = notIncludedLabel;
      yesInput.dataset.displayLabel = includedLabel;
      noInput.dataset.displayLabel = notIncludedLabel;
      if (rgbHelp instanceof HTMLElement) rgbHelp.hidden = true;
      if (outdoorAdapterHelp instanceof HTMLElement) {
        outdoorAdapterHelp.hidden = !outdoorSelected;
      }
    }

    this.#controllerLockMode = nextLockMode;
  }

  /** @param {boolean} outdoorSelected */
  #syncOutdoorMountingOptions(outdoorSelected) {
    const inputs = Array.from(
      this.querySelectorAll('input[name$="-mounting"]')
    ).filter((candidate) => candidate instanceof HTMLInputElement);
    const strips = this.querySelector('[data-mounting-3m]');
    if (!(strips instanceof HTMLInputElement)) return;

    if (outdoorSelected && !this.#mountingOutdoorLocked) {
      const checked = inputs.find((input) => input.checked && !input.disabled);
      if (checked) this.#previousMountingValue = checked.value;
    }

    strips.disabled = outdoorSelected;
    const stripsChoice = strips.closest('.tan-nd__choice');
    if (stripsChoice instanceof HTMLElement) stripsChoice.hidden = outdoorSelected;

    if (outdoorSelected) {
      this.#mountingOutdoorLocked = true;
      if (strips.checked) {
        const wallMount =
          inputs.find((input) => input.value === 'Wall mount kit' && !input.disabled) ||
          inputs.find((input) => !input.disabled);
        if (wallMount) wallMount.checked = true;
      }
      return;
    }

    if (this.#mountingOutdoorLocked) {
      const restored = inputs.find(
        (input) => input.value === this.#previousMountingValue && !input.disabled
      );
      if (restored) restored.checked = true;
    } else {
      const checked = inputs.find((input) => input.checked && !input.disabled);
      if (checked) this.#previousMountingValue = checked.value;
    }
    this.#mountingOutdoorLocked = false;
  }

  /** @param {unknown} value */
  #normalizeColorMode(value) {
    const normalized = String(value || '').trim().toLowerCase();
    if (normalized === 'rgb') return 'rgb';
    if (normalized === 'combination' || normalized === 'color combination') return 'combination';
    return 'solid';
  }

  #selectedColorMode() {
    const selected = this.querySelector('input[data-color-mode]:checked');
    return selected instanceof HTMLInputElement
      ? this.#normalizeColorMode(selected.dataset.colorMode || selected.value)
      : 'solid';
  }

  /** @param {string} value */
  #splitGraphemes(value) {
    const rawText = String(value || '');
    const text =
      typeof rawText.normalize === 'function' ? rawText.normalize('NFC') : rawText;
    if (text === this.#graphemeCacheSource) return this.#graphemeCache;

    let graphemes;
    try {
      if (typeof Intl.Segmenter === 'function') {
        if (!this.#graphemeSegmenter) {
          this.#graphemeSegmenter = new Intl.Segmenter(
            this.dataset.locale || 'en',
            { granularity: 'grapheme' }
          );
        }
        graphemes = Array.from(
          this.#graphemeSegmenter.segment(text),
          (entry) => entry.segment
        );
      }
    } catch {
      // Fall through to the Unicode code-point-safe baseline.
    }
    if (!Array.isArray(graphemes)) graphemes = Array.from(text);
    this.#graphemeCacheSource = text;
    this.#graphemeCache = graphemes;
    return graphemes;
  }

  /** @param {string} value */
  #visibleGraphemes(value) {
    return this.#splitGraphemes(value).filter((grapheme) => !/^\s+$/u.test(grapheme));
  }

  /**
   * Limit visible characters without splitting emoji or accented graphemes.
   * Whitespace is preserved so line breaks remain intact, but it does not count
   * toward the customer-facing character limit.
   *
   * @param {string} value
   * @param {number} limit
   */
  #limitTextToVisibleCharacters(value, limit) {
    const maximum = Math.max(1, Math.floor(Number(limit) || 50));
    const output = [];
    let visibleCount = 0;
    let exceeded = false;

    for (const grapheme of this.#splitGraphemes(value)) {
      if (/^\s+$/u.test(grapheme)) {
        if (output.length < 500) output.push(grapheme);
        else exceeded = true;
        continue;
      }

      if (visibleCount >= maximum) {
        exceeded = true;
        continue;
      }

      output.push(grapheme);
      visibleCount += 1;
    }

    return {
      value: output.join(''),
      count: visibleCount,
      exceeded,
    };
  }

  /**
   * @param {HTMLTextAreaElement} input
   * @param {boolean} announce
   */
  #sanitizeTextEmojis(input, clearNotice = false) {
    const raw = input.value;
    const withoutEmojis = tanRemoveTextEmojis(raw);
    // Canonical accents are identical text, and are sent to the renderer in NFC too.
    const clean = withoutEmojis.normalize('NFC');
    if (clearNotice) this.#emojiTextNotice = false;
    if (raw === clean) return false;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const direction = input.selectionDirection;
    input.value = clean;
    input.setSelectionRange(
      tanRemoveTextEmojis(raw.slice(0, start)).normalize('NFC').length,
      tanRemoveTextEmojis(raw.slice(0, end)).normalize('NFC').length,
      direction
    );
    if (withoutEmojis !== raw) this.#emojiTextNotice = true;
    return true;
  }

  #enforceTextLimit(input, announce = false) {
    this.#sanitizeTextEmojis(input, true);
    const result = this.#limitTextToVisibleCharacters(
      input.value,
      this.#numberData('characterLimit', 50)
    );

    if (result.value !== input.value) {
      const selectionStart = input.selectionStart;
      input.value = result.value;
      const nextCursor = Math.min(selectionStart ?? result.value.length, result.value.length);
      input.setSelectionRange(nextCursor, nextCursor);
    }

    this.#refreshFontCompatibility(input.value.trim(), this.#getSelectedFont());
    if (result.exceeded && announce) this.#openTextLimitDialog();
    return result;
  }

  #openTextLimitDialog() {
    const dialog = this.querySelector('[data-text-limit-dialog]');
    if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
    dialog.showModal();
  }

  /** @param {boolean} returnFocus */
  #closeTextLimitDialog(returnFocus = false) {
    const dialog = this.querySelector('[data-text-limit-dialog]');
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
    dialog.close();

    if (returnFocus) {
      const input = this.querySelector('[data-text-input]');
      if (input instanceof HTMLTextAreaElement) input.focus({ preventScroll: true });
    }
  }

  #colorDescriptors() {
    if (this.#colorDescriptorsCache) return this.#colorDescriptorsCache;

    const descriptors = [];
    const seen = new Set();

    this.querySelectorAll('input[data-color]').forEach((candidate) => {
      if (!(candidate instanceof HTMLInputElement)) return;
      const color = String(candidate.dataset.color || '').trim();
      if (!color || color === 'rgb') return;
      const id = color.toLowerCase();
      if (seen.has(id)) return;
      seen.add(id);
      const canonicalLabel = candidate.value || 'Neon color';
      const displayLabel = candidate.dataset.displayLabel || canonicalLabel;
      descriptors.push({
        id,
        label: canonicalLabel,
        displayLabel,
        color,
        core: String(candidate.dataset.coreColor || color),
        description: this.#t(
          'color.solid_color_description',
          { color: displayLabel.toLocaleLowerCase(this.dataset.locale || 'en') },
          `A vivid ${String(canonicalLabel || 'single-color').toLowerCase()} LED neon finish with dimmer and remote included.`
        ),
      });
    });

    this.querySelectorAll('[data-character-color]').forEach((candidate) => {
      if (!(candidate instanceof HTMLElement)) return;
      const color = String(
        candidate.dataset.characterColor ||
          (candidate instanceof HTMLInputElement ? candidate.value : '')
      ).trim();
      if (!color) return;
      const id = color.toLowerCase();
      if (seen.has(id)) return;
      seen.add(id);
      const canonicalLabel =
        candidate.dataset.colorName ||
        candidate.getAttribute('aria-label') ||
        'Neon color';
      const displayLabel = candidate.dataset.displayLabel || canonicalLabel;
      descriptors.push({
        id,
        label: canonicalLabel,
        displayLabel,
        color,
        core: String(candidate.dataset.coreColor || color),
        description: this.#t(
          'color.solid_color_description',
          { color: displayLabel.toLocaleLowerCase(this.dataset.locale || 'en') },
          `A vivid ${String(canonicalLabel || 'single-color').toLowerCase()} LED neon finish with dimmer and remote included.`
        ),
      });
    });

    this.#colorDescriptorsCache = descriptors;
    this.#colorDescriptorMap = new Map();
    descriptors.forEach((descriptor) => {
      [
        descriptor.id,
        descriptor.color,
        descriptor.label,
        descriptor.displayLabel,
      ].forEach((key) => {
        const normalized = String(key || '').trim().toLowerCase();
        if (normalized && !this.#colorDescriptorMap.has(normalized)) {
          this.#colorDescriptorMap.set(normalized, descriptor);
        }
      });
    });
    return descriptors;
  }

  /** @param {unknown} value */
  #colorDescriptorFor(value) {
    const needle = String(value || '').trim().toLowerCase();
    const descriptors = this.#colorDescriptors();
    return (
      this.#colorDescriptorMap?.get(needle) ||
      descriptors[0] || {
        id: '#ff0099',
        label: 'Rose red',
        displayLabel: this.#t('color.names.rose_red', {}, 'Rose red'),
        color: '#ff0099',
        core: '#ffe5f5',
        description: this.#t(
          'color.solid_description',
          {},
          'A vivid single-color LED neon finish with dimmer and remote included.'
        ),
      }
    );
  }

  #selectedSolidColor() {
    const selected = this.querySelector('input[data-color]:checked');
    if (!(selected instanceof HTMLInputElement)) return this.#colorDescriptorFor('#ff0099');
    return this.#colorDescriptorFor(selected.dataset.color || selected.value);
  }

  /**
   * @param {string} text
   * @param {string} fallbackId
   */
  #reconcileCharacterColors(text, fallbackId) {
    const count = this.#visibleGraphemes(text).length;
    const fallback = this.#colorDescriptorFor(fallbackId).id;
    const next = Array.from({ length: count }, (_, index) => {
      const stored = this.#characterColors[index];
      return stored ? this.#colorDescriptorFor(stored).id : fallback;
    });
    this.#characterColors = next;
    this.#activeCharacterIndex = count
      ? Math.max(0, Math.min(count - 1, this.#activeCharacterIndex))
      : 0;
    const icon = this.#getSelectedIcon();
    if (icon) {
      this.#iconColorId = this.#colorDescriptorFor(
        this.#iconColorId || fallback
      ).id;
    } else {
      this.#iconColorActive = false;
    }
  }

  /**
   * @param {number} index
   * @param {string} colorId
   */
  #setCharacterColor(index, colorId) {
    if (this.#iconColorActive && this.#getSelectedIcon()) {
      this.#iconColorId = this.#colorDescriptorFor(colorId).id;
      this.#syncCharacterColorUi();
      this.#scheduleUpdate();
      return;
    }
    if (!Number.isInteger(index) || index < 0 || index >= this.#characterColors.length) return;
    this.#characterColors[index] = this.#colorDescriptorFor(colorId).id;
    this.#activeCharacterIndex = index;
    this.#syncCharacterColorUi();
    this.#scheduleUpdate();
  }

  /** @param {string=} sourceText */
  #syncCharacterColorUi(sourceText) {
    const input = this.querySelector('[data-text-input]');
    const text =
      typeof sourceText === 'string'
        ? sourceText
        : input instanceof HTMLTextAreaElement
          ? input.value.trim()
          : '';
    const graphemes = this.#visibleGraphemes(text);
    const solid = this.#selectedSolidColor();
    this.#reconcileCharacterColors(text, solid.id);
    const icon = this.#getSelectedIcon();
    const signature = JSON.stringify([
      text,
      solid.id,
      this.#selectedColorMode(),
      this.#characterColors,
      this.#activeCharacterIndex,
      String(icon?.id || ''),
      this.#iconPlacement,
      this.#iconColorId,
      this.#iconColorActive,
    ]);
    if (this.#characterUiSignature === signature) return;
    this.#characterUiSignature = signature;

    const list = this.querySelector('[data-character-list]');
    if (list instanceof HTMLElement) {
      list.replaceChildren();
      const iconInsertionIndex = icon
        ? this.#clamp(
            this.#iconTextSplit(text).visibleBefore,
            0,
            graphemes.length
          )
        : -1;
      const appendIconControl = () => {
        if (!icon) return;
        const descriptor = this.#colorDescriptorFor(this.#iconColorId || solid.id);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tan-nd__character-icon';
        button.dataset.iconColorTarget = '';
        button.classList.toggle('is-active', this.#iconColorActive);
        button.setAttribute('aria-pressed', String(this.#iconColorActive));
        button.setAttribute(
          'aria-label',
          this.#t(
            'accessibility.icon_character',
            { icon: icon.label, color: descriptor.displayLabel || descriptor.label },
            `${icon.label} icon, ${descriptor.label}`
          )
        );
        button.title = `${icon.label}: ${descriptor.displayLabel || descriptor.label}`;
        button.style.setProperty('--tan-nd-character-color', descriptor.color);
        const mark = document.createElement('i');
        mark.className = 'tan-nd__character-icon-mark';
        mark.setAttribute('aria-hidden', 'true');
        mark.style.setProperty(
          '--tan-nd-character-icon-mask',
          `url(${JSON.stringify(icon.url)})`
        );
        const label = document.createElement('span');
        label.textContent = this.#t('accessibility.icon', {}, 'Icon');
        button.append(mark, label);
        list.append(button);
      };

      if (graphemes.length === 0 && !icon) {
        const message = document.createElement('span');
        message.className = 'tan-nd__character-empty';
        message.textContent = this.#t(
          'color.empty_characters',
          {},
          'Enter text to color each character.'
        );
        list.append(message);
      } else {
        graphemes.forEach((grapheme, index) => {
          if (index === iconInsertionIndex) appendIconControl();
          const descriptor = this.#colorDescriptorFor(this.#characterColors[index]);
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.characterIndex = String(index);
          const active = !this.#iconColorActive && index === this.#activeCharacterIndex;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
          button.setAttribute(
            'aria-label',
            this.#t(
              'accessibility.text_character',
              {
                index: index + 1,
                character: grapheme,
                color: descriptor.displayLabel || descriptor.label,
              },
              `Character ${index + 1}, ${grapheme}, ${descriptor.label}`
            )
          );
          button.title = `${grapheme}: ${descriptor.displayLabel || descriptor.label}`;
          button.style.setProperty('--tan-nd-character-color', descriptor.color);
          const character = document.createElement('span');
          character.textContent = grapheme;
          const swatch = document.createElement('i');
          swatch.setAttribute('aria-hidden', 'true');
          swatch.style.setProperty('--tan-nd-swatch', descriptor.color);
          button.append(character, swatch);
          list.append(button);
        });
        if (iconInsertionIndex === graphemes.length) appendIconControl();
      }
    }

    const activeColor =
      this.#iconColorActive && this.#getSelectedIcon()
        ? this.#iconColorId || solid.id
        : this.#characterColors[this.#activeCharacterIndex] || solid.id;
    this.querySelectorAll('[data-character-palette] [data-character-color]').forEach((candidate) => {
      if (!(candidate instanceof HTMLElement)) return;
      const descriptor = this.#colorDescriptorFor(
        candidate.dataset.characterColor ||
          (candidate instanceof HTMLInputElement ? candidate.value : '')
      );
      const active = descriptor.id === this.#colorDescriptorFor(activeColor).id;
      candidate.classList.toggle('is-active', active);
      candidate.setAttribute('aria-pressed', String(active));
    });
  }

  #syncColorModeUi() {
    const mode = this.#selectedColorMode();
    this.dataset.colorMode = mode;
    this.dataset.rgb = String(mode === 'rgb');

    this.querySelectorAll('[data-color-mode-panel]').forEach((candidate) => {
      if (!(candidate instanceof HTMLElement)) return;
      candidate.hidden = this.#normalizeColorMode(candidate.dataset.colorModePanel) !== mode;
    });

    this.querySelectorAll('input[data-color-mode]').forEach((candidate) => {
      if (!(candidate instanceof HTMLInputElement)) return;
      const selected = candidate.checked;
      candidate.closest('label')?.classList.toggle('is-selected', selected);
      candidate.setAttribute('aria-checked', String(selected));
    });

    const solid = this.#selectedSolidColor();
    const name = this.querySelector('[data-selected-color-name]');
    const description = this.querySelector('[data-selected-color-description]');
    if (name) name.textContent = solid.displayLabel || solid.label;
    if (description) description.textContent = solid.description;
    this.#syncCharacterColorUi();
    this.#syncExampleTriggers();
  }

  /**
   * Render text and, when selected, the icon inside the same inline flow. This
   * lets the placement control move the icon through real character gaps
   * without overlaying a letter or breaking the ruler geometry.
   *
   * @param {HTMLElement} container
   * @param {string} text
   * @param {'glow' | 'core'} layer
   * @param {'solid' | 'rgb' | 'combination'} colorMode
   * @param {Record<string, any> | null} icon
   * @param {Record<string, any> | null} iconMeasurement
   */
  #renderPreviewLayer(
    container,
    text,
    layer,
    colorMode,
    icon,
    iconMeasurement
  ) {
    let visibleIndex = 0;
    let placementSlot = 0;
    let lineIndex = 0;
    let iconInserted = false;
    const placement = this.#resolvedIconPlacement(text);
    const iconOnlyGlow =
      layer === 'glow' && container.hasAttribute('data-icon-glow');
    const visualizer = this.querySelector('[data-visualizer]');
    const glowEnabled =
      !(visualizer instanceof HTMLElement) ||
      !visualizer.classList.contains('is-glow-off');
    const compactGlow = this.#isMobileViewport();
    const signature = JSON.stringify([
      layer,
      text,
      colorMode === 'combination',
      String(icon?.id || ''),
      String(icon?.url || ''),
      placement,
      colorMode === 'combination' ? this.#characterColors : [],
      colorMode === 'combination' ? this.#activeCharacterIndex : null,
      colorMode === 'combination' ? this.#iconColorId : null,
      colorMode === 'combination' ? this.#iconColorActive : null,
      colorMode === 'combination' ? this.#selectedSolidColor().id : null,
      iconOnlyGlow,
      colorMode === 'combination' ? glowEnabled : null,
      colorMode === 'combination' ? compactGlow : null,
    ]);
    if (container.dataset.layerSignature === signature) return;
    container.dataset.layerSignature = signature;
    const fragment = document.createDocumentFragment();

    const appendIcon = () => {
      if (!icon || !iconMeasurement || iconInserted) return;
      const descriptor = this.#colorDescriptorFor(
        this.#iconColorId || this.#selectedSolidColor().id
      );
      const iconElement = document.createElement('i');
      iconElement.className =
        `tan-nd__preview-inline-icon tan-nd__preview-inline-icon--${layer}`;
      iconElement.setAttribute('aria-hidden', 'true');
      iconElement.style.setProperty(
        '--tan-nd-icon-mask',
        `url(${JSON.stringify(icon.url)})`
      );
      if (colorMode === 'combination') {
        iconElement.style.setProperty('--tan-nd-icon-neon', descriptor.color);
        iconElement.style.setProperty('--tan-nd-icon-core', descriptor.core);
      }
      if (layer === 'core') {
        iconElement.dataset.neonIcon = '';
        iconElement.dataset.iconColorTarget = '';
        iconElement.dataset.iconId = String(icon.id || '');
      }
      this.#hydrateIconVector(iconElement, icon);
      fragment.append(iconElement);
      iconInserted = true;
    };

    this.#splitGraphemes(text).forEach((grapheme) => {
      if (placementSlot === placement) appendIcon();
      if (/^\s+$/u.test(grapheme)) {
        fragment.append(document.createTextNode(grapheme));
        const lineBreaks = grapheme.match(/\r\n|\r|\n/g);
        if (lineBreaks) lineIndex += lineBreaks.length;
        if (!/^[\r\n]+$/u.test(grapheme)) placementSlot += 1;
        return;
      }

      const descriptor =
        colorMode === 'combination'
          ? this.#colorDescriptorFor(this.#characterColors[visibleIndex])
          : null;
      const span = document.createElement('span');
      span.dataset.previewGrapheme = '';
      span.dataset.previewLine = String(lineIndex);
      if (colorMode === 'combination') {
        span.dataset.characterIndex = String(visibleIndex);
      }
      span.textContent = grapheme;
      if (descriptor) {
        span.style.color = layer === 'core' ? descriptor.core : descriptor.color;
        if (!glowEnabled || iconOnlyGlow) {
          span.style.textShadow = 'none';
        } else if (layer === 'glow') {
          span.style.textShadow = (
            compactGlow
              ? [
                  '0 0 0.04em currentColor',
                  '0 0 0.12em currentColor',
                  '0 0 0.25em currentColor',
                  '0 0 0.42em currentColor',
                  '0 0 0.64em currentColor',
                ]
              : [
                  '0 0 0.08em currentColor',
                  '0 0 0.24em currentColor',
                  '0 0 0.52em currentColor',
                  '0 0 0.95em currentColor',
                  '0 0 1.45em currentColor',
                ]
          ).join(',');
        } else {
          span.style.textShadow = compactGlow
            ? `0 0 0.015em ${descriptor.core}, 0 0 0.05em ${descriptor.color}, 0 0 0.16em ${descriptor.color}`
            : `0 0 0.025em ${descriptor.core}, 0 0 0.1em ${descriptor.color}, 0 0 0.34em ${descriptor.color}`;
        }
      }
      if (
        colorMode === 'combination' &&
        !this.#iconColorActive &&
        visibleIndex === this.#activeCharacterIndex
      ) {
        span.classList.add('is-active-character');
      }
      fragment.append(span);
      visibleIndex += 1;
      placementSlot += 1;
    });
    appendIcon();
    container.replaceChildren(fragment);
  }

  /**
   * Add a zero-size inline marker whose DOM top edge is the exact baseline of
   * the final preview line. Canvas fontBoundingBox metrics are unreliable for
   * several custom WOFF2 faces in iOS Safari; the marker lets ink measurement
   * use the browser's real text baseline instead of estimating it.
   *
   * @param {HTMLElement} core
   */
  #ensurePreviewBaselineMarker(core) {
    let marker = Array.from(core.children).find(
      (child) =>
        child instanceof HTMLElement &&
        child.hasAttribute('data-preview-baseline')
    );
    if (marker instanceof HTMLElement) {
      if (marker !== core.lastElementChild) core.append(marker);
      return;
    }

    marker = document.createElement('i');
    marker.className = 'tan-nd__preview-baseline';
    marker.dataset.previewBaseline = '';
    marker.setAttribute('aria-hidden', 'true');
    core.append(marker);
  }

  /**
   * Match the inline SVG's preview stroke to the selected font's calibrated
   * core. The SVG uses non-scaling-stroke, so this value must be recomputed
   * from pre-transform CSS geometry instead of the zoomed client rectangle.
   *
   * @param {HTMLElement} preview
   * @param {Record<string, any>} measurements
   * @param {boolean} forceMeasure
   */
  #syncPreviewIconTubeWidth(preview, measurements, forceMeasure = false) {
    const iconMeasurement = measurements?.icon;
    const icon = preview.querySelector('[data-neon-icon]');
    if (!(icon instanceof HTMLElement) || !iconMeasurement) {
      preview.style.removeProperty('--tan-nd-icon-tube-px');
      delete preview.dataset.renderedIconWidth;
      delete preview.dataset.renderedIconHeight;
      return;
    }
    /*
     * Use layout width/height before the artboard's zoom transform. The SVG
     * stroke is transformed together with the icon afterwards; using only the
     * client rectangle here would apply that zoom twice.
     */
    let renderedWidth = this.#positiveNumber(
      preview.dataset.renderedIconWidth,
      0
    );
    let renderedHeight = this.#positiveNumber(
      preview.dataset.renderedIconHeight,
      0
    );
    if (forceMeasure || renderedWidth <= 0 || renderedHeight <= 0) {
      const iconStyle = window.getComputedStyle(icon);
      const computedWidth = this.#positiveNumber(iconStyle.width, 0);
      const computedHeight = this.#positiveNumber(iconStyle.height, 0);
      renderedWidth =
        computedWidth > 0
          ? computedWidth
          : icon.offsetWidth > 0
            ? icon.offsetWidth
            : icon.getBoundingClientRect().width;
      renderedHeight =
        computedHeight > 0
          ? computedHeight
          : icon.offsetHeight > 0
            ? icon.offsetHeight
            : icon.getBoundingClientRect().height;
      if (renderedWidth > 0) {
        preview.dataset.renderedIconWidth = String(renderedWidth);
      }
      if (renderedHeight > 0) {
        preview.dataset.renderedIconHeight = String(renderedHeight);
      }
    }
    const fontSize = this.#positiveNumber(
      window.getComputedStyle(preview).fontSize,
      0
    );
    if (renderedWidth <= 0 || renderedHeight <= 0 || fontSize <= 0) return;
    const tubePixels = this.#fontMatchedIconTubePixels(
      fontSize,
      renderedWidth,
      renderedHeight,
      this.#designState?.font || this.#getSelectedFont(),
      this.#getSelectedIcon()
    );
    preview.style.setProperty(
      '--tan-nd-icon-tube-px',
      `${Math.round(tubePixels * 1000) / 1000}px`
    );
  }

  /**
   * @param {string} text
   * @param {Array<string>} colors
   */
  #characterColorSummary(text, colors) {
    return this.#visibleGraphemes(text)
      .map((grapheme, index) => {
        const descriptor = this.#colorDescriptorFor(colors[index]);
        return `${index + 1}:${grapheme}=${descriptor.label}`;
      })
      .join(' | ');
  }

  /**
   * Customer-facing equivalent of #characterColorSummary. The canonical
   * English summary above remains unchanged for cart and production data.
   * @param {string} text
   * @param {Array<string>} colors
   */
  #characterColorDisplaySummary(text, colors) {
    return this.#visibleGraphemes(text)
      .map((grapheme, index) => {
        const descriptor = this.#colorDescriptorFor(colors[index]);
        return `${index + 1}:${grapheme}=${
          descriptor.displayLabel || descriptor.label
        }`;
      })
      .join(' | ');
  }

  /** @param {number} value @param {number} minimum @param {number} maximum */
  #clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, Number(value) || 0));
  }

  /**
   * Keep drag limits relative to the artboard's real anchor instead of assuming
   * the sign is vertically centred in the stage.
   *
   * @param {HTMLElement} stage
   * @param {HTMLElement} target
   */
  #previewDragBounds(stage, target) {
    const stageRect = stage.getBoundingClientRect();
    const artboard = this.querySelector('[data-artboard]');
    const artboardRect =
      artboard instanceof HTMLElement ? artboard.getBoundingClientRect() : null;
    const zoom = Math.max(0.1, this.#zoom);
    const centreX = artboardRect
      ? artboardRect.left + artboardRect.width / 2 - stageRect.left
      : stageRect.width / 2;
    const centreY = artboardRect
      ? artboardRect.top + artboardRect.height / 2 - stageRect.top
      : stageRect.height / 2;
    const halfWidth = (target.offsetWidth * zoom) / 2;
    const halfHeight = (target.offsetHeight * zoom) / 2;
    const safeInset = 12;
    const constrainToArtboard = this.#isMobileViewport() && artboardRect;
    const boundaryLeft = constrainToArtboard
      ? Math.max(0, artboardRect.left - stageRect.left)
      : 0;
    const boundaryTop = constrainToArtboard
      ? Math.max(0, artboardRect.top - stageRect.top)
      : 0;
    const boundaryRight = constrainToArtboard
      ? Math.min(stageRect.width, artboardRect.right - stageRect.left)
      : stageRect.width;
    const boundaryBottom = constrainToArtboard
      ? Math.min(stageRect.height, artboardRect.bottom - stageRect.top)
      : stageRect.height;

    return {
      zoom,
      left: Math.max(0, (centreX - boundaryLeft - halfWidth - safeInset) / zoom),
      right: Math.max(0, (boundaryRight - centreX - halfWidth - safeInset) / zoom),
      up: Math.max(0, (centreY - boundaryTop - halfHeight - safeInset) / zoom),
      down: Math.max(0, (boundaryBottom - centreY - halfHeight - safeInset) / zoom),
    };
  }

  /** @param {number} value @param {number} negative @param {number} positive */
  #normalisedPreviewOffset(value, negative, positive) {
    return value < 0 ? value * negative : value * positive;
  }

  /** @param {number} pixels @param {number} negative @param {number} positive */
  #previewOffsetFromPixels(pixels, negative, positive) {
    if (pixels < 0) return negative > 0 ? this.#clamp(pixels / negative, -1, 0) : 0;
    return positive > 0 ? this.#clamp(pixels / positive, 0, 1) : 0;
  }

  /** @param {{zoom: number, left: number, right: number, up: number, down: number} | null} cachedBounds */
  #applyPreviewOffset(cachedBounds = null) {
    const stage = this.querySelector('[data-stage]');
    const target =
      this.querySelector('[data-preview-drag-target]') || this.querySelector('[data-backboard]');
    if (!(stage instanceof HTMLElement) || !(target instanceof HTMLElement)) return;
    const x = this.#clamp(this.#previewOffset.x, -1, 1);
    const y = this.#clamp(this.#previewOffset.y, -1, 1);
    this.#previewOffset = { x, y };
    const bounds = x !== 0 || y !== 0
      ? cachedBounds || this.#previewDragBounds(stage, target)
      : null;
    const offsetX = bounds ? this.#normalisedPreviewOffset(x, bounds.left, bounds.right) : 0;
    const offsetY = bounds ? this.#normalisedPreviewOffset(y, bounds.up, bounds.down) : 0;
    const dragX = `${Math.round(offsetX)}px`;
    const dragY = `${Math.round(offsetY)}px`;
    if (target.style.getPropertyValue('--tan-nd-drag-x') !== dragX) {
      target.style.setProperty('--tan-nd-drag-x', dragX);
    }
    if (target.style.getPropertyValue('--tan-nd-drag-y') !== dragY) {
      target.style.setProperty('--tan-nd-drag-y', dragY);
    }
    if (this.#designState && typeof this.#designState === 'object') {
      this.#designState.previewOffset = { ...this.#previewOffset };
    }
  }

  /** @param {Record<string, any>} drag */
  #commitPreviewDragPosition(drag) {
    if (
      drag.latestClientX === drag.committedClientX &&
      drag.latestClientY === drag.committedClientY
    ) {
      return;
    }
    const bounds = drag.bounds;
    const deltaX = drag.latestClientX - drag.clientX;
    const deltaY = drag.latestClientY - drag.clientY;
    const initialX = this.#normalisedPreviewOffset(drag.x, bounds.left, bounds.right);
    const initialY = this.#normalisedPreviewOffset(drag.y, bounds.up, bounds.down);
    const nextX = this.#clamp(
      initialX + deltaX / bounds.zoom,
      -bounds.left,
      bounds.right
    );
    const nextY = this.#clamp(
      initialY + deltaY / bounds.zoom,
      -bounds.up,
      bounds.down
    );
    this.#previewOffset = {
      x: this.#previewOffsetFromPixels(nextX, bounds.left, bounds.right),
      y: this.#previewOffsetFromPixels(nextY, bounds.up, bounds.down),
    };
    drag.committedClientX = drag.latestClientX;
    drag.committedClientY = drag.latestClientY;
    this.#applyPreviewOffset(bounds);
    this.#positionMetrics();
  }

  #refreshPreviewDragBounds() {
    const drag = this.#previewDrag;
    if (!drag) return;
    const stage = this.querySelector('[data-stage]');
    if (!(stage instanceof HTMLElement) || !drag.target.isConnected) return;
    if (this.#previewDragFrame) {
      cancelAnimationFrame(this.#previewDragFrame);
      this.#previewDragFrame = 0;
      if (drag.moved) this.#commitPreviewDragPosition(drag);
    }
    drag.bounds = this.#previewDragBounds(stage, drag.target);
    drag.x = this.#previewOffset.x;
    drag.y = this.#previewOffset.y;
    drag.clientX = drag.latestClientX;
    drag.clientY = drag.latestClientY;
    drag.committedClientX = drag.latestClientX;
    drag.committedClientY = drag.latestClientY;
  }

  #beginPreviewDrag = (event) => {
    if (!(event instanceof PointerEvent) || !event.isPrimary || event.button !== 0 || this.#previewDrag) return;
    const target = event.currentTarget;
    if (!(target instanceof HTMLElement)) return;
    const stage = this.querySelector('[data-stage]');
    if (!(stage instanceof HTMLElement)) return;
    const character = event.target instanceof Element ? event.target.closest('[data-character-index]') : null;
    const characterIndex =
      character instanceof HTMLElement && Number.isInteger(Number(character.dataset.characterIndex))
        ? Number(character.dataset.characterIndex)
        : null;
    this.#previewDrag = {
      pointerId: event.pointerId,
      pointerType: event.pointerType,
      clientX: event.clientX,
      clientY: event.clientY,
      latestClientX: event.clientX,
      latestClientY: event.clientY,
      committedClientX: event.clientX,
      committedClientY: event.clientY,
      x: this.#previewOffset.x,
      y: this.#previewOffset.y,
      initialOffset: { ...this.#previewOffset },
      target,
      bounds: this.#previewDragBounds(stage, target),
      moved: false,
      scrollGesture: false,
      tapEligible: true,
      characterIndex,
    };
    target.setPointerCapture?.(event.pointerId);
  };

  #movePreviewDrag = (event) => {
    const drag = this.#previewDrag;
    if (!(event instanceof PointerEvent) || !drag || event.pointerId !== drag.pointerId || drag.scrollGesture) return;
    const deltaX = event.clientX - drag.clientX;
    const deltaY = event.clientY - drag.clientY;
    if (!drag.moved) {
      if (Math.hypot(deltaX, deltaY) < 6) return;
      drag.tapEligible = false;

      // The touch surface allows native pan-y and pinch-zoom. Only a clear
      // horizontal start may reposition the sign; a vertical start belongs
      // to the page for the rest of this contact, even before pointercancel.
      if (drag.pointerType === 'touch') {
        if (Math.abs(deltaY) >= Math.abs(deltaX)) {
          drag.scrollGesture = true;
          return;
        }
        if (Math.abs(deltaX) < 12 || Math.abs(deltaX) < Math.abs(deltaY) * 1.5) return;
      }

      drag.moved = true;
      drag.target.classList.add('is-dragging');
      drag.target.style.cursor = 'grabbing';
    }
    drag.latestClientX = event.clientX;
    drag.latestClientY = event.clientY;
    event.preventDefault();

    if (this.#previewDragFrame) return;
    this.#previewDragFrame = requestAnimationFrame(() => {
      this.#previewDragFrame = 0;
      if (this.#previewDrag === drag) this.#commitPreviewDragPosition(drag);
    });
  };

  #endPreviewDrag = (event) => {
    const drag = this.#previewDrag;
    if (!(event instanceof PointerEvent) || !drag || event.pointerId !== drag.pointerId) return;
    if (this.#previewDragFrame) {
      cancelAnimationFrame(this.#previewDragFrame);
      this.#previewDragFrame = 0;
    }

    // Cancel/lost-capture coordinates are not a confirmed drop location.
    // Restore the gesture's starting offset, including an intentional offset
    // from an earlier drag or shared design. Clear state before releasing
    // capture so its lostpointercapture event cannot finish this drag twice.
    const cancelled = event.type !== 'pointerup';
    this.#previewDrag = null;
    if (cancelled) {
      if (drag.moved) {
        this.#previewOffset = { ...drag.initialOffset };
        this.#applyPreviewOffset();
        this.#positionMetrics();
      }
    } else {
      drag.latestClientX = event.clientX;
      drag.latestClientY = event.clientY;
      if (drag.moved) this.#commitPreviewDragPosition(drag);
    }

    if (drag.target.hasPointerCapture?.(event.pointerId)) {
      drag.target.releasePointerCapture?.(event.pointerId);
    }
    drag.target.classList.remove('is-dragging');
    drag.target.style.cursor = 'grab';

    const isTap = !cancelled && !drag.moved && !drag.scrollGesture && drag.tapEligible &&
      Math.hypot(event.clientX - drag.clientX, event.clientY - drag.clientY) < 6;
    if (isTap && this.#selectedColorMode() === 'combination' && drag.characterIndex !== null) {
      this.#activeCharacterIndex = this.#clamp(
        drag.characterIndex,
        0,
        Math.max(0, this.#characterColors.length - 1)
      );
      this.#syncCharacterColorUi();
    }
  };

  #handlePreviewKeydown = (event) => {
    if (!(event instanceof KeyboardEvent)) return;
    const step = event.shiftKey ? 0.08 : 0.02;
    let next = { ...this.#previewOffset };
    if (event.key === 'ArrowLeft') next.x -= step;
    else if (event.key === 'ArrowRight') next.x += step;
    else if (event.key === 'ArrowUp') next.y -= step;
    else if (event.key === 'ArrowDown') next.y += step;
    else if (event.key === 'Home' || event.key === 'Escape') next = { x: 0, y: 0 };
    else return;

    event.preventDefault();
    event.stopPropagation();
    this.#previewOffset = {
      x: this.#clamp(next.x, -1, 1),
      y: this.#clamp(next.y, -1, 1),
    };
    this.#applyPreviewOffset();
    this.#positionMetrics();
  };

  /** @param {any} background */
  #backgroundSourceForViewport(background) {
    if (!background) return '';
    const desktopSource = typeof background.src === 'string' ? background.src : '';
    const mobileSource =
      typeof background.mobileSrc === 'string' && background.mobileSrc
        ? background.mobileSrc
        : desktopSource;
    return TAN_MOBILE_BACKGROUND_VIEWPORT.matches ? mobileSource : desktopSource;
  }

  /** @param {any} background */
  #applyBackgroundSources(background) {
    if (!background || typeof background.src !== 'string' || !background.src) return;
    const desktopSource = background.src;
    const mobileSource =
      typeof background.mobileSrc === 'string' && background.mobileSrc
        ? background.mobileSrc
        : desktopSource;
    const escapeCssUrl = (source) =>
      source.replace(/["\\\n\r\f]/g, (character) => `\\${character}`);

    this.style.setProperty(
      '--tan-nd-room-image',
      `url("${escapeCssUrl(desktopSource)}")`
    );
    this.style.setProperty(
      '--tan-nd-room-image-mobile',
      `url("${escapeCssUrl(mobileSource)}")`
    );
  }

  #applySelectedBackgroundForViewport() {
    const selected = this.#backgrounds.find(
      (entry) => entry.id === this.#selectedBackgroundId
    );
    if (selected) this.#applyBackgroundSources(selected);
  }

  /** @param {string} backgroundId */
  async #selectBackground(backgroundId) {
    const background = this.#backgrounds.find((entry) => entry.id === backgroundId);
    if (!background) return;
    if (background.id === this.#selectedBackgroundId) {
      // Clicking the active room cancels any still-loading room change. The
      // stale request intentionally skips its own cleanup, so clear all busy
      // markers here as part of the cancellation.
      this.#backgroundRequest += 1;
      this.querySelectorAll('[data-background-option][aria-busy="true"]').forEach(
        (candidate) => candidate.removeAttribute('aria-busy')
      );
      this.#applyBackgroundSources(background);
      return;
    }
    const request = ++this.#backgroundRequest;

    const option = Array.from(this.querySelectorAll('[data-background-option]')).find(
      (candidate) =>
        candidate instanceof HTMLButtonElement &&
        candidate.dataset.backgroundOption === background.id
    );
    this.querySelectorAll('[data-background-option][aria-busy="true"]').forEach((candidate) => {
      candidate.removeAttribute('aria-busy');
    });
    if (option instanceof HTMLButtonElement) option.setAttribute('aria-busy', 'true');

    try {
      const previewSource = this.#backgroundSourceForViewport(background);
      await new Promise((resolve, reject) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => resolve(true);
        image.onerror = () =>
          reject(
            new Error(
              this.#t(
                'errors.background_load_failed',
                {},
                'Background image failed to load.'
              )
            )
          );
        image.src = previewSource;
        if (image.complete && image.naturalWidth > 0) resolve(true);
      });
      if (request !== this.#backgroundRequest) return;

      this.#applyBackgroundSources(background);
      this.#selectedBackgroundId = background.id;
      this.#backgroundIndex = Math.max(
        0,
        this.#backgrounds.findIndex((entry) => entry.id === background.id)
      );

      const stage = this.querySelector('[data-stage]');
      if (stage instanceof HTMLElement) stage.dataset.background = 'room';
      this.querySelectorAll('[data-background-option]').forEach((candidate) => {
        if (!(candidate instanceof HTMLButtonElement)) return;
        const selected = candidate.dataset.backgroundOption === background.id;
        candidate.setAttribute('aria-pressed', String(selected));
        candidate.classList.toggle('is-active', selected);
      });
      if (option instanceof HTMLButtonElement && option.dataset.backgroundLabel) {
        option.setAttribute('aria-label', option.dataset.backgroundLabel);
      }
      this.querySelector('[data-background-toggle]')?.classList.add('is-active');
      this.#scheduleUpdate();
    } catch {
      if (request === this.#backgroundRequest && option instanceof HTMLButtonElement) {
        const label =
          background.label ||
          this.#t('visualizer.background', {}, 'Background');
        option.setAttribute(
          'aria-label',
          this.#t(
            'errors.named_background_load_failed',
            { background: label },
            `${label} could not be loaded`
          )
        );
      }
    } finally {
      if (request === this.#backgroundRequest && option instanceof HTMLButtonElement) {
        option.removeAttribute('aria-busy');
      }
    }
  }

  #bindMobileNativeScroll(signal) {
    // Styles arrive with the same guarded JS asset, so native layout and
    // removal of the former touch handler cannot be installed separately.
    const styleId = 'tan-nd-native-page-scroll-style';
    const nativeStylesLoaded = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(
      (link) => link instanceof HTMLLinkElement && link.sheet &&
        /\/assets\/tan-neon-designer\.css(?:\?|$)/.test(link.href)
    );
    if (!nativeStylesLoaded && !document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = "/* One native page scroller on phones. The review keeps its existing card. */\n@media (max-width: 749px),\n  (max-width: 1099px) and (orientation: landscape) and (max-height: 600px) and (hover: none) and (pointer: coarse) {\n  .tan-nd[data-native-page-scroll='true'] {\n    overflow-x: clip;\n    overflow-y: visible;\n  }\n\n  /* Keep single-axis ancestor clipping away from the sticky preview. The\n     viewport still clips horizontal overflow; controls keep their own clip. */\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) {\n    overflow-x: visible;\n  }\n\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) .tan-nd__layout {\n    display: block;\n    height: auto !important;\n    min-height: 0;\n    overflow-x: visible !important;\n    overflow-y: visible !important;\n    background-image: none;\n    overflow-anchor: auto;\n  }\n\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) .tan-nd__layout::before {\n    display: none;\n  }\n\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) .tan-nd__visualizer {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    align-self: start;\n    /* Let native sticky positioning choose its own compositing surface.\n       Do not keep a forced transform layer across keyboard/scroll changes. */\n    overflow: hidden;\n    contain: none;\n    will-change: auto;\n    height: var(--tan-nd-mobile-preview-height, 320px);\n    min-height: 0;\n    max-height: none;\n    background-color: #101420;\n    background-image:\n      linear-gradient(180deg, rgb(3 5 12 / 0.08), rgb(3 5 12 / 0.2)),\n      var(--tan-nd-room-image-mobile);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) .tan-nd__sidebar {\n    height: auto !important;\n    max-height: none !important;\n    min-height: 0;\n    overflow-x: clip !important;\n    overflow-y: visible !important;\n    overscroll-behavior-y: auto;\n    scrollbar-gutter: auto;\n    -webkit-overflow-scrolling: auto;\n    touch-action: pan-y pinch-zoom;\n    overflow-anchor: auto;\n  }\n\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review'])\n    :is(.tan-nd__font-menu, .tan-nd__font-grid, .tan-nd__icon-menu, .tan-nd__icon-grid) {\n    max-height: none;\n    overflow-x: clip;\n    overflow-y: visible;\n    overscroll-behavior-y: auto;\n  }\n\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) .tan-nd__icon-search {\n    position: relative;\n    top: auto;\n  }\n\n  /* Let browser focus scrolling expose the editor above the software keyboard. */\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review'])\n    .tan-nd__layout:has(textarea:focus, input:not([type='range']):not([type='radio']):not([type='checkbox']):focus)\n    .tan-nd__visualizer {\n    position: relative;\n  }\n}\n\n@media (max-width: 1099px) and (orientation: landscape) and (max-height: 600px) and (hover: none) and (pointer: coarse) {\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) .tan-nd__layout {\n    display: grid;\n    grid-template-columns: minmax(0, 52fr) minmax(0, 48fr);\n    align-items: start;\n  }\n\n  .tan-nd[data-native-page-scroll='true']:not([data-designer-step='review']) .tan-nd__visualizer {\n    height: max(260px, calc(100svh - var(--header-height, 60px)));\n    max-height: none;\n    background-image: none;\n  }\n}\n\n/* The theme also clips BODY horizontally. On native document-scroll phones,\n   leave only HTML's viewport clip above the editor. The desktop wrapper and\n   any open drawer's scroll lock must retain their original overflow rules. */\n@media (max-width: 749px) and (hover: none) and (pointer: coarse),\n  (min-width: 750px) and (max-width: 989px) and (orientation: landscape) and (max-height: 600px) and (hover: none) and (pointer: coarse) {\n  html:not([scroll-lock]) > body:has(.tan-nd[data-native-page-scroll='true']:not([data-designer-step='review'])) {\n    overflow-x: visible;\n  }\n}\n\n@media (max-width: 749px),\n  (max-width: 1099px) and (orientation: landscape) and (max-height: 600px) and (hover: none) and (pointer: coarse) {\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='true']:not([data-designer-step='review']) .tan-nd__visualizer {\n    position: relative;\n    top: auto;\n    z-index: 1;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='true']:not([data-designer-step='review']) .tan-nd__sidebar {\n    width: var(--tan-nd-mobile-panel-width, 95%);\n    height: var(--tan-nd-mobile-panel-height, 450px) !important;\n    max-height: var(--tan-nd-mobile-panel-height, 450px) !important;\n    margin: var(--tan-nd-mobile-panel-gap, 0px) auto 0;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    overscroll-behavior-y: auto;\n    scrollbar-gutter: stable;\n    touch-action: pan-y pinch-zoom;\n    border-radius: 8px;\n    background: #fff;\n  }\n}\n\n@media (max-width: 1099px) and (orientation: landscape) and (max-height: 600px) and (hover: none) and (pointer: coarse) {\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='true']:not([data-designer-step='review']) .tan-nd__layout {\n    height: max(300px, calc(100svh - var(--header-height, 60px))) !important;\n    align-items: stretch;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='true']:not([data-designer-step='review']) .tan-nd__visualizer {\n    height: 100%;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='true']:not([data-designer-step='review']) .tan-nd__sidebar {\n    width: calc(100% - 12px);\n    height: calc(100% - 12px) !important;\n    max-height: none !important;\n    margin: 6px;\n  }\n}\n\n@media (max-width: 749px) and (orientation: portrait) {\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='true']:not([data-designer-step='review']) .tan-nd__layout {\n    background-image:\n      linear-gradient(180deg, rgb(3 5 12 / 0.08), rgb(3 5 12 / 0.2)),\n      var(--tan-nd-room-image-mobile);\n    background-position: center top;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='true']:not([data-designer-step='review']) .tan-nd__visualizer {\n    background-color: transparent;\n    background-image: none;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__layout {\n    --tan-nd-mobile-room-frame: max(var(--tan-nd-mobile-preview-height, 320px), 100vh);\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: var(--tan-nd-mobile-preview-height, 320px) auto;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__layout::before,\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__visualizer::before {\n    content: '';\n    display: block;\n    inset: auto;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    width: 100%;\n    height: var(--tan-nd-mobile-room-frame);\n    min-height: 0;\n    max-height: none;\n    margin: 0;\n    background-color: #101420;\n    background-image:\n      linear-gradient(180deg, rgb(3 5 12 / 0.08), rgb(3 5 12 / 0.2)),\n      var(--tan-nd-room-image-mobile);\n    background-position: center top;\n    background-repeat: no-repeat;\n    background-size: cover;\n    pointer-events: none;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__layout::before {\n    position: sticky;\n    align-self: start;\n    grid-column: 1;\n    grid-row: 1 / -1;\n    border-radius: inherit;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__visualizer {\n    grid-column: 1;\n    grid-row: 1 / -1;\n    background-image: none;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__visualizer::before {\n    position: absolute;\n  }\n\n  .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__sidebar {\n    grid-column: 1;\n    grid-row: 2;\n  }\n\n  @supports (height: 100lvh) {\n    .tan-nd[data-native-page-scroll='true'][data-home-embed='false']:not([data-designer-step='review']) .tan-nd__layout {\n      --tan-nd-mobile-room-frame: max(var(--tan-nd-mobile-preview-height, 320px), 100lvh);\n    }\n  }\n}";
      document.body.append(style);
    }
    this.dataset.nativePageScroll = 'true';
    signal.addEventListener('abort', () => {
      delete this.dataset.nativePageScroll;
    }, { once: true });
  }

  #usesNativeMobileScroll() {
    return this.#isMobileViewport() && this.dataset.nativePageScroll === 'true';
  }

  #alignMobileEmbedControl(element, gap = 8, withinViewport = true) {
    if (
      !this.#usesNativeMobileScroll() || !this.#isHomeEmbed() ||
      this.dataset.designerStep === 'review' || !(element instanceof HTMLElement)
    ) return false;
    const sidebar = this.querySelector('.tan-nd__sidebar');
    if (
      !(sidebar instanceof HTMLElement) || !sidebar.contains(element) ||
      !/^(auto|scroll)$/.test(getComputedStyle(sidebar).overflowY)
    ) return false;
    const viewport = window.visualViewport;
    if (viewport && Math.abs(viewport.scale - 1) > 0.05) return true;
    const sidebarRect = sidebar.getBoundingClientRect();
    const visibleTop = viewport?.offsetTop || 0;
    const visibleBottom = visibleTop + (viewport?.height || window.innerHeight);
    if (withinViewport && (sidebarRect.bottom <= visibleTop || sidebarRect.top >= visibleBottom)) return true;
    const inset = withinViewport
      ? Math.max(0, visibleTop - sidebarRect.top - sidebar.clientTop)
      : 0;
    const maximum = Math.max(0, sidebar.scrollHeight - sidebar.clientHeight);
    const top = Math.max(0, Math.min(maximum,
      this.#elementTopInScroller(element, sidebar) - sidebar.clientTop - inset - gap
    ));
    if (Math.abs(sidebar.scrollTop - top) > 4) {
      this.#setPageScrollTop(sidebar, top, 'auto');
    }
    return true;
  }

  #alignMobileControl(element, gap = 8) {
    if (!(element instanceof HTMLElement) || !this.#usesNativeMobileScroll()) return;
    if (this.#alignMobileEmbedControl(element, gap)) return;
    const scroller = this.#getPageScroller();
    const preview = this.querySelector('.tan-nd__visualizer');
    let inset = 0;
    if (preview instanceof HTMLElement && getComputedStyle(preview).position === 'sticky') {
      const previewRect = preview.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      // Portrait controls sit below the preview; landscape controls sit beside it.
      const overlapsHorizontally = elementRect.left < previewRect.right && elementRect.right > previewRect.left;
      if (overlapsHorizontally) inset = previewRect.height;
    }
    const top = Math.max(0, this.#elementTopInScroller(element, scroller) - inset - gap);
    if (Math.abs(this.#getPageScrollTop(scroller) - top) > 4) {
      this.#setPageScrollTop(scroller, top, this.#mobileAlignmentBehavior());
    }
  }

  #getPageScroller() {
    const wrapper = document.querySelector('.page-wrapper');
    if (TAN_PAGE_WRAPPER_SCROLL.matches && wrapper instanceof HTMLElement) {
      return wrapper;
    }
    return document.scrollingElement || document.documentElement;
  }

  /** @param {Element} scroller */
  #pageScrollerKey(scroller) {
    return this.#isDocumentScroller(scroller) ? 'document' : 'page-wrapper';
  }

  /** @param {Element} scroller */
  #isDocumentScroller(scroller) {
    return (
      scroller === document.scrollingElement ||
      scroller === document.documentElement ||
      scroller === document.body
    );
  }

  /** @param {Element} scroller */
  #getPageScrollTop(scroller) {
    if (this.#isDocumentScroller(scroller)) {
      return window.scrollY || scroller.scrollTop || 0;
    }
    return scroller.scrollTop;
  }

  /** @param {Element} scroller @param {number} top @param {ScrollBehavior} behavior */
  #setPageScrollTop(scroller, top, behavior = 'auto') {
    const safeTop = Math.max(0, Number(top) || 0);
    if (this.#isDocumentScroller(scroller)) {
      window.scrollTo({ left: 0, top: safeTop, behavior });
      return;
    }
    if (typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ left: 0, top: safeTop, behavior });
    } else {
      scroller.scrollTop = safeTop;
    }
  }

  /** @param {HTMLElement} element @param {Element} scroller */
  #elementTopInScroller(element, scroller) {
    const elementRect = element.getBoundingClientRect();
    if (this.#isDocumentScroller(scroller)) {
      return elementRect.top + this.#getPageScrollTop(scroller);
    }
    const scrollerRect = scroller.getBoundingClientRect();
    return elementRect.top - scrollerRect.top + scroller.scrollTop;
  }

  #stepFromLocation() {
    return new URL(window.location.href).searchParams.get('designer_step') === 'review'
      ? 'review'
      : 'edit';
  }

  /** @param {{focus?: boolean, scrollTop?: number}} options */
  #syncDesignerStepFromLocation(options = {}) {
    this.#setDesignerStep(
      this.#stepFromLocation(),
      this.#isHomeEmbed() ? { ...options, focus: false } : options
    );
  }

  /** @param {'edit' | 'review'} step @param {{focus?: boolean, scrollTop?: number}} options */
  #setDesignerStep(step, options = {}) {
    const homeEmbed = this.#isHomeEmbed();
    const reviewMode = step === 'review';
    if (!reviewMode) delete this.dataset.reviewTransition;
    const enteringReview = reviewMode && this.dataset.designerStep !== 'review';
    const leavingReview = !reviewMode && this.dataset.designerStep === 'review';
    const nativeMobile = this.#usesNativeMobileScroll();
    if (nativeMobile && enteringReview) {
      this.dataset.nativeEditPageTop = String(this.#getPageScrollTop(this.#getPageScroller()));
    }
    const sidebar = this.querySelector('.tan-nd__sidebar');
    const reviewScroll = this.querySelector('[data-review-scroll]');
    const layout = this.querySelector('.tan-nd__layout');
    const mobileReview = reviewMode && this.#isMobileViewport();
    const savedEditSidebarScrollTop = Number(this.dataset.editSidebarScrollTop);
    if (enteringReview) {
      this.#closeFontPicker();
      this.#closeIconPicker();
      this.#setBackgroundPickerOpen(false);
      if (mobileReview && sidebar instanceof HTMLElement) {
        this.dataset.editSidebarScrollTop = String(sidebar.scrollTop);
      }
    }
    const transitionAnchor =
      enteringReview &&
      mobileReview &&
      layout instanceof HTMLElement
        ? layout
        : enteringReview &&
            this.#isSingleColumnLayout() &&
            sidebar instanceof HTMLElement
          ? sidebar
          : layout;
    const scroller = this.#getPageScroller();
    const hasRequestedScrollTop =
      Object.prototype.hasOwnProperty.call(options, 'scrollTop') &&
      typeof options.scrollTop === 'number' &&
      Number.isFinite(options.scrollTop);
    let targetScrollTop = homeEmbed
      ? null
      : hasRequestedScrollTop
        ? options.scrollTop
        : enteringReview && transitionAnchor instanceof HTMLElement
          ? this.#elementTopInScroller(transitionAnchor, scroller)
          : null;
    // A native editor can be much taller than the review card. Anchor the
    // shorter card at the workspace, then restore the editor position on Back.
    if (nativeMobile && enteringReview && layout instanceof HTMLElement) {
      targetScrollTop = this.#elementTopInScroller(layout, scroller);
    } else if (nativeMobile && leavingReview && this.dataset.nativeEditPageTop !== undefined) {
      const savedPageTop = Number(this.dataset.nativeEditPageTop);
      if (Number.isFinite(savedPageTop)) targetScrollTop = savedPageTop;
    }
    const review = this.querySelector('[data-designer-review]');
    const sidebarHeight =
      enteringReview && sidebar instanceof HTMLElement
        ? Math.ceil(sidebar.getBoundingClientRect().height)
        : 0;

    // Keep the long editor's height while the shorter review is painted. A
    // single frame is not enough in Chromium when `.page-wrapper` is the scroll
    // root: the browser can clamp to the footer between layout and paint, which
    // is visible as a bottom-to-top flash and can strand the review below a
    // large white area.
    if (review instanceof HTMLElement) review.style.marginTop = '';
    if (sidebar instanceof HTMLElement) {
      sidebar.style.minHeight =
        enteringReview && !mobileReview && sidebarHeight > 0 ? `${sidebarHeight}px` : '';
    }

    this.dataset.designerStep = reviewMode ? 'review' : 'edit';
    this.querySelectorAll('[data-designer-edit]').forEach((node) => {
      if (node instanceof HTMLElement) node.hidden = reviewMode;
    });

    if (review instanceof HTMLElement) {
      review.hidden = !reviewMode;
      if (reviewMode) {
        this.#renderReview();
      }
    }

    const syncSidebarScroll = () => {
      if (!(sidebar instanceof HTMLElement) || !this.#isMobileViewport()) return;
      if (reviewMode) {
        sidebar.scrollTop = 0;
        if (reviewScroll instanceof HTMLElement) reviewScroll.scrollTop = 0;
        return;
      }
      if (Number.isFinite(savedEditSidebarScrollTop)) {
        sidebar.scrollTop = Math.max(0, savedEditSidebarScrollTop);
      }
    };

    this.#syncAddButton(Boolean(this.#designState.valid));
    const syncTransitionScroll = () => {
      if (!Number.isFinite(targetScrollTop)) return;
      const currentScroller = this.#getPageScroller();
      if (
        currentScroller !== scroller &&
        transitionAnchor instanceof HTMLElement
      ) {
        targetScrollTop = this.#elementTopInScroller(transitionAnchor, currentScroller);
      }
      this.#setPageScrollTop(currentScroller, targetScrollTop);
    };

    syncTransitionScroll();
    syncSidebarScroll();
    const shouldFocus = options.focus && !homeEmbed;
    const needsTransitionCleanup =
      enteringReview && sidebar instanceof HTMLElement;
    if (homeEmbed && !reviewMode) delete this.dataset.editSidebarScrollTop;
    if (
      !shouldFocus &&
      !Number.isFinite(targetScrollTop) &&
      !needsTransitionCleanup
    ) {
      return;
    }

    requestAnimationFrame(() => {
      syncTransitionScroll();
      syncSidebarScroll();
      requestAnimationFrame(() => {
        syncTransitionScroll();
        syncSidebarScroll();
        requestAnimationFrame(() => {
          if (sidebar instanceof HTMLElement && enteringReview) {
            sidebar.style.minHeight = '';
          }
          syncTransitionScroll();
          syncSidebarScroll();
          if (!reviewMode) {
            delete this.dataset.editSidebarScrollTop;
            delete this.dataset.nativeEditPageTop;
          }
          if (!shouldFocus) return;
          if (reviewMode && review instanceof HTMLElement) {
            review.focus({ preventScroll: true });
            return;
          }
          if (this.#isMobileViewport()) {
            if (sidebar instanceof HTMLElement) {
              sidebar.focus({ preventScroll: true });
            }
            return;
          }
          const input = this.querySelector('[data-text-input]');
          if (input instanceof HTMLTextAreaElement) {
            input.focus({ preventScroll: true });
          }
        });
      });
    });
  }

  #openReview = () => {
    this.#flushPendingUpdate();
    const productReady = this.dataset.appBackendReady === 'true';
    const selectedFontId = String(this.#getSelectedFont().id || '');
    const fontReady =
      this.dataset.fontReady === 'true' &&
      this.dataset.fontLoading !== 'true' &&
      Boolean(this.#renderedFontId) &&
      this.#renderedFontId === selectedFontId;
    if (!fontReady) {
      this.#syncAddButton(false);
      this.#showCartError(
        this.#t(
          'errors.font_loading',
          {},
          'Wait for the selected font to finish loading.'
        )
      );
      return;
    }
    if (!this.#designState.valid || !productReady) {
      this.#showCartError(
        productReady
          ? this.#t(
              'errors.incomplete_selections',
              {},
              'Complete the required design selections before continuing.'
            )
          : this.#t(
              'errors.product_unavailable',
              {},
              'Select an available Custom Neon Sign product before continuing.'
            )
      );
      const input = this.querySelector('[data-text-input]');
      if (
        !this.#isHomeEmbed() &&
        input instanceof HTMLTextAreaElement &&
        !this.#designState.valid
      ) {
        input.focus();
      }
      return;
    }

    this.#showCartError('');
    if (this.#isHomeEmbed()) {
      const currentUrl = new URL(window.location.href);
      currentUrl.hash = '';
      const currentState =
        window.history.state && typeof window.history.state === 'object'
          ? { ...window.history.state }
          : {};
      const designDraft = this.#createHistoryDraft();
      window.history.replaceState(
        {
          ...currentState,
          tanDesignerDraft: designDraft,
        },
        '',
        currentUrl
      );

      const reviewUrl = new URL(currentUrl);
      if (reviewUrl.searchParams.get('designer_step') !== 'review') {
        reviewUrl.searchParams.set('designer_step', 'review');
        window.history.pushState(
          {
            ...currentState,
            tanDesignerStep: 'review',
            tanDesignerId: this.id,
            tanDesignerDraft: designDraft,
          },
          '',
          reviewUrl
        );
      }

      this.#setDesignerStep('review', { focus: false });
      this.#trackReviewOnce();
      return;
    }

    const scroller = this.#getPageScroller();
    const scrollerKey = this.#pageScrollerKey(scroller);
    const editScrollTop = this.#getPageScrollTop(scroller);
    const layout = this.querySelector('.tan-nd__layout');
    const sidebar = this.querySelector('.tan-nd__sidebar');
    const reviewAnchor =
      this.#isMobileViewport() && layout instanceof HTMLElement
        ? layout
        : this.#isSingleColumnLayout() && sidebar instanceof HTMLElement
          ? sidebar
          : layout;
    const targetScrollTop =
      this.#isMobileViewport()
        ? editScrollTop
        : reviewAnchor instanceof HTMLElement
        ? this.#elementTopInScroller(reviewAnchor, scroller)
        : editScrollTop;

    // Align before pushState: the theme-wide history wrapper snapshots the
    // live scroller immediately before it creates the review entry.
    this.#setPageScrollTop(scroller, targetScrollTop);

    const currentUrl = new URL(window.location.href);
    currentUrl.hash = '';
    const currentState =
      window.history.state && typeof window.history.state === 'object'
        ? { ...window.history.state }
        : {};
    const designDraft = this.#createHistoryDraft();
    window.history.replaceState(
      {
        ...currentState,
        tanDesignerDraft: designDraft,
        scrollTop: targetScrollTop,
        tanScrollRoot: scrollerKey,
      },
      '',
      currentUrl
    );

    const reviewUrl = new URL(currentUrl);
    if (reviewUrl.searchParams.get('designer_step') !== 'review') {
      reviewUrl.searchParams.set('designer_step', 'review');
      window.history.pushState(
        {
          ...currentState,
          tanDesignerStep: 'review',
          tanDesignerId: this.id,
          tanDesignerDraft: designDraft,
          scrollTop: targetScrollTop,
          tanScrollRoot: scrollerKey,
        },
        '',
        reviewUrl
      );
    }

    this.#setDesignerStep('review', { focus: true, scrollTop: targetScrollTop });
    this.#trackReviewOnce();
  };

  #leaveReview = () => {
    delete this.dataset.reviewTransition;
    const state =
      window.history.state && typeof window.history.state === 'object'
        ? window.history.state
        : {};
    if (state.tanDesignerStep === 'review' && state.tanDesignerId === this.id) {
      this.#focusEditorAfterPopstate = true;
      window.history.back();
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('designer_step');
    url.hash = '';
    const nextState = { ...state };
    delete nextState.tanDesignerStep;
    delete nextState.tanDesignerId;
    const scroller = this.#getPageScroller();
    const scrollerKey = this.#pageScrollerKey(scroller);
    const layout = this.querySelector('.tan-nd__layout');
    const sidebar = this.querySelector('.tan-nd__sidebar');
    const editAnchor =
      this.#isSingleColumnLayout() && sidebar instanceof HTMLElement ? sidebar : layout;
    const targetScrollTop =
      editAnchor instanceof HTMLElement
        ? this.#elementTopInScroller(editAnchor, scroller)
        : this.#getPageScrollTop(scroller);
    window.history.replaceState(
      {
        ...nextState,
        scrollTop: targetScrollTop,
        tanScrollRoot: scrollerKey,
      },
      '',
      url
    );
    this.#setDesignerStep('edit', { focus: true, scrollTop: targetScrollTop });
  };

  #handleDesignerPopState = () => {
    if (this.#isHomeEmbed()) {
      this.#applyHistoryDraft();
      this.#applyUrlState();
      this.#setDesignerStep(this.#stepFromLocation(), { focus: false });
      this.#scheduleUpdate();
      return;
    }
    this.#applyHistoryDraft();
    this.#applyUrlState();
    const nextStep = this.#stepFromLocation();
    const stepChanged = this.dataset.designerStep !== nextStep;
    const focusStep =
      stepChanged ||
      (this.#focusEditorAfterPopstate && nextStep === 'edit');
    this.#focusEditorAfterPopstate = false;
    const scroller = this.#getPageScroller();
    const state =
      window.history.state && typeof window.history.state === 'object'
        ? window.history.state
        : {};
    const currentScrollRoot = this.#pageScrollerKey(scroller);
    const layout = this.querySelector('.tan-nd__layout');
    const rootChanged =
      Boolean(state.tanScrollRoot) && state.tanScrollRoot !== currentScrollRoot;
    const normalizedScrollTop =
      rootChanged && layout instanceof HTMLElement
        ? this.#elementTopInScroller(layout, scroller)
        : null;
    if (rootChanged && Number.isFinite(normalizedScrollTop)) {
      window.history.replaceState(
        {
          ...state,
          scrollTop: normalizedScrollTop,
          tanScrollRoot: currentScrollRoot,
        },
        '',
        window.location.href
      );
    }
    let savedScrollTop = null;
    if (Number.isFinite(normalizedScrollTop)) {
      savedScrollTop = normalizedScrollTop;
    } else if (
      typeof state.scrollTop === 'number' &&
      Number.isFinite(state.scrollTop) &&
      (!state.tanScrollRoot || state.tanScrollRoot === currentScrollRoot)
    ) {
      savedScrollTop = state.scrollTop;
    }
    this.#setDesignerStep(nextStep, {
      focus: focusStep,
      ...(savedScrollTop !== null ? { scrollTop: savedScrollTop } : {}),
    });
    this.#scheduleUpdate();
  };

  #handlePageShow = () => {
    // A delayed page load must never move a visitor who is already scrolling.
    // Focus, keyboard and review transitions manage their own alignment.
    this.#resetAddToCartButton();
  };

  #renderReview() {
    const state = this.#designState;
    if (!state || !state.font) return;

    const setText = (selector, value) => {
      const output = this.querySelector(selector);
      if (output) output.textContent = String(value || '—');
    };
    const dimensions = this.#formatMeasurements(state.width || 0, state.height || 0);
    const textColor = state.characterColorDisplaySummary
      ? `${state.colorDisplayLabel || state.color} · ${
          state.characterColorDisplaySummary
        }`
      : state.colorDisplayLabel || state.color;
    const color =
      state.icon &&
      state.colorMode === 'combination' &&
      (state.iconColorDisplayLabel || state.iconColorLabel)
        ? `${textColor} · ${this.#t(
            'review.option_icon_color',
            {
              color:
                state.iconColorDisplayLabel || state.iconColorLabel,
            },
            `Icon: ${state.iconColorLabel}`
          )}`
        : textColor;
    const options = [
      this.#t(
        'review.option_remote',
        { value: state.remoteDisplayLabel || state.remote },
        `Remote: ${state.remote}`
      ),
      this.#t(
        'review.option_production',
        { value: state.rushDisplayLabel || state.rush },
        `Production: ${state.rush}`
      ),
      this.#t(
        'review.option_mockup',
        { value: state.mockupDisplayLabel || state.mockup },
        `Mock-up: ${state.mockup}`
      ),
      this.#t(
        'review.option_greeting',
        { value: state.greetingDisplayLabel || state.greeting },
        `Greeting card: ${state.greeting}`
      ),
    ].join(' · ');

    const reviewPreview = this.querySelector('[data-review-preview]');
    const reviewComposition = this.querySelector('[data-review-composition]');
    const reviewNeon = this.querySelector('[data-review-neon]');
    const reviewText =
      state.text || this.#t('text_entry.placeholder', {}, 'Your Text');
    const colorMode = this.#normalizeColorMode(state.colorMode);
    const proofColorFor = (value) => {
      const color = String(value || '').trim().toLowerCase();
      if (color === '#e8f4ff') return '#E6E6E6';
      if (color === '#f4ddb9') return '#F4DDB9';
      return String(value || '#ff0099');
    };
    const iconMeasurement = state.iconMeasurement;
    const hasIcon = Boolean(state.icon && iconMeasurement);
    let reviewFontSize = 36;
    if (reviewNeon instanceof HTMLElement) {
      reviewNeon.replaceChildren();
      reviewNeon.classList.toggle('is-rgb', colorMode === 'rgb');
      reviewNeon.classList.toggle('is-combination', colorMode === 'combination');
      reviewNeon.style.removeProperty('color');
      reviewNeon.style.removeProperty('text-shadow');
      if (colorMode === 'solid') {
        reviewNeon.style.color = proofColorFor(
          this.#colorDescriptorFor(state.colorId).color
        );
      }
      const lines = reviewText.split(/\r?\n/);
      const longestLine = Math.max(1, ...lines.map((line) => this.#countCharacters(line)));
      const lineFactor = Math.max(0.72, 1 - Math.max(0, lines.length - 1) * 0.08);
      const fontSize = Math.max(24, Math.min(54, 62 - longestLine * 1.2) * lineFactor);
      reviewFontSize = fontSize;
      reviewNeon.style.fontFamily = String(state.font.family || 'sans-serif');
      reviewNeon.style.lineHeight = String(
        Math.round(
          this.#positiveNumber(
            state.lineHeightEm,
            this.#positiveNumber(state.font.lineHeight, 1.2)
          ) * 10000
        ) / 10000
      );
      reviewNeon.style.fontSize = `${Math.round(fontSize * 10) / 10}px`;

      let visibleIndex = 0;
      let placementSlot = 0;
      let iconInserted = false;
      const maximumPlacement = this.#iconPlacementSlotCount(reviewText);
      const placement = hasIcon
        ? this.#clamp(
            Number.isFinite(state.iconPlacement)
              ? state.iconPlacement
              : iconMeasurement.placement,
            0,
            maximumPlacement
          )
        : -1;
      const fragment = document.createDocumentFragment();
      const appendIcon = () => {
        if (!hasIcon || iconInserted) return;
        const iconColor = this.#colorDescriptorFor(
          state.iconColorId || state.colorId
        );
        const icon = document.createElement('span');
        icon.className = 'tan-nd__review-inline-icon';
        icon.dataset.reviewIcon = '';
        icon.classList.toggle('is-rgb', colorMode === 'rgb');
        icon.setAttribute('aria-hidden', 'true');
        icon.style.setProperty(
          '--tan-nd-review-icon-mask',
          `url(${JSON.stringify(state.iconUrl)})`
        );
        const reviewIconWidth =
          reviewFontSize * this.#positiveNumber(iconMeasurement.widthEm, 1);
        const reviewIconHeight =
          reviewFontSize * this.#positiveNumber(iconMeasurement.heightEm, 1);
        icon.style.setProperty(
          '--tan-nd-review-icon-width',
          `${Math.round(reviewIconWidth * 10) / 10}px`
        );
        icon.style.setProperty(
          '--tan-nd-review-icon-height',
          `${Math.round(reviewIconHeight * 10) / 10}px`
        );
        icon.style.setProperty(
          '--tan-nd-review-icon-gap',
          `${Math.round(reviewFontSize * this.#positiveNumber(iconMeasurement.gapEm, 0.22) * 10) / 10}px`
        );
        icon.style.setProperty(
          '--tan-nd-review-icon-align',
          `${Math.round(
            this.#finiteNumber(iconMeasurement.alignEm, -0.18) * 1000
          ) / 1000}em`
        );
        const reviewFallbackHalfGap =
          Math.max(0, this.#finiteNumber(iconMeasurement.gapEm, 0.22)) / 2;
        icon.style.setProperty(
          '--tan-nd-review-icon-gap-before',
          `${Math.round(
            reviewFontSize *
              Math.max(
                0,
                this.#finiteNumber(
                  iconMeasurement.gapBeforeEm,
                  reviewFallbackHalfGap
                )
              ) *
              10
          ) / 10}px`
        );
        icon.style.setProperty(
          '--tan-nd-review-icon-gap-after',
          `${Math.round(
            reviewFontSize *
              Math.max(
                0,
                this.#finiteNumber(
                  iconMeasurement.gapAfterEm,
                  reviewFallbackHalfGap
                )
              ) *
              10
          ) / 10}px`
        );
        const reviewTubePixels = this.#fontMatchedIconTubePixels(
          reviewFontSize,
          reviewIconWidth,
          reviewIconHeight,
          state.font,
          state.icon
        );
        icon.style.setProperty(
          '--tan-nd-icon-tube-px',
          `${Math.round(reviewTubePixels * 1000) / 1000}px`
        );
        icon.style.setProperty(
          '--tan-nd-review-icon-neon',
          colorMode === 'rgb' ? '#9d00ff' : proofColorFor(iconColor.color)
        );
        if (colorMode === 'combination') {
          icon.style.setProperty('--tan-nd-review-icon-core', iconColor.core);
        }
        const iconGlow = document.createElement('i');
        iconGlow.className = 'tan-nd__review-inline-icon-glow';
        const iconCore = document.createElement('i');
        iconCore.className = 'tan-nd__review-inline-icon-core';
        this.#hydrateIconVector(iconGlow, state.icon);
        this.#hydrateIconVector(iconCore, state.icon);
        icon.append(iconGlow, iconCore);
        fragment.append(icon);
        iconInserted = true;
      };

      this.#splitGraphemes(reviewText).forEach((grapheme) => {
        if (placementSlot === placement) appendIcon();
        if (/^\s+$/u.test(grapheme)) {
          fragment.append(document.createTextNode(grapheme));
          if (!/^[\r\n]+$/u.test(grapheme)) placementSlot += 1;
          return;
        }
        if (colorMode === 'combination') {
          const descriptor = this.#colorDescriptorFor(state.characterColors?.[visibleIndex]);
          const character = document.createElement('span');
          character.textContent = grapheme;
          character.style.color = proofColorFor(descriptor.color);
          character.style.textShadow = 'none';
          fragment.append(character);
        } else {
          fragment.append(document.createTextNode(grapheme));
        }
        visibleIndex += 1;
        placementSlot += 1;
      });
      appendIcon();
      reviewNeon.append(fragment);
    }
    if (reviewComposition instanceof HTMLElement) {
      reviewComposition.classList.toggle('has-icon', hasIcon);
      reviewComposition.dataset.iconPosition = hasIcon ? state.iconPosition : '';
      reviewComposition.dataset.iconPlacement = hasIcon
        ? String(state.iconPlacement)
        : '';
    }
    if (reviewPreview instanceof HTMLElement) {
      const reviewColor =
        state.colorDisplayLabel ||
        state.color ||
        this.#t('color.selected', {}, 'neon color');
      const reviewFont =
        state.fontLabel || this.#t('accessibility.font', {}, 'font');
      reviewPreview.setAttribute(
        'aria-label',
        hasIcon
          ? this.#t(
              'accessibility.review_preview_label',
              {
                text: reviewText,
                icon: state.iconLabel,
                font: reviewFont,
                color: reviewColor,
                dimensions,
              },
              `${reviewText} with ${state.iconLabel} icon, ${reviewFont}, ${reviewColor}, ${dimensions}`
            )
          : this.#t(
              'accessibility.review_preview_label_without_icon',
              {
                text: reviewText,
                font: reviewFont,
                color: reviewColor,
                dimensions,
              },
              `Design ${reviewText}, font ${reviewFont}, color ${reviewColor}, dimensions ${dimensions}`
            )
      );
    }
    setText('[data-review-text]', state.text);
    setText('[data-review-font]', state.fontLabel);
    const reviewIconRow = this.querySelector('[data-review-icon-row]');
    if (reviewIconRow instanceof HTMLElement) reviewIconRow.hidden = !hasIcon;
    setText(
      '[data-review-icon-value]',
      hasIcon
        ? `${state.iconLabel} · ${
            state.iconPlacementDisplayLabel || state.iconPlacementLabel
          } · ${Math.round(state.iconScale)}%${
            colorMode === 'combination' &&
            (state.iconColorDisplayLabel || state.iconColorLabel)
              ? ` · ${
                  state.iconColorDisplayLabel || state.iconColorLabel
                }`
              : ''
          }`
        : ''
    );
    setText('[data-review-color]', color);
    setText('[data-review-size]', dimensions);
    setText('[data-review-dimensions]', dimensions);
    setText(
      '[data-review-usage]',
      state.usageDisplayLabel || state.usage
    );
    const reviewPowerAdapterRow = this.querySelector(
      '[data-review-power-adapter-row]'
    );
    const outdoorSelected = normalizedEquipmentValue(state.usage).startsWith('outdoor');
    if (reviewPowerAdapterRow instanceof HTMLElement) {
      reviewPowerAdapterRow.hidden = !outdoorSelected;
    }
    setText(
      '[data-review-power-adapter]',
      outdoorSelected ? state.powerAdapterDisplayLabel : ''
    );
    setText(
      '[data-review-backboard]',
      state.backboardDisplayLabel || state.backboard
    );
    setText(
      '[data-review-backboard-color]',
      state.backboardColorDisplayLabel || state.backboardColor
    );
    setText(
      '[data-review-mounting]',
      state.mountingDisplayLabel || state.mounting
    );
    setText('[data-review-options]', options);
    const rushNotesRow = this.querySelector('[data-review-rush-notes-row]');
    const rushNotes = String(state.rushNotes || '').trim();
    if (rushNotesRow instanceof HTMLElement) {
      rushNotesRow.hidden = !rushNotes;
    }
    setText('[data-review-rush-notes]', rushNotes);
    const greetingMessageRow = this.querySelector(
      '[data-review-greeting-message-row]'
    );
    const greetingMessage = String(state.greetingMessage || '').trim();
    if (greetingMessageRow instanceof HTMLElement) {
      greetingMessageRow.hidden = !greetingMessage;
    }
    setText('[data-review-greeting-message]', greetingMessage);
    const specialRequestRow = this.querySelector('[data-review-special-request-row]');
    const specialRequest = String(state.specialRequest || '').trim();
    if (specialRequestRow instanceof HTMLElement) {
      specialRequestRow.hidden = !specialRequest;
    }
    setText('[data-review-special-request]', specialRequest);

    const listPrice = this.querySelector('[data-review-list-price]');
    const totalPrice = this.querySelector('[data-review-price]');
    const price = state.price || {};
    if (listPrice instanceof HTMLElement) {
      listPrice.hidden = !(price.valid && price.discountPercent > 0);
      listPrice.textContent = this.#formatCurrency(price.listCurrent || 0);
    }
    if (totalPrice) totalPrice.textContent = this.#formatCurrency(price.totalCurrent || 0);
  }

  #trackReviewOnce() {
    if (this.#reviewTracked) return;
    this.#reviewTracked = true;

    const state = this.#designState;
    const payload = {
      funnel_name: 'neon_designer',
      intent_stage: 'next',
      funnel_step: 2,
      placement: this.#isHomeEmbed() ? 'home' : 'standalone',
      currency: String(this.dataset.currency || 'EUR'),
      character_count: Number(state.characterCount || 0),
      width_cm: Math.round(Number(state.width || 0)),
      height_cm: Math.round(Number(state.height || 0)),
      usage: String(state.usage || ''),
      backboard: String(state.backboard || ''),
      color_mode: String(state.colorMode || ''),
      icon_id: String(state.iconId || ''),
    };

    this.dispatchEvent(
      new CustomEvent('tan:designer:review', {
        bubbles: true,
        detail: payload,
      })
    );
  }

  /** @param {boolean} designValid */
  #syncAddButton(designValid) {
    const productReady = this.dataset.appBackendReady === 'true';
    const selectedFontId = String(this.#getSelectedFont().id || '');
    const fontReady =
      this.dataset.fontReady === 'true' &&
      this.dataset.fontLoading !== 'true' &&
      Boolean(this.#renderedFontId) &&
      this.#renderedFontId === selectedFontId;
    const canContinue = designValid && productReady && fontReady;
    const exactQuoteReady =
      this.#exactQuoteStatus === 'ready' &&
      Boolean(this.#exactQuoteDesignSignature) &&
      this.#exactQuoteDesignSignature ===
        this.#quoteDesignSignature(this.#designState);
    const nextButton = this.querySelector('[data-next-to-review]');
    const addButton = this.querySelector('[data-add-to-cart]');
    if (nextButton instanceof HTMLButtonElement) {
      nextButton.disabled =
        !canContinue ||
        !exactQuoteReady ||
        this.dataset.reviewPreparing === 'true';
    }
    if (addButton instanceof HTMLButtonElement) {
      addButton.disabled =
        !canContinue || addButton.dataset.loading === 'true';
    }
  }

  /**
   * Exact quotes are bound to customer-controlled design inputs rather than
   * browser-only natural font metrics. This lets viewport rerenders retain a
   * ready quote while any material customer change invalidates it.
   *
   * @param {Record<string, any>} state
   * @returns {string}
   */
  #quoteDesignSignature(state) {
    if (!state || typeof state !== 'object' || !state.font) return '';
    return JSON.stringify({
      text: String(state.text || ''),
      fontId: String(state.font?.id || ''),
      sizeDriver: String(state.sizeDriver || 'width'),
      width: Number(state.width) || 0,
      height: Number(state.height) || 0,
      minimumWidth: Number(state.minimumWidth) || 0,
      alignment: String(state.alignment || ''),
      colorMode: String(state.colorMode || ''),
      colorId: String(state.colorId || ''),
      characterColors: Array.isArray(state.characterColors)
        ? state.characterColors.map(String)
        : [],
      iconId: String(state.iconId || ''),
      iconPosition: String(state.iconPosition || ''),
      iconPlacement: Number.isFinite(state.iconPlacement)
        ? Number(state.iconPlacement)
        : null,
      iconScale: Number(state.iconScale) || 0,
      iconColorId: String(state.iconColorId || ''),
      backgroundId: String(state.backgroundId || ''),
      previewOffset: {
        x: Number(state.previewOffset?.x) || 0,
        y: Number(state.previewOffset?.y) || 0,
      },
      usage: String(state.usage || ''),
      powerAdapterId: String(state.powerAdapterId || 'standard-indoor'),
      backboard: String(state.backboard || ''),
      backboardColor: String(state.backboardColor || ''),
      mounting: String(state.mounting || ''),
      remote: String(state.remote || ''),
      rush: String(state.rush || ''),
      rushNotes: String(state.rushNotes || ''),
      mockup: String(state.mockup || ''),
      greeting: String(state.greeting || ''),
      greetingMessage: String(state.greetingMessage || ''),
      specialRequest: String(state.specialRequest || ''),
    });
  }

  #getSelectedFont() {
    const select = this.querySelector('[data-font-select]');
    const id = select instanceof HTMLSelectElement ? select.value : this.#fonts[0]?.id;
    return this.#fonts.find((font) => String(font.id) === String(id)) || this.#fonts[0] || {
      id: 'fallback',
      label: 'Barcelona',
      family: 'sans-serif',
      lineHeight: 1.6,
      rulerPadding: 6,
      minSmallestHeight: 5.45,
      minUppercaseHeight: 9.45,
      priceFactor: 1,
      doubleLine: false,
      doubleLinePremium: 0.1,
      priceBand: 'standard',
    };
  }

  #getSelectedIcon() {
    const select = this.querySelector('[data-icon-select]');
    const id =
      select instanceof HTMLSelectElement
        ? String(select.value || '')
        : String(this.#selectedIconId || '');
    if (!id) return null;
    return this.#icons.find((icon) => String(icon.id) === id) || null;
  }

  /** @param {Record<string, any>} icon */
  #iconBasePrice(icon) {
    const tier = ['simple', 'standard', 'detailed', 'complex'].includes(icon?.tier)
      ? String(icon.tier)
      : 'standard';
    const defaults = {
      simple: 35,
      standard: 45,
      detailed: 55,
      complex: 65,
    };
    const datasetKey = `iconPrice${tier.charAt(0).toUpperCase()}${tier.slice(1)}`;
    return this.#numberData(datasetKey, defaults[tier]);
  }

  #iconScaleMultiplier() {
    const scale = this.#clamp(this.#positiveNumber(this.#iconScale, 100), 70, 160);
    if (scale <= 100) return 1;
    if (scale <= 120) return 1.15;
    if (scale <= 140) return 1.3;
    return 1.45;
  }

  /** @param {Record<string, any>} icon */
  #iconShopPrice(icon) {
    return Math.round(this.#iconBasePrice(icon) * this.#iconScaleMultiplier());
  }

  #collectSelections() {
    const colorMode = this.#selectedColorMode();
    const modeInput = this.querySelector('input[data-color-mode]:checked');
    const selectedColor = this.#selectedSolidColor();
    const textInput = this.querySelector('[data-text-input]');
    const text = textInput instanceof HTMLTextAreaElement ? textInput.value.trim() : '';
    const characterColors =
      colorMode === 'combination' ? this.#characterColors.map((colorId) => String(colorId)) : [];
    const backboardColor = this.querySelector('[data-backboard-color]');
    const icon = this.#getSelectedIcon();
    const iconPlacement = icon ? this.#iconPlacementState(text) : null;
    const iconColor = icon
      ? this.#colorDescriptorFor(this.#iconColorId || selectedColor.id)
      : null;
    const background = this.#backgrounds.find(
      (entry) => entry.id === this.#selectedBackgroundId
    );
    let backgroundUrl = '';
    try {
      const url = new URL(String(background?.src || ''), document.baseURI);
      if (url.protocol === 'https:') backgroundUrl = url.href;
    } catch {
      backgroundUrl = '';
    }

    return {
      fontLabel: this.#getSelectedFont().label || 'Font',
      icon,
      iconId: String(icon?.id || ''),
      iconLabel: String(icon?.label || ''),
      iconUrl: String(icon?.url || ''),
      iconTier: String(icon?.tier || ''),
      iconPosition: icon ? iconPlacement.position : '',
      iconPlacement: icon ? iconPlacement.placement : null,
      iconPlacementLabel: icon ? iconPlacement.label : '',
      iconPlacementDisplayLabel: icon ? iconPlacement.displayLabel : '',
      iconScale: icon ? this.#iconScale : 0,
      iconColorId:
        icon && colorMode === 'combination' ? String(iconColor.id || '') : '',
      iconColorLabel:
        icon && colorMode === 'combination' ? String(iconColor.label || '') : '',
      iconColorDisplayLabel:
        icon && colorMode === 'combination'
          ? String(iconColor.displayLabel || iconColor.label || '')
          : '',
      colorMode,
      colorModeLabel:
        modeInput instanceof HTMLInputElement ? modeInput.value : 'Other colors',
      colorModeDisplayLabel:
        modeInput instanceof HTMLInputElement
          ? modeInput.dataset.displayLabel || modeInput.value
          : this.#t('color.other_colors', {}, 'Other colors'),
      color:
        colorMode === 'solid'
          ? selectedColor.label
          : colorMode === 'rgb'
            ? 'RGB color changing'
            : 'Color combination',
      colorDisplayLabel:
        colorMode === 'solid'
          ? selectedColor.displayLabel || selectedColor.label
          : colorMode === 'rgb'
            ? this.#t('color.rgb_heading', {}, 'RGB color changing')
            : this.#t('color.combination', {}, 'Color combination'),
      colorId: selectedColor.id,
      characterColors,
      characterColorSummary:
        colorMode === 'combination'
          ? this.#characterColorSummary(text, characterColors)
          : '',
      characterColorDisplaySummary:
        colorMode === 'combination'
          ? this.#characterColorDisplaySummary(text, characterColors)
          : '',
      backgroundId: String(background?.id || ''),
      backgroundLabel: String(background?.label || ''),
      backgroundUrl,
      previewOffset: { ...this.#previewOffset },
      alignment: this.#selectedValue('alignment') || 'center',
      usage: this.#selectedValue('usage') || 'Indoor use',
      usageDisplayLabel: this.#selectedDisplayValue(
        'usage',
        this.#t('usage.indoor_label', {}, 'Indoor use')
      ),
      powerAdapterId: this.#selectedValue('power-adapter') || 'standard-indoor',
      powerAdapterDisplayLabel: this.#selectedDisplayValue(
        'power-adapter',
        this.#t(
          'usage.power_adapter.standard_value',
          {},
          'Standard adapter – keep indoors or protected'
        )
      ),
      backboard: this.#selectedValue('backboard') || 'Cut to shape',
      backboardDisplayLabel: this.#selectedDisplayValue(
        'backboard',
        this.#t('backboard.styles.cut_to_shape', {}, 'Cut to shape')
      ),
      backboardColor:
        backboardColor instanceof HTMLSelectElement ? backboardColor.value : 'Clear acrylic',
      backboardColorDisplayLabel:
        backboardColor instanceof HTMLSelectElement
          ? backboardColor.selectedOptions[0]?.dataset.displayLabel ||
            backboardColor.value
          : this.#t('backboard.colors.clear', {}, 'Clear acrylic'),
      mounting: this.#selectedValue('mounting') || 'Wall mount kit',
      mountingDisplayLabel: this.#selectedDisplayValue(
        'mounting',
        this.#t('mounting.wall_kit', {}, 'Wall mount kit')
      ),
      remote: this.#selectedValue('remote') || 'Yes, included',
      remoteDisplayLabel: this.#selectedDisplayValue(
        'remote',
        this.#t('additional.remote.included', {}, 'Yes, included')
      ),
      rush: this.#selectedValue('rush') || 'Standard production',
      rushDisplayLabel: this.#selectedDisplayValue(
        'rush',
        this.#t('additional.production.standard', {}, 'Standard production')
      ),
      rushNotes:
        this.querySelector('[data-rush-input]') instanceof HTMLTextAreaElement
          ? this.querySelector('[data-rush-input]').value.trim()
          : '',
      mockup: this.#selectedValue('mockup') || 'Proceed without mock-up approval',
      mockupDisplayLabel: this.#selectedDisplayValue(
        'mockup',
        this.#t(
          'additional.mockup.proceed',
          {},
          'Proceed without mock-up approval'
        )
      ),
      greeting: this.#selectedValue('greeting') || 'No',
      greetingDisplayLabel: this.#selectedDisplayValue(
        'greeting',
        this.#t('common.no', {}, 'No')
      ),
      greetingMessage:
        this.querySelector('[data-greeting-input]') instanceof HTMLTextAreaElement
          ? this.querySelector('[data-greeting-input]').value.trim()
          : '',
      specialRequest:
        this.querySelector('[data-special-request-input]') instanceof HTMLTextAreaElement
          ? this.querySelector('[data-special-request-input]').value.trim()
          : '',
    };
  }

  #createHistoryDraft() {
    const state = this.#designState;
    if (!state?.text || !state?.font) return null;

    const fontSelect = this.querySelector('[data-font-select]');
    const requestedWidth =
      this.#sizeDriver === 'width' ? this.#getRequestedWidth() : state.width;
    const requestedHeight =
      this.#sizeDriver === 'height'
        ? this.#getRequestedHeight() || state.height
        : state.height;
    const values = {
      tan_text: state.text,
      tan_font: fontSelect instanceof HTMLSelectElement ? fontSelect.value : '',
      tan_icon: state.iconId,
      tan_icon_position: state.iconPosition,
      tan_icon_placement:
        state.iconId && Number.isFinite(state.iconPlacement)
          ? String(state.iconPlacement)
          : '',
      tan_icon_scale: state.iconId ? String(state.iconScale) : '',
      tan_icon_color:
        state.iconId && state.colorMode === 'combination'
          ? state.iconColorId
          : '',
      tan_color: state.color,
      tan_color_mode: state.colorMode,
      tan_color_id: state.colorId,
      tan_character_colors:
        state.colorMode === 'combination'
          ? JSON.stringify(state.characterColors || [])
          : '',
      tan_preview_x: String(Math.round((state.previewOffset?.x || 0) * 10000) / 10000),
      tan_preview_y: String(Math.round((state.previewOffset?.y || 0) * 10000) / 10000),
      tan_background: state.backgroundId,
      tan_width: String(requestedWidth),
      tan_height: String(requestedHeight),
      tan_size_driver: this.#sizeDriver,
      tan_align: state.alignment,
      tan_usage: state.usage,
      tan_power_adapter: state.powerAdapterId,
      tan_backboard: state.backboard,
      tan_backboard_color: state.backboardColor,
      tan_mounting: state.mounting,
      tan_remote: state.remote,
      tan_rush: state.rush,
      tan_rush_notes: state.rushNotes,
      tan_mockup: state.mockup,
      tan_greeting: state.greeting,
      tan_greeting_message: state.greetingMessage,
      tan_special_request: state.specialRequest,
    };
    const params = new URLSearchParams();
    Object.entries(values).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        params.set(key, String(value));
      }
    });

    return {
      version: 1,
      designerId: String(this.id || ''),
      params: params.toString(),
    };
  }

  #applyHistoryDraft() {
    const historyState =
      window.history.state && typeof window.history.state === 'object'
        ? window.history.state
        : null;
    const draft = historyState?.tanDesignerDraft;
    if (
      !draft ||
      draft.version !== 1 ||
      String(draft.designerId || '') !== String(this.id || '') ||
      typeof draft.params !== 'string'
    ) {
      return false;
    }

    this.#applyUrlState(new URLSearchParams(draft.params));
    return true;
  }

  #applyUrlState(params = new URLSearchParams(window.location.search)) {
    const textInput = this.querySelector('[data-text-input]');
    const specialRequestInput = this.querySelector('[data-special-request-input]');
    const rushInput = this.querySelector('[data-rush-input]');
    const greetingInput = this.querySelector('[data-greeting-input]');
    const fontSelect = this.querySelector('[data-font-select]');
    const iconSelect = this.querySelector('[data-icon-select]');
    const backboardColorSelect = this.querySelector('[data-backboard-color]');
    const width = params.get('tan_width');
    const height = params.get('tan_height');
    const sizeDriver = params.get('tan_size_driver');
    const colorMode = params.get('tan_color_mode');
    const colorId = params.get('tan_color_id');
    const characterColors = params.get('tan_character_colors');
    const requestedIconId = params.get('tan_icon');
    const iconId =
      requestedIconId === 'iconlarneonsigncustomisericin'
        ? 'pawheart'
        : requestedIconId;
    const iconPosition = params.get('tan_icon_position');
    const iconPlacement = Number.parseInt(params.get('tan_icon_placement') || '', 10);
    const iconColor = params.get('tan_icon_color');
    const iconScale = Number.parseFloat(params.get('tan_icon_scale') || '');
    const previewX = Number.parseFloat(params.get('tan_preview_x') || '');
    const previewY = Number.parseFloat(params.get('tan_preview_y') || '');
    const backgroundId = params.get('tan_background');

    if (backgroundId) {
      const backgroundIndex = this.#backgrounds.findIndex(
        (entry) => entry.id === backgroundId
      );
      if (backgroundIndex >= 0) {
        this.#selectedBackgroundId = backgroundId;
        this.#backgroundIndex = backgroundIndex;
        this.querySelectorAll('[data-background-option]').forEach((candidate) => {
          if (!(candidate instanceof HTMLButtonElement)) return;
          const selected = candidate.dataset.backgroundOption === backgroundId;
          candidate.setAttribute('aria-pressed', String(selected));
          candidate.classList.toggle('is-active', selected);
        });
      }
    }

    if (textInput instanceof HTMLTextAreaElement && params.has('tan_text')) {
      textInput.value = this.#limitTextToVisibleCharacters(
        params.get('tan_text') || '',
        this.#numberData('characterLimit', 50)
      ).value;
    }
    if (
      specialRequestInput instanceof HTMLTextAreaElement &&
      params.has('tan_special_request')
    ) {
      specialRequestInput.value = String(params.get('tan_special_request') || '').slice(0, 500);
    }
    if (rushInput instanceof HTMLTextAreaElement && params.has('tan_rush_notes')) {
      rushInput.value = String(params.get('tan_rush_notes') || '').slice(0, 300);
    }
    if (
      greetingInput instanceof HTMLTextAreaElement &&
      params.has('tan_greeting_message')
    ) {
      greetingInput.value = String(params.get('tan_greeting_message') || '').slice(0, 300);
    }
    if (fontSelect instanceof HTMLSelectElement && params.has('tan_font')) {
      const value = params.get('tan_font') || '';
      const fontIds = new Set(Array.from(fontSelect.options, (option) => option.value));
      if (fontIds.has(value)) {
        fontSelect.value = value;
      } else {
        /*
         * The corrected Manchester file now merges with the long-standing
         * theme block. Keep links created while both entries were visible.
         */
        const compatibleId = value === 'catalog-manchester' ? 'font_manchester' : '';
        if (compatibleId && fontIds.has(compatibleId)) fontSelect.value = compatibleId;
      }
    }
    if (iconSelect instanceof HTMLSelectElement && iconId) {
      if (Array.from(iconSelect.options).some((option) => option.value === iconId)) {
        iconSelect.value = iconId;
        this.#selectedIconId = iconId;
        if (iconId === 'infinitymark' && !Number.isFinite(iconScale)) {
          const restoredIcon = this.#icons.find(
            (icon) => String(icon.id || '') === iconId
          );
          this.#setIconScale(restoredIcon?.defaultScale || 70);
        }
      }
    }
    if (Number.isFinite(iconPlacement)) {
      const restoredText =
        textInput instanceof HTMLTextAreaElement ? textInput.value.trim() : '';
      const maximum = this.#iconPlacementSlotCount(restoredText);
      this.#iconPlacement =
        iconPosition === 'right' && iconPlacement >= maximum
          ? -1
          : Math.max(0, iconPlacement);
    } else if (iconPosition === 'left') {
      this.#iconPlacement = 0;
    } else if (iconPosition === 'right') {
      this.#iconPlacement = -1;
    }
    if (iconColor) this.#iconColorId = this.#colorDescriptorFor(iconColor).id;
    if (Number.isFinite(iconScale)) this.#setIconScale(iconScale);
    if (
      backboardColorSelect instanceof HTMLSelectElement &&
      params.has('tan_backboard_color')
    ) {
      const value = params.get('tan_backboard_color') || '';
      if (
        Array.from(backboardColorSelect.options).some(
          (option) => option.value === value
        )
      ) {
        backboardColorSelect.value = value;
      }
    }
    if (sizeDriver === 'height' && height) this.#setHeight(height);
    else if (width) this.#setWidth(width);

    if (colorMode) {
      const normalizedMode = this.#normalizeColorMode(colorMode);
      const modeInput = Array.from(this.querySelectorAll('input[data-color-mode]')).find(
        (candidate) =>
          candidate instanceof HTMLInputElement &&
          this.#normalizeColorMode(candidate.dataset.colorMode || candidate.value) === normalizedMode
      );
      if (modeInput instanceof HTMLInputElement) modeInput.checked = true;
    }

    if (colorId) {
      const normalizedColorId = colorId.trim().toLowerCase();
      const colorInput = Array.from(this.querySelectorAll('input[data-color]')).find(
        (candidate) =>
          candidate instanceof HTMLInputElement &&
          String(candidate.dataset.color || '').trim().toLowerCase() === normalizedColorId
      );
      if (colorInput instanceof HTMLInputElement) colorInput.checked = true;
    }

    if (characterColors) {
      try {
        const parsed = JSON.parse(characterColors);
        if (Array.isArray(parsed)) {
          this.#characterColors = parsed
            .filter((entry) => typeof entry === 'string' && entry.trim())
            .map((entry) => entry.trim());
        }
      } catch {
        this.#characterColors = characterColors
          .split(',')
          .map((entry) => entry.trim())
          .filter(Boolean);
      }
    }

    if (Number.isFinite(previewX) || Number.isFinite(previewY)) {
      this.#previewOffset = {
        x: this.#clamp(Number.isFinite(previewX) ? previewX : 0, -1, 1),
        y: this.#clamp(Number.isFinite(previewY) ? previewY : 0, -1, 1),
      };
    }

    [
      ['color', 'tan_color'],
      ['alignment', 'tan_align'],
      ['usage', 'tan_usage'],
      ['power-adapter', 'tan_power_adapter'],
      ['backboard', 'tan_backboard'],
      ['mounting', 'tan_mounting'],
      ['remote', 'tan_remote'],
      ['rush', 'tan_rush'],
      ['mockup', 'tan_mockup'],
      ['greeting', 'tan_greeting'],
    ].forEach(([name, key]) => {
      const value = params.get(key);
      if (!value) return;
      const input = Array.from(this.querySelectorAll(`input[name$="-${name}"]`)).find(
        (candidate) => candidate instanceof HTMLInputElement && candidate.value === value
      );
      if (input instanceof HTMLInputElement) input.checked = true;
    });
  }

  #shareDesign = async (event) => {
    const sourceButton =
      event?.currentTarget instanceof HTMLButtonElement
        ? event.currentTarget
        : this.querySelector('[data-share]');
    this.#flushPendingUpdate();
    if (!this.#designState.text) {
      this.#showCartError(
        this.#t(
          'errors.share_requires_text',
          {},
          'Enter your text before creating a share link.'
        )
      );
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('designer_step');
    const fontSelect = this.querySelector('[data-font-select]');
    const state = this.#designState;
    const values = {
      tan_text: state.text,
      tan_font: fontSelect instanceof HTMLSelectElement ? fontSelect.value : '',
      tan_icon: state.iconId,
      tan_icon_position: state.iconPosition,
      tan_icon_placement:
        state.iconId && Number.isFinite(state.iconPlacement)
          ? String(state.iconPlacement)
          : '',
      tan_icon_scale: state.iconId ? String(state.iconScale) : '',
      tan_icon_color:
        state.iconId && state.colorMode === 'combination'
          ? state.iconColorId
          : '',
      tan_color: state.color,
      tan_color_mode: state.colorMode,
      tan_color_id: state.colorId,
      tan_character_colors:
        state.colorMode === 'combination' ? JSON.stringify(state.characterColors || []) : '',
      tan_preview_x: String(Math.round((state.previewOffset?.x || 0) * 10000) / 10000),
      tan_preview_y: String(Math.round((state.previewOffset?.y || 0) * 10000) / 10000),
      tan_background: state.backgroundId,
      tan_width: String(state.width),
      tan_height: String(state.height),
      tan_size_driver: this.#sizeDriver,
      tan_align: state.alignment,
      tan_usage: state.usage,
      tan_power_adapter: state.powerAdapterId,
      tan_backboard: state.backboard,
      tan_backboard_color: state.backboardColor,
      tan_mounting: state.mounting,
      tan_mockup: state.mockup,
      tan_special_request: state.specialRequest,
    };

    Object.entries(values).forEach(([key, value]) => {
      if (value) url.searchParams.set(key, String(value));
      else url.searchParams.delete(key);
    });

    if (this.#isMobileViewport() && typeof navigator.share === 'function') {
      try {
        await navigator.share({
          title: this.#t(
            'share.title',
            {},
            'My custom neon design'
          ),
          url: url.toString(),
        });
        this.#showCartError('');
        return;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url.toString());
      const button =
        sourceButton instanceof HTMLButtonElement
          ? sourceButton
          : this.querySelector('[data-share]');
      const label = button?.querySelector('span:last-child');
      const previousAriaLabel =
        button?.getAttribute('aria-label') ||
        this.#t('share.action', {}, 'Share this design');
      button?.setAttribute(
        'aria-label',
        this.#t('share.copied_message', {}, 'Design link copied')
      );
      if (label) {
        const previous = label.textContent;
        label.textContent = this.#t('share.copied_short', {}, 'Copied');
        window.setTimeout(() => {
          label.textContent = previous;
          button?.setAttribute('aria-label', previousAriaLabel);
        }, 1600);
      } else {
        window.setTimeout(() => {
          button?.setAttribute('aria-label', previousAriaLabel);
        }, 1600);
      }
      this.#showCartError('');
    } catch {
      window.prompt(
        this.#t('share.copy_prompt', {}, 'Copy this design link:'),
        url.toString()
      );
    }
  };

  #addToCart = async () => {
    this.#flushPendingUpdate();
    const button = this.querySelector('[data-add-to-cart]');
    const label = this.querySelector('[data-add-label]');
    this.#rememberAddButtonIdleLabel();
    const selectedFontId = String(this.#getSelectedFont().id || '');
    const fontReady =
      this.dataset.fontReady === 'true' &&
      this.dataset.fontLoading !== 'true' &&
      Boolean(this.#renderedFontId) &&
      this.#renderedFontId === selectedFontId;
    const productReady =
      Boolean(this.dataset.variantId) && this.dataset.productAvailable === 'true';
    if (
      !(button instanceof HTMLButtonElement) ||
      this.dataset.designerStep !== 'review' ||
      !this.#designState.valid ||
      !fontReady ||
      !productReady ||
      button.dataset.loading === 'true'
    ) {
      this.#syncAddButton(false);
      this.#showCartError(
        fontReady
          ? this.#t(
              'errors.review_incomplete',
              {},
              'Review a complete design before adding it to the cart.'
            )
          : this.#t(
              'errors.font_loading',
              {},
              'Wait for the selected font to finish loading.'
            )
      );
      return;
    }

    button.dataset.loading = 'true';
    button.disabled = true;
    if (label) {
      label.textContent = this.#t('summary.adding', {}, 'Adding…');
    }
    this.#showCartError('');

    try {
      const price = this.#designState.price;
      if (!price || price.feeTargetMinor <= 0) {
        throw new Error(
          this.#t(
            'errors.invalid_base_price',
            {},
            'The selected Custom Neon Sign product must have a lower base price than the calculated design.'
          )
        );
      }

      const feeVariants = await this.#loadFeeVariants(price.feeTargetMinor);
      const feeVariant = this.#findClosestFeeVariant(price.feeTargetMinor, feeVariants);
      if (!feeVariant) {
        throw new Error(
          this.#t(
            'errors.fee_out_of_range',
            { amount: this.#formatMinorCurrency(price.feeTargetMinor) },
            `The calculated fee (${this.#formatMinorCurrency(
              price.feeTargetMinor
            )}) is outside the published TAN fee range.`
          )
        );
      }

      const configurationId = `tan-designer-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
      const canonicalDesign = this.#canonicalDesign();
      const checksum = this.#hash(canonicalDesign);
      const variantId = String(this.dataset.variantId || '');
      if (!variantId) {
        throw new Error(
          this.#t(
            'errors.select_product',
            {},
            'Select the Custom Neon Sign product in the theme editor.'
          )
        );
      }

      const state = this.#designState;
      const serializedCharacterColors = JSON.stringify(state.characterColors || []);
      const serializedPreviewOffset = JSON.stringify(
        state.previewOffset || { x: 0, y: 0 }
      );
      const mainProperties = {
        'Design source': 'TAN Online Designer',
        'Sign text': state.text,
        'Font style': state.fontLabel,
        'Color mode': state.colorModeLabel,
        'Neon color': state.color,
        'Text alignment': this.#titleCase(state.alignment),
        'Sign width': this.#formatCanonicalSingleMeasurement(state.width),
        'Sign height': this.#formatCanonicalSingleMeasurement(state.height),
        Usage: state.usage,
        'Backboard style': state.backboard,
        'Backboard color': state.backboardColor,
        'Mounting type': state.mounting,
        'Remote control': state.remote,
        'Rush order': state.rush,
        'Mock-up confirmation': state.mockup,
        'Greeting card': state.greeting,
        '_TAN configuration': configurationId,
        '_TAN main item': 'true',
        '_TAN expected fee variant': String(feeVariant.id),
        '_TAN fee unit': this.#formatMinorCurrency(feeVariant.price),
        '_TAN upgrades': state.price.optionLabels.join(', '),
        '_TAN customization percent': `${state.price.optionPercent}%`,
        '_TAN pricing version': this.dataset.version || 'tan-designer-v2',
        '_TAN design checksum': checksum,
        '_TAN calculated total': this.#formatMinorCurrency(state.price.totalMinor),
        '_TAN color mode': state.colorMode,
        '_TAN character colors': serializedCharacterColors,
        '_TAN preview position': serializedPreviewOffset,
        '_TAN font URL': String(state.font?.url || ''),
        '_TAN font ID': String(state.font?.id || ''),
        '_TAN font line height': String(state.font?.lineHeight || ''),
        '_TAN calibrated line height': Number(
          state.lineHeightEm || state.font?.lineHeight || 1.2
        ).toFixed(4),
        '_TAN font measurement height scale': Number(
          state.font?.measurementHeightScale || 1
        ).toFixed(4),
        '_TAN size base EUR': String(Math.round(state.price.sizeBasePrice || 0)),
        '_TAN chargeable characters': String(state.characterCount || 0),
        '_TAN character floor EUR': String(Math.round(state.price.characterFloorPrice || 0)),
        '_TAN character efficiency credit EUR': String(
          Number(state.price.characterEfficiencyCredit || 0).toFixed(2)
        ),
        '_TAN character charge EUR': String(
          Number(state.price.characterChargePrice || 0).toFixed(2)
        ),
        '_TAN character 1-6 unit EUR': String(
          Number(state.price.characterFirstSixRate || 0).toFixed(2)
        ),
        '_TAN character 7 unit EUR': String(
          Number(state.price.characterSeventhRate || 0).toFixed(2)
        ),
        '_TAN character 8 unit EUR': String(
          Number(state.price.characterEighthRate || 0).toFixed(2)
        ),
        '_TAN character 9 unit EUR': String(
          Number(state.price.characterNinthRate || 0).toFixed(2)
        ),
        '_TAN character 10+ unit EUR': String(
          Number(state.price.characterFromTenthRate || 0).toFixed(2)
        ),
        '_TAN character 10+ count': String(
          state.price.characterFromTenthCount || 0
        ),
        '_TAN character line multiplier': Number(
          state.price.characterLineMultiplier || 1
        ).toFixed(2),
        '_TAN character progression uplift EUR': String(
          Number(state.price.characterProgressionUplift || 0).toFixed(2)
        ),
        '_TAN protected size EUR': String(Math.round(state.price.protectedSizePrice || 0)),
        '_TAN natural production base EUR': String(
          Math.round(state.price.naturalProductionBasePrice || 0)
        ),
        '_TAN minimum design width cm': String(
          Math.round(state.price.sizeProgressionMinimumWidth || state.width || 0)
        ),
        '_TAN minimum design height cm': String(
          Math.round(state.price.sizeProgressionMinimumHeight || state.height || 0)
        ),
        '_TAN size progression steps': String(state.price.sizeProgressionSteps || 0),
        '_TAN size progression step EUR': String(
          Number(state.price.sizeProgressionStepPrice || 0).toFixed(2)
        ),
        '_TAN size progression uplift EUR': String(
          Math.round(state.price.sizeProgressionUplift || 0)
        ),
        '_TAN production base EUR': String(Math.round(state.price.productionBasePrice || 0)),
        '_TAN natural pricing driver': String(state.price.naturalPricingDriver || ''),
        '_TAN pricing driver': String(state.price.pricingDriver || ''),
        '_TAN font price factor': Number(state.price.effectiveFontFactor || 1).toFixed(2),
        '_TAN font price multiplier': Number(
          state.price.fontPriceMultiplier || 1
        ).toFixed(2),
        '_TAN font line style': state.price.doubleLine ? 'outline-double' : 'single',
        '_TAN pricing engine': String(state.price.pricingVersion || ''),
      };

      if (state.characterColorSummary) {
        mainProperties['Character colors'] = state.characterColorSummary;
      }
      if (state.icon) {
        mainProperties.Icon = state.iconLabel;
        mainProperties['Icon position'] = state.iconPlacementLabel;
        mainProperties['Icon size'] = `${Math.round(state.iconScale)}%`;
        if (state.colorMode === 'combination' && state.iconColorLabel) {
          mainProperties['Icon color'] = state.iconColorLabel;
        }
        mainProperties['_TAN icon ID'] = state.iconId;
        mainProperties['_TAN icon URL'] = state.iconUrl;
        mainProperties['_TAN icon tier'] = state.iconTier;
        mainProperties['_TAN icon position'] = state.iconPosition;
        mainProperties['_TAN icon placement'] = String(state.iconPlacement);
        mainProperties['_TAN icon placement label'] = state.iconPlacementLabel;
        mainProperties['_TAN icon color'] = state.iconColorId;
        mainProperties['_TAN icon scale'] = `${Math.round(state.iconScale)}%`;
        mainProperties['_TAN icon tube width'] =
          `${Math.round(this.#iconTubeWidthCm() * 10)} mm`;
        mainProperties['_TAN icon minimum height cm'] = String(
          this.#iconMinimumHeightCm(state.icon)
        );
        mainProperties['_TAN icon width cm'] = String(
          Math.round(
            this.#positiveNumber(
              state.iconMeasurement?.exactWidth,
              state.iconMeasurement?.width
            ) * 10
          ) / 10
        );
        mainProperties['_TAN icon height cm'] = String(
          Math.round(
            this.#positiveNumber(
              state.iconMeasurement?.exactHeight,
              state.iconMeasurement?.height
            ) * 10
          ) / 10
        );
        mainProperties['_TAN icon base EUR'] = String(
          Math.round(state.price.iconBasePrice || 0)
        );
        mainProperties['_TAN icon sized EUR'] = String(
          Math.round(state.price.iconSizedPrice || 0)
        );
        mainProperties['_TAN icon adjusted EUR'] = String(
          Math.round(state.price.iconTotalPrice || 0)
        );
      }
      const previewPosition = state.previewOffset || { x: 0, y: 0 };
      if (
        Math.abs(Number(previewPosition.x) || 0) > 0.0005 ||
        Math.abs(Number(previewPosition.y) || 0) > 0.0005
      ) {
        mainProperties['Preview position'] =
          `X ${Math.round((Number(previewPosition.x) || 0) * 100)}%, ` +
          `Y ${Math.round((Number(previewPosition.y) || 0) * 100)}%`;
      }
      if (state.rushNotes) mainProperties['Event or deadline notes'] = state.rushNotes;
      if (state.greeting === 'Yes' && state.greetingMessage) {
        mainProperties['Greeting card message'] = state.greetingMessage;
      }
      if (state.specialRequest) {
        mainProperties['Special request'] = state.specialRequest;
      }

      const feeProperties = {
        '_TAN fee': 'true',
        '_TAN configuration': configurationId,
        '_TAN expected main variant': variantId,
        '_TAN fee unit': this.#formatMinorCurrency(feeVariant.price),
        '_TAN upgrades': state.price.optionLabels.join(', '),
        '_TAN customization percent': `${state.price.optionPercent}%`,
        '_TAN pricing version': this.dataset.version || 'tan-designer-v2',
        '_TAN design checksum': checksum,
        '_TAN color mode': state.colorMode,
        '_TAN character colors': serializedCharacterColors,
        '_TAN preview position': serializedPreviewOffset,
      };
      if (state.icon) {
        feeProperties['_TAN icon ID'] = state.iconId;
        feeProperties['_TAN icon URL'] = state.iconUrl;
        feeProperties['_TAN icon tier'] = state.iconTier;
        feeProperties['_TAN icon position'] = state.iconPosition;
        feeProperties['_TAN icon placement'] = String(state.iconPlacement);
        feeProperties['_TAN icon placement label'] = state.iconPlacementLabel;
        feeProperties['_TAN icon color'] = state.iconColorId;
        feeProperties['_TAN icon scale'] = `${Math.round(state.iconScale)}%`;
        feeProperties['_TAN icon tube width'] =
          `${Math.round(this.#iconTubeWidthCm() * 10)} mm`;
        feeProperties['_TAN icon minimum height cm'] = String(
          this.#iconMinimumHeightCm(state.icon)
        );
        feeProperties['_TAN icon width cm'] = String(
          Math.round(
            this.#positiveNumber(
              state.iconMeasurement?.exactWidth,
              state.iconMeasurement?.width
            ) * 10
          ) / 10
        );
        feeProperties['_TAN icon height cm'] = String(
          Math.round(
            this.#positiveNumber(
              state.iconMeasurement?.exactHeight,
              state.iconMeasurement?.height
            ) * 10
          ) / 10
        );
        feeProperties['_TAN icon adjusted EUR'] = String(
          Math.round(state.price.iconTotalPrice || 0)
        );
      }

      const items = [
        {
          id: Number(variantId),
          quantity: 1,
          properties: mainProperties,
        },
        {
          id: Number(feeVariant.id),
          quantity: 1,
          properties: feeProperties,
        },
      ];

      const shopRoot = String(window.Shopify?.routes?.root || '/');
      const rootWithSlash = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
      const response = await fetch(`${rootWithSlash}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        throw new Error(
          this.#t(
            'errors.add_to_cart_failed',
            {},
            'The custom sign could not be added to the cart.'
          )
        );
      }

      window.location.assign(this.dataset.cartUrl || `${rootWithSlash}cart`);
    } catch {
      this.#showCartError(
        this.#t(
          'errors.add_to_cart_failed',
          {},
          'The custom sign could not be added to the cart.'
        )
      );
      this.#resetAddToCartButton();
    }
  };

  #rememberAddButtonIdleLabel() {
    const button = this.querySelector('[data-add-to-cart]');
    const label = this.querySelector('[data-add-label]');
    const currentLabel = label?.textContent?.trim() || '';
    if (
      button instanceof HTMLButtonElement &&
      button.dataset.loading !== 'true' &&
      currentLabel
    ) {
      this.#addButtonIdleLabel = currentLabel;
    } else if (!this.#addButtonIdleLabel) {
      this.#addButtonIdleLabel = this.#t(
        'summary.add_to_cart',
        {},
        'Add to cart'
      );
    }
  }

  #resetAddToCartButton() {
    const button = this.querySelector('[data-add-to-cart]');
    if (!(button instanceof HTMLButtonElement) || button.dataset.loading !== 'true') return;

    button.dataset.loading = 'false';
    const label = this.querySelector('[data-add-label]');
    if (label) {
      label.textContent =
        this.#addButtonIdleLabel ||
        this.#t('summary.add_to_cart', {}, 'Add to cart');
    }
    this.#syncAddButton(Boolean(this.#designState.valid));
  }

  /** @param {number} targetPrice */
  async #loadFeeVariants(targetPrice) {
    const urls = this.#getFeeUrls(targetPrice);

    for (const url of urls) {
      if (this.#findClosestFeeVariant(targetPrice, this.#feeVariants)) break;
      if (this.#loadedFeeUrls.has(url) || this.#failedFeeUrls.has(url)) continue;
      await this.#loadFeeVariantUrl(url);
    }

    return this.#feeVariants;
  }

  /** @param {string} url */
  async #loadFeeVariantUrl(url) {
    const existing = this.#feeLoadPromises.get(url);
    if (existing) return existing;

    const request = (async () => {
      try {
        const response = await fetch(url, {
          headers: { Accept: 'application/json' },
          signal: this.#abortController.signal,
          cache: 'force-cache',
        });
        if (!response.ok) {
          /*
           * Only cache a definitive missing resource. Rate limits, server
           * errors and offline failures remain retryable on the next cart
           * attempt instead of poisoning the checkout session.
           */
          if (response.status === 404 || response.status === 410) {
            this.#failedFeeUrls.add(url);
          }
          return;
        }

        const product = await response.json();
        const variants = Array.isArray(product?.variants)
          ? product.variants
              .filter(
                (variant) =>
                  variant?.available !== false &&
                  Number(variant?.id) > 0 &&
                  String(variant?.sku || '').startsWith('TAN-PC-')
              )
              .map((variant) => ({
                id: String(variant.id),
                price: this.#normalizeFeePrice(variant.price),
              }))
              .filter((variant) => variant.price > 0)
          : [];

        const byId = new Map(this.#feeVariants.map((variant) => [variant.id, variant]));
        variants.forEach((variant) => byId.set(variant.id, variant));
        this.#feeVariants = Array.from(byId.values()).sort((a, b) => a.price - b.price);
        this.#loadedFeeUrls.add(url);
      } catch (error) {
        if (error?.name === 'AbortError') throw error;
      }
    })();

    this.#feeLoadPromises.set(url, request);
    try {
      await request;
    } finally {
      if (this.#feeLoadPromises.get(url) === request) {
        this.#feeLoadPromises.delete(url);
      }
    }
  }

  /** @param {number} targetPrice */
  #getFeeUrls(targetPrice) {
    const urls = this.#readJson('[data-tan-nd-fee-urls]', []).filter(
      (url) => typeof url === 'string' && url.trim()
    );
    const rate = this.#marketRate();
    const targetShopMajor = Math.max(1, Math.round(targetPrice / this.#currencyMinorUnit() / rate));
    const preferred = urls.find((url) => {
      const match = String(url).match(/product-customization-(\d{4})-(\d{4})\.js(?:\?|$)/);
      return match && targetShopMajor >= Number(match[1]) && targetShopMajor <= Number(match[2]);
    });
    return preferred ? [preferred, ...urls.filter((url) => url !== preferred)] : urls;
  }

  /**
   * @param {number} targetPrice
   * @param {Array<{id: string, price: number}>} variants
   */
  #findClosestFeeVariant(targetPrice, variants) {
    if (!Number.isFinite(targetPrice) || targetPrice <= 0 || variants.length === 0) return null;
    const prices = [...new Set(variants.map((variant) => variant.price).filter((price) => price > 0))].sort(
      (a, b) => a - b
    );
    if (prices.length === 0) return null;

    const gaps = prices.slice(1).map((price, index) => price - prices[index]).filter((gap) => gap > 0);
    const medianGap = gaps.length ? gaps.sort((a, b) => a - b)[Math.floor(gaps.length / 2)] : this.#currencyMinorUnit();
    const tolerance = Math.max(2, Math.ceil(medianGap * 0.6));
    if (targetPrice < prices[0] - tolerance || targetPrice > prices.at(-1) + tolerance) return null;

    const closest = variants.reduce((candidate, variant) => {
      if (!candidate) return variant;
      return Math.abs(variant.price - targetPrice) < Math.abs(candidate.price - targetPrice) ? variant : candidate;
    }, null);
    return closest && Math.abs(closest.price - targetPrice) <= tolerance ? closest : null;
  }

  /** @param {unknown} value */
  #normalizeFeePrice(value) {
    if (value && typeof value === 'object' && 'amount' in value) {
      const amount = Number(value.amount);
      return Number.isFinite(amount) ? Math.round(amount * this.#currencyMinorUnit()) : 0;
    }
    if (typeof value === 'string') {
      const normalized = value.trim().replace(/\s/g, '').replace(',', '.');
      if (!normalized) return 0;
      const amount = Number(normalized);
      return Number.isFinite(amount) ? Math.round(amount * this.#currencyMinorUnit()) : 0;
    }
    const numeric = Number(value);
    return Number.isFinite(numeric) ? Math.round(numeric) : 0;
  }

  #canonicalDesign() {
    const state = this.#designState;
    const previewOffset = state.previewOffset || { x: 0, y: 0 };
    const canonical = {
      version: this.dataset.version,
      text: state.text,
      font: state.fontLabel,
      color: state.color,
      colorId: state.colorId,
      colorMode: this.#normalizeColorMode(state.colorMode),
      characterColors: Array.isArray(state.characterColors)
        ? state.characterColors.map((colorId) => String(colorId))
        : [],
      previewOffset: {
        x: Number(previewOffset.x) || 0,
        y: Number(previewOffset.y) || 0,
      },
      background: {
        id: String(state.backgroundId || ''),
        url: String(state.backgroundUrl || ''),
      },
      alignment: state.alignment,
      width: state.width,
      height: state.height,
      usage: state.usage,
      powerAdapterId: state.powerAdapterId,
      backboard: state.backboard,
      backboardColor: state.backboardColor,
      mounting: state.mounting,
      remote: state.remote,
      rush: state.rush,
      mockup: state.mockup,
      greeting: state.greeting,
      greetingMessage: state.greetingMessage,
      specialRequest: state.specialRequest,
      totalShop: state.price.totalShop,
      priceVersion: this.dataset.version,
    };
    if (state.icon) {
      canonical.icon = {
        id: state.iconId,
        label: state.iconLabel,
        url: state.iconUrl,
        tier: state.iconTier,
        position: state.iconPosition,
        placement: state.iconPlacement,
        placementLabel: state.iconPlacementLabel,
        colorId: state.iconColorId,
        scale: state.iconScale,
        adjustedPrice: state.price.iconTotalPrice,
      };
    }
    return JSON.stringify(canonical);
  }

  /** @param {string} input */
  #hash(input) {
    let hash = 2166136261;
    for (let index = 0; index < input.length; index += 1) {
      hash ^= input.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return `fnv1a-${(hash >>> 0).toString(16).padStart(8, '0')}`;
  }

  /** @param {string} name */
  #selectedValue(name) {
    const input = this.querySelector(`input[name$="-${name}"]:checked`);
    return input instanceof HTMLInputElement ? input.value : '';
  }

  /**
   * Return a localized label without changing the checked control's stable
   * canonical value. Those values continue to drive URLs, history and the
   * private production snapshot.
   * @param {string} name
   * @param {string} fallback
   */
  #selectedDisplayValue(name, fallback) {
    const input = this.querySelector(`input[name$="-${name}"]:checked`);
    if (!(input instanceof HTMLInputElement)) return fallback;
    return input.dataset.displayLabel || input.value || fallback;
  }

  #restoreMeasurementUnit() {
    let storedUnit = '';
    try {
      storedUnit = String(window.localStorage.getItem('tan-neon-designer.measurement-unit') || '');
    } catch {
      storedUnit = '';
    }
    this.#measurementUnit = storedUnit === 'in' ? 'in' : 'cm';
    this.#syncMeasurementUnitUi();
  }

  /** @param {'cm' | 'in'} unit */
  #setMeasurementUnit(unit) {
    const nextUnit = unit === 'in' ? 'in' : 'cm';
    if (nextUnit === this.#measurementUnit) return;
    this.#measurementUnit = nextUnit;
    try {
      window.localStorage.setItem('tan-neon-designer.measurement-unit', nextUnit);
    } catch {
      // Private browsing and embedded previews can disable persistent storage.
    }
    this.#syncMeasurementUnitUi();
    this.#scheduleUpdate();
  }

  #syncMeasurementUnitUi() {
    const usesInches = this.#measurementUnit === 'in';
    this.dataset.measurementUnit = this.#measurementUnit;
    this.querySelectorAll('[data-dimension-unit]').forEach((unit) => {
      unit.textContent = usesInches
        ? this.#t('size.inches', {}, 'in')
        : this.#t('size.centimeters', {}, 'cm');
    });
    const toggle = this.querySelector('[data-unit-toggle]');
    if (toggle instanceof HTMLButtonElement) {
      toggle.textContent = usesInches
        ? this.#t('size.use_centimeters', {}, 'Use centimeters')
        : this.#t('size.use_inches', {}, 'Use inches');
      toggle.setAttribute('aria-pressed', String(usesInches));
      toggle.setAttribute(
        'aria-label',
        usesInches
          ? this.#t(
              'accessibility.unit_centimeters',
              {},
              'Show size in centimeters'
            )
          : this.#t(
              'accessibility.unit_inches',
              {},
              'Show size in inches'
            )
      );
    }
  }

  /** @param {string | number} value */
  #displayValueToCm(value) {
    const parsed = Number.parseFloat(String(value ?? '').replace(',', '.'));
    if (!Number.isFinite(parsed)) return Number.NaN;
    return this.#measurementUnit === 'in' ? parsed * 2.54 : parsed;
  }

  /** @param {number} cm */
  #formatDimensionFieldValue(cm) {
    const metricValue = Number(cm) || 0;
    if (this.#measurementUnit !== 'in') return String(Math.round(metricValue));
    const inchValue = Math.round((metricValue / 2.54) * 10) / 10;
    return Number.isInteger(inchValue) ? String(inchValue) : inchValue.toFixed(1);
  }

  #getRequestedWidth() {
    const raw = this.#requestedWidth;
    return Number.isFinite(raw) ? raw : this.#numberData('minWidth', 20);
  }

  #getRequestedHeight() {
    const raw = this.#requestedHeight;
    return Number.isFinite(raw) && Number(raw) > 0 ? Number(raw) : null;
  }

  /** @param {string | number} value @param {boolean} syncInput */
  #setWidth(value, syncInput = true) {
    const min = this.#numberData('minWidth', 20);
    const max = this.#numberData('maxWidth', 240);
    const normalized = Math.max(min, Math.min(max, Math.round(Number(value) || min)));
    const ranges = this.querySelectorAll('[data-width-range]');
    const inputs = this.querySelectorAll('[data-width-input]');
    this.#authoritativeSize = null;
    this.#sizeDriver = 'width';
    this.#customerSelectedSize = true;
    this.#requestedWidth = normalized;
    ranges.forEach((range) => {
      if (range instanceof HTMLInputElement) range.value = String(normalized);
    });
    if (syncInput) {
      inputs.forEach((input) => {
        if (input instanceof HTMLInputElement) {
          input.value = this.#formatDimensionFieldValue(normalized);
        }
      });
    }
  }

  /** @param {string | number} value @param {boolean} syncInput */
  #setHeight(value, syncInput = true) {
    const max = this.#numberData('maxHeight', 120);
    const normalized = Math.max(1, Math.min(max, Math.round(Number(value) || 1)));
    const input = this.querySelector('[data-height-input]');
    this.#authoritativeSize = null;
    this.#sizeDriver = 'height';
    this.#customerSelectedSize = true;
    this.#requestedHeight = normalized;
    if (syncInput && input instanceof HTMLInputElement) {
      input.value = this.#formatDimensionFieldValue(normalized);
    }
  }

  /** @param {number} value */
  #setZoom(value) {
    this.#zoom = Math.max(0.7, Math.min(1.4, Math.round(value * 10) / 10));
    this.style.setProperty('--tan-nd-zoom', String(this.#zoom));
    requestAnimationFrame(() => {
      this.#applyPreviewOffset();
      this.#positionMetrics();
    });
  }

  #marketRate() {
    const currency = String(this.dataset.currency || 'EUR').toUpperCase();
    const shopCurrency = String(this.dataset.shopCurrency || currency).toUpperCase();
    if (currency === shopCurrency) return 1;
    const rate = Number(window.Shopify?.currency?.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }

  #currencyMinorUnit() {
    if (this.#currencyMinorUnitValue !== null) {
      return this.#currencyMinorUnitValue;
    }
    try {
      const digits = new Intl.NumberFormat(this.dataset.locale || 'en', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR',
      }).resolvedOptions().maximumFractionDigits;
      this.#currencyMinorUnitValue = 10 ** digits;
    } catch {
      this.#currencyMinorUnitValue = 100;
    }
    return this.#currencyMinorUnitValue;
  }

  /** @param {number} major */
  #formatCurrency(major) {
    try {
      if (!this.#currencyFormatter) {
        this.#currencyFormatter = new Intl.NumberFormat(
          this.dataset.locale || 'en',
          {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          }
        );
      }
      return this.#currencyFormatter.format(Number(major) || 0);
    } catch {
      return `${Math.round(Number(major) || 0)}`;
    }
  }

  /** @param {number} minor */
  #formatMinorCurrency(minor) {
    return this.#formatCurrency((Number(minor) || 0) / this.#currencyMinorUnit());
  }

  /** @param {number} cm */
  #formatSingleMeasurement(cm) {
    return `${Math.round(cm)} ${this.#t(
      'size.centimeters',
      {},
      'cm'
    )} / ${Math.round(cm / 2.54)} ${this.#t('size.inches', {}, 'in')}`;
  }

  /** English/canonical form retained for Shopify order properties. @param {number} cm */
  #formatCanonicalSingleMeasurement(cm) {
    return `${Math.round(cm)} cm / ${Math.round(cm / 2.54)} in`;
  }

  /** @param {number} width @param {number} height */
  #formatMeasurements(width, height) {
    return `${Math.round(width)} × ${Math.round(height)} ${this.#t(
      'size.centimeters',
      {},
      'cm'
    )} / ${Math.round(width / 2.54)} × ${Math.round(
      height / 2.54
    )} ${this.#t('size.inches', {}, 'in')}`;
  }

  /** @param {string} value */
  #countCharacters(value) {
    return this.#visibleGraphemes(value).length;
  }

  /** @param {unknown} value @param {number} fallback */
  #positiveNumber(value, fallback) {
    const parsed = Number.parseFloat(String(value ?? '').replace(',', '.'));
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
  }

  /** @param {unknown} value @param {number} fallback */
  #finiteNumber(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  /** @param {string} key @param {number} fallback */
  #numberData(key, fallback) {
    return this.#positiveNumber(this.dataset[key], fallback);
  }

  /** @param {string} selector @param {any} fallback */
  #readJson(selector, fallback) {
    const source = this.querySelector(selector);
    if (!(source instanceof HTMLScriptElement)) return fallback;
    try {
      return JSON.parse(source.textContent || '');
    } catch {
      return fallback;
    }
  }

  /**
   * Read one customer-facing phrase from the active Shopify locale payload.
   * English fallbacks keep the runtime compatible with older theme packages
   * that do not yet inject [data-tan-nd-copy].
   *
   * @param {string} key
   * @param {Record<string, unknown>=} parameters
   * @param {string=} fallback
   */
  #t(key, parameters = {}, fallback = '') {
    const candidate = this.#copy && typeof this.#copy[key] === 'string'
      ? this.#copy[key]
      : fallback || key;
    return Object.entries(parameters).reduce(
      (message, [name, value]) =>
        message.replaceAll(`[[${name}]]`, String(value ?? '')),
      candidate
    );
  }

  /** @param {string} message */
  #showCartError(message) {
    this.querySelectorAll('[data-cart-error]').forEach((output) => {
      if (!(output instanceof HTMLElement)) return;
      output.hidden = !message;
      output.textContent = message;
    });
  }

  /** @param {string} value */
  #escapeXml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&apos;');
  }

  /** @param {string} value */
  #titleCase(value) {
    return String(value || '').replace(/\b\w/g, (character) => character.toUpperCase());
  }
}

if (!customElements.get('tan-neon-designer')) {
  customElements.define('tan-neon-designer', TanNeonDesigner);
}

};

const dependenciesReady = () =>
  typeof window.TanNeonPricing?.calculate === 'function' &&
  Array.isArray(window.TanNeonIconCatalog);

if (dependenciesReady()) {
  initializeDesigner();
} else {
  let started = false;
  const tryInitialize = () => {
    if (started || !dependenciesReady()) return;
    started = true;
    document.removeEventListener('load', onDependencyLoad, true);
    document.removeEventListener('DOMContentLoaded', tryInitialize);
    initializeDesigner();
  };
  const onDependencyLoad = (event) => {
    if (event.target instanceof HTMLScriptElement &&
        /\/tan-neon-(?:pricing-engine|icon-catalog)\.js(?:[?#]|$)/.test(event.target.src)) {
      tryInitialize();
    }
  };
  document.addEventListener('load', onDependencyLoad, true);
  document.addEventListener('DOMContentLoaded', tryInitialize, { once: true });
  tryInitialize();
}
})();
